export default {
  message: {
    notifications: {
      title: 'Benachrichtigungen',
      markAllAsRead: 'Alle als gelesen markieren',
      now: 'Gerade eben',
      minutesAgo: 'Vor {minutes} Minuten',
      hoursAgo: 'Vor {hours} Stunden',
      yesterday: 'Gestern',
      messages: {
        systemUpdated: 'Neues Update verfügbar',
        shareChangedMarketing: '{name} hat dir Zugriff auf {objectCount} Objekte für die Vermarktung gegeben.',
        shareChangedManagement: '{name} hat dir Zugriff auf {objectCount} Objekte für die Bewirtschaftung gegeben.',
        shareChangedAccounting: '{name} hat dir Zugriff auf {objectCount} Objekte für die Buchhaltung gegeben.',
        shareChangedAsset: '{name} hat dir Zugriff auf {objectCount} Objekte für das Asset Management gegeben.',
        shareChangedUndefined: '{name} hat dir Zugriff auf {objectCount} Objekte gegeben.',
        reminderCreated: '{name} hat dir einen neuen Reminder erstellt.',
        reminderEmployeeChanged: '{name} hat dir einen Reminder zugewiesen.',
        eventCreated: '{name} hat dir einen neuen Termin erstellt.',
        invitationAccepted: '{name} hat den Termin {title} vom {date} zugesagt.',
        invitationDeclined: '{name} hat den Termin {title} vom {date} abgesagt.',
        objectMarkedForMarketing: '{name} hat dir ein Objekt für die Vermarktung freigegeben.',
        eventReminder: '{title} beginnt am {startDate} um {startTime}',
        warningUploadSignature: 'Die Unterschrift sollte so exakt wie möglich zugeschnitten werden.'
      }
    },
    navigation: {
      networkPartner: 'Netzwerkpartner',
      objects: 'Objekte',
      realEstate: 'Immobilien',
      reminder: 'Reminder',
      tickets: 'Tickets',
      messages: 'Nachrichten',
      draftMessages: 'Entwurf',
      closedTickets: 'Geschlossene Tickets',
      draftTickets: 'Entwurf',
      directory: 'Adressbuch',
      logFiles: 'Log-Files',
      handover: 'Übergaben',
      contractErrors: 'Contract errors',
      menus: {
        title: 'Menüführung',
        sidebar: 'Seitenmenü',
        explanationTopbarNav: 'Hier kannst du einstellen welche Menüführung du benutzen willst. PropBase bietet 2 Menü-Varianten. Das derzeit ausgewählte Menü am oberen Bildschirmrand und eine Variante als "Sidebar" zum ein und ausklappen. Du kannst beliebig oft zwischen diesen Varianten wechseln.'
      },
      dashboard: {
        title: 'Dashboard',
        overview: 'Übersicht',
        marketing: 'Vermarktung',
        management: 'Bewirtschaftung',
        accounting: 'Buchhaltung'
      },
      reporting: {
        title: 'Reporting',
        marketing: 'Vermarktung',
        management: 'Bewirtschaftung',
        accounting: 'Buchhaltung',
        tenantList: 'Mieterspiegel',
        publishHistory: 'Online-Historie',
        createTenantReport: 'Mieterspiegel generieren',
        buildingBreakingPage: 'Jedes Gebäude auf einer neuen Seite',
        displayPropertySummary: 'Total der Liegenschaft anzeigen',
        displayPropertySummaryTooltip: 'STWEG-Liegenschaften wird keinen Total anzeigen',
        withoutTenantsNames: 'DSG',
        withoutTenantsNamesTooltip: 'Mieternamen werden nicht angezeigt',
        selectPeriod: 'Zeitraum auswählen',
        selectKeyDate: 'Stichtag auswählen',
        startDate: 'Von',
        endDate: 'Bis',
        keyDate: 'Stichtag',
        startGenerating: 'Der Mieterspiegel wird generiert, dies kann einige Sekunden dauern. Du kannst in der Zwischenzeit weiterarbeiten.',
        errorGenerating: 'Das Erstellen eines Mieterspiegels ist fehlgeschlagen. Bitte wenden Sie sich an den Support.',
        standardReporting: 'Standard-Reportings',
        additionalReporting: 'Zusatz-Reportings'
      },
      marketing: {
        title: 'Vermarktung',
        marketplace: 'Marktplatz',
        myAdvertisements: 'Meine Inserate',
        openMessages: 'Offene Nachrichten',
        archive: 'Archiv'
      },
      contact: {
        title: 'Adressbuch',
        itemName: 'Kontakte',
        overview: 'Übersicht',
        export: 'Import/Export'
      },
      briefButler: 'BriefButler',
      deepSign: 'DeepSign',
      calendar: {
        title: 'Kalender',
        year: 'Jahr',
        month: 'Monat',
        week: 'Woche',
        workWeek: 'Arbeitswoche',
        day: 'Tag',
        days: 'Tage',
        today: 'Heute',
        list: 'Agenda',
        export: 'Export',
        day_s: 'Tage'
      },
      settings: {
        title: 'Einstellungen',
        companyProfile: 'Account',
        account: 'Account',
        employees: 'Benutzer',
        editRegion: 'Regionen bearbeiten'
      },
      management: {
        title: 'Bewirtschaftung',
        caretaker: 'Hauswart',
        groups: 'Alle Portfolios',
        buildings: 'Alle Gebäude',
        rentalObjects: 'Alle Mietobjekte',
        allCondominiumObjects: 'Alle STWE-Objekte',
        objects: 'Alle Objekte',
        tenant: 'Vermietungen',
        tenants: 'Alle Vermietungen',
        marketingList: 'Vermarktungsliste',
        overview: 'Übersicht',
        tickets: 'Tickets',
        settings: 'Einstellungen',
        properties: 'Alle Liegenschaften',
        allCondominiumOwners: 'Alle STWE'
      }
    },
    reporting: {
      titles: {
        overview: 'Übersicht Reporting',
        administration: 'Übersicht Reporting - Bewirtschaftung',
        marketing: 'Übersicht Reporting - Vermarktung',
        accounting: 'Übersicht Reporting - Buchhaltung',
        tenantList: 'Übersicht Reporting - Mieterspiegel',
        publishHistory: 'Übersicht Reporting - Online-Historie'
      }
    },
    settings: {
      confirmationText: 'Perform this operation? Unsaved changes will be permanently lost.',
      general: 'Allgemein',
      employees: 'Benutzer',
      messages: 'Nachrichten',
      templates: 'Vorlagen',
      notifications: 'Benachrichtigungen',
      availablePlaceholders: 'Verfügbare Platzhalter',
      domain: {
        title: 'Domains',
        name: 'Domain',
        validationKey: 'Validierungsschlüssel',
        isValid: 'Verifiziert',
        create: 'Domain hinzufügen',
        verify: 'Verifizieren',
        deletedSuccessfully: 'Domain wurde erfolgreich gelöscht',
        validatedSuccessfully: 'Domain wurde erfolgreich validiert',
        validationFailed: 'Domain konnte nicht validiert werden',
        confirmation: {
          title: 'Domain löschen',
          text: 'Diese Domain löschen? Alle dazugehörigen Mailboxen werden ebenfalls gelöscht?'
        },
        info: {
          title: 'Hinweis',
          text: 'Hinterlege für jede Domain einen SPF-Eintrag, der für einen reibungslosen E-Mail Versand sorgt.<br><br>Ein SPF-Eintrag regelt welche Server E-Mails für eine Absenderdomain versenden dürfen. Damit über das System E-Mails mit dieser Absenderadresse versenden werden dürfen, muss ein Eintrag <b>include:myprop.ch</b> integriert sein.<br><br><b>Beispiel:</b> v=spf1 a mx include:myprop.ch -all'
        },
        invalidText: 'Bitte einen DNS-Eintrag für diese Domain anlegen, um zu verifizieren, dass Sie der Eigentümer sind. Füge einen Eintrag vom Typ TXT mit dem Namen \'myprop\' und dem Validierungsschlüssel als Wert hinzu. Nachdem der Eintrag gesetzt wurde unten auf \'Verifizieren\' klicken. Belasse den TXT-Eintrag solange MyProp benutzt wird!'
      },
      senderEmailTicket: {
        title: ' Tickets - Absender-E-Mail',
        description: 'Bitte wähle hier die E-Mail-Adresse aus, von der erstellte Tickets ausgehen sollen. Es wird empfohlen, eine nicht-personenbezogene E-Mail-Adresse zu verwenden. Wird das Feld leer gelassen, wird standardmässig eine von PROPbase generierte E-Mail-Adresse verwendet.',
        savedSuccessfully: 'E-Mail des Absenders erfolgreich gespeichert',
        savedFailed: 'Die E-Mail-Adresse des Absenders konnte nicht gespeichert werden'
      },
      mailbox: {
        create: 'Postfach hinzufügen',
        edit: 'Postfach bearbeiten',
        title: 'Postfächer',
        inbound: 'Eingehend',
        outbound: 'E-Mail-Adresse',
        name: 'Dein vollständiger Name',
        mainUser: 'Benutzer',
        allowedUsers: 'E-Mail-Account Zugriff',
        confirmation: {
          title: 'Postfach löschen',
          text: 'Dieses Postfach löschen?'
        },
        configMailboxToast: 'Zuerst ein Postfach in den Einstellungen konfigurieren',
        folder: 'Ordner',
        setActivatedResponse: 'Automatische Antwort einstellen',
        automaticResponseFor: 'Automatische Antwort für',
        automaticResponse: 'Automatische Antwort',
        alertAutomaticResponse: 'Die automatischen Antworten der ausgewählten Postfächer ist unterschiedlich. Du wirst die aktuell hinterlegte automatische Antwort für alle Postfächer überschreiben.',
        sendAutomaticResponse: 'Automatische Antwort senden',
        noAutomaticResponse: 'Keine automatische Antwort',
        automaticResponseStatusWithEnd: 'Automatische Antwort ({from} {startTime} until {until} {endTime})',
        automaticResponseStatusWithoutEnd: 'Automatische Antwort ({from} {startTime})'
      },
      confidentialEmails: {
        title: 'Vertraulich E-Mail Liste',
        titleTooltip: 'Alle empfangene E-Mails welche an einer Adresse in dieser Liste gehen, werden automatisch als vertraulich gesetzt.',
        addEmail: 'E-Mail hinzufügen',
        modalAddEmail: {
          title: 'E-Mail zur vertraulichen Liste hinzufügen',
          emailOrDomain: 'E-mail oder Domain',
          tooltipEmailOrDomain: 'Wenn eine Domäne eingeben wird, werden alle E-Mails, die von einer auf diese Domäne registrierten E-Mail kommen, als vertraulich gesetzt.'
        },
        successRemoveEmail: 'Email(s) wurden von der vertraulich E-Mail Liste erfolgreich entfernt',
        setRemoveConfidential: 'Als vertraulich setzen/entfernen',
        confidential: 'Vertraulich'
      },
      signature: {
        title: 'E-Mail Signatur',
        setSignature: 'Signatur festlegen',
        addNewSignature: 'Signatur hinzufügen',
        deleteNewSignature: 'Signatur löschen',
        savedSuccessfully: 'Signatur gespeichert!',
        deletedSuccessfully: 'Signatur gelöscht!'
      },
      emailFont: {
        title: 'Email Schrift',
        fontFamily: 'Font family',
        fontSize: 'Font size',
        fontColor: 'Font color',
        savedSuccessfully: 'Email Schrift wurde erfolgreich gespeichert',
        savedUnSuccessfully: 'Email Schrift wurde nicht gespeichert. Bitte versuche es erneut'
      },
      template: {
        title: 'E-Mail Vorlagen',
        titleLetter: 'Textvorlage für Briefe',
        titleTicket: 'Ticket Vorlagen',
        titleDeepSign: 'DeepSign Vorlage',
        confirmation: {
          title: 'Textvorlage löschen',
          text: 'Diese Textvorlage(n) löschen?'
        },
        selectConnectionsFirst: 'Bitte wähle zuerst die Verknüpfungen aus, wenn die Vorlage Platzhalter enthält.',
        textTemplate: 'Textvorlage',
        templateSavedSuccessfully: 'Textvorlage gespeichert',
        documentSavedSuccessfully: 'Dokumentvorlage gespeichert',
        templateDeletedSuccessfully: 'Textvorlage(n) gelöscht',
        name: 'Interner Name',
        subject: 'Betreff',
        message: 'Nachricht',
        template: 'Vorlage',
        titleContract: 'Dokumentvorlagen',
        createTemplate: 'E-Mail Vorlage erstellen',
        createLetterTemplate: 'Textvorlage erstellen',
        createTicketTemplate: 'Ticket Vorlage erstellen',
        createDeepSignTemplate: 'Vorlage erstellen',
        showPlaceholders: 'Platzhalter anzeigen',
        createContractTemplate: 'Vorlage hochladen',
        editContractTemplate: 'Dokumentvorlage bearbeiten',
        contractTemplateCategories: {
          TEMPLATE_CATEGORY_UNDEFINED: 'Unbekannt',
          TEMPLATE_CATEGORY_GENERAL: 'Allgemeine Vorlage',
          TEMPLATE_CATEGORY_ORDERS: 'Auftrag',
          TEMPLATE_CATEGORY_TERMINATION: 'Kündigung',
          TEMPLATE_CATEGORY_CONTRACTS: 'Vertrag',
          TEMPLATE_CATEGORY_PAYMENTS: 'Zahlungsverkehr',
          TEMPLATE_CATEGORY_OFFER: 'Offerte',
          TEMPLATE_CATEGORY_LETTER: 'Brief'

        },
        contractTemplateCreator: 'Ersteller',
        createTemplateFor: 'Vorlage hochladen für',
        ownTemplate: 'Eigene Vorlage',
        editTemplate: 'Textvorlage bearbeiten',
        listObjectWithoutTenancyModal: 'Objekte ohne Mietverhältnisse',
        listObjectWithoutCondominiumModal: 'Objekte ohne Eigentümerverhältnis',
        confirmationContract: {
          title: 'Vertragsvorlage löschen',
          body: 'Willst du wirklich die ausgewählte(n) Vertragsvorlage(n) löschen? Bitte beachte, dass die Vorlage auch für die Eigentümer, sowie die angebundenen Netzwerkpartner gelöscht wird/werden.'
        },
        placeholderTemplate: {
          category: 'Kategorie',
          language: 'Sprache',
          enforcePdf: 'PDF erzwingen',
          filter: {
            all: 'Alle',
            owner: 'Eigentümer',
            addressBook: 'Adressbuch',
            condominiumOwnership: 'Stockwerkeigentumsverhältnis',
            mainCondominiumOwner: 'Haupt Stockwerkeigentümer',
            networkPartner: 'Netzwerkpartner',
            mainTenant: 'Hauptmieter',
            tenancy: 'Vermietung',
            previousTenancy: 'Frühere Vermietung',
            property: 'Liegenschaft',
            building: 'Gebäude',
            object: 'Objekt',
            rentComponents: 'MZ-Komponenten',
            order: 'Auftrag',
            misc: 'Sonstige',
            signature: 'Signatur'
          },
          signature: {
            firstSignature: '1. Unterschrift durch',
            secondSignature: '2. Unterschrift durch'
          }
        },
        category: {
          general: 'Allgemeine Vorlagen',
          orders: 'Aufträge',
          termination: 'Kündigung',
          contracts: 'Verträge',
          payments: 'Zahlungsverkehr'
        },
        addDocumentToDevice: 'Dokument dem Gerät hinzufügen',
        objectWithNoTenenacy: 'Für die folgenden Objekte konnte kein Dokument erstellt werden, da kein aktuelles Mietverhältnis existiert:'
      },
      exportTemplate: {
        title: 'Export Vorlagen',
        createTemplate: 'Vorlage erstellen',
        modalTitle: 'Export-Vorlage erstellen',
        modalEditTitle: 'Bearbeite Export-Vorlage',
        tenancyType: {
          title: 'Vermietungstyp',
          TENANCY_TYPE_ALL: 'Vermietungen + Leerstände',
          TENANCY_TYPE_RENTED: 'Vermietungen',
          TENANCY_TYPE_VACANT: 'Leerstände'
        }
      },
      notification: {
        notifiedMethod: {
          label: 'Bitte lege hier fest, wie du benachrichtigt werden möchtest',
          email: 'E-Mail',
          module: 'Benachrichtigungen im Modul',
          emailAndModule: 'E-Mail + Benachrichtigungen im Modul'
        },
        notificationsReceived: {
          label: 'Bitte lege hier fest, welche Benachrichtigungen du erhalten möchtest',
          ticketResponsible: 'Wechsel der zuständigen Person',
          statusChange: 'Statusänderungen',
          newComments: 'Neue, bearbeitete und gelöschte Kommentare',
          newEmail: 'Neue E-Mail eingegangen',
          newAppointment: 'Termin erstellt',
          newMention: 'Neue Erwähnung',
          mailSent: 'E-Mail gesendet',
          ticketCreated: 'Ticket erstellt',
          ticketDeleted: 'Ticket gelöscht',
          ticketOverdue: 'Überfällig'
        }
      },
      deepsign: {
        title: 'Deepsign',
        integration: 'Integrationen',
        accountLinkedToDeepsign: 'Dein DeepSign Account ist bereits verlinkt und du kannst los legen.',
        linkYourAccount: 'DeepSign Account verknüpfen'
      },
      tend: {
        title: 'Datenexport',
        until: 'Bis',
        success: 'Daten erfolgreich exportiert. Datei heruntergeladen.',
        error: 'Daten konnten nicht exportiert werden. Bitte versuche es erneut.'
      },
      evorest: {
        title: 'Evorest',
        subtitle: 'Hier kann festgelegt werden, ob Mietinteressenten Ihre Mietkaution investieren dürfen.',
        options: {
          allowInvestment: 'Investment erlauben',
          notAllowInvestment: 'Investment nicht erlauben'
        }
      },
      ticketing: {
        title: 'Ticketing',
        informationTickets: 'Informations tickets',
        subTitle: 'Definiere hier, wann Tickets erstellt und fällig werden sollen.',
        insurance_expire: 'Versicherungsauslauf',
        mortgage_expire: 'Hypothekenauslauf',
        building_strategy_revise: 'Gebäudestrategie überarbeiten',
        device_warranty_expire: 'Garantieauslauf',
        device_maintenance_expire: 'Auslauf Wartungsvertrag',
        device_inspection_expire: 'Auslauf Inspektionsvertrag',
        device_revision_expire: 'Auslauf Revisionsvertrag',
        device_maintenance_next: 'Nächste Wartung',
        device_inspection_next: 'Nächste offizielle Inspektion',
        device_revision_next: 'Nächste amtliche Revision',
        tenancy_fixed_term_ends: 'Befristete Verträge',
        tenancy_option_expire: 'Auslaufende Erneuerungsoptionen',
        tenancy_early_right_of_termination: 'Auslaufendes vorzeitiges Kündigungsrecht',
        tenancy_deposit_due_date: 'Kaution zu zahlen bis',
        tenancy_deposit_bank_guarantee: 'Kaution - Auslaufende Bankgarantie',
        createdAt: 'Tickets sollen',
        createdBefore: 'vor Auslauf erstellt werden.',
        beforeInspection: 'vor der Inspektion erstellt werden.',
        beforeMaintenance: 'vor der Wartungerstellt werden.',
        beforeRevision: 'vor der Revision erstellt werden.',
        beforeInspectionDue: 'vor der Inspektion fällig werden.',
        beforeMaintenanceDue: 'vor der Wartung fällig werden.',
        beforeRevisionDue: 'vor der Revision fällig werden.',
        dueAt: 'Tickets sollen',
        dueBefore: 'vor Auslauf fällig werden.'
      },
      synchronisation: {
        title: 'Synchronisation',
        abacusCard: {
          title: 'Abacus',
          subTitle: 'Die folgenden Funktionen aktivieren die Synchronisation von Abacus mit PROPbase.',
          syncDebitUntilDate: 'Sollgestellt Datum synchronisieren (synchronisiert sich automatisch alle 5 Minuten um :00, :05, usw.)',
          syncRentAdjustments: 'Mietzinsanpassungen synchronisieren (wird automatisch alle 30 Minuten um :15 und :45 synchronisiert)',
          syncDocuments: 'Dokumente synchronisieren (wird jeden Tag um 20.00 Uhr automatisch synchronisiert)'
        },
        syncNow: 'Jetzt synchronisieren'
      },
      reporting: {
        title: 'Reporting',
        addUsersModal: {
          title: 'Zugriffseinstellungen - {reportingName}',
          subtitle: 'Lege hier fest, welche Benutzer Zugriff auf dieses Reporting haben sollen',
          permittedUsers: 'Reporting-Zugriff',
          tooltipPermittedUsers: 'Administratoren sehen immer alle Reportings.'
        }
      }
    },
    logFileView: {
      subTitle: 'Synchronisation bei Fehler wird die Schnittstelle in einem Intervall von 3 Minuten angestupst'
    },
    networkPartner: {
      customer: 'Kunde',
      buildings: 'Gebäude',
      subTypes: {
        landlord: 'Bewirtschaftung',
        marketing: 'Vermarktung',
        landlord_marketing: 'Vermarktung/Bewirtschaftung',
        accounting: 'Buchhaltung',
        landlord_accounting: 'Bewirtschaftung/Buchhaltung',
        marketing_accounting: 'Vermarktung/Buchhaltung',
        landlord_marketing_accounting: 'Vermarktung/Bewirtschaftung/Buchhaltung',
        asset_management: 'Asset Management',
        asset_landlord: 'Asset Management/Bewirtschaftung',
        asset_marketing: 'Asset Management/Vermarktung',
        asset_accounting: 'Asset Management/Buchhaltung',
        asset_landlord_marketing: 'Asset Management/Bewirtschaftung/Vermarktung',
        asset_landlord_accounting: 'Asset Management/Bewirtschaftung/Buchhaltung',
        asset_marketing_accounting: 'Asset Management/Vermarktung/Buchhaltung',
        asset_landlord_marketing_accounting: 'Asset Management/Bewirtschaftung/Vermarktung/Buchhaltung'
      },
      region: 'Dienstleistungen nach Region',
      service: 'Dienstleistung',
      documents: 'Interne Dokumente',
      agreements_documents: 'Vereinbarungen/Dokumente',
      marketing: 'Netzwerkpartner Vermarktung',
      management: 'Netzwerkpartner Bewirtschaftung',
      accounting: 'Netzwerkpartner Buchhaltung',
      contactPersonName: 'Name',
      contactPersonPhone: 'Telefon',
      contactPersonEmail: 'E-Mail',
      managementCanton: 'ADMINbase',
      marketingCanton: 'MARKETbase',
      assetCanton: 'ASSETbase',
      accountingCanton: 'FINANCEbase',
      canton: 'Kanton',
      allCantons: 'Alle Kantone',
      building: {
        name: 'Name',
        address: 'Adresse',
        apartments: 'Wohnungen',
        parkingSpaces: 'PP',
        commercialGastronomy: 'Gewerbe + Gastronomie',
        services: 'Dienstleistungen',
        secondaryRooms: 'Nebenräume',
        house: 'Haus'
      }
    },
    contract: {
      savePdf: 'Als PDF speichern',
      letter: 'Brief',
      rentalContract: 'Mietvertrag'
    },
    contact: {
      msgBusinessEmail: 'Ist diese Checkbox angekreuzt, wird jede E-Mail und Portal Nachrichten an die Haupt-E-Mail sowie auch an die Geschäfts-E-Mail gesendet.',
      salutationPrivate: 'Sehr geehrter Herr Carosella',
      salutationCompany: 'Sehr geehrte Damen und Herren',
      forAccount: 'Kontakt erstellen für',
      createdFor: 'Kontakt erstellt für',
      createdForTooltip: 'Du kannst nur Kontakte verschieben, die nicht mit einer Vermietung, Eigentumsverhältnis, Ticket oder Gebäude verbunden sind.',
      forYourself: 'mein Adressbuch',
      newContact: 'Kontakt erstellen',
      editContact: 'Kontakt bearbeiten',
      noContacts: 'Keine Kontakte',
      source: 'Art der Anfrage',
      condoOwners: 'STWE',
      marketplace: {
        title: 'Quelle',
        ownWebsite: 'Eigene Website',
        print: 'Printmedien',
        poster: 'Plakat',
        other: 'Sonstige',
        applicationForm: 'Anmeldeformular'
      },
      companyPosition: 'Firma, Position',
      nameOrCompany: 'Name/Firma',
      types: {
        NONE: 'Keine',
        LANDLORD: 'Eigentümer',
        CLIENT: 'Mandant',
        TENANT: 'Mieter',
        CARETAKER: 'Hauswart',
        SERVICE_PROVIDER: 'Dienstleister',
        INTERESTED_PARTY: 'Interessent',
        BANK: 'Bank',
        INSURANCE: 'Versicherung',
        REAL_ESTATE_MANAGER: 'Bewirtschaftung',
        EMPLOYEE: 'Benutzer',
        USER: 'Benutzer',
        janitor: 'Hauswart',
        anyContact: 'Beliebiger Kontakt',
        CRAFTSMAN: 'Handwerker',
        AUTHORITY: 'Behörde',
        BOARD: 'Vorstand / Komission',
        ACCOUNTANT: 'Buchhaltung',
        MARKETER: 'Vermarktung',
        CONDOMINIUM_OWNER: 'Stockwerkeigentümer',
        SUB_TENANT: 'Untermieter',
        REPRESENTATION: 'Beistand/Vertretung',
        COOPERATIVE: 'Genossenschafter',
        SALE: 'Verkauf',
        EXTERNAL_DEBTOR: 'Externer Debitor',
        GUARANTOR: 'Solidarhafter',
        REVISOR: 'Revisor',
        DELEGATE: 'Delegierter / Ausschuss',
        BUILDING_CONTACT_TYPE_CRAFTSMAN: 'Handwerker',
        BUILDING_CONTACT_TYPE_JANITOR: 'Hauswart',
        BUILDING_CONTACT_TYPE_SERVICE_PROVIDER: 'Dienstleister'
      },
      industries: {
        INDUSTRY_LIVING_FURNISHING_HOUSEHOLD_APPLIANCES: 'Haushaltsgeräte',
        INDUSTRY_LIVING_FURNISHING_INTERIOR_DESIGN: 'Innenarchitektur',
        INDUSTRY_LIVING_FURNISHING_INTERIOR_DECORATION: 'Innendekoration',
        INDUSTRY_LIVING_FURNISHING_REAL_ESTATE_TRADING: 'Liegenschaftshandel Liegenschaftsvermittlung',
        INDUSTRY_LIVING_FURNISHING_REAL_ESTATE_MANAGEMENT: 'Liegenschaftsverwaltung',
        INDUSTRY_LIVING_FURNISHING_CLEANING: 'Reinigungsunternehmung',
        INDUSTRY_LIVING_FURNISHING_KEY_SERVICE: 'Schlüsselservice',
        INDUSTRY_LIVING_FURNISHING_BLINDS_AND_SHUTTERS: 'Storen und Rollladen',
        INDUSTRY_LIVING_FURNISHING_MOVING: 'Umzugsservice',
        INDUSTRY_LIVING_FURNISHING_CURTAINS: 'Vorhänge Vorhangservice',
        INDUSTRY_LIVING_FURNISHING_OTHER: 'Sonstige Wohnen & Einrichten',
        INDUSTRY_BUILD_RENOVATE_ARCHITECTURE: 'Architekturbüro',
        INDUSTRY_BUILD_RENOVATE_CONSTRUCTION: 'Bauunternehmung',
        INDUSTRY_BUILD_RENOVATE_ROOFING: 'Bedachungen',
        INDUSTRY_BUILD_RENOVATE_FLOORING_WALL_COVERINGS: 'Bodenbeläge',
        INDUSTRY_BUILD_RENOVATE_PLASTERER: 'Gipsergeschäft',
        INDUSTRY_BUILD_RENOVATE_HEATING: 'Heizungen',
        INDUSTRY_BUILD_RENOVATE_ENGINEERING: 'Ingenieurbüro',
        INDUSTRY_BUILD_RENOVATE_PAINTER: 'Malergeschäft',
        INDUSTRY_BUILD_RENOVATE_METAL_CONSTRUCTION: 'Metallbau Stahlbau',
        INDUSTRY_BUILD_RENOVATE_SANITARY: 'Sanitäre Anlagen und Installationen',
        INDUSTRY_BUILD_RENOVATE_LOCKSMITH: 'Schlosserei',
        INDUSTRY_BUILD_RENOVATE_JOINERY: 'Schreinerei',
        INDUSTRY_BUILD_RENOVATE_PLUMBING: 'Spenglerei',
        INDUSTRY_BUILD_RENOVATE_CARPENTRY: 'Zimmerei',
        INDUSTRY_BUILD_RENOVATE_ELECTRICIAN: 'Elektriker',
        INDUSTRY_BUILD_RENOVATE_OTHER: 'Sonstige Bauen & Renovieren',
        INDUSTRY_BUILD_GLAZIER: 'Fensterbauer',
        INDUSTRY_BUILD_SCAFFOLDER: 'Gerüstbauer',
        INDUSTRY_FINANCIAL_LAW_BANK: 'Bank',
        INDUSTRY_FINANCIAL_LAW_ACCOUNTING: 'Buchhaltungsbüro',
        INDUSTRY_FINANCIAL_LAW_FINANCIAL_CONSULTING: 'Finanzberatung',
        INDUSTRY_FINANCIAL_LAW_NOTARY: 'Notariatsbüro',
        INDUSTRY_FINANCIAL_LAW_LAWYER: 'Rechtsanwalt',
        INDUSTRY_FINANCIAL_LAW_TAX_CONSULTING: 'Steuerberatung / Treuhandbüro',
        INDUSTRY_FINANCIAL_LAW_ASSET_MANAGEMENT: 'Vermögensverwaltung',
        INDUSTRY_FINANCIAL_LAW_INSURANCE: 'Versicherung',
        INDUSTRY_FINANCIAL_LAW_OTHER: 'Sonstige Finanzen & Recht',
        INDUSTRY_GARDEN_PLANTS_HORTICULTURE: 'Gartenbau / Gartenunterhalt',
        INDUSTRY_GARDEN_PLANTS_DUMPSTER_SERVICE: 'Muldenservice Muldentransport',
        INDUSTRY_GARDEN_PLANTS_OTHER: 'Sonstige Garten & Pflanzen',
        INDUSTRY_OTHER_METER_READING: 'Ablesefirma',
        INDUSTRY_OTHER_FACILITY_MANAGEMENT: 'Facilty Management',
        INDUSTRY_OTHER_MAINTENANCE_INSTALLATION: 'Wartung & Installation',
        INDUSTRY_OTHER_BUILDING_SERVICES_ENGINEERING: 'Gebäudetechnik',
        INDUSTRY_OTHER_OTHER: 'Sonstige',
        INDUSTRY_OTHER_FIRE_PROTECTION: 'Brandschutz',
        INDUSTRY_BUILD_RENOVATE_FACADES: 'Fassaden',
        INDUSTRY_OTHER_WATERWORKS: 'Wasserwerk',
        INDUSTRY_OTHER_SWEEPINGS: 'Kehricht/Entsorgung',
        INDUSTRY_OTHER_ANTENNA_SYSTEM: 'Antennenanlage',
        INDUSTRY_OTHER_PEST_CONTROL: 'Schädlingsbekämpfung',
        INDUSTRY_FINANCIAL_LAW_PUBLIC_SECTOR: 'Öffentliche Hand',
        INDUSTRY_BUILD_RENOVATE_AIR_CONDITIONING: 'Lüftung/Klima',
        INDUSTRY_BUILD_RENOVATE_GARAGE_GATES: 'Garagentore',
        INDUSTRY_BUILD_RENOVATE_MOLD_CONTROL: 'Feuchtigkeits-/Schimmelbekämpfung',
        INDUSTRY_OTHER_MARKINGS: 'Markierungen',
        INDUSTRY_BUILD_RENOVATE_JOINTS: 'Fugen',
        INDUSTRY_OTHER_OIL: 'Energielieferant',
        INDUSTRY_BUILD_RENOVATE_LIFT_SERVICE: 'Aufzugsservice',
        INDUSTRY_OTHER_WATER_TREATMENT: 'Wasseraufbereitung',
        INDUSTRY_OTHER_ADVERTISING: 'Werbung',
        INDUSTRY_OTHER_CHIMNEY_SWEEPER: 'Kaminfeger',
        INDUSTRY_OTHER_ENGRAVING: 'Gravuren',
        INDUSTRY_BUILD_MASONRY: 'Maurer',
        INDUSTRY_CONSTRUCTION_MANAGEMENT: 'Bauleitung',
        INDUSTRY_SEWER_CLEANING: 'Kanalreinigung / Kanalisation',
        INDUSTRY_NATURE_CONSERVATION: 'Naturschutz',
        INDUSTRY_GEOMATICS: 'Geomatik / Vermessung',
        INDUSTRY_DECONSTRUCTION: 'Rückbau',
        INDUSTRY_GEOLOGIST: 'Geologe',
        INDUSTRY_POLLUTANT_EXPERT: 'Schadstoffexperte',
        INDUSTRY_INSULATION: 'Isolierung',
        INDUSTRY_LOCKING_SYSTEMS: 'Schliessanlagen'
      },
      creationModal: {
        confirmationTitle: 'Einige Änderungen wurden nicht gespeichert',
        confirmationText: 'Änderungen verwerfen und schliessen?',
        close: 'Schliessen'
      },
      export: {
        title: 'Kontakte Export',
        subTitle: 'Es kann nach Outlook, Thunderbird oder Google exportiert werden',
        url: 'Kontakte-URL'
      },
      import: {
        title: 'Import',
        subTitle: 'Importiere bestehenden Kontakte zu PropBase. Exportiere dazu dein Adressbuch aus Outlook, Thunderbird oder Google Kontakte als vCard-Datei und lade sie hier hoch.',
        placeholder: 'Kontakte importieren'
      },
      title: 'Kontakt',
      actions: {
        title: 'Aktionen',
        contactPerson: 'Kontaktperson',
        linkContact: 'Kontakt verknüpfen',
        addAddress: 'Adresse hinzufügen',
        editAddress: 'Adresse ändern',
        document: 'Dokumente',
        reminder: 'Reminder',
        contact: 'Kontakt hinzufügen',
        activity: 'Aktivität',
        event: 'Termin',
        email: 'E-Mail',
        createTicket: 'Ticket erstellen',
        briefButler: 'BriefButler',
        requestApplicationForm: 'Anmeldeformular anfragen',
        add: 'Erstellen'
      },
      linkContact: {
        title: 'Bestätigen',
        text: 'Diese beiden Kontakte verknüpfen?',
        unlink: 'Verknüpfung für diese beiden Kontakte aufheben?'
      },
      addressChange: {
        title: 'Bestätigen',
        text: 'Bist du dir sicher, dass du bei allen ausgewählten Kontakten die Adresse ändern möchtest?'
      },
      activity: {
        create: 'Aktivität erstellen',
        edit: 'Aktivität bearbeiten',
        start: 'Start',
        end: 'Ende',
        duration: 'Dauer',
        source: 'Quelle',
        sourceType: {
          ACTIVITY_SOURCE_PHONE: 'Telefon',
          ACTIVITY_SOURCE_MAIL: 'E-Mail',
          ACTIVITY_SOURCE_PERSONAL: 'Persönlich'
        }
      },
      sources: {
        UNDEFINED_REQUEST_SOURCE: '-',
        PHONE_REQUEST_SOURCE: 'Telefon',
        MAIL_REQUEST_SOURCE: 'E-Mail',
        WEBSITE_REQUEST_SOURCE: 'Website',
        MARKETPLACE_REQUEST_SOURCE: 'Marktplatz',
        PERSONAL_REQUEST_SOURCE: 'Persönlich'
      },
      address: {
        validFrom: 'Gültig ab',
        adressHistory: 'Anschriften-Zeitachse'
      },
      preferredCommunicationChannel: 'Bevorzugte Kommunikation',
      preferredCommunicationChannelType: {
        email: 'E-Mail',
        letter: 'Brief'
      },
      addTag: 'Tag hinzufügen',
      preferredLanguage: 'Bevorzugte Sprache',
      preferredLanguageValue: {
        PREFERRED_LANGUAGE_ENGLISH: 'Englisch',
        PREFERRED_LANGUAGE_GERMAN: 'Deutsch',
        PREFERRED_LANGUAGE_ITALIAN: 'Italienisch',
        PREFERRED_LANGUAGE_FRENCH: 'Französisch'
      },
      salutation: {
        salutationTooltip1: 'Hier kann eine individuelle Anrede definiert werden.</br> Ist die Standardanrede “',
        salutationTooltip2: '“ gewünscht, kann dieses Feld leer gelassen werden.',
        example: 'Beispiel: ',
        defaultSalutationIndividual: 'Hallo Max Mustermann',
        defaultSalutationCompany: 'Sehr geehrte Damen und Herren',
        prefixIndividualMale: 'Sehr geehrter Herr',
        prefixIndividualFemale: 'Sehr geehrte Frau',
        prefixIndividualOther: 'Hallo'
      },
      duplicatedContact: {
        title: 'Dubletten für neue Adresse',
        text: 'Hier kannst du die Kontakte sehen, die als Dublette erkannt wurden. Möchtest du den Kontakt trotzdem speichern?'
      },
      notificationPreferences: {
        title: 'Benachrichtigungseinstellungen',
        includeInSerialEmail: 'In Serienemail einfügen',
        portalAccess: 'Portal Zugriff'
      }
    },
    deepSign: {
      title: 'DeepSign',
      created: 'Erstellt',
      contacts: 'Kontakte',
      documentType: 'Dokumententyp',
      signers: 'Unterschriften',
      status: {
        title: 'Status',
        complete: 'Abgeschlossen',
        incomplete: 'Unvollständig',
        cancelled: 'Annulliert'
      },
      digitalSignature: 'Digitale Unterschrift',
      titleAction: 'Digitale Unterschrift',
      modal: {
        title: 'Signatur-Einladungen versenden',
        landlord: 'Bewirtschafter',
        addLandlord: 'Weiteren hinzufügen',
        tenant: 'Mieter',
        guarantor: 'Solidarhafter',
        message: 'Nachricht',
        signature: 'Signatur',
        signatureObligatoryDocs: 'Unterschrift pflichtige Dokumente',
        additionalDocs: 'Weitere Anhänge ohne Unterschrift',
        warningDocType: 'Nur Word oder PDF Dateien sind erlaubt',
        user: 'Benutzer',
        options: {
          LEGAL_WEIGHT_STANDARD: 'Einfache e-Signatur (EES)',
          LEGAL_WEIGHT_PROFESSIONAL: 'Fortgeschrittene e-Signatur (FES)',
          LEGAL_WEIGHT_QUALIFIED: 'Qualifizierte e-Signatur (QES)'
        }
      },
      messageSuccess: 'Das Dokument wurde versendet.',
      cancelSignature: 'Unterschrift-Prozess annullieren',
      messageCancelSignature: 'Willst du wirklich den Unterschrift-Prozess annullieren?',
      documentAddedAuto: 'Das unterschriebene Dokument ist automatisch der Vermietung hinzugefügt worden.'
    },
    digitalDeposit: {
      title: 'Digitale Kaution',
      description: 'Bitte überprüfe die Angaben aller Mieter',
      informationComplete: 'Angaben vollständig',
      informationIncomplete: 'Angaben unvollständig',
      informationIncompleteTooltip: 'Folgende Angaben sind unvollständig:<br><span>{list}</span>',
      chooseProvider: 'Anbieter wählen',
      descriptionProvider: 'Das Depot bei Evorest wird bei der Hypothekarbank Lenzburg AG geführt.',
      providers: {
        EVOREST: 'Evorest'
      },
      investment: 'Investment',
      descriptionInvestment: 'Hier können Investitionen zugelassen werden. Wenn der Eigentümer explizit keine Investitionen erlaubt, kann hier keine Investition zugelassen werden.',
      options: {
        allowInvestment: 'Investment erlauben',
        notAllowInvestment: 'Investment nicht erlauben'
      }
    },
    handoverProtocol: {
      title: 'Übergaben',
      deletion: {
        confirmationTitle: 'Übergabeprotokoll(e) löschen',
        confirmationText: 'Möchtest du diese(s) Übergabeprotokoll(e) löschen?'
      },
      status: {
        PROTOCOL_STATUS_SENT_TO_APP: 'An die App gesendet',
        PROTOCOL_STATUS_DRAFT: 'Entwurf',
        PROTOCOL_STATUS_FINISHED: 'Erledigt'
      }
    },
    briefButler: {
      title: 'BriefButler',
      emptyPage: 'Bitte kontaktiere den Support um BriefButler zu benutzen',
      sendDocument: 'Dokument versenden',
      onlyPdf: '(nur PDF)',
      modal: {
        title: 'BriefButler',
        howSendDoc: 'Wie möchtest du das Dokument versenden?'
      },
      errorsTable: {
        title: 'BriefButler Fehler',
        acknowledge: 'Fehler bestätigen',
        acknowledgeSuccess: 'Fehler erfolgreich bestätigt',
        acknowledgeError: 'Fehler konnte nicht bestätigt werden'
      },
      error: {
        fileType: 'Es können nur PDF-Datei hochgeladen werden.'
      }
    },
    ticketOverview: {
      titleModalCreate: 'Ticket erstellen',
      createTicket: 'Ticket erstellen',
      createOrder: 'Auftrag erstellen',
      createTask: 'Aufgabe erstellen',
      editTicket: 'Ticket bearbeiten',
      title: 'Tickets',
      noTickets: 'Keine Tickets',
      confirmationModal: {
        title: 'Einige Änderungen wurden nicht gespeichert',
        message: 'Schliessen',
        confirmation: 'Änderungen verwerfen und schließen?'
      },
      attachement: {
        document: 'Dokumente',
        image: 'Bilder',
        video: 'Videos'
      },
      ticket: {
        createTicket: 'Create ticket',
        title: 'Titel',
        description: 'Beschreibung',
        key: 'Ticketnummer',
        dueDate: 'Auszuführen bis',
        assignee: 'Zuständiger',
        observer: 'Observer',
        operator: 'Ausführender',
        noneOperator: 'Keiner',
        involvedPersons: 'Beteiligte Personen',
        searchContacts: 'Durchsuche Kontakte',
        attachment: 'Dateien',
        appointments: 'Termine',
        newAppointment: 'Neuer Termin',
        startDate: 'Start date',
        linkTickets: 'Tickets verknüpfen',
        linkedTickets: 'Verknüpfte Tickets',
        link: 'Verknüpfen',
        search: 'Suche nach Ticket Nr./Titel',
        connections: 'Verknüpfungen',
        linkedEmail: 'Verknüpfte Emails',
        orderBeExecutedFrom: 'Auszuführen ab',
        contactPersonOnSite: 'Ansprechperson vor Ort',
        details: 'Kontakte',
        creator: 'Ersteller',
        watchedByMe: 'Beobachte ich',
        newEvent: 'Neues Ereignis',
        showEntierProperty: 'Ganze Liegenschaft anzeigen',
        showEntierBuilding: 'Ganzes Gebäude anzeigen',
        overdueTicket: 'Überfällige Tickets',
        newComment: 'Schreibe einen Kommentar...',
        internalNote: 'Interner Kommentar',
        tooltipInternalNote: 'Interne Notizen können von allen Netzwerkpartnern, nicht aber von externen Beauftragten gelesen werden.',
        created: 'Erstellt',
        updated: 'Aktualisiert',
        createdBySystem: 'Vom System erstellt',
        costs: {
          title: 'Kosten',
          costAbsorption: 'Kostenübernahme',
          costAbsorptionValues: {
            COST_ABSORPTION_OWNER: 'Eigentümer',
            COST_ABSORPTION_TENANT: 'Mieter'
          }
        },
        deleteConfirmation: {
          title: 'Ticket löschen',
          text: 'Willst du das Ticket unwiderruflich löschen?',
          confirmationTextDeleteLinkedTicket: 'Willst du wirklich dieses verknüpfte Ticket entfernen?'
        },
        deleteCommentConfirmation: {
          title: 'Kommentar löschen',
          text: 'Willst du den Kommentar unwiderruflich löschen?'
        },
        unlinkMailConfirmation: {
          title: 'unlink mail',
          text: 'Do you really want to unlink this mail irreversibly?'
        },
        tabs: {
          all: 'Alle',
          comments: 'Kommentare',
          messages: 'Nachrichten',
          events: 'Termine',
          history: 'Verlauf'
        },
        type: {
          title: 'Typ',
          TICKET_TYPE_ORDER: 'Auftrag',
          TICKET_TYPE_OFFER: 'Offerte',
          TICKET_TYPE_ACTIVITY: 'Aktivität',
          TICKET_TYPE_TASK: 'Aufgabe'
        },
        connection_items: {
          object: 'Mietobjekt',
          building: 'Gebäude',
          tenancy: 'Mietverhältnis',
          property: 'Liegenschaft',
          condominium: 'STWE-Objekt',
          condo_owner: 'Eigentumsverhältnis',
          contact: 'Kontakt',
          device: 'Bauteile & Geräte',
          request: 'Anfrage',
          selected: 'Ausgewählt',
          mortgage: 'Hypothek',
          insurance: 'Versicherung'
        },
        linkType: {
          TICKET_LINK_TYPE_RELATES: 'verknüpft',
          TICKET_LINK_TYPE_BLOCKS: 'blockiert',
          TICKET_LINK_TYPE_IS_BLOCKED_BY: 'wird blockiert von'
        },
        priority: {
          title: 'Priorität',
          DEFAULT: 'Normal',
          LOW: 'Gering',
          HIGH: 'Hoch',
          overdue: 'Überfällig'
        },
        watcher: {
          stopWatcher: 'Beobachtung beenden',
          startWatcher: 'Beobachtung beginnen',
          watchingIssue: 'Dieser Vorgang wird beobachtet von:'
        },
        actions: {
          link: 'Andere Tickets verlinken',
          delete: 'Löschen',
          markAsUnread: 'Als ungelesen markieren',
          changeCondition: 'Zustand Bauteil/Gerät anpassen',
          replaceComponent: 'Bauteil / Gerät ersetzen',
          changeOperator: 'Ausführenden wechseln',
          uninstallDeviceTitle: 'Aktuelles Bauteil / Gerät deinstallieren',
          uninstallDeviceDescription: 'Bitte trage hier das Deinstallationsdatum von deinem aktuellen Bauteil / Gerät ein',
          enterNewDevice: 'Erfasse hier das neue Bauteil / Gerät'
        },
        comment: {
          emptyCommentsList: 'No comment available'
        },
        history: {
          ticketCreated: '<span style="font-weight: bold">{user}</span> hat das Ticket erstellt <i>{datetime}</i>',
          ticketCreatedBySystem: 'Dieses Ticket wurde vom System automatisch erstellt <i>{datetime}</i>',
          ticketLinkedEmail: '<span style="font-weight: bold">{user}</span> hat eine E-Mail verknüpft <i>{datetime}</i>',
          priorityChanged: '<span style="font-weight: bold">{user}</span> hat die Priorität geändert <i>{datetime}</i>',
          ticketLinked: '<span style="font-weight: bold">{user}</span> hat ein Ticket verlinkt <i>{datetime}</i>',
          ticketLinkRemoved: '<span style="font-weight: bold">{user}</span> hat ein verknüpftes Ticket entfernt <i>{datetime}</i>',
          ticketTypeChanged: '<span style="font-weight: bold">{user}</span> hat den Ticket-Typ geändert <i>{datetime}</i>',
          titleUpdated: '<span style="font-weight: bold">{user}</span> hat den Titel aktualisiert <i>{datetime}</i>',
          fileUploaded: '<span style="font-weight: bold">{user}</span> hat eine Datei hochgeladen <i>{datetime}</i>',
          fileDeleted: '<span style="font-weight: bold">{user}</span> hat eine Datei gelöscht <i>{datetime}</i>',
          assigneeChanged: '<span style="font-weight: bold">{user}</span> hat die zuständige Person geändert <i>{datetime}</i>',
          operatorChanged: '<span style="font-weight: bold">{user}</span> hat die ausführende Person geändert <i>{datetime}</i>',
          dueDateChanged: '<span style="font-weight: bold">{user}</span> hat das Fälligkeitsdatum geändert <i>{datetime}</i>',
          dateOrderChanged: '<span style="font-weight: bold">{user}</span> hat das Datum bei Auftrag auszuführen ab geändert <i>{datetime}</i>',
          statusChanged: '<span style="font-weight: bold">{user}</span> hat den Status geändert <i>{datetime}</i>',
          commentInternalAdded: '<span style="font-weight: bold">{user}</span> hat einen neuen internen Kommentar erfasst <i>{datetime}</i>',
          commentAdded: '<span style="font-weight: bold">{user}</span> hat einen neuen Kommentar erfasst <i>{datetime}</i>',
          commentEdited: '<span style="font-weight: bold">{user}</span> hat seinen Kommentar bearbeitet <i>{datetime}</i>',
          commentInternalEdited: '<span style="font-weight: bold">{user}</span> hat seinen internen Kommentar bearbeitet <i>{datetime}</i>',
          commentDeleted: '<span style="font-weight: bold">{user}</span> hat seinen Kommentar gelöscht <i>{datetime}</i>',
          descriptionUpdated: '<span style="font-weight: bold">{user}</span> hat die Beschreibung aktualisiert <i>{datetime}</i>',
          connectionAdded: '<span style="font-weight: bold">{user}</span> hat eine Verknüpfung hinzugefügt <i>{datetime}</i>',
          connectionRemoved: '<span style="font-weight: bold">{user}</span> hat eine Verknüpfung entfernt <i>{datetime}</i>',
          watchTicket: '<span style="font-weight: bold">{user}</span> beobachtet dat Ticket <i>{datetime}</i>',
          mentioned: '<span style="font-weight: bold">{user}</span> hat {user2} in einem Kommentar erwähnt <i>{datetime}</i>',
          descriptionAdded: '<span style="font-weight: bold">{user}</span> hat eine Beschreibung hinzugefügt <i>{datetime}</i>',
          descriptionDeleted: '<span style="font-weight: bold">{user}</span> hat die Beschreibung gelöscht <i>{datetime}</i>',
          connectionChanged: '<span style="font-weight: bold">{user}</span> hat eine Verknüpfung entfernt <i>{datetime}</i>',
          executeFromChanged: '<span style="font-weight: bold">{user}</span> hat das Ausführungsdatum geändert <i>{datetime}</i>',
          onSiteContactChanged: '<span style="font-weight: bold">{user}</span>  hat die Ansprechperson vor Ort geändert <i>{datetime}</i>'
        }
      },
      reference: {
        title: 'Referenz',
        referenceType: 'Referenz-Typ',
        WITHOUT: 'Ohne',
        ADVERT: 'Objekt',
        BUILDING: 'Gebäude',
        GROUP: 'Portfolio'
      },
      source: {
        title: 'Quelle',
        undefinedSource: 'Unbekannt',
        mail: 'E-Mail',
        phone: 'Telefon',
        other: 'Andere'
      },
      priority: {
        title: 'Priorität',
        default: 'Normal',
        low: 'Niedrig',
        high: 'Hoch'
      },
      type: {
        title: 'Typ',
        undefined: 'Undefiniert',
        damage: 'Schaden'
      },
      status: {
        title: 'Status',
        TICKET_STATUS_OPEN: 'Offen',
        TICKET_STATUS_IN_PROGRESS: 'In Bearbeitung',
        TICKET_STATUS_DONE: 'Fertig',
        TICKET_STATUS_CLOSED: 'Geschlossen',
        TICKET_STATUS_DRAFT: 'Entwurf',
        acceptOrder: 'Auftrag annehmen',
        declineOrder: 'Auftrag ablehnen',
        finishOrder: 'Auftrag abschliessen',
        reason: 'Grund (optional)'
      },
      notes: {
        title: 'Interne Notizen'
      },
      activities: {
        title: 'Aktivitäten',
        created: 'hat das Ticket erstellt',
        assignee: 'hat den Verantwortlichen geändert',
        added: 'hat eine Person hinzugefügt',
        removed: 'hat eine Person entfernt',
        type: 'hat den Typ geändert:',
        status: 'hat den Status geändert:',
        reference: 'hat die Referenz geändert:',
        deleteActivity: {
          title: 'Activität löschen',
          text: 'Willst du die Aktivität unwiderruflich löschen?'
        }
      },
      showAll: 'Alle anzeigen',
      hideAll: 'Weniger anzeigen',
      filters: {
        property: 'Liegenschaft',
        building: 'Gebäude',
        owner: 'Eigentümer',
        involvedPeople: 'Beteiligte Personen',
        object: 'Objekt'
      },
      changeAssignee: 'Zuständiger wechseln',
      startWatching: 'Beobachtung starten',
      changeStatusModal: {
        title: 'Status ändern',
        text: 'Wählen Sie den neuen Status für das/die Ticket(s)'
      },
      deleteTicketModal: {
        title: 'Ticket löschen',
        text: 'Willst du wirklich alle ausgewählten Tickets in den Papierkorb verschieben?'
      },
      changeConditionModal: {
        title: 'Zustand Bauteil/Gerät anpassen'
      }
    },
    dashboard: {
      hello: 'Hallo',
      whatToDo: ', was möchtest du tun?',
      propertyOnline: 'Online Inserate',
      propertyTotal: 'Total Inserate',
      openMessages: 'Offene Nachrichten',
      requests: 'Anfragen',
      messagesAdminExplanation: 'Da du Administrator bist, siehst du hier die Anzahl Anfragen aller Benutzer.',
      messagesNotAdminExplanation: 'Da du kein Administrator bist, siehst du hier nur die Anzahl deiner Anfragen.',
      appointmentsTotal: 'Total Termine',
      appointmentsWeek: 'Diese Woche',
      appointmentsAdminExplanation: 'Da du Administrator bist, siehst du hier die Anzahl der Termine aller Benutzer.',
      appointmentsNotAdminExplanation: 'Da du kein Administrator bist, siehst du hier nur die Anzahl deiner Termine.',
      myListing: 'Meine Inserate',
      news: 'Nachrichten',
      event: 'Termine',
      services: 'Serviceangebot',
      priceHubbleText: 'Professionelles Verkaufsexposé',
      poweredBy: 'powered by',
      learnMore: 'Mehr erfahren',
      exportCalendar: 'Kalender exportieren',
      allRentalObjects: 'Alle Mietobjekte',
      marketing: {
        upcomingEvents: 'Meine anstehenden Termine',
        reminders: 'Meine Reminder',
        newObjects: 'Neue Objekte',
        newRequests: 'Neue Anfragen',
        myNewRequests: 'Meine neuen Anfragen',
        unreadRequests: 'Alle Rückmeldungen',
        myUnreadRequests: 'Meine Rückmeldungen',
        viewingAppointmentsThisWeek: 'Vermarktungstermine - Woche',
        eventsThisWeek: 'Termine - Woche',
        eventsToday: 'Termine - Heute',
        myObjects: 'Meine Objekte',
        allObjects: 'Alle Objekte',
        inMarketing: 'In Vermarktung',
        online: 'Davon online',
        since4weeks: '> 4 Wo.',
        since8weeks: '> 8 Wo.',
        since12weeks: '> 12 Wo.',
        showAll: 'alle anzeigen',
        noEntries: 'Keine Einträge'
      },
      admin: {
        vacancyRate: 'Leerstand',
        vacancyRateTooltip: '% von Nettomiete',
        newMessages: 'Nachrichten',
        properties: 'Liegenschaften',
        eventsToday: 'Termine - Heute',
        buildings: 'Gebäude',
        eventsThisWeek: 'Termine diese Woche',
        overall: 'Gesamt',
        published: 'Inseriert',
        inMarketing: 'In Vermarktung',
        notInMarketing: 'Nicht in Vermarktung',
        vacancy: 'Leerstand'
      },
      rentalObjects: {
        Admin: {
          vacancy: 'Alle Objekte die du für die Bewirtschaftung erhalten hast und Stand heute einen Leerstand haben.',
          notInMarketing: 'Alle Objekte die du für die Bewirtschaftung erhalten hast und noch nicht in für die Vermarktung freigegeben worden sind.',
          inMarketing: 'Alle Objekte die du für die Bewirtschaftung erhalten hast und die für die Vermarktung freigegeben worden sind. Dies muss nicht zwingend der Anzahl der Objekte in deiner Vermarktung entsprechen, sollten die Dienstleistungen für ein Objekt an unterschiedliche Firmen zugewiesen worden sein.',
          published: 'Alle Objekte die du für die Bewirtschaftung erhalten hast und auf mindestens einem Marktplatz publiziert werden. Dies muss nicht der Anzahl der Online-Objekte in deiner Vermarktung entsprechen, sollten die Dienstleistungen für ein Objekt an unterschiedliche Firmen zugewiesen worden sein.'
        },
        Asset: {
          vacancy: 'Alle Objekte die du für das Assetmanagement erhalten hast und Stand heute einen Leerstand haben.',
          notInMarketing: 'Alle Objekte die du für das Assetmanagement erhalten hast und noch nicht für die Vermarktung freigegeben worden sind.',
          inMarketing: 'Alle Objekte die du für das Assetmanagement erhalten hast und die für die Vermarktung freigegeben worden sind.',
          published: 'Alle Objekte die du für das Assetmanagement erhalten hast und auf mindestens einem Marktplatz publiziert werden. '
        },
        Accounting: {
          vacancy: 'Alle Objekte die du für die Buchhaltung erhalten hast und Stand heute einen Leerstand haben.',
          notInMarketing: 'Alle Objekte die du für die Buchhaltung erhalten hast und noch nicht für die Vermarktung freigegeben worden sind.',
          inMarketing: 'Alle Objekte die du für die Buchhaltung erhalten hast und die für die Vermarktung freigegeben worden sind.',
          published: 'Alle Objekte die du für die Buchhaltung erhalten hast und auf mindestens einem Marktplatz publiziert werden. '
        },
        Owner: {
          vacancy: 'Alle deine Objekte die Stand heute einen Leerstand haben.',
          notInMarketing: 'Alle deine Objekte die noch nicht für die Vermarktung freigegeben worden sind.',
          inMarketing: 'Alle deine Objekte die für die Vermarktung freigegeben worden sind.',
          published: 'Alle deine Objekte die auf mindestens einem Marktplatz publiziert werden.'
        }
      }
    },
    howitworks: {
      menu: {
        home: 'HOME',
        business: 'BUSINESS',
        rent: 'MIETEN / KAUFEN'
      },
      contact: {
        title: 'Schreibe uns',
        question: 'Schreibe deine Frage hier'
      },
      title: 'Die Plattform mit digitalen Services rund um die Immobilie',
      block1Text: 'Vermarkten und verwalten Sie ihre Objekte, nutzen Sie einfache Kommunikationswege, erweitern Sie ihr Netzwerk und schaffen Sie nachhaltige Kundenbindung.</br> </br> Buchen Sie die vorgefertigten Modulbausteine entsprechend Ihren Bedürfnissen. Dank unbegrenzter Skalierbarkeit vermarkten und verwalten Sie ihr Portfolio, unabhängig wie viele Objekte Sie im Bestand haben.</br> </br>Steigern Sie die Produktivität und digitalisieren Sie ihre Prozesse.',
      icon1Title: 'Intelligente Schnittstelle',
      icon1Text: 'Erfolgreich publizieren Sie ihre Objekte auf Knopfdruck auf allen gängigen Immobilienportalen.',
      icon2Title: 'Anfragen sammeln',
      icon2Text: 'Portalunabhängig alle Anfragen an einem Ort objekt- und personenbezogen gesammelt.',
      icon3Title: 'Besichtigungstermine',
      icon3Text: 'Organisieren Sie alle Ihre Besichtigungstermine strukturiert im propbase.ch Kalender und exportieren Sie diesen.',
      icon4Title: 'Digitales Anmeldeformular',
      icon4Text: 'Mietinteressenten erhalten einen kundenfreundlichen und digitalen Anmeldeprozess.',
      icon5Title: 'Interessentenauswahl',
      icon5Text: 'Finden Sie rasch und zeitsparend adäquate Mieter oder Käufer mittels Scoring.',
      icon6Title: 'Verwalten',
      icon6Text: 'Bewirtschaften Sie effizient, zuverlässig und kompetent alle Ihre Objekte an einem Ort.',
      block2Title: 'Effektive Immobilienvermarktung',
      block2Text: 'Der Service Vermarktung der PropBase dient als Schnittstelle zwischen den Inserierenden und den Immobilienportalen.<br>  Veröffentlichen Sie Ihre Inserate auf der benutzerfreundlichen Oberfläche und legen Sie mit nur wenigen Klicks fest auf welchen Portalen Sie veröffentlichen möchten.<br>  Managen Sie eingehende Anfragen an nur einem Ort. Kommunizieren Sie mit den Interessenten im PropBase-Messenger oder direkt per Mail und vereinbaren Sie effizient die Besichtigungstermine.<br> Versenden Sie das digitale Anmeldeformular sowie Dokumentationen um rasch den optimalen Interessenten zu selektieren.',
      block3Title: 'Clevere Immobilienverwaltung',
      block3Text: 'Bewirtschafter, Vermarkter, Eigentümer oder Dienstleister, PropBase ist Ihr innovativer und effizienter Helfer.<br>  Mit dem Kommunikations- und Service-Modul Verwaltung erledigen Sie professionell und übersichtlich Ihre Tätigkeiten. Dies spart unnötige Kommunikationswege und bietet allen einen langfristigen Mehrwert, führt zu mehr Kundennähe und Qualität.<br>  Kontakte, Liegenschaften, Nachrichten, Schadensmanagement, ein übersichtliches Dokumentenmanagement, digitale Pinnwand für Mieter und vieles mehr.<br> Für alle Ihre Immobilienangelegenheiten ist ab sofort propbase.ch der sichere Ort.',
      block4Title: 'Steigerung Ihrer Effizienz',
      block4Text: 'Durch die Digitalisierung erreichen Sie signifikante Effizienzgewinne bei der täglichen Arbeit als Immobilienexperte. <br>  Ihre Tätigkeiten sind dank der Digitalisierung optimal und zeitsparend gestaltet. <br> Nutzen Sie unser Kontaktformular oder rufen Sie uns einfach an.',
      block5Title: 'Beginnen Sie jetzt mit der Digitalisierung ihrer Prozesse',
      block5Text: 'Erstellen Sie ihr Profil bei PropBase oder kontaktieren Sie uns.',
      getRegister: 'Jetzt registrieren',
      calculationText: 'Gebe Sie die Anzahl ihrer Immobilien-Objekte an:',
      calculationResult1: 'Bis zu',
      calculationResult2: 'Immobilien-Objekte MEHR verwalten'
    },
    applicationFromLanding: {
      iconSection: {
        title: 'Bewerben in 4 Schritten und jederzeit wiederverwenden',
        text1: 'Auf <<Jetzt Bewerben>> klicken',
        text2: 'Registrieren',
        text3: 'Anmeldeformular ausfüllen',
        text4: 'Anmeldeformular absenden'
      },
      propertySection: {
        title: 'Online Bewerbung einreichen',
        owner: 'Anbieter',
        object: 'Objekt',
        button: 'Jetzt Bewerben!'
      },
      screenSection: {
        title: 'Deine Vorteile',
        text0: 'Kostenlos',
        text1: 'Anmeldeformular nur einmal anlegen',
        text2: 'Notwendige Dokumente hochladen',
        text3: 'Anmeldeformular für andere Mietobjekte nutzen',
        text4: 'Deine Bewerbungen verwalten',
        text5: 'Einfache Kommunikation'
      },
      backgroundSection: {
        title: 'Einfach, clever und digital',
        text: 'PropBase ist dein innovativer und effizienter Helfer: Nachrichten, Inserate, Besichtigungstermine und ein übersichtliches Dokumentenmanagement. Für alle deine Immobilienangelegenheiten ist ab sofort propbase.ch der sichere Ort.'
      }
    },
    landingPage: {
      title: 'Die Plattform mit digitalen Services rund um die Immobilie',
      subTitle: 'Ihre Immobilienangelegenheiten gestalten sich immer komplexer, kostenintensiver und zeitraubender?',
      block1: 'Richten Sie den Fokus auf Ihre Immobilienlösung, während PropBase Ihre Immobilienprozesse digitalisiert.',
      block2Title: 'Sie suchen ein neues Zuhause?',
      block2: 'Entdecken Sie PropBase für Immobiliensuchende',
      copyright: 'Copyright © 2020 Alle Rechte vorbehalten PropBase AG',
      business: 'BUSINESS',
      rent: 'MIETEN / KAUFEN'
    },
    help: {
      title: 'Willkommen bei den PropBase FAQs',
      leftTitle: 'Kategorien',
      rightTitle: 'Häufig gestellte Fragen',
      placeholder: 'Wie können wir dir helfen?'
    },
    noProducts: {
      title: 'Willkommen bei PropBase!',
      description: 'Derzeit ist noch kein Modul für Sie freigeschaltet.',
      contactStart: 'Ihr persönlicher Ansprechpartner meldet sich bei Ihnen und begleitet Sie bei Ihrem Start.',
      contact: 'Oder setzen Sie sich sofort mit uns in Verbindung unter der Telefonnummer: +41 44 512 76 77 / E-Mail: support@propbase.ch.',
      greeting: 'Gute Zusammenarbeit und viel Erfolg bei der Vermarktung Ihrer Immobilien wünscht ihr PropBase Team'
    },
    registration: {
      title: 'Registrierung',
      password: 'Passwort',
      repeatPassword: 'Passwort wiederholen',
      setPassword: 'Passwort setzen'
    },
    openMessagesOverview: {
      title: 'Offene Nachrichten',
      received: 'Empfangen'
    },
    openMessagesBulkReply: {
      title: 'Sammelnachricht',
      noPersonSelected: 'Keine Personen ausgewählt',
      template: {
        reject: 'Absage',
        rejectValue: 'Vielen Dank für deine Bewerbung.\n\nLeider können wir dir keine Zusage für dieses Objekt geben.\nFür deine weitere Suche wünschen wir dir weiterhin alles Gute.\n\nFreundliche Grüsse\n{fullName}',
        appointment: 'Besichtigung',
        appointmentValue: 'Vielen Dank für Ihr Interesse an unserem Objekt.\n\nFür die Vereinbarung eines Besichtigungstermins melden Sie sich bitte bei\nHerrn / Frau XXX unter Tel.: … …, tagsüber zwischen XX:XX und XX:XX Uhr.\n\nBesten Dank und freundliche Grüsse\n{fullName}'
      }
    },
    marketplace: {
      title: 'Marktplatz'
    },
    advertisementsOverview: {
      title: 'Meine Inserate',
      setClient: 'Netzwerkpartner wählen',
      setAssignee: 'Zuständigen wählen',
      setExportPlatforms: 'Export-Plattformen',
      matching: {
        info: 'Es gingen externe Anfragen ein, welche nicht eindeutig einem deiner Inserate zugeordnet werden konnten. Du solltest diese zuordnen um PropBase optimal nutzen zu können. Klicke dazu einfach auf den/die untenstehenden Link(s).',
        noTitle: '<Kein Titel>'
      }
    },
    propertiesView: {
      title: 'Liegenschaften',
      filter: {
        name: 'Lg.-Bez.',
        city: 'Stadt',
        buildingCount: 'Gebäudeanzahl'
      },
      name: 'Liegenschafts-Bezeichnung',
      number: 'Liegenschafts-ID',
      documents: 'Allgemeine Liegenschaftsdokumente',
      keyDate: 'Stichtag HKNK',
      development: {
        title: 'Erschliessung',
        PROPERTY_DEVELOPMENT_UNDEFINED: '-',
        PROPERTY_DEVELOPMENT_FULL: 'Erschlossen',
        PROPERTY_DEVELOPMENT_PARTIAL: 'Teilerschlossen',
        PROPERTY_DEVELOPMENT_UNDEVELOPED: 'Nicht erschlossen'
      },
      egrid: 'E-GRID',
      landRegisterNumber: 'Parzellen Nummer',
      constructionZone: 'Bauzone',
      acquisitionDate: 'Übernahmedatum',
      optedPortionKey: {
        title: 'Schlüssel des optierten Anteils',
        OPTED_PORTION_KEY_M2: 'm²',
        OPTED_PORTION_KEY_M3: 'm³',
        OPTED_PORTION_KEY_VALUE_RATIO: 'Wertquote',
        OPTED_PORTION_KEY_TV: 'TV',
        OPTED_PORTION_KEY_ELEVATOR: 'Lift',
        OPTED_PORTION_KEY_LOCATION_COMPENSATION: 'Lageausgleich',
        OPTED_PORTION_KEY_UNIT: 'Einheit',
        OPTED_PORTION_KEY_NUMBER_OF_INHABITANTS: 'Anzahl Bewohner'
      },
      propertyType: {
        title: 'Liegenschaftstyp',
        PROPERTY_TYPE_RENTAL: 'Mietliegenschaft',
        PROPERTY_TYPE_CONDOMINIUM_OWNERSHIP: 'STWEG',
        PROPERTY_TYPE_COOPERATIVE: 'Genossenschaft',
        PROPERTY_TYPE_UNDEFINED: 'Undefiniert'
      },
      tabs: {
        property: 'Liegenschaft',
        buildings: 'Gebäude',
        landRegister: 'Parzelle'
      },
      deleteConfirmation: {
        title: 'Liegenschaft löschen',
        text: 'Diese Liegenschaft(en) mit allen dazugehörigen Gebäuden und Objekten löschen?'
      },
      createProperty: 'Liegenschaft anlegen',
      property: 'Liegenschaft',
      transferPropertiesAction: 'Liegenschaft/en mit Abacus synchronisieren',
      transferPropertiesConfirmationBody: 'Möchtest du die Liegenschaft/en in Abacus übertragen? Achtung: Dieser Vorgang kann nicht rückgängig gemacht werden.',
      addBuilding: 'Gebäude hinzufügen',
      deleteRentAdjustment: 'Delete rent adjustments',
      deleteRentAdjustmentDateInput: 'Rent adjustment date',
      objectCount: 'Anzahl',
      successMessageCreation: 'Liegenschaft erstellt',
      noExactValue: 'Ziel Netto- und Bruttomiete wurden nicht auf allen Objekten in der Mietzins-Potenzial Kachel ausgefüllt.',
      rentComponents: {
        title: 'Mietzinsbestandteile',
        advancePaymentRentComponents: {
          advancePayment: 'Akonto',
          ADVANCE_PAYMENT_RENT_COMPONENT_GENERAL_ELECTRICITY: 'Allgemeinstrom',
          ADVANCE_PAYMENT_RENT_COMPONENT_MAINTENANCE_GARDEN_SURROUNDING: 'Hauswartung/Garten/Umgebung',
          ADVANCE_PAYMENT_RENT_COMPONENT_MAINTENANCE_ELECTRICITY_WATER_SEWAGE: 'Hauswartung/Strom/Wasser/Abwasser',
          ADVANCE_PAYMENT_RENT_COMPONENT_HEATING_HOT_WATER: 'Heiz- und Warmwasserkosten',
          ADVANCE_PAYMENT_RENT_COMPONENT_HEATING: 'Heizkosten',
          ADVANCE_PAYMENT_RENT_COMPONENT_GARBAGE: 'Kehricht',
          ADVANCE_PAYMENT_RENT_COMPONENT_GARBAGE_MAINTENANCE: 'Kehricht/Hauswartung',
          ADVANCE_PAYMENT_RENT_COMPONENT_TV: 'Multimedia Gebühren',
          ADVANCE_PAYMENT_RENT_COMPONENT_ELECTRICITY_MAINTENANCE_GARBAGE: 'Strom/Hauswartung/Kehricht',
          ADVANCE_PAYMENT_RENT_COMPONENT_ELECTRICITY_WATER_SEWAGE: 'Strom/Wasser/Abwasser',
          ADVANCE_PAYMENT_RENT_COMPONENT_ELECTRICITY_WATER_SEWAGE_MAINTENANCE: 'Strom/Wasser/Abwasser/Hauswartung',
          ADVANCE_PAYMENT_RENT_COMPONENT_ELECTRICITY_WATER_SEWAGE_GARBAGE: 'Strom/Wasser/Abwasser/Kehricht',
          ADVANCE_PAYMENT_RENT_COMPONENT_ELECTRICITY_WATER_SEWAGE_GARBAGE_MAINTENANCE: 'Strom/Wasser/Abwasser/Kehricht/Hauswartung',
          ADVANCE_PAYMENT_RENT_COMPONENT_ELECTRICITY_WATER_SEWAGE_GARBAGE_ELEVATOR: 'Strom/Wasser/Abwasser/Kehricht/Lift',
          ADVANCE_PAYMENT_RENT_COMPONENT_WATER_SEWAGE: 'Wasser/Abwasser',
          ADVANCE_PAYMENT_RENT_COMPONENT_WATER_SEWAGE_MAINTENANCE: 'Wasser/Abwasser/Hauswartung',
          ADVANCE_PAYMENT_RENT_COMPONENT_WATER_SEWAGE_GARBAGE: 'Wasser/Abwasser/Kehricht',
          ADVANCE_PAYMENT_RENT_COMPONENT_ADDITIONAL_COSTS: 'Nebenkosten',
          ADVANCE_PAYMENT_RENT_COMPONENT_HEATING_ADDITIONAL_COSTS: 'Heiz- und Nebenkosten',
          ADVANCE_PAYMENT_RENT_COMPONENT_MAINTENANCE: 'Hauswartung',
          ADVANCE_PAYMENT_RENT_COMPONENT_ELECTRICITY_WATER: 'Strom/Wasser',
          ADVANCE_PAYMENT_RENT_COMPONENT_ELEVATOR: 'Lift',
          ADVANCE_PAYMENT_RENT_COMPONENT_SERVICE_MINERGIE_VENTILATION: 'Service/Reinigung Lüftung (Minergie)',
          ADVANCE_PAYMENT_RENT_COMPONENT_SEE_CONTRACT: 'Nebenkosten gemäss Detail',
          ADVANCE_PAYMENT_RENT_COMPONENT_E_CHARGING_STATION: 'E-Ladestation'
        },
        flatRateRentComponents: {
          flatRate: 'Pauschal',
          FLAT_RATE_RENT_COMPONENT_MAINTENANCE_GARDEN_SURROUNDING: 'Hauswartung/Garten/Umgebung',
          FLAT_RATE_RENT_COMPONENT_HEATING_HOT_WATER: 'Heiz- und Warmwasserkosten',
          FLAT_RATE_RENT_COMPONENT_HEATING: 'Heizkosten',
          FLAT_RATE_RENT_COMPONENT_GARBAGE: 'Kehricht',
          FLAT_RATE_RENT_COMPONENT_ELEVATOR: 'Lift',
          FLAT_RATE_RENT_COMPONENT_TV: 'Multimedia Gebühren',
          FLAT_RATE_RENT_COMPONENT_ELECTRICITY: 'Strom',
          FLAT_RATE_RENT_COMPONENT_ELECTRICITY_GARBAGE: 'Strom/Kehricht',
          FLAT_RATE_RENT_COMPONENT_ELECTRICITY_WATER_SEWAGE: 'Strom/Wasser/Abwasser',
          FLAT_RATE_RENT_COMPONENT_ELECTRICITY_WATER_SEWAGE_GARBAGE: 'Strom/Wasser/Abwasser/Kehricht',
          FLAT_RATE_RENT_COMPONENT_WATER_SEWAGE: 'Wasser/Abwasser',
          FLAT_RATE_RENT_COMPONENT_WATER_SEWAGE_GARBAGE: 'Wasser/Abwasser/Kehricht',
          FLAT_RATE_RENT_COMPONENT_ADDITIONAL_COSTS: 'Nebenkosten',
          FLAT_RATE_RENT_COMPONENT_WATER: 'Wasser',
          FLAT_RATE_RENT_COMPONENT_MAINTENANCE: 'Hauswartung',
          FLAT_RATE_RENT_COMPONENT_SERVICE_MINERGIE_VENTILATION: 'Service/Reinigung Lüftung (Minergie)',
          FLAT_RATE_RENT_COMPONENT_DISH_WASHER: 'Geschirrspülmaschine',
          FLAT_RATE_RENT_COMPONENT_FREEZER: 'Tiefkühltruhe',
          FLAT_RATE_RENT_COMPONENT_SEE_CONTRACT: 'Nebenkosten gemäss Detail',
          FLAT_RATE_RENT_COMPONENT_BUDGET_EXPECTATIONS: 'Budgeterwartungen',
          FLAT_RATE_RENT_COMPONENT_RENOVATION_FUND: 'Erneuerungsfonds',
          FLAT_RATE_RENT_COMPONENT_IN_FAVOR_OF_PROPERTY_1: 'Pauschale zu Gunsten Liegenschaft 1',
          FLAT_RATE_RENT_COMPONENT_IN_FAVOR_OF_PROPERTY_2: 'Pauschale zu Gunsten Liegenschaft 2',
          FLAT_RATE_RENT_COMPONENT_IN_FAVOR_OF_PROPERTY_3: 'Pauschale zu Gunsten Liegenschaft 3',
          FLAT_RATE_RENT_COMPONENT_IN_FAVOR_OF_ADDITIONAL_COSTS_1: 'Pauschale zu Gunsten Nebenkosten 1',
          FLAT_RATE_RENT_COMPONENT_IN_FAVOR_OF_ADDITIONAL_COSTS_2: 'Pauschale zu Gunsten Nebenkosten 2',
          FLAT_RATE_RENT_COMPONENT_IN_FAVOR_OF_ADDITIONAL_COSTS_3: 'Pauschale zu Gunsten Nebenkosten 3'
        },
        additionalRentComponents: {
          title: 'Weitere Mietzinsbestandteile',
          ADDITIONAL_RENT_COMPONENT_RENT_REDUCTION: 'Mietzinsreduktion',
          ADDITIONAL_RENT_COMPONENT_RENT: 'Miete',
          ADDITIONAL_RENT_COMPONENT_ADDED_VALUE_E_CHARGING_STATION: 'Mehrwert E-Ladestation',
          ADDITIONAL_RENT_COMPONENT_TENANT_IMPROVEMENT: 'Mieterausbau',
          ADDITIONAL_RENT_COMPONENT_AMORTIZATION: 'Amortisation'
        },
        transmitData: 'Daten übertragen',
        transmitDataTooltip: 'Daten werden definitiv in die Buchhaltung übertragen und können nach dem Speichern nicht mehr angepasst oder gelöscht werden.'
      },
      distributionKeys: {
        title: 'Schlüsselwerte',
        key: 'Schlüssel',
        value: 'Wert',
        m2: 'm²',
        m3: 'm³',
        valueRatio: 'Wertquote',
        tv: 'TV-Schlüssel',
        elevator: 'Lift',
        locationCompensation: 'Lageausgleich'
      },
      createLandRegister: {
        title: 'Parzellen',
        add: 'Parzellen hinzufügen',
        edit: 'Parzellen bearbeiten',
        cadastralValue: 'Katasterwert',
        plotPurchasePrice: 'Kaufpreis Parzelle',
        plotType: 'Grundstückart',
        utilizationZone: 'Nutzungszone',
        noiseSensitivity: 'Lärmempfindlichkeit',
        remark: 'Anmerkungen',
        easement: 'Dienstbarkeiten',
        priorityNotices: 'Vormerkungen',
        realEstateRights: 'Grundpfandrechte',
        inventories: 'Inventare',
        load: 'Belastungen',
        landRegisterDocuments: 'Parzellendokumente',
        delete: 'Parzelle löschen',
        formOfOwnership: 'Eigentumsform',
        category: {
          title: 'Kategorie',
          type: {
            PLOT_CATEGORY_PLOT: 'Grundstück',
            PLOT_CATEGORY_PURCHASE_CONTRACT: 'Kaufrechtsvertrag',
            PLOT_CATEGORY_BUILDING_RIGHT: 'Baurecht',
            PLOT_CATEGORY_DEVELOPMENT_AGREEMENT: 'Entwicklungsvereinbarung',
            PLOT_CATEGORY_UNSOLD_CONDOMINIUM: 'Unverkaufte STWEG',
            PLOT_CATEGORY_UNDEFINED: '-'
          }
        },
        operation: {
          title: 'Betrieb',
          type: {
            PLOT_OPERATION_WITH_OPERATION: 'mit Betrieb',
            PLOT_OPERATION_WITHOUT_OPERATION: 'ohne Betrieb',
            PLOT_OPERATION_UNDEFINED: '-'
          }
        },
        purchaseDate: 'Kaufdatum',
        termUntil: 'Laufzeit bis',
        promissoryNote: 'Schuldbrief',
        strategy: {
          title: 'Strategie',
          type: {
            PLOT_STRATEGY_CONTINUE_WITHOUT_RENOVATION: 'Weiterführen ohne Sanierung',
            PLOT_STRATEGY_MAINTAIN: 'Instandhalten',
            PLOT_STRATEGY_REPAIR: 'Instandsetzen',
            PLOT_STRATEGY_REPLACEMENT_NEW_CONSTRUCTION: 'Ersatz Neubau',
            PLOT_STRATEGY_SALE: 'Verkauf',
            PLOT_STRATEGY_UNDEFINED: '-'
          }
        },
        reviewStrategy: 'Strategie überprüfen'
      },
      hasntBeenAbacusSynchronized: 'Bitte kontaktiere den Support um die Synchronisierung des neuen Eigentümers zu starten',
      toolTipAccountantAleadySet: 'Es ist bereits ein Buchhalter gesetzt. Bitte kontaktiere den Support, um den Buchhalter zu wechseln.'
    },
    matchSuggested: {
      title: 'Anfrage zuordnen',
      message: 'Anfragenachricht:',
      explanation: 'Untenstehend ist die neue Anfrage und das daraus resultierende Objekt gelistet. Daneben sind Objekte gelistet, welche dem der Anfrage ähnlich sind. Ordne die Anfrage dem tatsächlichen Objekt zu. Trifft keines zu, wähle \'Keine Übereinstimmungen\', um in den nächsten Schritt zu gelangen.',
      noMatches: 'Keine Übereinstimmungen'
    },
    matchManual: {
      title: 'Anfrage zuordnen',
      message: 'Anfragetext:',
      explanation: 'Untenstehend ist die neue Anfrage und das daraus resultierende Objekt gelistet. Daneben sind Objekte gelistet, welche dem der Anfrage ähnlich sind. Ordne die Anfrage dem tatsächlichen Objekt zu. Trifft keines zu, wähle \'Keine Übereinstimmungen\', um in den nächsten Schritt zu gelangen.',
      newObject: 'Neues Objekt anlegen',
      noMatchingFilter: 'Es gibt keine Objekte, die Ihren Filterkriterien entsprechen.'
    },
    advertisementManagementOverview: {
      title: 'Objekt',
      object: 'Objekt',
      deletion: {
        confirmation: {
          title: 'Objekt löschen',
          text: 'Diese(s) Objekt(e) nur dann löschen wenn diese(s) aus Versehen erstellt wurden! Objekt(e) wird in allen Modulen gelöscht. Objekt(e) löschen?'
        },
        deleting: 'Löschen...'
      },
      menu: {
        advert: 'Inserat',
        settings: 'Einstellungen',
        interestedParties: 'Interessenten',
        documents: 'Dokumente',
        contacts: 'Kontakte'
      },
      involvedContact: {
        client: 'Mandant',
        noAssignees: 'Keine zuständigen Kontakte gesetzt',
        assigneeManagementMarketing: 'Zuständiger Vermarkter & Bewirtschafter',
        assigneeManagement: 'Zuständiger Bewirtschaftung',
        assigneeMarketing: 'Zuständiger Vermarktung',
        assigneeOwner: 'Zuständiger Eigentümer',
        assigneeAsset: 'Zuständiger Asset Manager',
        assigneeAccounting: 'Zuständige Buchhaltung'
      }
    },
    manageDocuments: {
      noDocuments: 'Keine Dokumente',
      documents: 'Dokumente',
      document: 'Dokument',
      addDocument: 'Dokument hinzufügen',
      name: 'Name',
      documentName: 'Dokument Name',
      user: 'Benutzer',
      uploaded: 'Hochgeladen',
      version: {
        title: 'Version',
        current: 'Aktuelle Version',
        all: 'Alle Versionen',
        add: 'Version hinzufügen',
        new: 'Neue Version',
        showAllVersion: 'alle Versionen anzeigen',
        showCurrentVersion: 'aktuelle Version anzeigen'
      },
      type: {
        title: 'Dokumententyp',
        no_type: 'kein Typ',
        other: 'Sonstige',
        application_form: 'Anmeldeformular',
        instruction_manual: 'Bedienungsanleitungen',
        credit_check: 'Bonitätsprüfung',
        owners_meeting: 'Eigentümerversammlung',
        pay_in_slip: 'Einzahlungsscheine',
        energy_certificate: 'Energieausweis',
        warranty_certificate: 'Garantieschein',
        building_plan: 'Pläne',
        house_regulation: 'Hausregeln',
        bank_statement: 'Kontoauszug',
        additional_costs_bill: 'Nebenkostenabrechnung',
        invoice: 'Rechnungen',
        sepa_direct_debit_mandate: 'SEPA Lastschriftmandat',
        handover_protocol: 'Übergabeprotokoll',
        decision: 'Verfügung',
        agreement: 'Vereinbarung',
        contract: 'Vertrag',
        deposit_confirmation: 'Kautionsbestätigung',
        building_insurance_policy: 'Versicherungspolice',
        key_list: 'Schlüsselverzeichnis',
        termination_doc_type: 'Kündigung',
        rent_adjustment_doc_type: 'Mietzinsanpassung',
        references_doc_type: 'Referenzen',
        maintenance_contract_doc_type: 'Wartungsvertrag',
        regulations: 'Reglement',
        regulations_for_use_and_management: 'Nutzungs- und Verwaltungsordnung',
        annual_financial_statement: 'Jahresabschluss',
        purchase_contract_and_land_register: 'Grundbuchsauszug',
        purchase_contract: 'Kaufvertrag',
        land_register: 'Grundbuchsauszug',
        condominium_ownership: 'STWEG',
        renewal_fond: 'Erneuerungsfond',
        mortgage: 'Hypothek',
        order: 'Auftrag',
        offer: 'Offerte',
        identity: 'Ausweisdokumente',
        extract_from_debt_collection_register: 'Betreibungsregisterauszug',
        bank_account_details: 'Kontoverbindung',
        situation_plan: 'Situationsplan',
        construction_law_agreement: 'Baurechtsvertrag',
        easement_agreement: 'Dienstbarkeitsvertrag',
        cadastral_estimate: 'Katasterschätzung',
        letter: 'Brief',
        trade_register_excerpt: 'Handelsregisterauszug',
        payment_reminder: 'Zahlungserinnerungen/Mahnung',
        protocol: 'Protokoll',
        court_doc_type: 'Gerichtsdokumente',
        honorarium: 'Honorar',
        budget: 'Budget',
        official_estimate: 'Amtliche Schätzung',
        building_description: 'Baubeschrieb',
        permits: 'Bewilligungen',
        legal_matters: 'Rechtliches'
      },
      tooltipShowInPortal: 'Das Portal ist für dieses Objekt nicht aktiv.'
    },
    managementOverview: {
      properties: 'Liegenschaften',
      groups: 'Portfolio',
      buildings: 'Gebäude',
      objects: 'Objekte',
      marketing: 'Vermarktung',
      rentPrice: 'Mietpreis',
      createGroup: 'Portfolio erstellen',
      addToGroup: 'Zu Portfolio hinzufügen',
      createObject: 'Objekt anlegen',
      changePortfolioName: 'Portfolio Name ändern'
    },
    managementGroup: {
      buildingCount: 'Gebäudeanzahl',
      objectCount: 'Objektanzahl',
      apartments: 'Wohnung',
      commercial: 'Gewerbe',
      parkingSpaces: 'Parkplätze',
      vacant: 'Leerstand',
      objectMarketing: 'Objekte Vermarktung',
      deleteConfirmation: {
        title: 'Portfolio löschen',
        text: 'Das Portfolio löschen?'
      }
    },
    serialLetterProcess: {
      defineLetterContent: 'Briefinhalt definieren',
      defineLetterContentHeadline: 'Hier kannst du den Betreff und den Brieftext für die Vorlage \'Serienbrief\' definieren. Wenn du keinen Briefinhalt definieren möchtest, kannst du über den "Weiter"- Button einfach zu Step 2 navigieren.',
      subject: 'Betreff',
      letterText: 'Brieftext',
      chooseTemplate: 'Vorlage auswählen',
      step3: {
        createAcollectionDocument: 'Möchtest du ein Sammeldokument für jede ausgewählte Vorlage erstellen?',
        NdocumentsAreGenerated: 'Vorschau:       Es werden {x} Dokumente generiert',
        oneDocumentisCreated: 'Vorschau:       Es wird 1 Dokument erstellt',
        documentAssignedToContacts: 'Soll das Dokument im Anschluss den Kontakten zugeordnet werden?',
        documentAssignedToContactsTooltip: 'Wenn für jede ausgewählte Vorlage nur ein Dokument erstellt werden soll, ist es nicht möglich dieses zu einem Kontakt zuzuordnen.',
        documentAssignedToTenancies: 'Soll das Dokument im Anschluss den Vermietungen zugeordnet werden?',
        documentAssignedToTenanciesTooltip: 'Wenn für jede ausgewählte Vorlage nur ein Dokument erstellt werden soll, ist es nicht möglich dieses zu einer Vermietung zuzuordnen.',
        showDocumentInPortal: 'Möchtest du dieses Dokument im Portal anzeigen?',
        showDocumentInPortalTooltip: 'Einige Objekte haben ein nicht aktives Portal und erhalten daher keine Benachrichtigungen.',
        documentNamed: 'Wie sollte das Dokument benannt werden?',
        documentName: 'Dokumentname',
        createSerialLetter: 'Serienbrief erstellen',
        documentAssignedToOneContact: 'Soll das Dokument im Anschluss dem Kontakt zugeordnet werden?',
        documentAssignedToOneTenancy: 'Soll das Dokument im Anschluss der Vermietung zugeordnet werden?',
        includeRoommate: 'Willst du die Mitbewohner im Brief adressieren?',
        sorting: {
          title: 'Sortierung',
          desiredSortingLetter: 'Gewünschte Sortierung der Briefe',
          sortPropbaseStandard: 'Propbase Standard (Aktuelle Sortierung)',
          sortByAddressNumber: 'Nach Adressnummer'
        },
        sendToBriefbutler: 'Willst du diese(s) Dokument(e) mit BriefButler versenden?',
        errorSendToBriefbutler: 'Das Senden von Dokumenten ist fehlgeschlagen. Bitte versuche es erneut oder kontaktiere support@propbase.ch.'
      }
    },
    tableColumnHeadings: {
      industries: 'Branchen',
      notes: 'Bemerkungen',
      nameContact: 'Name',
      contractNumber: 'Vertragsnummer',
      owner: 'Eigentümer',
      note: 'Notiz',
      marketing: 'Vermarkter',
      administration: 'Bewirtschafter',
      asset: 'Asset Management',
      partner: 'Partner',
      ewid: 'EWID',
      info: 'Info',
      duration: 'Dauer',
      text: 'Text',
      propertyName: 'Lg.-Bez.',
      propertiesId: 'Lg.-ID',
      buildingId: 'Gbd.-ID',
      buildingsName: 'Gbd.-Bez.',
      objects: 'Obj.-Bez.',
      objectsCount: 'Objekte',
      previousTenancy: 'Vorheriger Mieter',
      newTenancy: 'Neuer Mieter',
      handoverDate: 'Übergabetermin',
      caution: 'Kaution',
      template: 'Interner Name',
      task: 'Aufgabe',
      order: 'Auftrag',
      tickets: 'Tickets',
      objectNumber: 'Obj.-Nummer',
      buildingStrategy: 'Gebäudestrategie',
      buildingStrategyReviewAt: 'Strategie überprüfen',
      numericId: 'Obj.-ID',
      addressNumber: 'Adr.-ID',
      platform: 'Anbieter',
      information: 'Informationen',
      offerType: 'Angebotstyp',
      title: 'Titel',
      status: 'Status',
      publishedAt: 'Veröffentlicht am',
      receivedOpened: 'Erhalten / Geöffnet',
      price: 'Mietpreis',
      address: 'Adresse',
      zipCity: 'PLZ/Ort',
      thumbnail: 'Foto',
      transferredToAccounting: 'BuHa',
      client: 'Mandant',
      contract: 'Contract',
      debtor: 'Debtor',
      lastTimeSynced: 'Last time synced',
      errorMessages: 'Error messages',
      responsibleMarketing: 'Verantwortlicher Vermarktung',
      responsibleManagement: 'Verantwortlicher Bewirtschaftung',
      adminAssignee: 'Zuständiger',
      assetAssignee: 'Zuständiger',
      condominiumOwner: 'Stockwerkeigentümer',
      valueQuota: 'Wertquote',
      totalValueQuota: 'Gesamtwertquote',
      valueQuotaBuilding: 'Wertquote Gebäude',
      floor: 'Etg.',
      levels: 'Anzahl Geschosse',
      rooms: 'Zi.',
      constructionYear: 'Baujahr',
      livingArea: 'Wfl.',
      mapArea: 'Fl.',
      area: 'Fläche',
      type: 'Typ',
      subType: 'Unterkategorie',
      grossRent: 'Bruttomiete',
      netRent: 'Nettomiete',
      additionalCosts: 'NK',
      coldRentPerMonth: 'Monatlicher Mietzins',
      heatingCosts: 'HK',
      utilities_HC: 'NK/HK',
      marketRent: 'Marktmiete',
      networkPartner: 'Netzwerkpartner',
      availability: 'Verfügbarkeit',
      reference: 'Referenz',
      tenant: 'Mieter',
      buildings: 'Gebäude',
      grossTargetRentYear: 'Brutto Soll/Jahr',
      grossActualRentYear: 'Brutto Ist/Jahr',
      netTargetRentYear: 'Netto Soll/Jahr',
      netActualRentYear: 'Netto Ist/Jahr',
      subject: 'Betreff',
      message: 'Nachricht',
      letter: 'Brieftext',
      from: 'Von',
      to: 'An',
      date: 'Datum',
      publicId: 'Objekt-Ref.',
      assignee: 'Zuständiger',
      signee: 'Unterzeichner',
      request: 'Anfragen',
      appointment: 'Besichtigungen',
      applicationForm: 'Anmeldungen',
      contactPersons: 'Kontaktpersonen',
      progress: 'Fortschritt',
      marketplaceName: 'Quelle',
      favorite: 'Favorit',
      description: 'Beschreibung',
      roleInBuilding: 'Rolle im Gebäude',
      category: 'Typ',
      condominiumObjects: 'STOWE-Objekte',
      viewingDone: 'Besichtigung durchgeführt',
      fieldName: 'Feldname',
      availableFrom: 'Verfügbar ab',
      logs: {
        success: 'Erfolgreich',
        time: 'Zeit',
        entity: 'Entität',
        id: 'ID',
        triggered: 'Ausgelöst durch',
        error: 'Fehler'
      },
      m2PerYear: 'm2/Jahr',
      marketNetRent: 'Markt Nettomiete',
      marketGrossRent: 'Markt Bruttomiete',
      targetNetRent: 'Ziel Nettomiete',
      targetGrossRent: 'Ziel Bruttomiete',
      subtenant: 'Untermieter',
      startOfContract: 'Vertragsstart',
      endOfContract: 'Vertragsende',
      tenanciePartner: 'Partner',
      tenancieObjectId: 'Obj.-ID',
      ownershipStart: 'Eigentumsstart',
      ownershipEnd: 'Eigentumsende',
      ownershipStarting: 'Eigentumsstart',
      ownershipEnding: 'Eigentumsende',
      roommate: 'Mitbewohner',
      debitUntil: 'Sollgestellt bis',
      noDebitUntil: {
        title: 'Nicht sollgestellt bis',
        tooltip: 'Wenn ‘Nicht sollgestellt bis’ und ein Datum ausgewählt ist, werden alle Objekte angezeigt welche nicht bis zu diesem Datum sollgestellt sind'
      },
      subCategory: 'Unterobjektart',
      noteForMarketing: 'Notiz für Vermarktung',
      viewingContact: 'Besichtigungskontakt',
      HeatingAdditionalCosts: 'Heiz- und Nebenkosten',
      room: 'Raum',
      brand: 'Marke',
      model: 'Modell',
      installation: 'Installation',
      uninstallation: 'Deinstallation',
      warrantyExpiration: 'Ablauf Garantie',
      acquisitionCosts: 'Kaufpreis inkl. Bau- und Nebenkosten',
      manufacturer: 'Hersteller',
      serialNumber: 'Seriennummer',
      componentsDevices: 'Bauteile & Geräte',
      unit: 'Einheit',
      amount: 'Menge',
      lifeSpan: 'Lebensdauer',
      calculatedReplacement: 'Kalkulatorischer Ersatz',
      maintenanceCosts: 'Wartungskosten',
      nextMaintenance: 'Nächste Wartung',
      grossOverallRentPerYear: 'Brutto Ziel/Jahr',
      netOverallRentPerYear: 'Netto Ziel/Jahr',
      contact: 'Kontakt',
      reason: 'Grund',
      document: 'Dokument',
      ticketKey: 'Ticketnummer',
      ticketTitle: 'Titel',
      ticketConnections: 'Verknüpfungen',
      ticketPriority: 'Priorität',
      ticketExecuteFrom: 'Auszuführen ab',
      ticketExecuteUntil: 'Auszuführen bis',
      bkp: 'BKP',
      costs: 'Kosten',
      measures: 'Massnahmen',
      component: 'Bauteil',
      position: 'Lage',
      operator: 'Ausführender',
      contactName: 'Name',
      communication: 'Kommunikation',
      roles: 'Rolle',
      tags: 'Tags',
      percentage: 'Prozentsatz',
      plannedReplacement: 'Geplanter Ersatz',
      futureCostFactor: 'Zukünftiger Kostenfaktor %',
      plannedCosts: 'Geplante Kosten'
    },
    managementObjectsConfig: {
      bulkActions: {
        setMarketingClient: 'Vermarkter wählen',
        setAdministrationClient: 'Bewirtschafter wählen',
        setAssetManager: 'Asset Manager wählen',
        setAccounting: 'Buchhalter wählen',
        tooltip: {
          marketingAction: 'Du kannst keinen Vermarkter wählen solange ein Asset Manager für deine Objekte zuständig ist.',
          administrationAction: 'Du kannst keinen Bewirtschafter wählen, solange ein Asset Manager für deine Objekte zuständig ist.'
        }
      },
      modal: {
        titleSetMarketingClient: 'Auswahl bestätigen - Freigabe für Vermarktung',
        titleSetAdministrationClient: 'Auswahl bestätigen - Freigabe für Bewirtschaftung',
        bodySetMarketingClient: 'Möchtest du wirklich diese {SELECTED_OBJECT_COUNT} Objekte zur Vermarktung durch {SELECTED_MARKETING_NAME} freigeben?',
        bodySetAdministrationClient: 'Möchtest du wirklich diese {SELECTED_OBJECT_COUNT} Objekte zur Verwaltung durch {SELECTED_ADMINISTRATION_NAME} freigeben?',
        titleSetAssetManager: 'Auswahl bestätigen - Freigabe für Asset Management',
        bodySetAssetManager: 'Möchtest du wirklich diese {SELECTED_OBJECT_COUNT} Liegenschaft/en zum Asset Management durch {SELECTED_ASSET_NAME} freigeben?',
        titleSetAccountingClient: 'Auswahl bestätigen - Freigabe für Buchhaltung',
        bodySetAccountingClient: 'Möchtest du wirklich diese {SELECTED_OBJECT_COUNT} Liegenschaft/en zur Buchhaltung durch {SELECTED_MARKETING_NAME} freigeben?',
        confirmationBtn: 'Bestätigen',
        assembleList: 'Liste zusammenstellen'
      },
      alertText: 'Sie können nur maximal 7 Felder auswählen. Deaktivieren Sie die Markierung eines Feldes, um ein anderes Feld auswählen zu können.'
    },
    manageAdvertisement: {
      title: 'Das ist die Übersicht des Inseratmanagements!'
    },
    manageBuilding: {
      building: 'Gebäude',
      edit: 'Gebäude bearbeiten',
      buildingType: 'Gebäudetyp',
      managementData: 'Verwaltungsdaten',
      realEstateNumber: 'Immobiliennummer',
      deleteConfirmation: {
        title: 'Gebäude löschen',
        text: 'Diese(s) Gebäude mit allen dazugehörigen Objekten löschen?'
      },
      administrationType: {
        title: 'Verwaltungsart',
        undefined_administration_type: '-',
        letting: 'Vermietung',
        initial_letting: 'Erstvermietung',
        partial_letting: 'Teilmietverwaltung',
        condominium_ownership: 'Stockwerkeigentum',
        owners_corporation: 'Wohnungseigentümergemeinschaft'
      },
      fee: {
        title: 'Honorar',
        undefined_fee: '-',
        agreed: 'Vereinbart',
        collecting: 'Vereinnahmt',
        flat_fee: 'Pauschale',
        percentage: 'In Prozent'
      },
      buildingData: 'Gebäudedaten',
      plotArea: 'Grundstücksfläche',
      buildingArea: 'Gebäudefläche',
      floors: 'Anzahl Geschosse',
      mapsView: {
        menu: {
          baseData: 'Basisdaten',
          objects: 'Objekte',
          contacts: 'Partner'
        },
        showObjects: 'Objekte anzeigen',
        showNetwork: 'Partner anzeigen',
        showBuilding: 'Gebäude anzeigen',
        searchPlaceholder: 'Gebäude suchen',
        direction: 'Routenplaner'
      },
      noExactValue: 'Ziel Netto- und Bruttomiete wurden nicht auf allen Objekten in der Mietzins-Potenzial Kachel ausgefüllt.',
      bulkAction: {
        addJanitors: 'Hauswarte hinzufügen',
        removeJanitors: 'Hauswarte entfernen',
        addCraftsmen: 'Handwerker hinzufügen',
        removeCraftsmen: 'Handwerker entfernen',
        addServiceProviders: 'Dienstleister hinzufügen',
        removeServiceProviders: 'Dienstleister entfernen',
        addDelegate: 'Delegierter / Ausschuss hinzufügen',
        addRevisor: 'Revisor hinzufügen',
        addTenantChange: 'Mieterwechsel Kontakte hinzufügen',
        removeBuilding: 'Gebäude löschen',
        activateTenancy: 'Vermietung aktivieren',
        activateCondominium: 'Eigentümerverhältnis aktivieren',
        closeTenancy: 'Vermietung abschliessen',
        successMessages: {
          addJanitors: 'Hauswart/e wurde/n erfolgreich gesetzt',
          addCraftsmen: 'Handwerker wurde/n erfolgreich gesetzt',
          addServiceProviders: 'Dienstleister wurde/n erfolgreich gesetzt',
          addDelegate: 'Delegierte/r wurde/n erfolgreich gesetzt',
          addRevisor: 'Revisor/en wurde/n erfolgreich gesetzt',
          addTenantChange: 'Mieterwechsel Kontakt/e wurde/n erfolgreich gesetzt'
        }
      }
    },
    onBoardingTabs: {
      savedMessage: 'Daten erfolgreich gespeichert!',
      building: 'Gebäude',
      objects: 'Objekte',
      tenants: 'Mieter',
      condominium: 'STWEG',
      devices: 'Bauteile & Geräte',
      documents: 'Dokumente',
      contacts: 'Kontakte',
      history: 'Historie',
      toOverview: 'Zur Übersicht',
      confirmModal: {
        confirmationTitle: 'Bestätigen',
        confirmationText: 'Diese Aktion durchführen? Bisherige Änderungen gehen verloren.',
        confirmationButton: 'Daten verwerfen'
      },
      toProperty: 'Zur Liegenschaft',
      toBuilding: 'Zum Gebäude',
      toObject: 'Zum Objekt',
      toContact: 'Zum Kontakt'
    },
    portalTab: {
      title: 'Links einbetten',
      subTitle: 'Hier kannst du externe Links hinterlegen, benennen und direkt im Portal anzeigen lassen.',
      description: 'Beschreibung',
      link: 'Link',
      addLink: 'Link hinzufügen',
      deleteLink: 'Link löschen'
    },
    onBoarding: {
      deleteModals: {
        confirmation: 'Bestätigen',
        bodyObject: 'Diese(s) Objekt(e) nur dann löschen, wenn diese(s) aus Versehen erstellt wurde/n! Objekt(e) wird/werden in allen Modulen gelöscht. Objekt(e) löschen?',
        bodyDevice: 'Dieses Gerät unwiderruflich löschen? Verknüpfungen zu bestehenden Tickets werden dadurch gelöscht.',
        bodyRoom: 'Bist du sicher, dass du den/die ausgewählte(n) Raum/Räume löschen möchtest? Alle zugehörigen Bauteile & Geräte, sowie Verknüpfungen zu bestehenden Tickets werden dadurch gelöscht.',
        bodyInsurance: 'Diese Versicherung unwiderruflich löschen?',
        bodyMortgage: 'Diese Hypothek unwiederruflich löschen?',
        bodyBankDetails: 'Diese Liegenschaftskonto unwiederruflich löschen?',
        bodyTenancy: 'Diese Vermietung unwiderruflich löschen?',
        bodyCondominiumOwner: 'Dieses Eigentümerverhältnis unwiderruflich löschen?',
        bodyVacancy: 'Diesen Leerstand unwiderruflich löschen?',
        bodyDocument: 'Dieses Dokument unwiderruflich löschen?',
        bodyEnergySource: 'Diesen Energieträger unwiderruflich löschen?',
        bodyEnergySourceOrder: 'Diese Bestellung unwiderruflich löschen?',
        titleCostAdjusment: 'Mietzinsanpassung löschen',
        bodyCostAdjusment: 'Diese Mietzinsanpassung wirklich löschen?',
        titleAmortization: 'Amortisation löschen',
        bodyAmortization: 'Diese Amortisation unwiderruflich löschen?',
        titleTankReadings: 'Stand Menge löschen',
        bodyTankReadings: 'Diese Stand Menge unwiderruflich löschen?',
        titleSubTenants: 'Untermieter löschen',
        titleRoommate: 'Mitbewohner löschen',
        titleTenants: 'Mieter löschen',
        bodySubTenants: 'Untermieter unwiderruflich löschen?',
        titledepositShares: 'Kaution unwiderruflich löschen',
        bodydepositShares: 'Diese Kaution unwiderruflich löschen?',
        bodyRoommate: 'Mitbewohner unwiderruflich löschen?',
        bodyTenants: 'Mieter unwiderruflich löschen?',
        bodySettlement: 'Verrechnungsobjekt unwiderruflich löschen',
        titleDocument: 'Dokument löschen',
        titleRetention: 'Mietzinsreserve löschen',
        bodyRetention: 'Diese Mietzinsreserve unwiderruflich löschen?',
        bodyPlot: 'Diese Parzelle unwiederruflich löschen?'
      },
      interestedParties: {
        progress: 'Fortschritt',
        marketplaceName: 'Quelle',
        checklist: {
          title: 'Checklist',
          depositReceived: 'Kaution erhalten',
          contractReceived: 'Vertrag erhalten',
          contractSent: 'Vertrag versendet',
          creditCheckDone: 'Bonitätscheck durchgeführt',
          referencesObtained: 'Referenzen eingeholt',
          applicationFormReceived: 'Anmeldeformular erhalten',
          applicationFormRequested: 'Anmeldeformular angefragt',
          viewingAppointmentDone: 'Besichtigung durchgeführt',
          viewingAppointmentArranged: 'Besichtigung vereinbart',
          viewingAppointmentContactShared: 'Besichtigungskontakt geteilt'
        },
        request: 'Anfrage',
        rejectConfirmation: {
          title: 'Interessenten-Absage',
          body: 'Allen offenen Anfragen absagen'
        },
        listContactsWithoutEmailModal: {
          title: 'Folgende Mietinteressenten haben keine E-Mail',
          titleOther: 'Folgende Kontakte haben keine E-Mail',
          hasJoinTenant: 'Die Email wurde an den Mitmieter gesendet',
          hasJoinCondo: 'Die Email wurde an den Miteigentümer/Mitbewohner gesendet'
        },
        deactivateAdvert: {
          title: 'Inserat deaktivieren',
          body: 'Willst du das Inserat bei allen Plattformen deaktivieren?'
        },
        unpublishAdvert: {
          title: 'Deaktivieren',
          body: 'Möchtest du das Inserat deaktivieren?'
        },
        setFutureAddressModalTenancy: {
          title: 'Zukünftige Adresse ändern',
          body: 'Soll im Zuge der Vertragsaktivierung auch die Adresse aller Mieter zum Vertragsbeginn geändert werden?'
        },
        setFutureAddressModalCondominium: {
          title: 'Zukünftige Adresse ändern',
          body: 'Soll im Zuge der Vertragsaktivierung auch die Adresse aller Stockwerkeigentümer zum Vertragsbeginn geändert werden?'
        },
        deleteConfirmation: {
          title: 'Anfrage löschen',
          text: 'Diese Anfrage(n) unwiderruflich löschen?'
        },
        modal: {
          requestWithoutEmail: 'Diese Anfragen haben keine Email-Adresse hinterlegt',
          contactWithoutEmail: 'Diese {source} haben keine Email-Adresse hinterlegt.',
          tenants: 'Mieter',
          condoOwners: 'Stockwerkeigentümer',
          contacts: 'Kontakte',
          requests: 'Anfragen'
        },
        reject: {
          tootltip: 'Eine Anfrage mit einer reservierten oder aktivierten Vermietung kann nicht abgesagt werden'
        },
        moveRequest: {
          tootltip: 'Eine Anfrage mit einer reservierten oder aktivierten Vermietung kann nicht verschoben werden'
        },
        ticketForOwnerTooltip: 'Der Eigentümer verfügt aktuell nicht über das Ticketing-System. '
      },
      createBuilding: {
        baseData: 'Stammdaten',
        involvedContacts: 'Kontaktpersonen',
        features: {
          adminBase: 'Eigenschaften',
          marketBase: 'Eigenschaften Gebäude'
        },
        distances: 'Entfernungen',
        energySource: 'Energieträger',
        device: 'Bauteile & Geräte',
        settlements: 'Verrechnungsobjekt',
        insurance: 'Versicherungen',
        mortgage: 'Hypotheken',
        generalBuilding: 'Allgemeine Gebäudedokumente',
        propertyBankDetails: 'Liegenschaftskonto'
      },
      buildings: {
        createBuilding: 'Gebäude anlegen',
        zipTo: 'PLZ (bis)',
        zipFrom: 'PLZ (von)',
        numberObjects: 'Anzahl Objekte',
        filterName: 'Gbd.-Bez.',
        name: 'Gebäude-Bezeichnung',
        contractAmendments: 'Vertragszusätze zum Gebäude',
        position: 'Lage',
        statistics: {
          overall: 'Alle',
          new: 'Neu',
          done: 'Erledigt',
          received: 'Empfangen'
        },
        positionTypes: {
          UNDEFINED_LOCATION: '-',
          RIGHT: 'Rechts',
          MIDDLE: 'Mitte',
          MIDDLE_LEFT: 'Mitte/links',
          MIDDLE_RIGHT: 'Mitte/rechts',
          LEFT: 'Links',
          NORTH: 'Nord',
          SOUTH: 'Süd',
          WEST: 'West',
          EAST: 'Ost',
          NORTH_WEST: 'Nord/West',
          NORTH_EAST: 'Nord/Ost',
          SOUTH_WEST: 'Süd/West',
          SOUTH_EAST: 'Süd/Ost',
          MIDDLE_FRONT: 'Mitte/vorne',
          MIDDLE_LEFT_LEFT: 'Mitte/links links',
          MIDDLE_RIGHT_RIGHT: 'Mitte/rechts rechts'
        },
        constructionTypes: {
          title: 'Bauart',
          OLD_BUILDING: 'Altbau',
          NEW_BUILDING: 'Neubau',
          HIGH_RISE_BUILDING: 'Hochhaus',
          MIDDLE_TERRACED_HOUSE: 'Reihenmittelhaus',
          RAISED_GROUND_FLOOR: 'Hochparterre',
          CORNER_BUILDING: 'Eckhaus',
          MINERGIE_CONSTRUCTION: 'Minergie bauweise',
          MINERGIE_CERTIFIED: 'Minergie zertifiziert',
          LISTED_BUILDING: 'Denkmalgeschützt'
        },
        title: 'Gebäude',
        egid: 'EGID',
        address: 'Adresse',
        constructionYear: 'Baujahr',
        renovationYear: 'Renovierung',
        locationQuality: {
          title: 'Lagequalität',
          EXCELLENT_QUALITY: 'Allerbeste Lage',
          TOP_QUALITY: 'Ausgezeichnet',
          VERY_GOOD_QUALITY: 'Sehr gut bis ausgezeichnet',
          BETTER_QUALITY: 'Gut bis sehr gut',
          GOOD_QUALITY: 'Gut',
          AVERAGE_QUALITY: 'Durchschnittlich',
          MODERATE_QUALITY: 'Mässig',
          BAD_QUALITY: 'Schlecht',
          VERY_BAD_QUALITY: 'Sehr schlecht'
        },
        buildingZone: 'Bauzone',
        landRegisterNo: 'Parzellennummer',
        volume: 'Volumen',
        distances: {
          title: 'Entfernungen',
          kindergarten: 'Kindergarten',
          primarySchool: 'Grundschule',
          upperSchool: 'Weiterführende Schule',
          shop: 'Einkaufen',
          publicTransport: 'Nahverkehr',
          motorway: 'Autobahn'
        },
        floors: 'Anzahl Geschosse',
        objects: {
          prepareHandover: 'Übergabe vorbereiten',
          create: 'Objekt anlegen',
          titleObject: 'Objekt',
          objectName: 'Objekt-Bezeichnung',
          objectID: 'Objekt-ID',
          titleObjects: 'Objekte',
          titleObjectNumber: 'Objekt #',
          digitalApplicationform: 'Digitales Anmeldeformular',
          addTenancy: 'Mietverhältnis hinzufügen',
          addVacancy: 'Leerstand hinzufügen',
          notificationChangeTenant: 'Meldung Mieterwechsel',
          enterTermination: 'Enter termination',
          add: 'Objekte hinzufügen',
          name: 'Objektbezeichnung',
          objectNumber: 'Objekt-Nummer',
          ewid: 'EWID',
          awn: 'aWN',
          opted: 'Optiert',
          publishAddress: 'Adresse veröffentlichen',
          administrationType: {
            title: 'Verwaltungsart',
            LETTING: 'Vermietung',
            INITIAL_LETTING: 'Erstvermietung',
            PARTIAL_LETTING: 'Teilmietverwaltung',
            CONDOMINIUM_OWNERSHIP: 'Stockwerkeigentumsverwaltung'
          },
          type: {
            title: 'Art',
            rent: 'Vermietung',
            buy: 'Verkauf'
          },
          category: {
            title: 'Typ',
            undefined_category: '-',
            apartment: 'Wohnung',
            house: 'Haus',
            commercial: 'Gewerblich',
            gastronomy: 'Gastronomie',
            garden: 'Garten',
            parking_space: 'Parkplatz',
            secondary_room: 'Nebenräume',
            plot: 'Grundstück',
            agriculture: 'Agrar'
          },
          subCategory: {
            title: 'Unterobjektart',
            atelier: 'Atelier',
            attic_flat: 'Attikawohnung',
            bar: 'Bar',
            cafe: 'Café',
            car_repair_shop: 'Autogarage',
            castle: 'Schloss',
            chalet: 'Chalet',
            earth_sheltered_dwelling: 'Höhlen- / Erdhaus',
            detached_house: 'Einfamilienhaus',
            doctors_office: 'Praxis',
            duplex_house: 'Maisonette-Wohnung',
            farm_house: 'Bauernhaus',
            furnished_flat: 'Möblierte Wohnung',
            granny_flat: 'Einliegerwohnung',
            hobby_room: 'Hobbyraum',
            hotel: 'Hotel',
            loft: 'Loft',
            maisonette: 'Maisonette',
            multiplex_house: 'Mehrfamilienhaus',
            office: 'Büro',
            one_room_flat: 'Studio',
            restaurant: 'Restaurant',
            retail_location: 'Ladenfläche',
            roof_flat: 'Dachwohnung',
            row_house: 'Reiheneinfamilienhaus',
            rustico: 'Rustico',
            single_room: 'Einzelzimmer',
            stoeckli: 'Stöckli',
            stepped_flat: 'Terrassenwohnung',
            stepped_house: 'Terrassenhaus',
            villa: 'Villa',
            workshop: 'Werkstatt',
            agricultural_installation: 'Landwirtschaftsbetrieb',
            mountain_farm: 'Alpwirtschaft',
            farm: 'Farm',
            duplex: 'Maisonette-Wohnung',
            studio: 'Studio',
            terrace_flat: 'Terrassenwohnung',
            bachelor_flat: 'Einliegerwohnung',
            attic: 'Mansarde',
            alottment_garden: 'Schrebergarten',
            club: 'Club / Disco',
            casino: 'Casino',
            movie: 'Kino / Theater',
            squash: 'Squash / Badminton',
            indoor_tennis: 'Tennishalle',
            tennis: 'Tennisplatz',
            sports_hall: 'Sportanlage',
            camp_ground: 'Camping- / Zeltplatz',
            outdoor_swimming_pool: 'Freibad',
            indoor_swimming_pool: 'Hallenbad',
            golf_course: 'Golfplatz',
            motel: 'Motel',
            pub: 'Pub',
            fitness_center: 'Fitnessstudio',
            single_house: 'Einfamilienhaus',
            bifamiliar_house: 'Doppeleinfamilienhaus',
            terrance_house: 'Terrassenhaus',
            multiple_dwelling: 'Mehrfamilienhaus',
            cave_house: 'Höhlen- / Erdhaus',
            shop: 'Laden',
            advertising_area: 'Werbefläche',
            commercial_sub_category: 'Gewerbe',
            storage_room: 'Lager',
            practice: 'Praxis',
            kiosk: 'Kiosk',
            gardening: 'Gärtnerei',
            fuel_station: 'Tankstelle',
            cheese_factory: 'Käserei',
            butcher: 'Metzgerei',
            bakery: 'Bäckerei',
            hairdresser: 'Coiffeursalon',
            shopping_center: 'Shoppingcenter',
            factory: 'Fabrik',
            industrial_object: 'Industrieobjekt',
            arcade: 'Arkade',
            living_commercial_building: 'Wohn- / Geschäftshaus',
            library: 'Bücherei',
            hospital: 'Krankenhaus',
            laboratory: 'Labor',
            mini_gold_course: 'Minigolfplatz',
            nursing_home: 'Pflegeheim',
            riding_hall: 'Reithalle',
            sanatorium: 'Sanatorium',
            party_room: 'Partyraum',
            sauna: 'Sauna',
            solarium: 'Solarium',
            carpentry_shop: 'Schreinerei',
            old_age_home: 'Altersheim',
            department_store: 'Geschäftshaus',
            home: 'Heim',
            display_window: 'Schaufenster',
            garage: 'Garage',
            parking_garage: 'Parkhaus',
            parking_surface: 'Parkfläche',
            open_slot: 'Aussenstellplatz',
            covered_slot: 'Gedeckter Parkplatz',
            single_garage: 'Einzelgarage',
            double_garage: 'Doppelgarage',
            underground_slot: 'Auto-Einstellplatz',
            boat_dry_dock: 'Boot Hallenplatz',
            boat_landing_stage: 'Boot Stegplatz',
            covered_parking_place_bike: 'Moto Hallenplatz',
            outdoor_parking_place_bike: 'Moto Aussenplatz',
            horse_box: 'Stallboxe',
            boat_mooring: 'Boot Bojenplatz',
            building_land: 'Bauland',
            agricultural_land: 'Agrarland',
            commercial_land: 'Gewerbeland',
            industrial_land: 'Industriebauland',
            cellar_compartment: 'Kellerabteil',
            attic_compartment: 'Estrichabteil',
            other: 'Sonstige',
            visitor_parking_lot: 'Besucherparkplatz',
            caretaker_room: 'Hauswartraum',
            laundry_room: 'Waschküche',
            janitor_room: 'Hauswartraum',
            commercial_storage_room: 'Abstellraum',
            archive_room: 'Archivraum',
            antenna_system: 'Antennenanlage',
            training_room: 'Schulungsraum',
            toilet_facility: 'WC-Anlage',
            bicycle_parking: 'Velo-Abstellplatz',
            handicapped_indoor_parking: 'Behinderten-Auto-Einstellplatz',
            handicapped_outdoor_parking: 'Behinderten-Auto-Aussenstellplatz',
            double_outdoor_parking: 'Doppel-Auto-Aussenstellplatz',
            double_indoor_parking: 'Doppel-Auto-Einstellplatz',
            customer_parking: 'Kundenparkplatz',
            retirement_apartment: 'Alterswohnung',
            staff_room: 'Personalraum',
            server_room: 'Serverraum',
            meeting_room: 'Sitzungszimmer',
            building_services: 'Haustechnik',
            electric_parking_space: 'Elektroparkplatz'
          },
          title: 'Titel',
          inclTax: 'inkl. MWST',
          titleMaxLength: '(max. 70 Zeichen)',
          description: 'Beschreibung',
          utilizations: {
            title: 'Nutzung',
            agricultural: 'landwirtschaftlich',
            commercial_utilization: 'kommerzielle Nutzung',
            construction: 'im Umbau',
            gastronomy_utilization: 'gastronomische Nutzung',
            industrial: 'industrielle Nutzung',
            investment: 'Investition',
            parking: 'Parken',
            residential: 'Wohnen',
            storage: 'Lager',
            vacation: 'Ferien- / Zweitwohnung'
          },
          development: {
            title: 'Erschliessung',
            full: 'Erschlossen',
            partial: 'Teilerschlossen',
            undeveloped: 'Unerschlossen'
          },
          renovation: {
            title: 'Renovierung',
            start: 'Beginn',
            end: 'Ende',
            text: 'Text',
            add: 'Renovierung hinzufügen',
            deleteConfirmation: {
              title: 'Renovierung löschen',
              text: 'Diese Renovierung unwiderruflich löschen?'
            },
            editDevice: {
              title: 'Bauteile & Geräte'
            }
          },
          pricing: {
            title: 'Mietzins-Potenzial',
            titleMarketing: 'Mietzins',
            rents: 'Mietzinse',
            currentCosts: 'Vertraglicher Mietzins',
            adjustedCosts: 'Mietzins-Anpassungen',
            currency: 'Währung',
            unit: {
              title: 'Einheit',
              on_request: 'Auf Anfrage',
              fixed: 'pro Monat',
              m2_year: 'm²/Jahr',
              m2_month: 'm²/Monat'
            },
            coldRent: 'Nettomiete',
            coldRentPerDueDate: 'Nettomiete / Fälligkeit',
            additional: 'Nebenkosten',
            additionalAndHeatingCostsAdvertising: 'Heiz- und Nebenkosten',
            additionalAndHeatingCosts: 'Heiz- und Nebenkosten / Fälligkeit',
            additionalAndHeatingCostsTooltip: 'Wenn die Mietzinsbestandteile ausgefüllt sind, wird dieses Feld als Summe verwendet.',
            additionalPerDueDate: 'Nebenkosten / Fälligkeit',
            additionalShort: 'NK/BK',
            heating: 'Heizkosten',
            heatingPerDueDate: 'Heizkosten / Fälligkeit',
            heatingShort: 'HK',
            sellingPrice: 'Verkaufspreis',
            sellingPriceM2: 'Verkaufspreis pro m²',
            totalRent: 'Bruttomiete',
            totalRentPerDueDate: 'Bruttomiete / Fälligkeit',
            paymentInterval: {
              title: 'Zahlungsintervall',
              monthly: 'Monatlich',
              quarterly: 'Quartalsweise',
              halfYearly: 'Halbjährlich',
              yearly: 'Jährlich'
            },
            marketRent: 'Marktmiete',
            commonDistrictRent: 'Quartiersübliche Miete',
            rentReserves: 'Mietreserven',
            targetMarketNetRent: 'Ziel Nettomiete',
            upperMarketNetRent: 'Obere Grenze Markt Nettomiete',
            upperMarketHeatingAndAdditional: 'Obere Grenze Markt Heiz- und Nebenkosten',
            upperMarketGrossRent: 'Obere Grenze Markt Bruttomiete',
            underMarketNetRent: 'Untere Grenze Markt Nettomiete',
            underMarketHeatingAndAdditional: 'Untere Grenze Markt Heiz- und Nebenkosten',
            underMarketGrossRent: 'Untere Grenze Markt Bruttomiete',
            marketNetRent: 'Markt Nettomiete',
            marketHeatingAndAdditional: 'Markt Heiz- und Nebenkosten',
            marketGrossRent: 'Markt Bruttomiete',
            targetMarketHeatingAndAdditional: 'Ziel Heiz- und Nebenkosten',
            targetMarketGrossRent: 'Ziel Bruttomiete',
            tax: 'MWST',
            taxNetRent: 'Nettomiete MWST',
            taxHeatingAdditionalCosts: 'Heiz- und Nebenkosten MWST',
            grossRentInclTax: 'Bruttomiete inkl. MWST'
          },
          availability: {
            title: 'Verfügbarkeit',
            type: 'Typ',
            IMMEDIATELY: 'Ab sofort',
            BY_ARRANGEMENT: 'Nach Absprache',
            FROM_DATE: 'Ab',
            TEMPORARY_LIVING: 'Befristet',
            By: 'Ab',
            until: 'Bis'
          },
          deposit: {
            title: 'Kaution',
            depositNeeded: 'Kaution erforderlich',
            amount: 'Kautionshöhe',
            accountOffers: '{accountName} bietet folgende Kautionen an:',
            pleaseSelectOption: 'Bitte wählen Sie eine Option aus',
            depositInsurance: {
              title: 'Kautionsversicherung',
              UNDEFINED_DEPOSIT_INSURANCE: '-',
              NO_DEPOSIT_INSURANCE: 'Keine Kautionsversicherung',
              ALL_DEPOSIT_INSURANCES: 'Alle Kautionsversicherungen',
              AXA: 'AXA',
              FIRST_CAUTION: 'FirstCaution',
              GO_CAUTION: 'goCaution',
              HELVETIA: 'Helvetia',
              MOBILAR: 'Mobiliar',
              SMART_CAUTION: 'SmartCaution',
              SWISS_CAUTION: 'SwissCaution',
              ZUERICH: 'Zürich'
            }
          },
          parkingSpaces: {
            title: 'Parkplätze',
            parkingType: {
              title: 'Parkplatztyp',
              PARKING_TYPE_PARKING_SPACE: 'Stellplatz',
              PARKING_TYPE_CARPORT: 'Carport',
              PARKING_TYPE_DOUBLE_CARPORT: 'Doppelcarport',
              PARKING_TYPE_GARAGE: 'Garage',
              PARKING_TYPE_DOUBLE_GARAGE: 'Doppelgarage',
              PARKING_TYPE_DUPLEX: 'Duplex',
              PARKING_TYPE_CAR_PARK: 'Parkhaus',
              PARKING_TYPE_UNDERGROUND_GARAGE: 'Auto-Einstellplatz',
              PARKING_TYPE_ELECTRIC: 'Elektroparkplatz'
            },
            costs: 'Kosten',
            removeParking: 'Löschen',
            addParking: 'Parkplatz hinzufügen'
          },
          features: {
            title: {
              adminBase: 'Eigenschaften',
              marketBase: 'Eigenschaften Objekt'
            },
            defaultBath: 'Bad/Dusche/WC',
            defaultCorridor: 'Korridor',
            defaultLivingroom: 'Wohnzimmer',
            defaultBedroom: 'Schlafzimmer',
            interiorAccessories: 'Innenausstattung',
            sanitary: 'Sanitär',
            indoorArea: 'Innenbereich',
            outdoorArea: 'Aussenbereich',
            technologyAndHeating: 'Technik & Heizung',
            heating: 'Heizung',
            bathroomCount: 'Anzahl Badezimmer',
            showerCount: 'Anzahl Duschen',
            toiletCount: 'Anzahl Toiletten',
            guestToiletCount: 'Anzahl Gästetoiletten',
            separateToiletCount: 'Anzahl separate Toiletten',
            furnishing: {
              title: 'Möblierung',
              FURNISHED: 'Möbliert',
              PARTLY_FURNISHED: 'Teilmöbliert',
              NOT_FURNISHED: 'Unmöbliert'
            },
            furnishingType: {
              title: 'Art der Inneneinrichtung',
              UNDEFINED_FURNISHING_TYPE: '-',
              SIMPLE_FURNISHING: 'Einfach',
              STANDARD_FURNISHING: 'Standard',
              UPSCALE_FURNISHING: 'Gehoben',
              LUXURY_FURNISHING: 'Luxuriös'
            },
            additionalRooms: {
              title: 'Nebenräume',
              ADDITIONAL_ROOM_ATTIC: 'Dachboden',
              ADDITIONAL_ROOM_BICYCLE_STORAGE: 'Veloraum',
              ADDITIONAL_ROOM_WASHING_AND_DRYING_ROOM: 'Waschküche',
              ADDITIONAL_ROOM_BASEMENT: 'Keller',
              ADDITIONAL_ROOM_FITNESS_ROOM: 'Fitnessraum',
              ADDITIONAL_ROOM_HOBBY_ROOM: 'Bastelraum',
              ADDITIONAL_ROOM_ARCHIVE: 'Archive',
              ADDITIONAL_ROOM_STORING_PLACE: 'Lagerraum',
              ADDITIONAL_ROOM_WORKROOM: 'Werkstatt',
              ADDITIONAL_ROOM_HALL: 'Halle',
              ADDITIONAL_ROOM_COLD_STORAGE_CELL: 'Kühlraum'
            },
            kitchens: {
              title: 'Küche',
              NO_KITCHEN: 'Keine Küche',
              TEA_KITCHEN: 'Teeküche',
              BUILD_IN_KITCHEN: 'Einbauküche',
              KITCHENETTE: 'Kochnische',
              EAT_IN_KITCHEN: 'Wohnküche',
              SMALL_KITCHEN: 'Kleine Küche',
              OPEN_KITCHEN: 'Offene Küche',
              GLASS_CERAMIC_STOVE: 'Glaskeramikkochfeld',
              INDUCTION_STOVE: 'Induktionskochfeld',
              TEPANIAKI: 'Tepaniaki',
              STEAMER: 'Dampfgarer',
              COMBI_STEAMER: 'Kombisteamer',
              DISHWASHER: 'Geschirrspüler'
            },
            sanitaries: {
              title: 'Sanitär',
              SANITARY_BATHROOM_WITH_WINDOW: 'Bad mit Fenster',
              SANITARY_BATHROOM_WITH_SHOWER: 'Bad mit Dusche',
              SANITARY_BATHROOM_WITH_BATHTUB: 'Bad mit Wanne',
              SANITARY_SAUNA: 'Sauna',
              SANITARY_SWIMMING_POOL: 'Swimmingpool',
              SANITARY_JACUZZI: 'Jacuzzi',
              SANITARY_TOWEL_RADIATOR: 'Handtuchradiator',
              SANITARY_WASHING_MACHINE: 'Waschmaschine',
              SANITARY_DRYER: 'Tumbler',
              SANITARY_CONNECTION_FOR_WASHING_MACHINE: 'Waschmaschinenanschluss'
            },
            floorings: {
              title: 'Fussboden',
              FLOORING_TILES: 'Plättli',
              FLOORING_LAMINATE: 'Laminat',
              FLOORING_PARQUET: 'Parkett',
              FLOORING_STONE: 'Stein',
              FLOORING_DOUBLE_FLOOR: 'Doppelboden',
              FLOORING_WOOD_BOARDS: 'Holzdielen',
              FLOORING_MARBLE: 'Marmor',
              FLOORING_PVC: 'PVC/Linoleum',
              FLOORING_CARPET: 'Teppich',
              FLOORING_TERRACOTTA: 'Terrakotta',
              FLOORING_OTHERS: 'Andere',
              FLOORING_ANHYDRIT: 'Anhydrit',
              FLOORING_VINYL: 'Vinyl'
            },
            windows: {
              title: 'Fenster',
              WINDOW_ALUMINIUM: 'Aluminium',
              WINDOW_WOOD: 'Holz',
              WINDOW_PLASTIC: 'Kunststoff',
              WINDOW_LAMELLAR_SHUTTER: 'Lamellenstoren',
              WINDOW_SHUTTER_BLINDS: 'Jalousieläden'
            },
            glazings: {
              title: 'Verglasung',
              GLAZING_ACOUSTIC_GLAZING: 'Schallschutz',
              GLAZING_SUN_PROTECTION: 'Sonnenschutz',
              GLAZING_SIMPLY_GLAZED: 'Einfach verglast',
              GLAZING_DOUBLE_GLAZED: 'Doppelt verglast',
              GLAZING_TRIPLE_GLAZED: 'Dreifach verglast',
              GLAZING_RESISTANT_GLASS: 'Sicherheitsglas'
            },
            extras: {
              title: 'Extras',
              EXTRAS_BALCONY: 'Balkon',
              EXTRAS_FRENCH_BALCONY: 'Französischer Balkon',
              EXTRAS_WINTER_GARDEN: 'Wintergarten',
              EXTRAS_GARDEN: 'Garten',
              EXTRAS_VERANDA: 'Veranda',
              EXTRAS_TERRACE: 'Terrasse',
              EXTRAS_LOGGIA: 'Loggia',
              EXTRAS_GARDEN_HOUSE: 'Gartenhaus'
            },
            technologies: {
              title: 'Technik',
              TECHNOLOGY_ALARM_SYSTEM: 'Alarmsystem',
              TECHNOLOGY_CAMERA: 'Kamera',
              TECHNOLOGY_HIGH_VOLTAGE_CURRENT: 'Starkstrom'
            },
            heatings: {
              title: 'Heizung',
              CENTRAL_HEATING: 'Zentralheizung',
              SELF_CONTAINED_CENTRAL_HEATING: 'Etagenheizung',
              UNDERFLOOR_HEATING: 'Fussbodenheizung',
              RADIATOR: 'Radiator',
              CONTROLLED_RESIDENTIAL_VENTILATION: 'Kontrollierte Wohnungsbelüftung',
              AIR_CONDITIONING: 'Klimaanlage',
              STOVE: 'Ofen',
              WOOD_BURNING_STOVE: 'Holzofen',
              STORAGE_HEATER: 'Nachtspeicherofen',
              FIREPLACE: 'Feuerstelle',
              OPEN_FIREPLACE: 'Offene Feuerstelle'
            },
            pets: {
              title: 'Haustiere',
              PETS_ALLOWED: 'Erlaubt',
              PETS_NOT_ALLOWED: 'Nicht erlaubt',
              PETS_SMALL_ALLOWED: 'Kleintiere und Tiere die keinen Auslauf benötigen erlaubt',
              PETS_DOGS_ALLOWED: 'Hunde erlaubt',
              PETS_CATS_ALLOWED: 'Katzen erlaubt',
              PETS_AFTER_CONSULTATION: 'Nach Absprache erlaubt'
            },
            wheelchairAccessible: {
              title: 'Rollstuhlgängig',
              APPLIES: 'Ja',
              DOES_NOT_APPLY: 'Nein'
            }
          },
          vacant: 'Leerstehend',
          published: 'Veröffentlicht',
          floor: 'Etage',
          groundFloorLabel: 'EG',
          raisedGroundFloorLabel: 'HP',
          loweredGroundFloorLabel: 'TP',
          firstFloorLabel: '1. OG',
          secondFloorLabel: '2. OG',
          thirdFloorLabel: '3. OG',
          floorLabel: '. OG',
          firstBasementFloorLabel: '1. UG',
          secondBasementFloorLabel: '2. UG',
          thirdBasementFloorLabel: '3. UG',
          basementFloorLabel: '. UG',
          livingSpace: 'Wohnfläche',
          livingSpaceShort: 'WFL',
          effectiveArea: 'Nutzfläche',
          inactive: 'Inaktiv',
          inactiveTooltip: 'Um das Objekt auf inaktiv zu setzten, muss das letzte Mietverhältnis/Leerstand ein Enddatum haben.',
          inactivePopup: {
            title: 'Achtung',
            text: 'Objekt {objectId} wurde wieder auf aktiv gesetzt. Bitte passe die Schlüsselwerte für dieses Objekt auf Abacus an.',
            ok: 'Ok'
          },
          flatSharingCommunity: {
            title: 'In Wohngemeinschaft',
            applies: 'Ja',
            doesNotApply: 'Nein'
          },
          yearLastRenovation: 'Letzte bauliche Änderung',
          otoId: {
            title: 'OTO-ID',
            tooltip: 'Dies ist der installierte und dem Objekt zugewiesene Glasfaseranschluss. <br>Die OTO-ID beginnt mit A. oder B'
          },
          condition: {
            title: 'Zustand',
            UNDEFINED_CONDITION: '-',
            FIRST_OCCUPANCY: 'Erstbezug',
            FIRST_OCCUPANCY_AFTER_RESTORATION: 'Erstbezug nach Sanierung',
            EXCELLENT: 'Ausgezeichnet',
            DILAPIDATED: 'Baufällig',
            LIVEABLE: 'Bewohnbar',
            WELL_KEPT: 'Gepflegt',
            GOOD: 'Gut',
            MODERNIZED: 'Modernisiert',
            LIKE_NEW: 'Wie neu',
            PASSABLE: 'Passabel',
            PARTLY_RENOVATED: 'Teilweise renoviert',
            PARTLY_NEED_OF_RENOVATION: 'Teils renovierungsbedürftig',
            PARTLY_RESTORATED: 'Teilweise saniert',
            PARTLY_NEED_OF_RESTORATION: 'Teilweise sanierungsbedürftig',
            FULLY_RENOVATED: 'Vollständig renoviert',
            FULLY_RESTORATED: 'Vollständig saniert'
          },
          numberOfFloors: 'Anzahl Geschosse',
          locationQualities: {
            title: 'Lagequalität',
            PARTICULARLY_QUIET: 'Besonders ruhig',
            SUNNY: 'Viel Sonne',
            BEAUTIFUL_VIEW: 'Schöne Aussicht',
            HILLSIDE: 'Hanglage',
            LAKESIDE: 'Am See',
            UNOBSTRUCTABLE: 'Unverbaubar',
            FOREST: 'Waldlage',
            COMMERCIAL_CENTER: 'Einkaufszentrum',
            PEDESTRIAN_AREA: 'Fussgängerzone',
            CENTRAL: 'Zentral',
            WELL_DEVELOPED: 'Gut erschlossen'
          },
          volume: 'Volumen',
          quote: 'Wertquote',
          rooms: 'Zimmer',
          roomHeight: 'Raumhöhe',
          firstTimeOccupancy: 'Erstbezugsdatum',
          assignedSideRooms: {
            title: 'Zugeordnete Nebenräume',
            placeholder: 'Beispiel: Keller 1, Veloraum 1'
          },
          sharedUse: {
            title: 'Mitbenutzung',
            placeholder: 'Beispiel: Waschküche, Veloraum'
          },
          specialFeatures: {
            title: 'Besonderheiten',
            placeholder: 'Beispiel: eigene Waschmaschine, kontrollierte Wohnungslüftung'
          },
          unusualAgreement: {
            title: 'Spezielle Vereinbarung',
            placeholder: 'Beispiel: Die speziellen Vorhänge dürfen nicht ersetzt werden.'
          },
          status: {
            undefined: 'n/a',
            vacant: 'Leerstand',
            vacant_not_activated: 'Leerstand (nicht aktiviert)',
            not_activated: 'Nicht aktiviert',
            current: 'Aktiv',
            temporary: 'Aktiv (befristet)',
            current_terminated: 'Aktiv (gekündigt)',
            terminated: 'Gekündigt',
            closed: 'Abgeschlossen',
            future: 'Zukünftig',
            inactive: 'Inaktiv',
            unjustified_use: 'Ungerechtfertigte Nutzung',
            undefined_online: 'n/a<br>Vermarktung (online)',
            vacant_online: 'Leerstand<br>Vermarktung (online)',
            vacant_not_activated_online: 'Leerstand (nicht aktiviert)<br>Vermarktung (online)',
            not_activated_online: 'Nicht aktiviert<br>Vermarktung (online)',
            current_online: 'Aktiv<br>Vermarktung (online)',
            current_terminated_online: 'Aktiv (gekündigt)<br>Vermarktung (online)',
            terminated_online: 'Gekündigt<br>Vermarktung (online)',
            closed_online: 'Abgeschlossen<br>Vermarktung (online)',
            future_online: 'Zukünftig<br>Vermarktung (online)',
            undefined_offline: 'n/a<br>Vermarktung (offline)',
            vacant_offline: 'Leerstand<br>Vermarktung (offline)',
            vacant_not_activated_offline: 'Leerstand (nicht aktiviert)<br>Vermarktung (offline)',
            not_activated_offline: 'Nicht aktiviert<br>Vermarktung (offline)',
            current_offline: 'Aktiv<br>Vermarktung (offline)',
            current_terminated_offline: 'Aktiv (gekündigt)<br>Vermarktung (offline)',
            terminated_offline: 'Gekündigt<br>Vermarktung (offline)',
            closed_offline: 'Abgeschlossen<br>Vermarktung (offline)',
            future_offline: 'Zukünftig<br>Vermarktung (offline)'
          },
          inMarketingStatus: {
            online: 'Vermarktung (online)',
            offline: 'Vermarktung (offline)',
            no: 'Nicht in Vermarktung'
          },
          futureStatus: {
            reserved: 'Reserviert',
            future: 'Zukünftig',
            vacant: 'Leerstand',
            futureRented: 'Vermietet',
            inactive: 'Inaktiv',
            undefined: 'n/a'
          },
          areas: {
            title: 'SIA Flächen',
            siaAff: 'Aussen-Funktionsfläche (AFF)',
            siaAgf: 'Aussen-Geschossfläche (AGF)',
            siaAngf: 'Aussen-Nettogeschossfläche (ANGF)',
            siaAkf: 'Aussen-Konstruktionsfläche (AKF)',
            siaAkfn: 'FK tragend (AKFN)',
            siaAkft: 'KF nicht-tragend (AKFT)',
            siaAnf: 'Aussen-Nutzfläche (ANF)',
            siaAvf: 'Aussen-Verkehrsfläche (AVF)',
            siaFf: 'Funktionsfläche (FF)',
            siaGf: 'Geschossfläche (GF)',
            siaGgf: 'Gebäudegrundfläche (GGF)',
            siaGsf: 'Grundstücksfläche (GSF)',
            siaHnf: 'Hauptnutzfläche (HNF)',
            siaHnf1: 'HNF Wohnen (HNF1)',
            siaHnf2: 'HNF Büro (HNF2)',
            siaHnf3: 'HNF Produktion (HNF3)',
            siaHnf4: 'HNF Lager (HNF4)',
            siaHnf5: 'HNF Bildung & Kultur (HNF5)',
            siaHnf6: 'HNF Heilen & Pflegen (HNF6)',
            siaKf: 'Konstruktionsfläche (KF)',
            siaKfn: 'KF nichttragend (KFN)',
            siaKft: 'KF tragend (KFT)',
            siaNf: 'Nutzfläche (NF)',
            siaNgf: 'Nettogeschossfläche (NGF)',
            siaNnf: 'Nebennutzfläche (NNF)',
            siaUf: 'Umgebungsfläche (UF)',
            siaUuf: 'Unbearbeitete UF (UUF)',
            siaBuf: 'Bearbeitete UF (BUF)',
            siaVf: 'Verkehrsfläche (VF)'
          },
          characteristics: {
            broadbandInternet: 'Breitbandinternet',
            cableTv: 'Kabelfernsehen',
            chargingStation: 'E-Auto Ladestation',
            childFriendly: 'Kinderfreundlich',
            communityGarden: 'Gemeinschaftsgarten',
            conciergeService: 'Conciergeservice',
            elevator: 'Lift',
            fiberGlass: 'Glasfaser',
            intercom: 'Gegensprechanlage',
            isdn: 'ISDN',
            park: 'Parkanlage',
            playground: 'Spielplatz',
            satellite: 'Satellite'
          },
          tenancies: {
            title: 'Mietverhältnis',
            titleGuarantor: 'Solidarhafter dieser Vermietungen',
            titleNumber: 'Vermietung #',
            add: 'Mietverhältnis hinzufügen',
            addVacancy: 'Leerstand hinzufügen',
            extendTenancy: 'Mietverhältnis verlängern',
            delete: 'Mietverhältnis löschen',
            deleteVacancy: 'Leerstand löschen',
            digitalDeposit: 'Digitale Kaution',
            deleteTermination: {
              title: 'Kündigung löschen',
              text: 'Willst du wirklich die Kündigungsdaten löschen?'
            },
            afterDeleteTenancyVacancy1: 'Falls bereits eine Sollstellung auf Abacus verbucht worden ist, muss die Vermietung oder Leerstand auf Abacus manuell auf ungültig gesetzt werden.',
            afterDeleteTenancyVacancy2: 'Falls eine Sollstellung auf Abacus erstellt worden ist (nocht nicht verbucht), muss die Sollstellung auf diese Vermietung oder Leerstand gelöscht werden bevor man dieses Mietverhältnis oder Leerstand endgültig löscht.',
            startingFrom: 'Vertragsstart',
            endingFrom: 'Vertragsende',
            activateVacancyConfirmationTitle: 'Leerstand aktivieren',
            activateVacancyConfirmationBody: 'Willst du wirklich diesen Leerstand aktivieren? Damit wird er in die Buchhaltung übertragen und kann nicht mehr geändert werden.',
            vacancy: 'Leerstand',
            note: 'Bemerkung',
            extend: {
              title: 'Option auswählen',
              titleTooltip: 'Hier werden nur echte Optionen angezeigt. Für die Weiterführung eines Mietverhältnisses mit einer unechter Option muss ein neues Mietverhältnis angelegt werden.',
              extend: 'verlängern'
            },
            activateModal: {
              title: 'Vermietung aktivieren',
              uploadContract: 'Mietvertrag hochladen',
              activateOtherTenancies: 'Weitere Vermietungen aktivieren'
            },
            closeModalBody: 'Diese Vermietung/en abschliessen?',
            vacancyReason: {
              title: 'Grund für Leerstand',
              VACANCY_REASON_UNDEFINED: '-',
              VACANCY_REASON_NO_NEXT_TENANT: 'Kein Nachmieter',
              VACANCY_REASON_INITIAL_LETTING: 'Erstvermietung',
              VACANCY_REASON_RENOVATION: 'Umbau',
              VACANCY_REASON_TEMPORARY_TENANCY: 'Befristeter Mietvertrag',
              VACANCY_REASON_SALE: 'Verkauf',
              VACANCY_REASON_TERMINATION_UNDER_OR_257D: 'Kündigung aufgrund OR 257d',
              VACANCY_REASON_EVICTION: 'Ausweisung',
              renovationTooltip: 'Sobald ein Enddatum bei dem Leerstand gesetzt wurde, wird hier das Datum 1 Tag später als das Enddatum des Leerstandes angezeigt.'
            },
            rentalObjects: 'Mietobjekte',
            contractAmendments: 'Vertragszusätze',
            contractAmendmentsPlaceholder: 'Beispiel: Haustiere',
            status: {
              not_activated: 'Nicht aktiviert',
              current: 'Aktiv',
              unjustified_use: 'Ungerechtfertigte Nutzung',
              current_terminated: 'Aktiv (gekündigt)',
              temporary: 'Aktiv (befristet)',
              current_temporary: 'Aktiv (befristet)',
              terminated: 'Gekündigt',
              closed: 'Abgeschlossen',
              future: 'Zukünftig'
            },
            tenantType: {
              title: 'Miet-Typ',
              external: 'Fremdmiete',
              own: 'Eigenmiete',
              corporate: 'Konzernmiete'
            },
            rentType: {
              title: 'Vertragsart',
              RENT_TYPE_VMWG: 'VMWG',
              RENT_TYPE_CONDOMINIUM_OWNERSHIP: 'STWEG',
              RENT_TYPE_INDEX: 'Indexmiete',
              RENT_TYPE_GRADUATED: 'Staffelmiete',
              RENT_TYPE_TURNOVER: 'Umsatzmiete',
              RENT_TYPE_SUBSIDIZES: 'Subventioniert',
              RENT_TYPE_NOT_VMWG: 'Ausserhalb VMWG'
            },
            typeOfUse: {
              title: 'Nutzungsart',
              TYPE_OF_USE_VACATION: 'Ferien- / Zweitwohnung',
              TYPE_OF_USE_COMMERCIAL: 'kommerzielle Nutzung',
              TYPE_OF_USE_PARKING: 'Parken',
              TYPE_OF_USE_PARKING_EXTERNAL: 'Parken fremdvermietet',
              TYPE_OF_USE_AGRICULTURAL: 'landwirtschaftlich',
              TYPE_OF_USE_RADIO_ANTENNA: 'Funkantenne',
              TYPE_OF_USE_CONSTRUCTION: 'im Umbau',
              TYPE_OF_USE_GASTRONOMY: 'gastronomische Nutzung',
              TYPE_OF_USE_INDUSTRIAL: 'industrielle Nutzung',
              TYPE_OF_USE_INVESTMENT: 'Investition',
              TYPE_OF_USE_STORAGE: 'Lager',
              TYPE_OF_USE_RESIDENTIAL: 'Wohnen',
              TYPE_OF_USE_SECONDARY_ROOM: 'Nebenräume',
              TYPE_OF_USE_OFFICE: 'Büro',
              TYPE_OF_USE_STORE: 'Laden',
              TYPE_OF_USE_ADVERTISING_AREA: 'Werbefläche'
            },
            optionType: {
              title: 'Optionstyp',
              toolTip: 'Echte Option - gestaltet das Mietverhältnis, welches zu den bereits vereinbarten Bedingungen weitergeführt wird <br> Unechte Option - gibt dem Mieter das Recht auf Verhandlungen betreffend neuen Vertragsbedingungen.'
            },
            automaticExtending: {
              title: 'Automatische Verlängerung',
              titleReadOnly: 'Adresse veröffentlichen',
              toolTip: 'Dieses Feld dient ausschliesslich zur Information und hat keine Auswirkungen.'
            },
            industryCode: {
              title: 'Branchen-Bezeichnung',
              1: 'Landwirtschaft, Jagd und damit verbundene Tätigkeiten',
              2: 'Forstwirtschaft und Holzeinschlag',
              3: 'Fischerei und Aquakultur',
              5: 'Kohlenbergbau',
              6: 'Gewinnung von Erdöl und Erdgas',
              7: 'Erzbergbau',
              8: 'Gewinnung von Steinen und Erden, sonstiger Bergbau',
              9: 'Erbringung von Dienstleistungen für den Bergbau und für die Gewinnung von Steinen und Erden',
              10: 'Herstellung von Nahrungs- und Futtermitteln',
              11: 'Getränkeherstellung',
              12: 'Tabakverarbeitung',
              13: 'Herstellung von Textilien',
              14: 'Herstellung von Bekleidung',
              15: 'Herstellung von Leder, Lederwaren und Schuhen',
              16: 'Herstellung von Holz-, Flecht-, Korb- und Korkwaren (ohne Möbel)',
              17: 'Herstellung von Papier, Pappe und Waren daraus',
              18: 'Herstellung von Druckerzeugnissen; Vervielfältigung von bespielten Ton-, Bild- und Datenträgern',
              19: 'Kokerei und Mineralölverarbeitung',
              20: 'Herstellung von chemischen Erzeugnissen',
              21: 'Herstellung von pharmazeutischen Erzeugnissen',
              22: 'Herstellung von Gummi- und Kunststoffwaren',
              23: 'Herstellung von Glas und Glaswaren, Keramik, Verarbeitung von Steinen und Erden',
              24: 'Metallerzeugung und -bearbeitung',
              25: 'Herstellung von Metallerzeugnissen',
              26: 'Herstellung von Datenverarbeitungsgeräten, elektronischen und optischen Erzeugnissen',
              27: 'Herstellung von elektrischen Ausrüstungen',
              28: 'Maschinenbau',
              29: 'Herstellung von Automobilen und Automobilteilen',
              30: 'Sonstiger Fahrzeugbau',
              31: 'Herstellung von Möbeln',
              32: 'Herstellung von sonstigen Waren',
              33: 'Reparatur und Installation von Maschinen und Ausrüstungen',
              35: 'Energieversorgung',
              36: 'Wasserversorgung',
              37: 'Abwasserentsorgung',
              38: 'Sammlung, Behandlung und Beseitigung von Abfällen; Rückgewinnung',
              39: 'Beseitigung von Umweltverschmutzungen und sonstige Entsorgung',
              41: 'Hochbau',
              42: 'Tiefbau',
              43: 'Vorbereitende Baustellenarbeiten, Bauinstallation und sonstiges Ausbaugewerbe',
              45: 'Handel mit Motorfahrzeugen; Instandhaltung und Reparatur von Motorfahrzeugen',
              46: 'Grosshandel (ohne Handel mit Motorfahrzeugen)',
              47: 'Detailhandel (ohne Handel mit Motorfahrzeugen)',
              49: 'Landverkehr und Transport in Rohrfernleitungen',
              50: 'Schifffahrt',
              51: 'Luftfahrt',
              52: 'Lagerei sowie Erbringung von sonstigen Dienstleistungen für den Verkehr',
              53: 'Post-, Kurier- und Expressdienste',
              55: 'Beherbergung',
              56: 'Gastronomie',
              58: 'Verlagswesen',
              59: 'Herstellung, Verleih und Vertrieb von Filmen und Fernsehprogrammen; Kinos; Tonstudios und Verlegen von Musik',
              60: 'Rundfunkveranstalter',
              61: 'Telekommunikation',
              62: 'Erbringung von Dienstleistungen der Informationstechnologie',
              63: 'Informationsdienstleistungen',
              64: 'Erbringung von Finanzdienstleistungen',
              65: 'Versicherungen, Rückversicherungen und Pensionskassen (ohne Sozialversicherung)',
              66: 'Mit Finanz- und Versicherungsdienstleistungen verbundene Tätigkeiten',
              68: 'Grundstücks- und Wohnungswesen',
              69: 'Rechts- und Steuerberatung, Wirtschaftsprüfung',
              70: 'Verwaltung und Führung von Unternehmen und Betrieben; Unternehmensberatung',
              71: 'Architektur- und Ingenieurbüros; technische, physikalische und chemische Untersuchung',
              72: 'Forschung und Entwicklung',
              73: 'Werbung und Marktforschung',
              74: 'Sonstige freiberufliche, wissenschaftliche und technische Tätigkeiten',
              75: 'Veterinärwesen',
              77: 'Vermietung von beweglichen Sachen',
              78: 'Vermittlung und Überlassung von Arbeitskräften',
              79: 'Reisebüros, Reiseveranstalter und Erbringung sonstiger Reservierungsdienstleistungen',
              80: 'Wach- und Sicherheitsdienste sowie Detekteien',
              81: 'Gebäudebetreuung; Garten- und Landschaftsbau',
              82: 'Erbringung von wirtschaftlichen Dienstleistungen für Unternehmen und Privatpersonen a. n. g.',
              84: 'Öffentliche Verwaltung, Verteidigung; Sozialversicherung',
              85: 'Erziehung und Unterricht',
              86: 'Gesundheitswesen',
              87: 'Heime (ohne Erholungs- und Ferienheime)',
              88: 'Sozialwesen (ohne Heime)',
              90: 'Kreative, künstlerische und unterhaltende Tätigkeiten',
              91: 'Bibliotheken, Archive, Museen, botanische und zoologische Gärten',
              92: 'Spiel-, Wett- und Lotteriewesen',
              93: 'Erbringung von Dienstleistungen des Sports, der Unterhaltung und der Erholung',
              94: 'Interessenvertretungen sowie kirchliche und sonstige religiöse Vereinigungen (ohne Sozialwesen und Sport)',
              95: 'Reparatur von Datenverarbeitungsgeräten und Gebrauchsgütern',
              96: 'Erbringung von sonstigen überwiegend persönlichen Dienstleistungen',
              97: 'Private Haushalte mit Hauspersonal',
              98: 'Herstellung von Waren und Erbringung von Dienstleistungen durch private Haushalte für den Eigenbedarf ohne ausgeprägten Schwerpunkt',
              99: 'Exterritoriale Organisationen und Körperschaften'
            },
            tenancy: 'Mietverhältnis',
            subTenant: 'Untermieter',
            addSubTenant: 'Untermieter hinzufügen',
            addNewRent: 'Neuen Mietzins hinzufügen',
            roommates: 'Mitbewohner',
            addRoommate: 'Mitbewohner hinzufügen',
            contractType: {
              title: 'Vertragstyp',
              permanent: 'unbefristet',
              temporary: 'befristet'
            },
            contractNumber: 'Vertragsnummer',
            startAt: 'Vertragsstart',
            endAt: 'Vertragsende',
            licensePlate: 'Autokennzeichen',
            intendedUse: 'Verwendungszweck',
            liabilityEndsAt: 'Haftungsende',
            closed: 'Abgeschlossen',
            depositPaidOut: 'Kaution ausbezahlt',
            dividedBySeveralPersons: 'Wird der Pflichtanteilschein durch mehrere Personen geteilt?',
            inArrears: 'Nachschüssig',
            coldRentPerMonth: 'Nettomiete / Monat',
            additionalCostsPerMonth: 'Heiz- und Nebenkosten / Monat',
            grossRentPerMonth: 'Bruttomiete / Monat',
            activated: 'Aktiviert',
            opted: 'Optiert',
            familyFlat: 'Familienwohnung',
            secondaryResidence: 'Zweitwohnsitz',
            finalInvoiceCreated: 'Endabrechnung erstellt',
            calculationBasis: {
              title: 'Berechnungsgrundlage',
              TENANCY_CALCULATION_BASIS_DEFAULT: 'Standard',
              TENANCY_CALCULATION_BASIS_M2_YEAR: 'm²'
            },
            indexData: {
              title: 'Index',
              general: 'Allgemein',
              firstRentAdjustmentPossibleOn: 'Mietzinsanpassung erstmals möglich per',
              contractImputedAtIndex: 'Unterstellung des Indexes in %',
              rentAdjustmentByMonth: 'Mietzinsanpassung nach Monaten',
              rentAdjustmentByPoints: 'Mietzinsanpassung nach Punkten',
              referenceMonthForIndex: 'Referenzmonat für Index',
              rentAdjustmentAdditionalBenefit: 'Mietzinsanpassung bei Mehrleistung möglich',
              belowInitialRentAllowed: 'Unterschreitung des Anfangsmietzins',
              maximumRate: 'Maximalzins',
              rentAdjustmentNotification: {
                title: 'Anzeigefrist',
                RENT_ADJUSTMENT_NOTIFICATION_DAYS: 'Tage',
                RENT_ADJUSTMENT_NOTIFICATION_MONTHS: 'Monat'
              },
              rentAdjustmentMonths: 'Miezinsanpassungsmonate',
              additionalCosts: 'Nebenkosten',
              additionalCostsAdjustmentAllowed: 'Anpassung der Nebenkosten-Pauschalen möglich'
            },
            option: {
              title: 'Optionen',
              renewalOption: 'Erneuerungsoptionen',
              earlyRightTermination: 'Vorzeitiges Kündigungsrecht',
              optionFrom: 'Option von',
              optionUntil: 'Option bis',
              optionPer: 'Option per',
              exerciseUntil: 'Auszuüben bis',
              optionExercised: 'Option ausgeübt',
              realOption: 'Echte Option',
              unrealOption: 'Unechte Option'
            },
            rentComponents: 'Mietzinsbestandteile',
            rentBasis: 'Mietzinsbasis',
            m2PerYear: 'm2 / Jahr',
            costIncreaseType: {
              title: 'Kostensteigerung Typ',
              COST_INCREASE_TYPE_FLAT_RATE: 'Pauschal',
              COST_INCREASE_TYPE_INDEX: 'Index'
            },
            costIncreaseDate: 'Kostensteigerung Datum',
            costIncreaseValue: 'Kostensteigerung Prozent',
            dueDates: 'Fälligkeiten',
            contractCreationDate: 'Vertragsdatum',
            contractActivationDate: 'Aktivierungsdatum',
            terminationTitle: 'Kündigungsdetails',
            terminationTenant: 'Kündigung Mieter',
            terminationLandlord: 'Kündigung Vermieter',
            sameAsTenantTermination: 'Gleich wie Mieter',
            termination: 'Kündigung erfassen',
            terminationData: 'Kündigungsdaten',
            terminationResponsible: 'Wer hat den Vertrag gekündigt?',
            terminationDate: 'Vertragsende',
            terminationReturn: 'Rückgabetermin',
            terminationReason: 'Kündigungsgrund',
            terminationDesiredMoveoutDate: 'gewünschtes Auszugsdatum',
            noticePeriod: 'Kündigungsfrist (Monate)',
            noticeToQuit: 'Kündigungstermine (Ende Monat)',
            correspondenceAddress: 'Korrespondenzadresse',
            debtor: 'Debitor',
            guarantor: 'Solidarhafter',
            earliestQuit: 'Frühstes Kündigungs-Datum',
            additionalCostsBillingType: {
              title: 'NK-Abrechnungsart',
              flatrate: 'Pauschale',
              advancePayment: 'Akonto'
            },
            monthlyRentDueBy: 'Monatsmiete zahlbar bis',
            referenceInterestRate: {
              date: 'Referenzzins Datum',
              rate: 'Referenzzins Effektiv',
              ratePossible: 'Referenzzins Möglich',
              tooltipDate: 'Der Referenzzins wird automatisch ausgefüllt, wenn man ein Datum ab 10.09.2008 eingibt.'
            },
            countryIndex: {
              baseDate: 'Landesindex Basisdatum',
              baseYear: 'Landesindex Basisjahr',
              date: 'Landesindex Datum',
              inflation: 'Landesindex Teuerung',
              baseYearOptions: {
                COUNTRY_INDEX_BASE_YEAR_1914: '1914',
                COUNTRY_INDEX_BASE_YEAR_1939: '1939',
                COUNTRY_INDEX_BASE_YEAR_1966: '1966',
                COUNTRY_INDEX_BASE_YEAR_1977: '1977',
                COUNTRY_INDEX_BASE_YEAR_1982: '1982',
                COUNTRY_INDEX_BASE_YEAR_1993: '1993',
                COUNTRY_INDEX_BASE_YEAR_2000: '2000',
                COUNTRY_INDEX_BASE_YEAR_2005: '2005',
                COUNTRY_INDEX_BASE_YEAR_2010: '2010',
                COUNTRY_INDEX_BASE_YEAR_2015: '2015',
                COUNTRY_INDEX_BASE_YEAR_2020: '2020'
              }
            },
            currency: 'Währung',
            numberOfPersons: 'Haushaltsgrösse',
            tenants:
              {
                title: 'Mieter',
                userReference: 'userReference',
                accountId: 'accountId',
                current: 'Mieter',
                address: {
                  addressRequeredTooltip: 'Mieter müssen eine Adresse gesetzt haben',
                  inspectorAddressRequiredTooltip: 'Inspektor muss eine Adresse gesetzt haben',
                  maintenanceAddressRequiredTooltip: 'Wartungsunternehmen muss eine Adresse gesetzt haben',
                  revisorAddressRequiredTooltip: 'Revisor muss eine Adresse gesetzt haben'
                }
              },
            tenancyStatus: {
              title: 'Status Mietverhältnis',
              tooltip: 'Sobald ein Mietverhältnis aktiviert worden ist, kann es nicht mehr bearbeitet werden.',
              inProgress: 'In Bearbeitung',
              active: 'Aktiv',
              activeClosed: 'Aktiv (Abgeschlossen)'
            },
            vacancyStatus: {
              title: 'Status Leerstand',
              tooltip: 'Sobald ein Leerstand aktiviert worden ist, kann es nicht mehr bearbeitet werden.'
            },
            tax: {
              title: 'MWST',
              opted: 'Optiert',
              taxable: 'steuerbar'
            },
            deposit: {
              title: 'Kaution',
              type: {
                title: 'Kautionstyp',
                noDeposit: 'keine Kaution',
                DEPOSIT_TYPE_INSURANCE_GUARANTEE: 'Mietkautionsversicherung/Bürgschaft',
                DEPOSIT_TYPE_DEPOT: 'Mietzinsdepot',
                DEPOSIT_TYPE_COOPERATIVE_SHARE: 'Genossenschaftsanteil',
                DEPOSIT_TYPE_COMPULSORY_SHARE_CERTIFICATES: 'Pflichtanteilscheine',
                DEPOSIT_TYPE_CASH_PAYMENT: 'Barzahlung',
                DEPOSIT_TYPE_BANK_GUARANTEE: 'Bankgarantie',
                DEPOSIT_TYPE_COLLECTIVE_INSURANCE: 'Kollektivversicherung'
              },
              amount: 'Kautionshöhe',
              insuranceName: 'Versicherungsname/Bürge',
              insuranceNameCollective: 'Versicherungsname',
              depositShare: {
                contactId: 'Kontakt',
                amount: 'Kautionshöhe'
              },
              dueDate: 'Zu zahlen bis',
              paidDate: 'Kaution bezahlt am',
              paidDateInsurance: 'Zertifikat erhalten am',
              validFrom: 'Gültig ab',
              validUntil: 'Gültig bis',
              paidAmount: 'Bezahlter Betrag',
              insuredAmount: 'Versicherter Betrag',
              guaranteedAmount: 'Garantierter Betrag',
              bankName: 'Bankname',
              bankAccount: 'Bankkonto',
              policyNumber: 'Policen-Nr',
              clearingNumber: 'Clearing-Nummer',
              bic: 'BIC (SWIFT)',
              refundedOn: 'Rückerstattet am',
              refundAmount: 'Rückerstattungshöhe',
              remark: 'Bemerkung'
            },
            additionalCostsBillingTypes: {
              title: 'Nebenkostenabrechnung',
              options: {
                UNDEFINED_ADDITIONAL_COSTS_BILLING_TYPE: 'Keine Abrechnung',
                ADVANCE_PAYMENT_ADDITIONAL_COSTS_BILLING_TYPE: 'Abrechnung',
                FLATRATE_ADDITIONAL_COSTS_BILLING_TYPE: 'Keine Abrechnung (Pauschal)'
              },
              tooltip: 'Keine Abrechnung: Der Vertrag wird nicht in der HKNK berücksichtigt und die Schlüssel und Zähler werden ebenfalls nicht berücksichtigt<br><br>Abrechnung: Der Vertrag wird abgerechnet<br><br>Keine Abrechnung (Pauschale): Der Vertrag wird nicht abgerechnet. Die Schlüssel und Zähler werden jedoch in die Berechnung mit einbezogen und der Anteil, welcher eigentlich diesem Vertrag zugeteilt wird, wird zulasten Immobilieneigentümer verbucht.'
            },
            branchName: 'Branch name',
            byDateTooltip: 'Mietzinsanpassungen werden in der Liegenschafts- und Gebäude-Tabelle über Nacht aktualisiert.',
            retentionOfRent: {
              title: 'Mietzinsreserve',
              add: 'Mietzinsreserve hinzufügen',
              effective: 'Effektiv',
              possible: 'Möglich',
              remark: 'Bemerkung',
              type: {
                title: 'Typ',
                RETENTION_OF_RENT_INSUFFICIENT_GROSS_RENT: 'Ungenügende Bruttorendite',
                RETENTION_OF_RENT_INSUFFICIENT_NET_RETURN: 'Ungenügende Nettorendite',
                RETENTION_OF_RENT_VALUE_ENHANCING_INVESTMENTS: 'Wertvermehrende Investitionen',
                RETENTION_OF_RENT_ADJUSTMENT_NEIGHBORHOOD: 'Anpassung Orts- und Quartierüblichkeit'
              },
              inPercent: {
                title: 'Bezeichnung',
                true: '% der Nettomiete',
                false: 'Betrag'
              }
            },
            modal: {
              attention: 'Achtung',
              message: 'Es besteht bereits ein laufendes Mietverhältnis, mit Enddatum {endDate}. Möchtest du das Vertragsende entsprechend anpassen?',
              yes: 'Ja',
              no: 'Nein'
            },
            tenancyOnMarketing: 'Solange das Objekt in Vermarktung ist, kann das Mietverhältnis nur auf MARKETbase bearbeitet werden',
            rentBasisPossible: {
              title: 'Mietzinsbasis möglich',
              countryIndexDatePossible: 'Landesindex Datum möglich',
              countryIndexInflationPossible: 'Landesindex Teuerung möglich',
              costIncreasePossibleDate: 'Kostensteigerung Datum möglich',
              referenceInterestRateReservationPercentage: 'Referenzzins Vorbehalt in %',
              valueInCHF: 'Betrag in CHF',
              countryIndexInflationReservationPercentage: 'Landesindex Vorbehalt in %',
              costIncreaseReservationPercentage: 'Kostensteigerung Vorbehalt in %'
            }
          },
          ownerAgreement: {
            title: 'Eigentümerverhältnis',
            add: 'Eigentümerverhältnis hinzufügen',
            delete: 'Eigentümerverhältnis löschen',
            condominiumOwner: 'Stockwerkeigentümer',
            ownershipStart: 'Eigentumsstart',
            ownershipEnd: 'Eigentumsende',
            ownershipStatus: {
              title: 'Status Eigentümerverhältnis',
              tooltip: 'Ist ein Eigentümerverhältnis einmal aktiviert, kann es nicht mehr bearbeitet werden.'
            },
            roommateContact: {
              title: 'Mitbewohner',
              tooltip: `<span style="text-align: left">Eingegebene Mitbewohner erhalten bei Serien E-Mails auch eine E-Mail.<br>
              Bei Serienbriefe werden die eingegebenen Kontakte in den folgenden Platzhaltern ergänzt:<br>
              <ul style="margin: 0; padding: 0;">
              <li>{stwe.brief_anrede}</li>
              <li>{stwe.brief_briefanschrift}</li>
              <li>{stwe.brief_briefanschrift_1}</li>
              <li>{stwe.brief_briefanschrift_2}</li>
              </ul>
              Im geführten Prozess der Serienbriefe - Schritt 3 - entscheidet man, ob die Mitbewohner im Brief adressiert werden.</span>`
            },
            activateModal: {
              title: 'Eigentümerverhältnis aktivieren'
            },
            addTenant: 'Mieter hinzufügen',
            deleteTooltip: 'Du kannst Eigentümerverhältnisse nur löschen, wenn diese noch nie aktiviert worden sind.',
            budgetDemands: 'Budgetforderungen',
            condoRented: 'Ist dieses Objekt von der Stockwerkeigentümerschaft vermietet worden?'
          },
          involvedContacts: {
            title: 'Kontaktpersonen',
            assigneeMarketing: 'Netzwerkpartner Vermarktung',
            assigneeAdministration: 'Netzwerkpartner Bewirtschaftung',
            caretaker: 'Hauswart'
          },
          addActivity: 'Aktivität hinzufügen',
          addReminder: 'Reminder hinzufügen',
          addRentAdjustment: 'Mietzinsanpassung hinzufügen',
          tooltip: {
            addTenancy: 'Solange das Objekt in Vermarktung ist, können Mietverhältnisse nur auf MARKETbase hinzugefügt werden'
          },
          rentalObject: 'Mietobjekt',
          tenantMovingOut: 'Ausziehender Mieter',
          tenantMovingIn: 'Einziehender Mieter',
          endOfTenancy: 'Mietende',
          previousAddress: 'Bisherige Adresse',
          startOfTenancy: 'Mietbeginn',
          tenantChangeNotification: {
            greeting: 'Sehr geehrte Damen und Herren,',
            intro: 'anbei senden wir Ihnen die Mieterinformationen für den Mieterwechsel.'
          }
        },
        insurances: {
          title: 'Versicherungen',
          newInsurance: 'Neue Versicherung',
          deleteInsurance: 'Versicherung löschen',
          titleNumber: 'Versicherung #',
          noticeDate: 'Frühstes Kündigungsdatum',
          type: {
            title: 'Typ',
            INSURANCE_TYPE_UNDEFINED: '-',
            INSURANCE_TYPE_FIRE_ELEMENTAL_DAMAGE: 'Feuer-/Elementarschadenversicherung',
            INSURANCE_TYPE_BUILDING_PROPERTY_LIABILITY: 'Gebäudesach- und Haftpflichtversicherung',
            INSURANCE_TYPE_LIABILITY: 'Haftpflichtversicherung',
            INSURANCE_TYPE_BUILDING_PROPERTY_INSURANCE: 'Gebäudesachversicherung',
            INSURANCE_TYPE_LEGAL_EXPENSES: 'Rechtsschutzversicherung',
            INSURANCE_TYPE_CONSTRUCTION_LIABILITY: 'Bauwesen-/Bauherrenhaftpflichtversicherung',
            INSURANCE_TYPE_CANTONAL_BUILDING_INSURANCE: 'Kantonale Gebäudeversicherung',
            INSURANCE_TYPE_ACCIDENT_INSURANCE: 'Unfallversicherung',
            INSURANCE_TYPE_ART_IN_ARCHITECTURE: 'Kunst am Bau',
            INSURANCE_TYPE_BUSINESS_INSURANCE: 'Betriebsversicherung'
          },
          benefits: {
            title: 'Versicherungsleistungen',
            INSURANCE_BENEFIT_LIABILITY: 'Haftpflicht',
            INSURANCE_BENEFIT_WATER: 'Wasser',
            INSURANCE_BENEFIT_LOSS_OF_RENTAL_INCOME: 'Mieterertragsausfall',
            INSURANCE_BENEFIT_BURGLARY_ROBBERY: 'Einbruchdiebstahl und Beraubung',
            INSURANCE_BENEFIT_GLASS_BREAKAGE: 'Glasbruch',
            INSURANCE_BENEFIT_EXTENDED_COVERAGE: 'Erweiterte Deckung',
            INSURANCE_BENEFIT_BUILDING_SERVICES_FAILURE: 'Ausfall Gebäudetechnik',
            INSURANCE_BENEFIT_NATURAL_HAZARDS: 'Elementarschaden',
            INSURANCE_BENEFIT_CONVERSIONS_AND_RENOVATIONS: 'Umbauten und Sanierungen'
          },
          premiumPaidUpTo: 'Prämie bezahlt bis',
          note: 'Bemerkung',
          amount: 'Versicherungshöhe',
          company: 'Versicherungsgesellschaft',
          policyNumber: 'Policen-Nummer',
          costs: 'Prämie pro Jahr',
          excess: 'Selbstbehalt',
          startingAt: 'Vertragsstart',
          endingAt: 'Vertragsende',
          add: 'Versicherung hinzufügen'
        },
        energySource: {
          title: 'Energieträger',
          newEnergySource: 'Neuer Energieträger',
          deleteEnergySource: 'Energieträger löschen',
          titleNumber: 'Energieträger #',
          type: 'Typ',
          types: {
            ENERGY_SOURCE_TYPE_UNDEFINED: 'keine Angabe',
            ENERGY_SOURCE_NO: 'kein Energieträger',
            ENERGY_SOURCE_HEAT_PUMP: 'Wärmepumpe',
            ENERGY_SOURCE_AIR: 'Wärmepumpe (Luft)',
            ENERGY_SOURCE_GEOTHERMAL_ENERGY: 'Wärmepumpe (Erdwärme)',
            ENERGY_SOURCE_GEOTHERMAL_PROBE: 'Wärmepumpe (Sonde)',
            ENERGY_SOURCE_EARTH_TUBE: 'Wärmepumpe (Erdregister)',
            ENERGY_SOURCE_WATER: 'Wärmepumpe (Wasser)',
            ENERGY_SOURCE_GAS: 'Gas',
            ENERGY_SOURCE_OIL: 'Heizöl',
            ENERGY_SOURCE_WOOD_GENERIC: 'Holz',
            ENERGY_SOURCE_WOOD: 'Holz (Stückholz)',
            ENERGY_SOURCE_WOOD_PELLETS: 'Holz (Pellets)',
            ENERGY_SOURCE_WOOD_CHIPS: 'Holz (Schnitzel)',
            ENERGY_SOURCE_WASTE_HEAT: 'Abwärme (innerhalb des Gebäudes)',
            ENERGY_SOURCE_ELECTRICITY: 'Elektrizität',
            ENERGY_SOURCE_SUN: 'Sonne (thermisch)',
            ENERGY_SOURCE_DISTRICT_HEATING_GENERIC: 'Fernwärme',
            ENERGY_SOURCE_DISTRICT_HEATING_HIGH: 'Fernwärme (Hochtemperatur)',
            ENERGY_SOURCE_DISTRICT_HEATING_LOW: 'Fernwärme (Niedertemperatur)',
            ENERGY_SOURCE_OTHER: 'Andere'
          },
          tankSize: 'Tankgrösse',
          tankContent: 'Tankinhalt',
          orderQuantity: 'Bestellmenge',
          add: 'Energieträger hinzufügen',
          storageTank: 'Lager/Tank',
          tankReadings: 'Stand Menge',
          reading: 'Stand Menge',
          addReading: 'hinzufügen Stand Menge',
          addOrder: 'Bestellung hinzufügen',
          unit: 'Einheit',
          units: {
            ENERGY_SOURCE_UNIT_L: 'l',
            ENERGY_SOURCE_UNIT_KG: 'kg',
            ENERGY_SOURCE_UNIT_M3: 'm³',
            ENERGY_SOURCE_UNIT_KWH: 'kWh',
            ENERGY_SOURCE_UNIT_STERE: 'Ster'
          },
          order: 'Bestellung',
          quantity: 'Menge'
        },
        editNote: 'Notizen bearbeiten',
        microLocationRatingProposal: 'Mikrolage-Rating Vorschlag',
        microLocationRatingProposalToolTip: 'Mikrolage-Rating FPRE',
        microLocationRating: 'Mikrolage-Rating',
        buildingStrategy: {
          type: 'Gebäudestrategie',
          reviewAt: 'Strategie überprüfen',
          BUILDING_STRATEGY_TYPE_NO_RENOVATION: 'Weiterführen ohne Sanierung',
          BUILDING_STRATEGY_TYPE_MAINTAIN: 'Instandhalten',
          BUILDING_STRATEGY_TYPE_REPAIR: 'Instandsetzen',
          BUILDING_STRATEGY_TYPE_REPLACEMENT: 'Ersatz Neubau',
          BUILDING_STRATEGY_TYPE_SALE: 'Verkauf',
          BUILDING_STRATEGY_TYPE_UNDEFINED: 'Undefiniert'
        }
      },
      devices: {
        createOrder: 'Auftrag erstellen',
        description: 'Bezeichnung',
        duplicatePopup: 'Wie oft soll dieses Gerät dupliziert werden?',
        title: 'Bauteile & Geräte',
        newDevice: 'Neues Gerät',
        room: 'Raum',
        deleteDevice: 'Gerät löschen',
        titleNumber: 'Gerät #',
        add: 'Gerät hinzufügen',
        addAll: 'Alle Geräte hinzufügen',
        addDevices: 'Geräte hinzufügen',
        searchType: 'Typ suchen',
        type: 'Bauteil / Gerät',
        unassignedDevices: 'Nicht zugeordnete Geräte',
        measures: 'Sofort',
        measureUntil: 'Umsetzungszeitraum',
        note: 'Massnahmen / Bemerkung',
        system: 'Unterkategorie',
        brand: 'Marke',
        model: 'Modell',
        manufacturer: 'Hersteller',
        serialNumber: 'Seriennummer',
        assetNumberFm: 'Anlagenummer FM',
        installation: 'Installation',
        uninstallation: 'Deinstallation',
        bkpH: 'BKP Nummer',
        acquisitionCosts: 'Kaufpreis inkl. Bau- und Nebenkosten',
        acquisitionCostsShort: 'Kaufpreis',
        cataloguePrice: 'Richtpreis pro Einheit',
        warrantyExpiration: 'Ablauf Garantie',
        guidePriceSum: 'Richtpreis Summe',
        maintenance: {
          title: 'Wartung',
          titleInspection: 'Inspektion',
          titleRevision: 'Revision',
          officialControl: 'Letzte Wartung',
          lastInspection: 'Letzte offizielle Inspektion',
          nextInspection: 'Nächste offizielle Inspektion',
          nextControl: 'Nächste Wartung',
          company: 'Firma/Person',
          subscriptionStart: 'Vertragsstart',
          subscriptionEnd: 'Vertragsende',
          costs: {
            title: 'Kosten',
            currency: 'Währung',
            interval: {
              title: 'Intervall',
              quarterly: 'alle 3 Monate',
              yearly: 'Jährlich',
              monthly: 'Monatlich',
              triannual: 'alle 4 Monate',
              half_yearly: 'alle 6 Monate',
              bi_monthly: 'alle 2 Monate',
              two_yearly: 'Alle 2 Jahre',
              three_yearly: 'Alle 3 Jahre',
              four_yearly: 'Alle 4 Jahre',
              five_yearly: 'Alle 5 Jahre',
              ten_yearly: 'Alle 10 Jahre',
              twenty_yearly: 'Alle 20 Jahre',
              every_6_years: 'Alle 6 Jahre',
              every_8_years: 'Alle 8 Jahre',
              every_15_years: 'Alle 15 Jahre'
            },
            amount: 'Vertragliche Kosten',
            maintenanceCosts: 'Wartungskosten'
          }
        },
        contract: 'Vertrag',
        lastRevision: 'Letzte Revision',
        lastOfficialRevision: 'Letzte amtliche Revision',
        nextOfficialRevision: 'Nächste amtliche Revision',
        typeValues: {
          DEVICE_TYPE_UNDEFINED: 'Neues Gerät',
          DEVICE_TYPE_MASTER_BUILDER_WORK_DOWN_PIPES: 'Wohnungsabläufe/Fallleitungen',
          DEVICE_TYPE_MASTER_BUILDER_WORK_BASIC_LINE: 'Grundleitungen/Bodenabläufe/Einlaufschacht/Schlammsammler/Kontrollschacht',
          DEVICE_TYPE_MASTER_BUILDER_WORK_DRAINAGE_LINE: 'Sickerleitung',
          DEVICE_TYPE_MASTER_BUILDER_WORK_PUMP_CHAMBER: 'Pumpenschacht',
          DEVICE_TYPE_MASTER_BUILDER_WORK_TERRACE_DRAIN: 'Dach-/Terrassenablauf',
          DEVICE_TYPE_WINDOW_DOOR_AUTOMATIC_SLIDING_DOOR: 'Automatische Schiebetüre',
          DEVICE_TYPE_WINDOW_DOOR_EXTERIOR_DOOR: 'Aussentüren',
          DEVICE_TYPE_WINDOW_DOOR_EXTERIOR_DOOR_SOLID_WOOD: 'Aussentüren Massivholz',
          DEVICE_TYPE_WINDOW_DOOR_EXTERIOR_DOOR_WOOD_MATERIAL: 'Aussentüren Holzstoff, Pressspan, kunstharzbelegt',
          DEVICE_TYPE_WINDOW_DOOR_EXTERIOR_DOOR_METAL: 'Aussentüren Metall',
          DEVICE_TYPE_WINDOW_DOOR_FIRE_GATE: 'Brandschutztor',
          DEVICE_TYPE_WINDOW_DOOR_ROOF_WINDOW: 'Dachfenster',
          DEVICE_TYPE_WINDOW_DOOR_WINDOW: 'Fenster',
          DEVICE_TYPE_WINDOW_DOOR_WINDOW_WOOD_DOUBLE_GLAZING: 'Fenster, Doppelverglasung in Holz',
          DEVICE_TYPE_WINDOW_DOOR_WINDOW_PLASTIC: 'Fenster Kunststoff, Wärme-/Schallschutz',
          DEVICE_TYPE_WINDOW_DOOR_WINDOW_WOOD: 'Fenster Holz, Wärme-/Schallschutz',
          DEVICE_TYPE_WINDOW_DOOR_WINDOW_WOOD_METAL: 'Fenster Holz-Metall, Wärme-/Schallschutz',
          DEVICE_TYPE_WINDOW_DOOR_WINDOW_METAL: 'Fenster Metall, Wärme-/Schallschutz',
          DEVICE_TYPE_WINDOW_DOOR_GATE_DRIVE: 'Torantrieb',
          DEVICE_TYPE_WINDOW_DOOR_GARAGE_DOOR: 'Garagentor',
          DEVICE_TYPE_WINDOW_DOOR_DOOR_AUTOMATION: 'Türautomatik',
          DEVICE_TYPE_ROOFING_PENT_ROOF: 'Pultdach',
          DEVICE_TYPE_ROOFING_SADDLE_ROOF: 'Satteldach',
          DEVICE_TYPE_ROOFING_TERRACE: 'Terrasse',
          DEVICE_TYPE_ROOFING_HIPPED_ROOF: 'Walmdach',
          DEVICE_TYPE_ROOFING_TENT_ROOF: 'Zeltdach',
          DEVICE_TYPE_ROOFING_FLAT_ROOF: 'Flachdach',
          DEVICE_TYPE_ROOFING_SHEARING_ROOF: 'Schrägdach',
          DEVICE_TYPE_ROOFING_FRONT_PANEL: 'Vordach',
          DEVICE_TYPE_SEALING_INSULATION_FACADE: 'Fassadenisolation',
          DEVICE_TYPE_SEALING_INSULATION_FACADE_WOOD: 'Hinterlüftete Fassadenisolation Holzerverkleidung',
          DEVICE_TYPE_SEALING_INSULATION_FACADE_PLATES: 'Hinterlüftete Fassadenisolation Platten',
          DEVICE_TYPE_SEALING_INSULATION_FACADE_ETERNIT: 'Hinterlüftete Fassadenisolation Eternitverkleidung, - Schindeln',
          DEVICE_TYPE_SEALING_INSULATION_INTERIOR: 'Innendämmung',
          DEVICE_TYPE_FACADE_PLASTER: 'Fassade',
          DEVICE_TYPE_FACADE_PLASTER_PAINTING: 'Fassade streichen',
          DEVICE_TYPE_OUTER_FINISHES: 'Storen',
          DEVICE_TYPE_OUTER_FINISHES_FOLDING_SHUTTERS: 'Klappläden',
          DEVICE_TYPE_OUTER_FINISHES_SHUTTERS: 'Rollläden',
          DEVICE_TYPE_OUTER_FINISHES_SHUTTERS_WOOD: 'Rollläden Holz',
          DEVICE_TYPE_OUTER_FINISHES_SHUTTERS_METAL: 'Rollläden Metall, Aluminium',
          DEVICE_TYPE_OUTER_FINISHES_SLAT_TOWERS: 'Lamellenstoren',
          DEVICE_TYPE_OUTER_FINISHES_SLAT_TOWERS_OUTSIDE_ALUMINIUM: 'Lamellenstoren aussen, Aluminium',
          DEVICE_TYPE_OUTER_FINISHES_SLAT_TOWERS_INSIDE: 'Lamellenstoren innen, Aluminium oder Kunststoff',
          DEVICE_TYPE_OUTER_FINISHES_BLIND_SHOPS: 'Jalousieläden',
          DEVICE_TYPE_OUTER_FINISHES_BLIND_SHOPS_WOOD: 'Jalousieläden Holz',
          DEVICE_TYPE_OUTER_FINISHES_BLIND_SHOPS_METAL: 'Jalousieläden Metall, Aluminium',
          DEVICE_TYPE_OUTER_FINISHES_SUN_BLINDS: 'Sonnenstoren',
          DEVICE_TYPE_OUTER_FINISHES_SUN_BLINDS_VOLANT: 'Sonnenstoren mit Volant',
          DEVICE_TYPE_OUTER_FINISHES_GLARE_PROTECTION: 'Blendschutzanlagen',
          DEVICE_TYPE_OUTER_FINISHES_PRIVACY_SCREEN: 'Sichtschutz',
          DEVICE_TYPE_OUTER_FINISHES_PRIVACY_SCREEN_GLASS: 'Sichtschutz Glas',
          DEVICE_TYPE_OUTER_FINISHES_PRIVACY_SCREEN_WOOD: 'Sichtschutz Holz',
          DEVICE_TYPE_OUTER_FINISHES_PRIVACY_SCREEN_METAL: 'Sichtschutz Metall',
          DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_LIGHTING: 'Beleuchtungsinstallationen',
          DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_CO2: 'CO2 Anlage',
          DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SINA: 'Elektro Kontrolle SINA',
          DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SMOKE_VENT: 'Rauch-/Wärmeabzug Anlage',
          DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_PROOF_OF_SAFETY_SINA: 'Sicherheitsnachweis (SiNa)',
          DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SWITCHGEAR_COMBINATION: 'SGK (Schaltgerätekombination)',
          DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_PHOTOVOLTAIC: 'Photovoltaik',
          DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_LOW_VOLTAGE_SYSTEM: 'Niederspannungsanlage',
          DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_CABLE: 'Kabel',
          DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SWITCH: 'Schalter Starkstrom',
          DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SWITCHBOARD: 'Schaltschrank',
          DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SOCKET: 'Steckdosen Starkstrom',
          DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_UPS: 'USV Notstrom',
          DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_INFRASTRUCTURE_ELECTRIC_CHARGING: 'Infrastruktur Elektroladestationen',
          DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_ELECTRIC_CHARGING_STATION: 'Elektroladestationen',
          DEVICE_TYPE_LIGHTS_ILLUMINANT: 'Leuchtmittel',
          DEVICE_TYPE_LIGHTS: 'Leuchten und Lampen',
          DEVICE_TYPE_LIGHTS_CEILING: 'Deckenleuchte',
          DEVICE_TYPE_LIGHTS_CABINET: 'Unterschrank Beleuchtung',
          DEVICE_TYPE_LIGHTS_SPOTS: 'Spots',
          DEVICE_TYPE_LIGHTS_MIRROR_CABINET: 'Spiegelschrank Beleuchtung',
          DEVICE_TYPE_TELEPHONE_CENTER: 'Telefonhauszentrale, Kleinzentrale',
          DEVICE_TYPE_TELEPHONE_DISTRIBUTOR: 'Telefonverteiler, Installationen',
          DEVICE_TYPE_LOW_CURRENT_INSTALLATION: 'Schwachstrominstallationen',
          DEVICE_TYPE_LOW_CURRENT_INSTALLATION_INTERCOM: 'Gegensprechanlage',
          DEVICE_TYPE_LOW_CURRENT_INSTALLATION_FIBERGLASS: 'Glasfaseranschluss',
          DEVICE_TYPE_LOW_CURRENT_INSTALLATION_EMERGENCY_PHONE_LIFT: 'Nottelefon Lift',
          DEVICE_TYPE_LOW_CURRENT_INSTALLATION_INTERPHONE: 'Sonnerien',
          DEVICE_TYPE_LOW_CURRENT_INSTALLATION_BELL: 'Glocke',
          DEVICE_TYPE_LOW_CURRENT_INSTALLATION_DOOR_OPENER: 'Türöffner',
          DEVICE_TYPE_LOW_CURRENT_INSTALLATION_INTERCOM_VIDEO: 'Video-Gegensprechanlage',
          DEVICE_TYPE_LOW_CURRENT_INSTALLATION_MULTIMEDIA: 'Multimedia-Anschluss',
          DEVICE_TYPE_LOW_CURRENT_INSTALLATION_INTRUSION_DETECTION: 'Einbruchmeldeanlage',
          DEVICE_TYPE_LOW_CURRENT_INSTALLATION_ISDN: 'ISDN',
          DEVICE_TYPE_LOW_CURRENT_INSTALLATION_CABLE: 'Kabel',
          DEVICE_TYPE_LOW_CURRENT_INSTALLATION_SWITCH: 'Schalter Schwachstrom',
          DEVICE_TYPE_LOW_CURRENT_INSTALLATION_SWITCHBOARD: 'Schaltschrank',
          DEVICE_TYPE_LOW_CURRENT_INSTALLATION_SOCKET: 'Steckdosen Schwachstrom',
          DEVICE_TYPE_LOW_CURRENT_INSTALLATION_TELEPHONE_SWITCHBOARD: 'Telefonhauszentrale, Kleinzentrale',
          DEVICE_TYPE_LOW_CURRENT_INSTALLATION_TELEPHONE_DISTRIBUTOR: 'Telefonverteiler, Installationen',
          DEVICE_TYPE_LOW_CURRENT_INSTALLATION_TV_ANTENNA: 'TV-Antenne/Satelitenschüssel',
          DEVICE_TYPE_LOW_CURRENT_INSTALLATION_TV_CABLE: 'TV-Kabelanschluss',
          DEVICE_TYPE_OTHER_ELECTRICITY_BATTERY: 'Batterie',
          DEVICE_TYPE_OTHER_ELECTRICITY_OTHER: 'Übriges',
          DEVICE_TYPE_OTHER_ELECTRICITY_LIGHTNING_PROTECTION: 'Blitzschutz',
          DEVICE_TYPE_OTHER_ELECTRICITY: 'Übrige Elektroanlagen',
          DEVICE_TYPE_OTHER_ELECTRICITY_SOCKET: 'Steckdosen',
          DEVICE_TYPE_HEATING_TRANSITION_POSITION_ROOF_VENTILATION: 'Dachventilatoren',
          DEVICE_TYPE_HEATING_TRANSITION_POSITION_FILTER_REPLACEMENT: 'Filter Wechsel',
          DEVICE_TYPE_HEATING_TRANSITION_POSITION_AIR_CONDITIONING: 'Klimaanlagen',
          DEVICE_TYPE_HEATING_TRANSITION_POSITION_VENTILATION: 'Be-/Entlüftungsanlagen',
          DEVICE_TYPE_ENERGY_SUPPLY_SUPPLY: 'Zulieferung Energieträger',
          DEVICE_TYPE_ENERGY_SUPPLY_LEAKAGE_WARNING: 'Leckwarngerät',
          DEVICE_TYPE_ENERGY_SUPPLY_TANK: 'Tankanlage',
          DEVICE_TYPE_ENERGY_SUPPLY_STORAGE: 'Lagerung',
          DEVICE_TYPE_ENERGY_SUPPLY_GAS_LINE: 'Gasleitung',
          DEVICE_TYPE_ENERGY_SUPPLY_FUEL_TANK_INSIDE: 'Öl- / Brennstofftank innenliegend',
          DEVICE_TYPE_ENERGY_SUPPLY_FUEL_TANK_EARTH_LOADED: 'Öl- / Brennstofftank erdverlegt',
          DEVICE_TYPE_HEAT_GENERATION: 'Wärmeerzeugung/Abwärmenutzung',
          DEVICE_TYPE_HEAT_GENERATION_BOILER: 'Boiler',
          DEVICE_TYPE_HEAT_GENERATION_SINGLE_WATER_BOILER: 'Einzel-Warmwasserboiler',
          DEVICE_TYPE_HEAT_GENERATION_COMBIBOILER_HEATING: 'Kombiboiler mit Heizung kombiniert',
          DEVICE_TYPE_HEAT_GENERATION_ELECTRIC_BOILER: 'Elektroboiler',
          DEVICE_TYPE_HEAT_GENERATION_BOILER_GAS_APPLIANCES: 'Boiler Gasapparate',
          DEVICE_TYPE_HEAT_GENERATION_BURNER: 'Brenner',
          DEVICE_TYPE_HEAT_GENERATION_EARTH_PROBE: 'Erdsonde',
          DEVICE_TYPE_HEAT_GENERATION_ELECTRIC_STORAGE_STOVE: 'Elektrospeicherofen',
          DEVICE_TYPE_HEAT_GENERATION_EXPANSION_DEVICE: 'Expansionsgerät',
          DEVICE_TYPE_HEAT_GENERATION_DISTRICT_HEATING: 'Fernwärme',
          DEVICE_TYPE_HEAT_GENERATION_DISTRICT_HEATING_SUBSTATION: 'Fernwärme Unterstation',
          DEVICE_TYPE_HEAT_GENERATION_COMBINED_BOILER: 'Kombi-Kessel',
          DEVICE_TYPE_HEAT_GENERATION_HEATING_BOILER: 'Heizkessel',
          DEVICE_TYPE_HEAT_GENERATION_THERMAL_SOLAR_SYSTEM: 'Thermische Solaranlage',
          DEVICE_TYPE_HEAT_GENERATION_HEAT_EXCHANGER: 'Wärme-/Plattentauscher',
          DEVICE_TYPE_HEAT_GENERATION_HEAT_PUMP: 'Wärmepumpe',
          DEVICE_TYPE_HEAT_GENERATION_FIREPLACE: 'Kamin',
          DEVICE_TYPE_HEAT_GENERATION_HEAT_ACCUMULATOR: 'Wärmespeicher',
          DEVICE_TYPE_HEAT_GENERATION_SOLAR_PANELS: 'Sonnenkollektoren',
          DEVICE_TYPE_HEAT_GENERATION_HEATING_ELEMENT: 'Heizkörper',
          DEVICE_TYPE_HEAT_GENERATION_RADIATORS: 'Radiatoren',
          DEVICE_TYPE_HEAT_GENERATION_RADIATORS_HEATWALLS: 'Radiatoren / Heizwände',
          DEVICE_TYPE_HEAT_GENERATION_TOWEL_RADIATORS: 'Handtuchradiator',
          DEVICE_TYPE_HEAT_GENERATION_FLOOR_HEATING: 'Bodenheizung',
          DEVICE_TYPE_HEAT_GENERATION_ELECTRIC_STOVE: 'Elektroofen',
          DEVICE_TYPE_HEAT_GENERATION_ROOF_HEATING: 'Deckenheizung',
          DEVICE_TYPE_HEAT_DISTRIBUTION: 'Wärmeverteilung',
          DEVICE_TYPE_HEAT_DISTRIBUTION_HEAT_METER: 'Wärmemessgeräte',
          DEVICE_TYPE_HEAT_DISTRIBUTION_HEAT_QUANTITY_FLOW_METERS: 'Wärme-, Mengen- und Durchflusszähler',
          DEVICE_TYPE_HEAT_DISTRIBUTION_HEATING_COST_ALLOCATOR: 'Heizkostenverteiler',
          DEVICE_TYPE_HEAT_DISTRIBUTION_CIRCULATING_PUMP: 'Umwälzpumpe',
          DEVICE_TYPE_VENTILATION_VENTILATION_CONTROL_CENTER: 'Lüftungszentrale',
          DEVICE_TYPE_VENTILATION_VENTILATION: 'Lüftung',
          DEVICE_TYPE_VENTILATION_CONTROLLED_HOME: 'Lüftung Kontrollierte Wohnungslüftung',
          DEVICE_TYPE_VENTILATION_CHANNELS: 'Lüftungskanäle',
          DEVICE_TYPE_VENTILATION_SUPPLY_AIR_FAN: 'Zuluftventilator',
          DEVICE_TYPE_VENTILATION_EXHAUST_AIR_FAN: 'Abluftventilator',
          DEVICE_TYPE_VENTILATION_SMOKE_EXTRACTION_SYSTEM: 'Rauchabzugsanlage',
          DEVICE_TYPE_VENTILATION: 'Lüftungsanlagen',
          DEVICE_TYPE_AIR_CONDITIONING_RECOOLING: 'Rückkühlung',
          DEVICE_TYPE_AIR_CONDITIONING: 'Klimaanlagen',
          DEVICE_TYPE_AIR_CONDITIONING_INDIVIDUAL_ROOMS: 'Klimageräte für einzelne Räume',
          DEVICE_TYPE_COOLING_CHILLERS: 'Kältemaschinen',
          DEVICE_TYPE_COOLING_COLD_RESERVOIR: 'Kältespeicher',
          DEVICE_TYPE_COOLING_COLD_WATER_TANK: 'Kaltwasserspeicher',
          DEVICE_TYPE_COOLING_COLD_STORAGE_CELL: 'Kühlzellen',
          DEVICE_TYPE_COOLING: 'Kälteanlagen',
          DEVICE_TYPE_SPECIAL_FACILITY: 'Spezialanlagen',
          DEVICE_TYPE_INSULATION: 'Dämmungen HLK-Installationen',
          DEVICE_TYPE_INSULATION_CHIMNEY: 'Cheminée',
          DEVICE_TYPE_SPECIAL_FACILITY_MEASUREMENT_CONTROL_TECHNOLOGY_BUILDING_MANAGEMENT_SYSTEM: 'Gebäudeleitsystem MSRL',
          DEVICE_TYPE_MEASUREMENT_CONTROL_TECHNOLOGY_CONTROL_SYSTEM: 'Mess-, Steuer- und Regelungstechnik',
          DEVICE_TYPE_MEASUREMENT_CONTROL_TECHNOLOGY: 'Steuerung',
          DEVICE_TYPE_SPECIAL_FACILITY_MEASUREMENT_CONTROL_TECHNOLOGY_VALVES: 'Ventile',
          DEVICE_TYPE_SANITARY_BATHTUB: 'Badewanne/Duschentasse',
          DEVICE_TYPE_SANITARY_BATHTUB_ACRYLIC: 'Badewanne / Duschentasse Acryl',
          DEVICE_TYPE_SANITARY_BATHTUB_STEEL: 'Badewanne / Duschentasse Stahl, emailiert',
          DEVICE_TYPE_SANITARY_RENOVATION: 'Badsanierung/neues Badezimmer',
          DEVICE_TYPE_SANITARY_CONTROL_FITTINGS: 'Bedienungsarmaturen',
          DEVICE_TYPE_SANITARY_WASHBASIN: 'Waschtisch',
          DEVICE_TYPE_SANITARY_WASHBASIN_CERAMIC: 'Waschtisch Keramik',
          DEVICE_TYPE_SANITARY_MIRROR_CABINET: 'Spiegelschrank',
          DEVICE_TYPE_SANITARY_MIRROR_CABINET_PLASTIC: 'Spiegelschrank Kunststoff',
          DEVICE_TYPE_SANITARY_MIRROR_CABINET_WOODEN: 'Spiegelschrank Holzwerkstoff',
          DEVICE_TYPE_SANITARY_MIRROR_CABINET_METAL: 'Spiegelschrank Metall, einbrennlackiert',
          DEVICE_TYPE_SANITARY_BIDET: 'Bidet',
          DEVICE_TYPE_SANITARY_SHOWER: 'Dusche',
          DEVICE_TYPE_SANITARY_SHOWER_HEAD_HOSE: 'Schlauch/Brause',
          DEVICE_TYPE_SANITARY_SHOWER_ROD: 'Duschstange',
          DEVICE_TYPE_SANITARY_SHOWER_ROD_CHROME_STEEL: 'Duschstange Chromstahl',
          DEVICE_TYPE_SANITARY_SHOWER_HEAD_HOLDER: 'Duschkopfhalter',
          DEVICE_TYPE_SANITARY_LAVABO: 'Lavabo',
          DEVICE_TYPE_SANITARY_URINAL: 'Pissoir',
          DEVICE_TYPE_SANITARY_FLUSH_TANK: 'Spülkasten',
          DEVICE_TYPE_SANITARY_FLUSH_TANK_FLUSH_MOUNTED: 'Spülkasten Unterputz',
          DEVICE_TYPE_SANITARY_FLUSH_TANK_PLASTIC: 'Spülkasten Aufputz, Kunstoff',
          DEVICE_TYPE_SANITARY_FLUSH_TANK_CERAMIC: 'Spülkasten Aufputz, Keramik',
          DEVICE_TYPE_SANITARY_LAVABO_TOILET_BIDET_URINAL: 'Lavabo/WC/Bidet/Pissoir',
          DEVICE_TYPE_SANITARY_LAVABO_TOILET_BIDET_URINAL_CERAMIC: 'Lavabo/WC/Bidet/Pissoir Keramik',
          DEVICE_TYPE_SANITARY_LAVABO_TOILET_BIDET_URINAL_CLOSOMAT: 'Lavabo/WC/Bidet/Pissoir Dusch-WC, z.B. Clos-o-mat',
          DEVICE_TYPE_SANITARY_SHOWER_CABIN: 'Duschkabinen',
          DEVICE_TYPE_SANITARY_SHOWER_CABIN_PLASTIC: 'Duschkabinen Kunststoff',
          DEVICE_TYPE_SANITARY_SHOWER_CABIN_GLASWALLS: 'Duschkabinen Glaswände',
          DEVICE_TYPE_SANITARY_TOILET: 'Klosett',
          DEVICE_TYPE_SANITARY_TOILET_CERAMIC: 'Klosett Keramik',
          DEVICE_TYPE_SANITARY_TOILET_CLOSOMAT: 'Closomat',
          DEVICE_TYPE_SANITARY_TOILET_COVER: 'Klosett-Deckel',
          DEVICE_TYPE_SANITARY_TOILET_COVER_SOFT_CLOSE: 'Klosett-Deckel Absenkautomatik',
          DEVICE_TYPE_SPECIAL_SANITARY: 'Spezielle Sanitärapparate',
          DEVICE_TYPE_SPECIAL_SANITARY_WATER_SOFTENER: 'Enthärtungsanlage',
          DEVICE_TYPE_SPECIAL_SANITARY_LIMESCALE_PROTECTION: 'Kalkschutzanlage',
          DEVICE_TYPE_SPECIAL_SANITARY_DEHUMIDIFIER: 'Luftentfeuchter',
          DEVICE_TYPE_SPECIAL_SANITARY_WASHING_MACHINE: 'Waschmaschine',
          DEVICE_TYPE_SPECIAL_SANITARY_COMBI_WASHER_DRYER: 'Kombi Waschmaschine/Trockner',
          DEVICE_TYPE_SPECIAL_SANITARY_WASHING_ELECTRICITY_METER: 'Waschstromzähler',
          DEVICE_TYPE_SPECIAL_SANITARY_TUMBLER: 'Wäschetrockner',
          DEVICE_TYPE_SPECIAL_SANITARY_VACUUM_DEGASSING_DEVICE: 'Vakuumentgasungsgerät',
          DEVICE_TYPE_SPECIAL_SANITARY_WATER_TAP: 'Wasserhahn',
          DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_SUPPLY: 'Versorgungsapparate',
          DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_DISPOSAL: 'Entsorgungsapparate',
          DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_WATER_TREATMENT: 'Wasseraufbereitung',
          DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_SEWAGE_PUMP: 'Schmutzwasserpumpe\n',
          DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_WATER_DISTRIBUTION_BATTERY: 'Wasserverteilbatterie\n',
          DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_SEWAGE_TANK: 'Schmutzwassertank\n',
          DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_PIPING_COLD_WATER: 'Kaltwasserleitungen\n',
          DEVICE_TYPE_SANITARY_PIPING_RAIN_WATER: 'Regenwasseranlage',
          DEVICE_TYPE_SANITARY_PIPING_WARM_WATER: 'Warmwasserleitungen',
          DEVICE_TYPE_SANITARY_PIPING: 'Sanitärleitungen',
          DEVICE_TYPE_SANITARY_INSULATION: 'Dämmungen Sanitärinstallationen',
          DEVICE_TYPE_SANITARY_EQUIPMENT_MIRROR_CABINETS: 'Spiegelschränke',
          DEVICE_TYPE_SANITARY_EQUIPMENT_MIRROR_CABINETS_ONE_DOOR: 'Spiegelschrank 1-türig',
          DEVICE_TYPE_SANITARY_EQUIPMENT_MIRROR_CABINETS_TWO_DOOR: 'Spiegelschrank 2-türig',
          DEVICE_TYPE_SANITARY_EQUIPMENT_MIRROR: 'Spiegel',
          DEVICE_TYPE_SANITARY_EQUIPMENT_BATHROOM_FURNITURE: 'Badezimmermöbel',
          DEVICE_TYPE_SANITARY_EQUIPMENT_SHOWER_CABIN: 'Duschkabinen',
          DEVICE_TYPE_SANITARY_EQUIPMENT: 'Sanitärinstallationselemente',
          DEVICE_TYPE_ELECTRIC_PNEUMATIC_BOARD: 'Elektro- und Pneumatiktafeln',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_REFRIGERATOR: 'Kühlschrank',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_REFRIGERATOR_ACCESSORIES: 'Kühlschrank Zubehör',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_REFRIGERATOR_ACCESSORIES_COMPARTMENT: 'Tiefkühlfach im Kühlschrank',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_WASTE: 'Kehrichtfach',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_WASTE_SEPARATING_SYSTEM: 'Kehrichtfach mit Trennsystem',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_WASTE_HOLDER: 'Kehrichtfach nur Halterung',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_INDUCTION_HOB: 'Induktionskochfeld (Herd)',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_FREEZER: 'Tiefkühlschrank',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN: 'Backofen',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN_ACCESSORIES: 'Backofenzubehör',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN_ACCESSORIES_BLECH: 'Blech',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN_ACCESSORIES_GRID: 'Gitter',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN_ACCESSORIES_THERMOMETER: 'Backofenthermometer',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN_ACCESSORIES_GRILL: 'Grillzubehör',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_STEAM_EXHAUST_HOOD: 'Dampfabzughaube',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_STEAMER: 'Steamer',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_STEAMER_ACCESSORIES: 'Steamer Zubehör',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_DISH_WASHER: 'Geschirrspüler',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_DISH_WASHER_CUTLERY_TRAY: 'Geschirrspüler mit Besteckfach',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_GLASS_CERAMIC_HOB: 'Glaskeramikkochfeld (Herd)',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_HOB: 'Kochfeld',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_HOT_PLATES_HOB: 'Kochplatten',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_GAS_HOB: 'Gaskochfeld',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_MINOR_KITCHEN: 'Minor Küche',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_FURNITURE: 'Küchenmöbel',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_MICROWAVE: 'Mikrowelle',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_STOVE_WITH_OVEN: 'Einbauherd mit Backofen',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_FILTER: 'Dampfabzugsfilter',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_CARBON_FILTER: 'Aktivkohlefilter (Dampfabzug)',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_ALUMINIUM_FILTER: 'Alufilter (Dampfabzug)',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_DRYER: 'Trockenapparat',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COMBINATION_FURNITURE: 'Küchenkombinationsmöbel',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER: 'Küchenabdeckung',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_CHROME_STEEL: 'Küchenabdeckung Chromstahl',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_GRANITE: 'Küchenabdeckung Granit',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_GLASS: 'Küchenabdeckung Glas',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_SYNTHETIC_RESIN: 'Küchenabdeckung Kunstharzoberfläche',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_WOODEN: 'Küchenabdeckung Holz massiv oder Mehrschichtplatte',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_SEALING: 'Dichtungen von Backöfen, Kühlschränken',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_VENTILATION_GRILLE: 'Lüftungsgitter',
          DEVICE_TYPE_KITCHEN_EQUIPMENT: 'Kücheneinrichtungen',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_TOP_CABINET: 'Schränke oben',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_TOP_CABINET_HIGH_GLOSS: 'Schränke oben Hochglanz',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_TOP_CABINET_WOOD: 'Schränke oben Holz',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_UNDER_CABINET: 'Schränke unten',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_UNDER_CABINET_HIGH_GLOSS: 'Schränke unten Hochglanz',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_UNDER_CABINET_WOOD: 'Schränke unten Holz',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_DRAWER: 'Schublade',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_DRAWER_WITH_CUTLERY: 'Schublade mit Besteckeinsatz',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_DRAWER_WITH_BOTTLE_HOLDER: 'Schublade mit Flaschenhalterung',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_DRAWER_WITH_SLIPS_MAT: 'Schublade mit Rutschmatten',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_FLUSHING_BASIN: 'Spülbecken',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_FLUSHING_BASIN_CHROME_STEEL: 'Spülbecken Chromstahl',
          DEVICE_TYPE_KITCHEN_EQUIPMENT_FLUSHING_BASIN_PLASTIC: 'Spühlbecken Kunststoff',
          DEVICE_TYPE_OTHER_SANITARY: 'Übriges Sanitäranlagen',
          DEVICE_TYPE_ELEVATOR_HANDICAP_LIFT: 'Behindertenlift',
          DEVICE_TYPE_ELEVATOR_BED_LIFT: 'Bettenlift',
          DEVICE_TYPE_ELEVATOR: 'Personenlift',
          DEVICE_TYPE_ELEVATOR_MERCHANDISE_LIFT: 'Warenlift',
          DEVICE_TYPE_MOVING_STAIRCASE: 'Fahrtreppen, Rolltreppe, Fahrsteige',
          DEVICE_TYPE_FACADE_CLEANING: 'Fassadenreinigungsanlagen',
          DEVICE_TYPE_GOODS_CONVEYING_OTHER: 'Sonstige Förderanlagen',
          DEVICE_TYPE_GOODS_CONVEYING_PNEUMATIC_TUBE: 'Rohrpost',
          DEVICE_TYPE_GOODS_CONVEYING_FILE_LIFT: 'Aktenlift',
          DEVICE_TYPE_GOODS_CONVEYING: 'Warenförderanlagen',
          DEVICE_TYPE_LIFTING: 'Hebeeinrichtungen',
          DEVICE_TYPE_PARKING: 'Parkieranlagen',
          DEVICE_TYPE_TRANSPORT_OTHER: 'Übrige Transportanlagen, Lageranlagen',
          DEVICE_TYPE_PLASTERER: 'Gipserarbeiten',
          DEVICE_TYPE_METAL: 'Metallbauarbeiten',
          DEVICE_TYPE_METAL_CAR_SHELTER: 'Autounterstand',
          DEVICE_TYPE_METAL_MAILBOX: 'Briefkastenanlage',
          DEVICE_TYPE_METAL_BALCONY_ENLARGEMENT: 'Balkonvergrösserung',
          DEVICE_TYPE_CARPENTER_SCREED_EXTENSION_LADDER: 'Estrich Auszugleiter',
          DEVICE_TYPE_CARPENTER_CELLAR_DOOR: 'Kellertüren',
          DEVICE_TYPE_CARPENTER_APARTMENT_DOOR: 'Wohnungstüren',
          DEVICE_TYPE_CARPENTER_DOOR: 'Türen',
          DEVICE_TYPE_CARPENTER_DOOR_WOODEN: 'Türen Massivholz',
          DEVICE_TYPE_CARPENTER_DOOR_WOOD_MATERIAL: 'Türen Holzwerkstoff, Pressspan, kunstharzbelegt',
          DEVICE_TYPE_CARPENTER_DOOR_METAL: 'Türen Metall',
          DEVICE_TYPE_CARPENTER_DOOR_FRAME: 'Türrahmen, -zargen, -schwellen, innen',
          DEVICE_TYPE_CARPENTER_DOOR_FRAME_WOOD: 'Türrahmen, -zargen, -schwellen, innen Rahmen und Schwellen Holz',
          DEVICE_TYPE_CARPENTER_DOOR_FRAME_METAL_STONE: 'Türrahmen, -zargen, -schwellen, innen Rahmen und Schwellen Metall, Kunst- oder Naturstein',
          DEVICE_TYPE_CARPENTER_DOOR_FRAME_METAL: 'Türrahmen, -zargen, -schwellen, innen Zargen Metall',
          DEVICE_TYPE_CARPENTER_LOCKS: 'Schlösser',
          DEVICE_TYPE_CARPENTER_LOCKS_APARTMENT_DOOR: 'Schlösser Wohnungstüre',
          DEVICE_TYPE_CARPENTER_LOCKS_ROOM_DOOR: 'Schlösser Zimmertüre',
          DEVICE_TYPE_CARPENTER_LOCKS_KITT_JOINT: 'Schlösser Kittfugen',
          DEVICE_TYPE_CARPENTER_BUILT_IN_CLOSETS: 'Einbauschränke',
          DEVICE_TYPE_CARPENTER_BUILT_IN_CLOSETS_CHANNELBOARDS: 'Einbauschränke Spanplatten',
          DEVICE_TYPE_CARPENTER_BUILT_IN_CLOSETS_WOODEN: 'Einbauschränke Holz',
          DEVICE_TYPE_CARPENTER_BUILT_IN_CLOSETS_HIGH_GLOSS: 'Einbauschränke hochglanz',
          DEVICE_TYPE_CARPENTER_SLIDING_DOOR: 'Schiebetüren/Faltwände',
          DEVICE_TYPE_CARPENTER_SLIDING_DOOR_WOODEN_MATERIAL: 'Schiebetüren/Faltwände Holzwerkstoff oder massiv',
          DEVICE_TYPE_CARPENTER_SLIDING_DOOR_ROLLS: 'Schiebetüren/Faltwände Rollen',
          DEVICE_TYPE_CARPENTER_DOOR_FRAME_COLOR_OIL: 'Öl- oder Kunstharzfarbanstriche, bei Türen und Türrahmen',
          DEVICE_TYPE_CARPENTER_GLASS_INSERT_DOOR: 'Glaseinsatz zu Türen',
          DEVICE_TYPE_CARPENTER_FITTINGS_FOR_DOOR: 'Beschläge zu Türen',
          DEVICE_TYPE_CARPENTER_RUBBER_SEALS_DOOR: 'Gummidichtungen zu Türen',
          DEVICE_TYPE_CARPENTER_SHELF: 'Gestell',
          DEVICE_TYPE_CARPENTER_SHELF_WOOD: 'Gestell Holz',
          DEVICE_TYPE_CARPENTER_SHELF_METAL: 'Gestell Metall',
          DEVICE_TYPE_CARPENTER_CLOSET: 'Schrank',
          DEVICE_TYPE_CARPENTER_CLOSET_WOOD: 'Schrank Holz',
          DEVICE_TYPE_CARPENTER_CLOSET_METAL: 'Schrank Metall',
          DEVICE_TYPE_CARPENTER: 'Schreinerarbeiten/Türen',
          DEVICE_TYPE_WINDOW_DOUBLE_GLAZING: 'Fenster Doppelverglasung',
          DEVICE_TYPE_WINDOW_INSULATING_GLAZING: 'IV-Fenster',
          DEVICE_TYPE_WINDOW_FITTINGS: 'Beschläge',
          DEVICE_TYPE_WINDOW_WINDOW_FRAME: 'Fensterrahmen, -zargen, -schwellen',
          DEVICE_TYPE_WINDOW_SPECIAL_GLAZING: 'Spezialverglasungen (innere) Sicherheitsschalter',
          DEVICE_TYPE_WINDOW_WINDOW_SILL: 'Fenstersimse',
          DEVICE_TYPE_WINDOW_WINDOW_SILL_WOOD: 'Fenstersimse Holz',
          DEVICE_TYPE_WINDOW_WINDOW_SILL_WOOD_PAINTED: 'Fenstersimse Holz-gestrichen',
          DEVICE_TYPE_WINDOW_WINDOW_SILL_TILES: 'Fenstersimse Platten',
          DEVICE_TYPE_WINDOW_WINDOW_SILL_STONE: 'Fenstersime Stein',
          DEVICE_TYPE_WINDOW: 'Fenster',
          DEVICE_TYPE_WINDOW_TRIPLE: 'Fenster 3-fach Verglasung',
          DEVICE_TYPE_LOCKING_LOCK: 'Schlösser',
          DEVICE_TYPE_LOCKING_KEY: 'Schlüssel',
          DEVICE_TYPE_LOCKING_WIRELESS_TRANSMITTER: 'Funksender',
          DEVICE_TYPE_LOCKING: 'Schliessanlagen',
          DEVICE_TYPE_INTERIOR_FINISHES: 'Innere Abschlüsse',
          DEVICE_TYPE_ELEMENT_WALL: 'Elementwände',
          DEVICE_TYPE_CHROME_STEEP_FINISH: 'Einbauten, Einrichtungen in Chromstahl',
          DEVICE_TYPE_OTHER_INTERIOR1: 'Übriges Ausbau 1',
          DEVICE_TYPE_FLOORING_COVERING: 'Bodenbelag',
          DEVICE_TYPE_FLOORING_BALL_YARN: 'Kugelgarn',
          DEVICE_TYPE_FLOORING_LAMINATE: 'Boden Laminat (Kunstparkett)',
          DEVICE_TYPE_FLOORING_LAMINATE_MEDIUM_QUALITY: 'Boden Laminat (Kunstparkett) mittlere Qualität, Klasse 32',
          DEVICE_TYPE_FLOORING_LAMINATE_HIGH_QUALITY: 'Boden Laminat (Kunstparkett) gehobene Qualität, Klasse 33',
          DEVICE_TYPE_FLOORING_LINOLEUM: 'Boden Linoleum',
          DEVICE_TYPE_FLOORING_VINYL: 'Boden Vinyl',
          DEVICE_TYPE_FLOORING_DIRT_TRAP_CARPET: 'Boden Schmutzschleusenteppich',
          DEVICE_TYPE_FLOORING_PARQUET: 'Boden Parkett/Holzriemen',
          DEVICE_TYPE_FLOORING_PARQUET_ADHESIVE: 'Boden Parkett/Holzriemen Klebeparkett, kleinformatiges Massivholzparkett (Klötzliparkett)',
          DEVICE_TYPE_FLOORING_PARQUET_HARDWOOD: 'Boden Parkett/Holzriemen Hartholzriemen / Massivparkett',
          DEVICE_TYPE_FLOORING_PARQUET_SOFTWOOD: 'Boden Parkett/Holzriemen Weichholzriemen / Mehrschichtparkett',
          DEVICE_TYPE_FLOORING_PARQUET_FOURNIER: 'Boden Parkett/Holzriemen (Fournierparkett, Echtholzfurnier o. dünne Decklamelle)',
          DEVICE_TYPE_FLOORING_PARQUET_SEALING: 'Boden Parkett-Versiegelung/-Ölung, Oberflächenbehandlung',
          DEVICE_TYPE_FLOORING_FLOOR_UNDERLAY: 'Unterlagen für Bodenbeläge',
          DEVICE_TYPE_FLOORING_INSTALLATION_FLOOR: 'Installationsböden',
          DEVICE_TYPE_FLOORING_TILES: 'Boden Platten',
          DEVICE_TYPE_FLOORING_TILES_SOUND_PLATES: 'Boden Platten Ton',
          DEVICE_TYPE_FLOORING_TILES_NATURAL_STONE_SOFT: 'Boden Platten Naturstein, weich, (Gneis, Schiefer, Kalk, Marmor, etc.)',
          DEVICE_TYPE_FLOORING_TILES_NATURAL_STONE_HARD: 'Boden Platten Naturstein, hart (Granit, Quarz, Feldspat etc.)',
          DEVICE_TYPE_FLOORING_TILES_CERAMIC: 'Boden Platten Keramik, lasiert (Steinzeug, Steingut)',
          DEVICE_TYPE_FLOORING_TILES_STONEWARE: 'Boden Platten Feinsteinzeug, durchgefärbt, ohne Lasur',
          DEVICE_TYPE_FLOORING_TILES_ARTIFICIAL_STONE: 'Boden Platten Kunststein',
          DEVICE_TYPE_FLOORING_CARPET: 'Boden Teppich',
          DEVICE_TYPE_FLOORING_CARPET_NATURAL_FIBER: 'Boden Teppich Naturfaser, Sisal-Kokos',
          DEVICE_TYPE_FLOORING_CARPET_BALL_YARN: 'Boden Teppich Kugelgarn',
          DEVICE_TYPE_FLOORING_CARPET_NEEDLE_FELT: 'Boden Teppich Nadelfilz',
          DEVICE_TYPE_FLOORING_CARPET_MEDIUM_QUALITY: 'Boden Teppich mittlere Qualität',
          DEVICE_TYPE_FLOORING_SKIRTING: 'Sockelleisten',
          DEVICE_TYPE_FLOORING_SKIRTING_PLASTIC: 'Sockelleisten Kunststoff / furniert',
          DEVICE_TYPE_FLOORING_SKIRTING_WOOD: 'Sockelleisten Buchen- / Eichenholz',
          DEVICE_TYPE_FLOORING_JOINT: 'Kittfugen',
          DEVICE_TYPE_FLOORING: 'Boden',
          DEVICE_TYPE_FLOORING_PVC: 'Boden PVC, Novilon etc.',
          DEVICE_TYPE_FLOORING_RUBBER: 'Boden Gummi, Kautschuk',
          DEVICE_TYPE_FLOORING_CORK: 'Boden Korkboden versiegelt',
          DEVICE_TYPE_FLOORING_RAW: 'Boden Roh',
          DEVICE_TYPE_FLOORING_COATED: 'Boden Beschichtung',
          DEVICE_TYPE_WALL_COVERING_WORK: 'Wand Schreiner-, Gipser-, Tapezierarbeiten',
          DEVICE_TYPE_WALL_COVERING_WALLPAPER: 'Wand Tapeten',
          DEVICE_TYPE_WALL_COVERING_WALLPAPER_MEDIUM_QUALITY: 'Wand Tapeten mittlere Qualität, Raufaser, bedruckt oder roh gestrichen',
          DEVICE_TYPE_WALL_COVERING_WALLPAPER_GOOD_QUALITY: 'Wand Tapeten Glasfaser, streichbar',
          DEVICE_TYPE_WALL_COVERING_WALLPAPER_GLASS_FIBER: 'Wand Tapete mittlere Qualität, Raufaser, bedruckt oder roh gestrichen',
          DEVICE_TYPE_WALL_COVERING_PLASTER: 'Wand Beschichtung Verkleidung/Verputz',
          DEVICE_TYPE_WALL_COVERING_PLASTER_GLUE_COLOR: 'Wand Beschichtung Verkleidung/Verputz, Dispersions-, Leimfarbe, (Blanc-fix, geweisselt)',
          DEVICE_TYPE_WALL_COVERING_PLASTER_ACRYL: 'Wand Beschichtung Verkleidung/Verputz, Acryl, Alkydharzfarben, Kunstharz',
          DEVICE_TYPE_WALL_COVERING_PLASTER_MINERALS: 'Wand Verputz Mineralische Fassandenputze auf Mauerwerk',
          DEVICE_TYPE_WALL_COVERING_PLASTER_PLASTIC: 'Wand Verputz Kunststoffputze Fassade auf Mauerwerk',
          DEVICE_TYPE_WALL_COVERING_PLASTER_SILICATE_COATING: 'Wand Verputz Silikatanstrich auf Fassadenputz (rein mineralisch)',
          DEVICE_TYPE_WALL_COVERING_PLASTER_DISPERSION_PAINT: 'Wand Verputz Dispersionsfarbe aussen Beschichtung für mineralische Untergründe',
          DEVICE_TYPE_WALL_COVERING_ABRASION: 'Wand Abrieb',
          DEVICE_TYPE_WALL_COVERING_ABRASION_PLASTIC: 'Wand Abrieb Kunststoff',
          DEVICE_TYPE_WALL_COVERING_ABRASION_ROUGH_PUTT: 'Wand Abrieb rohe Putze, Klosterputze usw. mineralisch',
          DEVICE_TYPE_WALL_COVERING_ABRASION_WHITE_PLASTER: 'Wand Abrieb Weissputz',
          DEVICE_TYPE_WALL_COVERING_WOOD_WORKER: 'Wand Holztäfer',
          DEVICE_TYPE_WALL_COVERING_WOOD_WORKER_WALL_ROUGH: 'Wand Holztäfer roh, Verkleidung',
          DEVICE_TYPE_WALL_COVERING_WOOD_WORKER_LASED: 'Wand Holztäfer lasiert',
          DEVICE_TYPE_WALL_COVERING_WOOD_WORKER_PAINTED_OPAQUE: 'Wand Holztäfer deckend gestrichen',
          DEVICE_TYPE_WALL_COVERING_WOOD_WORKER_GLAZE: 'Wand Holztäfer Lasur / Deckfarbe (Öl-, Acrylharz - oder Kunstharzfarbe)',
          DEVICE_TYPE_WALL_COVERING: 'Wände',
          DEVICE_TYPE_WALL_COVERING_CERAMIC: 'Wand Keramikplatten lasiert',
          DEVICE_TYPE_WALL_COVERING_STONEWORK: 'Wand Steinzeug-, Steingutplatten; Glasmosaik (eingefärbt)',
          DEVICE_TYPE_WALL_COVERING_STONEWARE: 'Wand Feinsteinzeugplatten, durchgefärbt, ohne Lasur',
          DEVICE_TYPE_WALL_COVERING_TILES: 'Wand Platten',
          DEVICE_TYPE_CEILING_WORK: 'Decke Schreiner-, Gipser-, Tapezierarbeiten',
          DEVICE_TYPE_CEILING_WALLPAPER: 'Decke Tapete',
          DEVICE_TYPE_CEILING_PLASTER: 'Decke Beschichtung an Verkleidung/Verputz',
          DEVICE_TYPE_CEILING_ABRASION: 'Decke Abrieb',
          DEVICE_TYPE_CEILING_COVERING_ABRASION_PLASTIC: 'Decke Kunststoffabrieb',
          DEVICE_TYPE_CEILING_COVERING_ABRASION_ROUGH_PUTT: 'Decke Abriebe rohe Putze, Klosterputze usw. mineralisch',
          DEVICE_TYPE_CEILING_COVERING_ABRASION_WHITE_PLASTER: 'Decke Abrieb Weissputz',
          DEVICE_TYPE_CEILING_WOOD_WORKER: 'Decke Holztäfer',
          DEVICE_TYPE_CEILING: 'Deckenbekleidungen',
          DEVICE_TYPE_CEILING_REGULAR: 'Decken',
          DEVICE_TYPE_CEILING_REGULAR_METAL: 'Decke abgehängt in Metall, inkl. Einbauleuchten',
          DEVICE_TYPE_CEILING_REGULAR_WOOD: 'Decke Holz, gestemmt',
          DEVICE_TYPE_INTERIOR_SURFACE_TREATMENTS_PAINTING: 'Malerarbeiten (neu gestrichen)',
          DEVICE_TYPE_OTHER_INTERIOR2_SHUTTER: 'Rollläden',
          DEVICE_TYPE_OTHER_INTERIOR2_BLADE: 'Lamellenstoren',
          DEVICE_TYPE_OTHER_INTERIOR2_BELT: 'Gurten, für Rollladen und Storen',
          DEVICE_TYPE_OTHER_INTERIOR2_SHUTTER_MOTOR: 'Motoren für Stoffstoren, Raffstoren, Rollläden',
          DEVICE_TYPE_OTHER_INTERIOR2_ELECTRIC: 'Elektrische Kurbel',
          DEVICE_TYPE_OTHER_INTERIOR2_CRANK: 'Kurbeln',
          DEVICE_TYPE_OTHER_INTERIOR2_BLIND: 'Jalousieläden',
          DEVICE_TYPE_OTHER_INTERIOR2_LETTER_BOX: 'Briefkasten',
          DEVICE_TYPE_OTHER_INTERIOR2: 'Übriges Ausbau 2',
          DEVICE_TYPE_OTHER_INTERIOR2_SETS: 'Waschtischgarnituren',
          DEVICE_TYPE_OTHER_INTERIOR2_SETS_WASHBASIN_BOWL: 'Schale',
          DEVICE_TYPE_OTHER_INTERIOR2_SETS_SOAP_HOLDER: 'Seifenhalter',
          DEVICE_TYPE_OTHER_INTERIOR2_SETS_TOOTH_GLASS: 'Zahnglashalter',
          DEVICE_TYPE_OTHER_INTERIOR2_SETS_GLASS_SHELF: 'Glastablar',
          DEVICE_TYPE_OTHER_INTERIOR2_SETS_TOWEL_BARS: 'Handtuchstangen',
          DEVICE_TYPE_OTHER_INTERIOR2_SETS_HOLDING_RACK: 'Haltestangen',
          DEVICE_TYPE_OTHER_INTERIOR2_SETS_CURTAIN_ROD: 'Vorhangstangen',
          DEVICE_TYPE_OTHER_INTERIOR2_SETS_PACKAGE: 'Packungen, Dichtungen',
          DEVICE_TYPE_OTHER_INTERIOR2_ARMATURE: 'Mischer Küche/Waschtisch',
          DEVICE_TYPE_OTHER_INTERIOR2_ARMATURE_SINGLE_LEVER: 'Einhebel Mischer',
          DEVICE_TYPE_OTHER_INTERIOR2_DOUBLE_LEVER: 'Zweigriff Mischer',
          DEVICE_TYPE_OTHER_INTERIOR2_ARMATURE_SWIVEL: 'Schwenkbarer Mischer',
          DEVICE_TYPE_OTHER_INTERIOR2_ARMATURE_PULL_OUT_SPRAY: 'Mischer mit Auszugsbrause',
          DEVICE_TYPE_OTHER_INTERIOR2_ARMATURE_THERMAL_MIXER: 'Thermischer Mischer',
          DEVICE_TYPE_OTHER_INTERIOR2_OPERATING_GARNITURE: 'Ablaufgarnitur',
          DEVICE_TYPE_OTHER_INTERIOR2_SETS_BATH_TOWEL_HOLDER: 'Badetuchhalter',
          DEVICE_TYPE_OTHER_INTERIOR2_SETS_BATH_TOWEL_HOLDER_CHROME_STEEL: 'Badetuchhalter Chromstahl',
          DEVICE_TYPE_OTHER_INTERIOR2_SETS_BATH_TOWEL_HOLDER_PLASTIC: 'Badetuchhalter PVC',
          DEVICE_TYPE_OTHER_INTERIOR2_SETS_BATH_TOWEL_HOLDER_HOOK: 'Badetuchhalter Haken',
          DEVICE_TYPE_OTHER_INTERIOR2_SETS_PAPER_HOLDER: 'Papierhalter',
          DEVICE_TYPE_OTHER_INTERIOR2_SETS_PAPER_HOLDER_CHROME_STEEL: 'Papierhalter Chromstahl',
          DEVICE_TYPE_OTHER_INTERIOR2_SETS_PAPER_HOLDER_PLASTIC: 'Papierhalter PVC',
          DEVICE_TYPE_OTHER_TRANSPORT_CONTAINER: 'Container',
          DEVICE_TYPE_OTHER_TRANSPORT_CONTAINER_PLASTIC_GREEN: 'Container Kunststoff grün',
          DEVICE_TYPE_OTHER_TRANSPORT_CONTAINER_PLASTIC_BLACK: 'Container Kunststoff schwarz',
          DEVICE_TYPE_OTHER_TRANSPORT_CONTAINER_METAL: 'Container Metall',
          DEVICE_TYPE_GARDENING_TRANSITION_POSITION_OUTDOOR_PARKING: 'Aussenparkplatz',
          DEVICE_TYPE_GARDENING_TRANSITION_POSITION_PLANTING: 'Bepflanzung',
          DEVICE_TYPE_GARDENING_TRANSITION_POSITION_GROUND_MARKING: 'Bodenmarkierungen',
          DEVICE_TYPE_GARDENING_TRANSITION_POSITION_CONTAINER_SITE: 'Containerplatz',
          DEVICE_TYPE_GARDENING_TRANSITION_POSITION_BIKE_SHELTER: 'Velounterstand',
          DEVICE_TYPE_GARDENING_TRANSITION_POSITION_ACCESS_PATH: 'Zugangswege',
          DEVICE_TYPE_GARDENING_FENCE: 'Zäune u.ä.',
          DEVICE_TYPE_GARDENING_WALLS: 'Gartenmauern, Garagenmauern, Geländemauern, massiv',
          DEVICE_TYPE_GARDENING_CEMENT_BOARD: 'Zementplatten',
          DEVICE_TYPE_GARDENING_ACCESS_PATH: 'Zugangswege',
          DEVICE_TYPE_GARDENING_LAWN: 'Rasen',
          DEVICE_TYPE_GARDENING: 'Übrige Gärtnerarbeiten',
          DEVICE_TYPE_FENCING: 'Einfriedungen',
          DEVICE_TYPE_SUPERSTRUCTURE_TERRANCE: 'Terrassen',
          DEVICE_TYPE_SUPERSTRUCTURE_BIKE_STAND: 'Veloständer',
          DEVICE_TYPE_SUPERSTRUCTURE: 'Aufbauten',
          DEVICE_TYPE_SUPERSTRUCTURE_RAILING: 'Geländer',
          DEVICE_TYPE_SUPERSTRUCTURE_RAILING_SAFETY_GLASS: 'Geländer Sicherheitsglas',
          DEVICE_TYPE_SUPERSTRUCTURE_RAILING_METAL: 'Geländer Metall',
          DEVICE_TYPE_SUPERSTRUCTURE_RAILING_CHROME_STEEL: 'Geländer Chromstahl',
          DEVICE_TYPE_SUPERSTRUCTURE_RAILING_CONCRETE: 'Geländer Beton',
          DEVICE_TYPE_PLAYGROUND: 'Spiel- und Sportplätze',
          DEVICE_TYPE_PLAYGROUND_DEVICE: 'Spielgerät',
          DEVICE_TYPE_GARDEN_OTHER: 'Übriges Garten',
          DEVICE_TYPE_DEVICE_TRANSITION_POSITION_FIRE_EXTINGUISHER: 'Feuerlöscher',
          DEVICE_TYPE_DEVICE_TRANSITION_POSITION_LAWN_MOWER: 'Rasenmäher',
          DEVICE_TYPE_DEVICE_TRANSITION_POSITION_SECURITY_CAMERA: 'Überwachungskamera',
          DEVICE_TYPE_DEVICE_TRANSITION_POSITION_INDOOR_BIKE_SHELTER: 'Veloständer für Veloraum',
          DEVICE_TYPE_AIR_COMPRESSOR: 'Druckluftkompressor',
          DEVICE_TYPE_GAS_SYSTEM_LABORATORY: 'Gasanlage Labor',
          DEVICE_TYPE_HOIST_CRANE: 'Hebekran',
          DEVICE_TYPE_HEATING_DISTRIBUTOR: 'Heizverteiler',
          DEVICE_TYPE_INTERIOR_METAL_DOORS: 'Innentüren Metall',
          DEVICE_TYPE_REFRIGERATING_MACHINE: 'Kältemaschine',
          DEVICE_TYPE_REFRIGERATED_CEILING: 'Kühldecke',
          DEVICE_TYPE_COOLING_DISTRIBUTOR: 'Kühlverteiler',
          DEVICE_TYPE_VENTILATION_MONOBLOCK: 'Lüftungsmonoblock',
          DEVICE_TYPE_NEUTRALIZATION_SYSTEM: 'Neutralisationsanlage',
          DEVICE_TYPE_PURE_WATER_SYSTEM: 'Reinwasseranlage',
          DEVICE_TYPE_WATER_SYSTEM_SEPARATOR: 'Systemtrenner Wasser',
          DEVICE_TYPE_RECIRCULATING_AIR_COOLING_UNIT: 'Umluft -Kühlgerät',
          DEVICE_TYPE_RECIRCULATING_AIR_COOLER: 'Umluftkühler',
          DEVICE_TYPE_STAIR: 'Treppe',
          DEVICE_TYPE_WARDROBE: 'Garderobe',
          DEVICE_TYPE_COAT_HOOKS: 'Kleiderhaken',
          DEVICE_TYPE_GATE: 'Tor',
          DEVICE_TYPE_CURTAIN_RAIL: 'Vorhangschiene'
        },
        systemValues: {
          DEVICE_SYSTEM_MASTER_BUILDER_WORK: 'Baumeisterarbeiten',
          DEVICE_SYSTEM_WINDOW_DOOR: 'Fenster, Aussentüren, Tore',
          DEVICE_SYSTEM_ROOFING: 'Bedachungsarbeiten',
          DEVICE_SYSTEM_SEALING_INSULATION: 'Spezielle Dichtungen und Dämmungen',
          DEVICE_SYSTEM_FACADE_PLASTER: 'Fassadenputze',
          DEVICE_SYSTEM_OUTER_FINISHES: 'Äussere Abschlüsse, Sonnenschutz',
          DEVICE_SYSTEM_HEAVY_CURRENT_INSTALLATION: 'Starkstrominstallationen',
          DEVICE_SYSTEM_LIGHTS: 'Leuchten- und Lampenlieferung',
          DEVICE_SYSTEM_TELEPHONE: 'Telefonanlage',
          DEVICE_SYSTEM_LOW_CURRENT_INSTALLATION: 'Allgemeine Schwachstrominstallationen',
          DEVICE_SYSTEM_OTHER_ELECTRICITY: 'Übriges',
          DEVICE_SYSTEM_HEATING_TRANSITION_POSITION: 'Übergangsposition',
          DEVICE_SYSTEM_ENERGY_SUPPLY: 'Zulieferung Energieträger, Lagerung, Gasleitung',
          DEVICE_SYSTEM_HEAT_GENERATION: 'Wärmeerzeugung/Abwärmenutzung',
          DEVICE_SYSTEM_HEAT_DISTRIBUTION: 'Wärmeverteilung',
          DEVICE_SYSTEM_VENTILATION: 'Lüftungsanlagen',
          DEVICE_SYSTEM_AIR_CONDITIONING: 'Klimaanlagen',
          DEVICE_SYSTEM_COOLING: 'Kälteanlagen',
          DEVICE_SYSTEM_SPECIAL_FACILITY: 'Spezialanlagen',
          DEVICE_SYSTEM_INSULATION: 'Dämmungen HLK-Installationen',
          DEVICE_SYSTEM_SANITARY: 'Allgemeine Sanitärapparate',
          DEVICE_SYSTEM_SPECIAL_SANITARY: 'Spezielle Sanitärapparate',
          DEVICE_SYSTEM_SANITARY_SUPPLY_DISPOSAL: 'Sanitäre Ver- und Entsorgungsapparate',
          DEVICE_SYSTEM_SANITARY_PIPING: 'Sanitärleitungen',
          DEVICE_SYSTEM_SANITARY_INSULATION: 'Dämmungen Sanitärinstallationen',
          DEVICE_SYSTEM_SANITARY_EQUIPMENT: 'Sanitärinstallationselemente',
          DEVICE_SYSTEM_ELECTRIC_PNEUMATIC_BOARD: 'Elektro- und Pneumatiktafeln',
          DEVICE_SYSTEM_KITCHEN_EQUIPMENT: 'Kücheneinrichtungen',
          DEVICE_SYSTEM_OTHER_SANITARY: 'Übriges',
          DEVICE_SYSTEM_ELEVATOR: 'Aufzüge',
          DEVICE_SYSTEM_MOVING_STAIRCASE: 'Fahrtreppen, Fahrsteige',
          DEVICE_SYSTEM_FACADE_CLEANING: 'Fassadenreinigungsanlagen',
          DEVICE_SYSTEM_GOODS_CONVEYING: 'Sonstige Förderanlagen',
          DEVICE_SYSTEM_LIFTING: 'Hebeeinrichtungen',
          DEVICE_SYSTEM_PARKING: 'Parkieranlagen',
          DEVICE_SYSTEM_STORAGE: 'Lageranlagen',
          DEVICE_SYSTEM_TRANSPORT_OTHER: 'Übriges',
          DEVICE_SYSTEM_PLASTERER: 'Gipserarbeiten',
          DEVICE_SYSTEM_METAL: 'Metallbauarbeiten',
          DEVICE_SYSTEM_CARPENTER: 'Schreinerarbeiten/Türen',
          DEVICE_SYSTEM_WINDOW: 'Fenster',
          DEVICE_SYSTEM_LOCKING: 'Schliessanlagen',
          DEVICE_SYSTEM_INTERIOR_FINISHES: 'Innere Abschlüsse',
          DEVICE_SYSTEM_ELEMENT_WALL: 'Elementwände',
          DEVICE_SYSTEM_CHROME_STEEL_FACILITY: 'Einbauten, Einrichtungen in Chromstahl',
          DEVICE_SYSTEM_OTHER_INTERIOR1: 'Übriges',
          DEVICE_SYSTEM_FLOORING: 'Bodenbeläge',
          DEVICE_SYSTEM_WALL_COVERING: 'Wandbeläge, Wandbekleidungen',
          DEVICE_SYSTEM_CEILING: 'Deckenbekleidungen',
          DEVICE_SYSTEM_INTERIOR_SURFACE_TREATMENTS: 'Innere Oberflächenbehandlungen',
          DEVICE_SYSTEM_OTHER_INTERIOR2: 'Übriges',
          DEVICE_SYSTEM_OTHER_TRANSPORT: 'Übriges',
          DEVICE_SYSTEM_GARDEN_TRANSITION_POSITION: 'Übergangsposition',
          DEVICE_SYSTEM_GARDENING: 'Gärtnerarbeiten',
          DEVICE_SYSTEM_FENCING: 'Einfriedungen',
          DEVICE_SYSTEM_SUPERSTRUCTURE: 'Aufbauten',
          DEVICE_SYSTEM_PLAYGROUND: 'Spiel- und Sportplätze',
          DEVICE_SYSTEM_GARDEN_OTHER: 'Übriges',
          DEVICE_SYSTEM_DEVICE_TRANSITION_POSITION: 'Übergangsposition',
          DEVICE_SYSTEM_MEASUREMENT_CONTROL_TECHNOLOGY: 'Spezialanlagen',
          DEVICE_SYSTEM_MEASUREMENT_CONTROL_TECHNOLOGY_CONTROL_SYSTEM: 'Spezialanlagen'
        },
        facilityPlant: {
          title: 'Gewerk',
          DEVICE_FACILITY_SHELL_CONSTRUCTION1: 'Rohbau 1',
          DEVICE_FACILITY_SHELL_CONSTRUCTION2: 'Rohbau 2',
          DEVICE_FACILITY_PLANT_ELECTRICITY: 'Elektroanlagen',
          DEVICE_FACILITY_PLANT_AIR_CONDITIONING: 'Heizungs-, Lüftungs-, Klima und Kälteanlagen',
          DEVICE_FACILITY_PLANT_SANITARY: 'Sanitäranlagen',
          DEVICE_FACILITY_PLANT_TRANSPORT_WAREHOUSE: 'Transportanlagen',
          DEVICE_FACILITY_PLANT_INTERIOR1: 'Ausbau 1',
          DEVICE_FACILITY_PLANT_INTERIOR2: 'Ausbau 2',
          DEVICE_FACILITY_PLANT_GARDEN: 'Gartenanlagen',
          DEVICE_FACILITY_PLANT_DEVICE: 'Geräte'
        },
        eMainGroup: {
          DEVICE_E_MAIN_GROUP_UNDEFINED: '-',
          DEVICE_E_MAIN_GROUP_CONSTRUCTION_BUILDING: 'Konstruktion Gebäude',
          DEVICE_E_MAIN_GROUP_BUILDING_TECHNOLOGY: 'Technik Gebäude',
          DEVICE_E_MAIN_GROUP_BUILDING_EXTERIOR_WALL_CLADDING: 'Äussere Wandbekleidung Gebäude',
          DEVICE_E_MAIN_GROUP_ROOFING_BUILDING: 'Bedachung Gebäude',
          DEVICE_E_MAIN_GROUP_EXPANSION_BUILDING: 'Ausbau Gebäude',
          DEVICE_E_MAIN_GROUP_USESPECIFIC_FACILITY_BUILDING: 'Nutzungsspezifische Anlage Gebäude',
          DEVICE_E_MAIN_GROUP_SURROUNDINGS_BUILDING: 'Umgebung Gebäude',
          DEVICE_E_MAIN_GROUP_EQUIPMENT_BUILDING: 'Ausstattung'
        },
        eElementGroup: {
          DEVICE_E_ELEMENT_GROUP_UNDEFINED: '-',
          DEVICE_E_ELEMENT_GROUP_BASE_PLATE: 'Bodenplatte, Fundament',
          DEVICE_E_ELEMENT_GROUP_WALL_CONSTRUCTION: 'Wandkonstruktion',
          DEVICE_E_ELEMENT_GROUP_SUPPORT_STRUCTURE: 'Stützenkonstruktion',
          DEVICE_E_ELEMENT_GROUP_CEILING_CONSTRUCTION: 'Deckenkonstruktion, Dachkonstrucktion',
          DEVICE_E_ELEMENT_GROUP_COMPLEMENTARY_SERVICE_CONSTRUCTION: 'Ergänzende Leistung zu Konstruktion',
          DEVICE_E_ELEMENT_GROUP_ELECTRICAL_PLANT: 'Elektroanlage',
          DEVICE_E_ELEMENT_GROUP_BUILDING_AUTOMATION: 'Gebäudeautomation',
          DEVICE_E_ELEMENT_GROUP_SECRURITY_SYSTEM: 'Sicherheitsanlage',
          DEVICE_E_ELEMENT_GROUP_TECHNICAL_FIRE_PROTECTION_SYSTEM: 'Technische Brandschutzanlage',
          DEVICE_E_ELEMENT_GROUP_HEATING_SYSTEM: 'Wärmeanlage',
          DEVICE_E_ELEMENT_GROUP_COOLING_SYSTEM: 'Kälteanlage',
          DEVICE_E_ELEMENT_GROUP_VENTILATION_SYSTEM: 'Lufttechnische Anlage',
          DEVICE_E_ELEMENT_GROUP_WATER_GAS_COMPRESSED_AIR_SYSTEM: 'Wasser-, Gas-, Druckluftanlage',
          DEVICE_E_ELEMENT_GROUP_TRANSPORT_SYSTEM: 'Transportanlage',
          DEVICE_E_ELEMENT_GROUP_EXTERIOR_WALL_CLADDING_UNDER_TERRAIN: 'Äussere Wandbekleidung unter Terrain',
          DEVICE_E_ELEMENT_GROUP_EXTERIOR_WALL_CLADDING_OVER_TERRAIN: 'Äussere Wandbekleidung über Terrain',
          DEVICE_E_ELEMENT_GROUP_INSTALLED_OUTER_WALL: 'Einbaute zu Aussenwand',
          DEVICE_E_ELEMENT_GROUP_ROOFING: 'Dachhaut',
          DEVICE_E_ELEMENT_GROUP_INSTALLED_ROOF: 'Einbaute zu Dach',
          DEVICE_E_ELEMENT_GROUP_PARTITION_WALL: 'Trennwand, Tür, Tor',
          DEVICE_E_ELEMENT_GROUP_FLOORING: 'Bodenbelag',
          DEVICE_E_ELEMENT_GROUP_WALL_COVERING: 'Wandbekleidung',
          DEVICE_E_ELEMENT_GROUP_CEILING_CLADDING: 'Deckenbekleidung',
          DEVICE_E_ELEMENT_GROUP_BUILTIN_PROTECTIVE_DEVICE: 'Einbaute, Schutzeinrichtung zu Ausbau',
          DEVICE_E_ELEMENT_GROUP_SUPPLEMENTARY_SERVICE_EXPANSION: 'Ergänzende Leistung zu Ausbau',
          DEVICE_E_ELEMENT_GROUP_PRODUCTION_PLANT: 'Produktionsanlage, Laboranlage',
          DEVICE_E_ELEMENT_GROUP_COMMERCIAL_KITCHEN: 'Grossküche',
          DEVICE_E_ELEMENT_GROUP_LAUNDRY_PLANT: 'Wäschereianlage, Reinigungsanlage',
          DEVICE_E_ELEMENT_GROUP_HOSPITAL_FACILITY: 'Spitalanlage',
          DEVICE_E_ELEMENT_GROUP_FACILITY_EDUCATION: 'Anlage für Bildung, Kultur',
          DEVICE_E_ELEMENT_GROUP_SPORTS_FACILITY: 'Sportanlage, Freizeitanlage',
          DEVICE_E_ELEMENT_GROUP_USESPECIFIC_PLANT: 'Weitere nutzungsspezifische Anlage',
          DEVICE_E_ELEMENT_GROUP_SURROUNDING_DESIGN: 'Umgebungsgestaltung',
          DEVICE_E_ELEMENT_GROUP_SURROUNDING_STRUCTURE: 'Umgebungsbauwerk',
          DEVICE_E_ELEMENT_GROUP_GREEN_AREA: 'Grünfläche',
          DEVICE_E_ELEMENT_GROUP_HARD_SURFACE: 'Hartfläche',
          DEVICE_E_ELEMENT_GROUP_PROTECTIVE_DEVICE_SURROUNDINGS: 'Schutzeinrichtung Umgebung',
          DEVICE_E_ELEMENT_GROUP_TECHNOLOGY_SURROUNDINGS: 'Technik Umgebung',
          DEVICE_E_ELEMENT_GROUP_EQUIPMENT_SURROUNDINGS: 'Ausstattung Umgebung',
          DEVICE_E_ELEMENT_GROUP_SMALL_INVENTORY: 'Kleininventar',
          DEVICE_E_ELEMENT_GROUP_ART_ON_BUILDING: 'Kunst am Bau'
        },
        eElement: {
          DEVICE_E_ELEMENT_UNDEFINED: '-',
          DEVICE_E_ELEMENT_SEWERAGE_BUILDING: 'Kanalisation Gebäude',
          DEVICE_E_ELEMENT_SEALING: 'Abdichtung, Dämmung Bodenplatte',
          DEVICE_E_ELEMENT_SINGLE_FOUNDATION: 'Einzelfundament, Streifenfundament',
          DEVICE_E_ELEMENT_NON_SUPPORTING_FLOOR_SLAB: 'Nicht tragende Bodenplatte',
          DEVICE_E_ELEMENT_SUPPORTING_FLOOR_SLAB: 'Tragende Bodenplatte',
          DEVICE_E_ELEMENT_EXTERNAL_WALL_CONSTRUCTION: 'Aussenwandkonstruktion',
          DEVICE_E_ELEMENT_INTERIOR_WALL_CONSTRUCTION: 'Innenwandkonstruktion',
          DEVICE_E_ELEMENT_EXTERNAL_SUPPORT: 'Aussenstütze',
          DEVICE_E_ELEMENT_INNER_SUPPORT: 'Innenstütze',
          DEVICE_E_ELEMENT_CEILING: 'Decke',
          DEVICE_E_ELEMENT_STAIRS: 'Treppe, Rampe',
          DEVICE_E_ELEMENT_BALCONY: 'Balkon',
          DEVICE_E_ELEMENT_ROOF_CONSTRUCTION: 'Dachkonstruktion',
          DEVICE_E_ELEMENT_CHIMNEY: 'Schornstein',
          DEVICE_E_ELEMENT_BREAKTHROUGH_CONSTRUCTION: 'Durchbruch, Schlitz zu Konstruktion',
          DEVICE_E_ELEMENT_MACHINE_BASE: 'Maschinensockel, Einlage',
          DEVICE_E_ELEMENT_PLANT_HEAVY_CURRENT: 'Apparat, Anlage Starkstrom',
          DEVICE_E_ELEMENT_HEAVY_CURRENT_INSTALLATION: 'Installation Starkstrom',
          DEVICE_E_ELEMENT_LUMINAIRE: 'Leuchte',
          DEVICE_E_ELEMENT_ELECTRICAL_DEVICE: 'Elektrogerät',
          DEVICE_E_ELEMENT_PLANT_WEAK_CURRENT: 'Apparat, Anlage Schwachstrom',
          DEVICE_E_ELEMENT_LOW_CURRENT_INSTALLATION: 'Installation Schwachstrom',
          DEVICE_E_ELEMENT_MANAGEMENT_LEVEL: 'Managementebene',
          DEVICE_E_ELEMENT_AUTOMATION_LEVEL: 'Automationsebene',
          DEVICE_E_ELEMENT_FIELD_LEVEL: 'Feldebene',
          DEVICE_E_ELEMENT_ROOM_AUTOMATION: 'Raumautomation',
          DEVICE_E_ELEMENT_AUTOMATION_NETWORK: 'Automationsnetzwerk',
          DEVICE_E_ELEMENT_SWITCHGEAR_COMBINATION: 'Schaltgerätekombination',
          DEVICE_E_ELEMENT_INTEGRATION: 'Integration',
          DEVICE_E_ELEMENT_CENTRAL_CLOCK_SYSTEM: 'Zentrale Uhrenanlage',
          DEVICE_E_ELEMENT_BURGLAR_ALARM_SYSTEM: 'Einbruchmeldeanlage, Überfallmeldeanlage',
          DEVICE_E_ELEMENT_ACCESS_CONTROL_SYSTEM: 'Zutrittskontrollanlage',
          DEVICE_E_ELEMENT_VIDEO_SURVEILLANCE_SYSTEM: 'Videoüberwachungsanlage',
          DEVICE_E_ELEMENT_PERIMETER_PROTECTION: 'Perimeterschutz, Umgebungsschutz',
          DEVICE_E_ELEMENT_FIRE_ALARM_SYSTEM: 'Brandmeldeanlage',
          DEVICE_E_ELEMENT_GAS_DETECTION_SYSTEM: 'Gasmeldeanlage',
          DEVICE_E_ELEMENT_WET_EXTINGUISHING_SYSTEM: 'Nasslöschanlage',
          DEVICE_E_ELEMENT_DRY_EXTINGUISHING_SYSTEM: 'Trockenlöschanlage',
          DEVICE_E_ELEMENT_EXTINGUISHING_SYSTEM: 'Löschgerät',
          DEVICE_E_ELEMENT_SMOKE_HEAT_EXTRACTION_SYSTEM: 'Rauch- und Wärmeabzugsanlage',
          DEVICE_E_ELEMENT_STORAGE_HEAT_PLANT: 'Lagerung zu Wärmeanlage',
          DEVICE_E_ELEMENT_HEAT_GENERATION: 'Wärmeerzeugung',
          DEVICE_E_ELEMENT_MAIN_HEAT_DISTRIBUTION: 'Wärmehauptverteilung',
          DEVICE_E_ELEMENT_HEAT_OUTPUT: 'Wärmeabgabe',
          DEVICE_E_ELEMENT_STORAGE_REFRIGERATION_PLANT: 'Lagerung zu Kälteanlage',
          DEVICE_E_ELEMENT_REFRIGERATION: 'Kälteerzeugung',
          DEVICE_E_ELEMENT_COOLING_MAIN_DISTRIBUTION: 'Kältehauptverteilung',
          DEVICE_E_ELEMENT_COLD_OUTPUT: 'Kälteabgabe',
          DEVICE_E_ELEMENT_FRESH_AIR_DUCTING: 'Aussenluftführung, Fortluftführung',
          DEVICE_E_ELEMENT_AIR_PREPARATION: 'Luftaufbereitung',
          DEVICE_E_ELEMENT_MAIN_AIR_DISTRIBUTION: 'Lufthauptverteilung',
          DEVICE_E_ELEMENT_AIR_OUTPUT: 'Luftabgabe',
          DEVICE_E_ELEMENT_SMALL_SYSTEM_SUPPLY_AIR: 'Kleinanlage für Zuluft, Abluft',
          DEVICE_E_ELEMENT_ARMATURE_APPARATUS: 'Armatur, Apparat',
          DEVICE_E_ELEMENT_INSTALLATION_ELEMENT: 'Installationselement',
          DEVICE_E_ELEMENT_WATER_TREATMENT_PLANT: 'Wasseraufbereitungsanlage, Abwasseraufbereitungsanlage',
          DEVICE_E_ELEMENT_SUPPLY_LINE: 'Versorgungsleitung',
          DEVICE_E_ELEMENT_DISPOSAL_LINE: 'Entsorgungsleitung',
          DEVICE_E_ELEMENT_GAS_SYSTEM: 'Gasanlage',
          DEVICE_E_ELEMENT_COMPRESSED_AIR_SYSTEM: 'Druckluftanlage, Vakuumanlage',
          DEVICE_E_ELEMENT_PASSENGER_ELEVATOR: 'Personenaufzug',
          DEVICE_E_ELEMENT_FREIGHT_ELEVATOR: 'Lastenaufzug',
          DEVICE_E_ELEMENT_BED_ELEVATOR: 'Bettenaufzug',
          DEVICE_E_ELEMENT_ESCALATOR: 'Fahrtreppe, Fahrsteig',
          DEVICE_E_ELEMENT_LIFTING_TABLE: 'Hubtisch, Verladestation, Spezialaufzug',
          DEVICE_E_ELEMENT_PARKING_FACILITY: 'Parkieranlage',
          DEVICE_E_ELEMENT_OTHER_TRANSPORT_SYSTEM: 'Weitere Transportanlage',
          DEVICE_E_ELEMENT_WALL_SEALING_UNDER_TERRAIN: 'Wandabdichtung unter Terrain',
          DEVICE_E_ELEMENT_EXTERNAL_THERMAL_INSULATION_UNDER_TERRAIN: 'Aussenwärmedämmung unter Terrain',
          DEVICE_E_ELEMENT_PROTECTIVE_LAYER_UNDER_TERRAIN: 'Schutzschicht unter Terrain',
          DEVICE_E_ELEMENT_EXTERNAL_COATING: 'Äussere Beschichtung',
          DEVICE_E_ELEMENT_EXTERIOR_THERMAL_INSULATION: 'Aussenwärmedämmung',
          DEVICE_E_ELEMENT_FACADE_CLADDING: 'Fassadenbekleidung',
          DEVICE_E_ELEMENT_FACADE_SYSTEM: 'Fassadensystem',
          DEVICE_E_ELEMENT_UNDERSIDE_CLADDING: 'Bekleidung Untersicht',
          DEVICE_E_ELEMENT_FALL_PROTECTION: 'Absturzsicherung',
          DEVICE_E_ELEMENT_WINDOW: 'Fenster',
          DEVICE_E_ELEMENT_DOOR: 'Tür, Tor',
          DEVICE_E_ELEMENT_SUN_PROTECTION: 'Sonnenschutz',
          DEVICE_E_ELEMENT_ROOF_WATERPROOFING_UNDER_TERRAIN: 'Dachabdichtung unter Terrain',
          DEVICE_E_ELEMENT_FLAT_ROOF: 'Flachdach',
          DEVICE_E_ELEMENT_INCLINED_ROOF: 'Geneigtes Dach',
          DEVICE_E_ELEMENT_LIGHTNING_PROTECTION: 'Blitzschutz',
          DEVICE_E_ELEMENT_BUILTIN_FLAT_ROOF: 'Einbaute zu Flachdach',
          DEVICE_E_ELEMENT_BUILTIN_SLOPING_ROOF: 'Einbaute zu geneigtem Dach',
          DEVICE_E_ELEMENT_FIXED_PARTITION_WALL: 'Feststehende Trennwand',
          DEVICE_E_ELEMENT_MOVABLE_PARTITION_WALL: 'Bewegliche Trennwand',
          DEVICE_E_ELEMENT_INTERIOR_WINDOWS: 'Innenfenster',
          DEVICE_E_ELEMENT_INTERIOR_DOOR: 'Innentür, Innentor',
          DEVICE_E_ELEMENT_DARKENING: 'Verdunkelung',
          DEVICE_E_ELEMENT_SUBSTRUCTURE_FLOOR_COVERING: 'Unterkonstruktion zu Bodenbelag',
          DEVICE_E_ELEMENT_FINISHED_FLOOR_COVERING: 'Fertiger Bodenbelag',
          DEVICE_E_ELEMENT_SUBSTRUCTURE_WALL_CLADDING: 'Unterkonstruktion zu Wandbekleidung',
          DEVICE_E_ELEMENT_FINISHED_WALL_COVERING: 'Fertige Wandbekleidung',
          DEVICE_E_ELEMENT_SUBSTRUCTURE_CEILING_CLADDING: 'Unterkonstruktion zu Deckenbekleidung',
          DEVICE_E_ELEMENT_FINISHED_CEILING_CLADDING: 'Fertige Deckenbekleidung',
          DEVICE_E_ELEMENT_BUILTIN_CABINET: 'Einbauschrank, Regal',
          DEVICE_E_ELEMENT_BUILTIN_KITCHEN: 'Einbauküche',
          DEVICE_E_ELEMENT_INTERIOR_WINDOW_FINISHING: 'Innerer Fensterausbau',
          DEVICE_E_ELEMENT_PROTECTIVE_DEVICE: 'Schutzeinrichtung',
          DEVICE_E_ELEMENT_STOVE: 'Ofen, Cheminée',
          DEVICE_E_ELEMENT_SMALL_COMPONENT: 'Kleinbauteil',
          DEVICE_E_ELEMENT_GREENERY_IN_BUILDING: 'Begrünung im Gebäude',
          DEVICE_E_ELEMENT_BREAKTHROUGH_EXTENSION: 'Durchbruch, Schlitz zu Ausbau',
          DEVICE_E_ELEMENT_PARTITIONING: 'Abschottung',
          DEVICE_E_ELEMENT_CLEANING: 'Reinigung',
          DEVICE_E_ELEMENT_SUPPLY: 'Versorgung, Entsorgung für Produktionsanlage, Laboranlage',
          DEVICE_E_ELEMENT_APPARATUS_PRODUCTION_PLANT: 'Apparat für Produktionsanlage, Laboranlage',
          DEVICE_E_ELEMENT_CONTROL_SYSTEM_PRODUCTION_PLANT: 'Steuerung für Produktionsanlage, Laboranlage',
          DEVICE_E_ELEMENT_INSTALLED_PRODUCTION_PLANT: 'Einbaute in Produktionsanlage, Laboranlage',
          DEVICE_E_ELEMENT_SUPPLY_KITCHEN: 'Versorgung, Entsorgung für Grossküche',
          DEVICE_E_ELEMENT_APPARATUS_KITCHEN: 'Apparat für Grossküche',
          DEVICE_E_ELEMENT_CONTROL_SYSTEM_KITCHEN: 'Steuerung für Grossküche',
          DEVICE_E_ELEMENT_INSTALLATION_KITCHEN: 'Einbaute in Grossküche',
          DEVICE_E_ELEMENT_SUPPLY_LAUNDRY_PLANT: 'Versorgung, Entsorgung für Wäschereianlage, Reinigungsanlage',
          DEVICE_E_ELEMENT_APPARATUS_LAUNDRY_PLANT: 'Apparat für Wäschereianlage, Reinigungsanlage',
          DEVICE_E_ELEMENT_CONTROL_LAUNDRY_PLANT: 'Steuerung für Wäschereianlage, Reinigungsanlage',
          DEVICE_E_ELEMENT_INSTALLATION_LAUNDRY_PLANT: 'Einbaute in Wäschereianlage, Reinigungsanlage',
          DEVICE_E_ELEMENT_VITAL_DATA_MONITORING: 'Vitaldatenüberwachung, Diagnostik',
          DEVICE_E_ELEMENT_DEVICE_CARE: 'Gerät für Pflege',
          DEVICE_E_ELEMENT_TREATMENT_DEVICE: 'Gerät für Behandlung',
          DEVICE_E_ELEMENT_MEASURE: 'Messen, Analysieren',
          DEVICE_E_ELEMENT_CLEANING_DISINFECION: 'Reinigung, Desinfektion, Sterilisation',
          DEVICE_E_ELEMENT_MEDICAL_FURNITURE: 'Medizinisches Mobiliar',
          DEVICE_E_ELEMENT_MEDICAL_TRANSPORT: 'Medizinisches Transportmittel',
          DEVICE_E_ELEMENT_OPERATING_EQUIPMENT: 'Betriebsmittel',
          DEVICE_E_ELEMENT_SUPPLY_EDUCATION: 'Versorgung, Entsorgung für Bildung, Kultur',
          DEVICE_E_ELEMENT_APPARATUS_EDUCATION: 'Apparat für Bildung, Kultur',
          DEVICE_E_ELEMENT_CONTROL_EDUCATION: 'Steuerung für Bildung, Kultur',
          DEVICE_E_ELEMENT_FITTED_EDUCATION: 'Einbaute für Bildung, Kultur',
          DEVICE_E_ELEMENT_SUPPLY_SPORTS_FACILITY: 'Versorgung, Entsorgung für Sportanlage, Freizeitanlage',
          DEVICE_E_ELEMENT_APPARATUS_SPORTS_FACILITY: 'Apparat für Sportanlage, Freizeitanlage',
          DEVICE_E_ELEMENT_CONTROL_SPORTS_FACILITY: 'Steuerung für Sportanlage, Freizeitanlage',
          DEVICE_E_ELEMENT_FIXTURES_SPORTS_FACILITY: 'Einbaute für Sportanlage, Freizeitanlage',
          DEVICE_E_ELEMENT_SUPPLY_USESPECIFIC_FACILITY: 'Versorgung, Entsorgung für nutzungsspezifische Anlage',
          DEVICE_E_ELEMENT_APPARATUS_USESPECIFIC_FACILITY: 'Apparat für nutzungsspezifische Anlage',
          DEVICE_E_ELEMENT_CONTROL_USESPECIFIC_FACILITY: 'Steuerung für nutzungsspezifische Anlage',
          DEVICE_E_ELEMENT_INSTALLED_USESPECIFIC_FACILITY: 'Einbaute in nutzungsspezifische Anlage',
          DEVICE_E_ELEMENT_TERRAIN_ADJUSTMENT: 'Geländeanpassung',
          DEVICE_E_ELEMENT_SLOPE_STABILIZATION_SURROUNDINGS: 'Böschungssicherung Umgebung',
          DEVICE_E_ELEMENT_PLANT_STAND_PROTECTION: 'Schutz Pflanzenbestand',
          DEVICE_E_ELEMENT_DRAINAGE: 'Entwässerung',
          DEVICE_E_ELEMENT_EXTERIOR_CONSTRUCTION: 'Konstruktion im Aussenbereich',
          DEVICE_E_ELEMENT_EXTERIOR_ROOFING: 'Überdachung im Aussenbereich',
          DEVICE_E_ELEMENT_RETAINING_WALL: 'Stützmauer',
          DEVICE_E_ELEMENT_FREE_STANDING_WALL: 'Frei stehende Wand',
          DEVICE_E_ELEMENT_SMALL_STRUCTURE: 'Kleinbauwerk',
          DEVICE_E_ELEMENT_VEGETATION_LAYER: 'Vegetationsschicht',
          DEVICE_E_ELEMENT_LAWN: 'Rasen',
          DEVICE_E_ELEMENT_PLANTING: 'Bepflanzung',
          DEVICE_E_ELEMENT_WATER_AREA: 'Wasserfläche',
          DEVICE_E_ELEMENT_FOUNDATION_LAYER: 'Fundationsschicht',
          DEVICE_E_ELEMENT_CONCLUSION: 'Abschluss',
          DEVICE_E_ELEMENT_COVERING: 'Belag',
          DEVICE_E_ELEMENT_TRACK_SUPERSTRUCTURE: 'Gleisoberbau',
          DEVICE_E_ELEMENT_RESTRAINT_SYSTEM: 'Rückhaltesystem',
          DEVICE_E_ELEMENT_ENCLOSURE: 'Einfriedung',
          DEVICE_E_ELEMENT_IMMISSION_CONTROL: 'Immissionsschutz',
          DEVICE_E_ELEMENT_ELECTRICAL_SYSTEM_SURROUNDINGS: 'Elektroanlage Umgebung',
          DEVICE_E_ELEMENT_HEAT_PLANT_SURROUNDINGS: 'Wärmeanlage Umgebung',
          DEVICE_E_ELEMENT_REFRIGERATION_SYSTEM_SURROUNDINGS: 'Kälteanlage Umgebung',
          DEVICE_E_ELEMENT_WATER_GAS_AIR_SYSTEM: 'Wasser-, Gas-, Druckluftanlage Umgebung',
          DEVICE_E_ELEMENT_TRANSPORT_SYSTEM_ENVIRONMENT: 'Transportanlage Umgebung',
          DEVICE_E_ELEMENT_EQUIPMENT_ITEM: 'Ausstattungsgegenstand',
          DEVICE_E_ELEMENT_DEVICE_ENVIRONMENT: 'Gerät Umgebung',
          DEVICE_E_ELEMENT_GENERAL_FURNITURE: 'Allgemeines Mobiliar',
          DEVICE_E_ELEMENT_USESPECIFIC_SMALL_INVENTORY: 'Nutzungsspezifisches Kleininventar',
          DEVICE_E_ELEMENT_MOBILE_DEVICE: 'Mobiles Gerät',
          DEVICE_E_ELEMENT_ART_OBJECT: 'Kunstobjekt'
        },
        eSubElement: {
          DEVICE_E_SUB_ELEMENT_UNDEFINED: '-',
          DEVICE_E_SUB_ELEMENT_SEWERAGE: 'Kanalisation',
          DEVICE_E_SUB_ELEMENT_LOAD_BEARING_EXTERIOR_WALLS: 'Lasttragende Aussenwände',
          DEVICE_E_SUB_ELEMENT_LOAD_BEARING_INTERIOR_WALLS: 'Lasttragende Innenwände',
          DEVICE_E_SUB_ELEMENT_HIGH_VOLATAGE_PLANT: 'Hochspannungsanlage',
          DEVICE_E_SUB_ELEMENT_MEDIUM_VOLTAGE_PLANT: 'Mittelspannungsanlage',
          DEVICE_E_SUB_ELEMENT_LOW_VOLTAGE_PLANT: 'Niederspannungsanlage',
          DEVICE_E_SUB_ELEMENT_COMPENSATION: 'Kompensation',
          DEVICE_E_SUB_ELEMENT_POWER_GENERATION_PLANTS: 'Energieerzeugungsanlagen',
          DEVICE_E_SUB_ELEMENT_EMERGENCY_POWER_PLANT: 'Notstromanlage',
          DEVICE_E_SUB_ELEMENT_BATTERY_CHARGING_DEVICE: 'Batterie- und Ladeeinrichtung',
          DEVICE_E_SUB_ELEMENT_EMERGENCY_LIGHTING_SYSTEM: 'Notlichtanlage',
          DEVICE_E_SUB_ELEMENT_LIGHTING: 'Beleuchtung',
          DEVICE_E_SUB_ELEMENT_LUMINAIRE: 'Leuchte',
          DEVICE_E_SUB_ELEMENT_MEASURING_DEVICE: 'Messeinrichtung (Elektro)',
          DEVICE_E_SUB_ELEMENT_COMMUNICATION_SYSTEM: 'Kommunikationsanlage',
          DEVICE_E_SUB_ELEMENT_SECURITY_SYSTEM: 'Sicherheitssystem',
          DEVICE_E_SUB_ELEMENT_MANAGEMENT_STATION: 'Managementstation',
          DEVICE_E_SUB_ELEMENT_AUTOMATION_STATION: 'Automationsstation',
          DEVICE_E_SUB_ELEMENT_ACCESS_CONTROL_SYSTEM: 'Zutrittskontrollanlage',
          DEVICE_E_SUB_ELEMENT_SEPARATING_SYSTEM: 'Vereinzelungsanlagen',
          DEVICE_E_SUB_ELEMENT_BARRIER_SYSTEM: 'Schrankenanlage',
          DEVICE_E_SUB_ELEMENT_PARKING_CASHIER_SYSTEM: 'Parking- und Kassenanlage',
          DEVICE_E_SUB_ELEMENT_FIRE_ALARM_SYSTEM: 'Brandmeldeanlage',
          DEVICE_E_SUB_ELEMENT_EARLY_FIRE_DETECTION: 'Brandfrüherkennung / Ansaugsystem (RAS) überwacht',
          DEVICE_E_SUB_ELEMENT_FIRE_PROTECTION_CURTAIN: 'Brandschutzvorhang (BS-Vorhang)',
          DEVICE_E_SUB_ELEMENT_WET_EXTINGUISHING_SYSTEMS: 'Nasschlöschanlagen',
          DEVICE_E_SUB_ELEMENT_DRY_EXTINGUISHING_SYSTEMS: 'Trockenlöschanlage',
          DEVICE_E_SUB_ELEMENT_EXTINGUISHING_DEVICE: 'Löschgerät',
          DEVICE_E_SUB_ELEMENT_SMOKE_HEAT_EXTRACTION_SYSTEM: 'Rauch- und Wärmeabzugsanlage Natürlich',
          DEVICE_E_SUB_ELEMENT_TANK_SYSTEM: 'Tankanlage',
          DEVICE_E_SUB_ELEMENT_LEAKAGE_MONITORING: 'Leckageüberwachung',
          DEVICE_E_SUB_ELEMENT_DISTRICT_HEATING: 'Fernwärme / Übergabestation',
          DEVICE_E_SUB_ELEMENT_SOLID_FUEL_STORAGE: 'Festbrennstofflager',
          DEVICE_E_SUB_ELEMENT_CONVEYOR_SYSTEM_FUELS: 'Förderanlage Brennstoffe',
          DEVICE_E_SUB_ELEMENT_HEATING_BURNER_OIL: 'Heizbrenner Oel / Gas',
          DEVICE_E_SUB_ELEMENT_WOOD_STOVE: 'Holz- / Feststoffbrenner / Ofen, Holzofen',
          DEVICE_E_SUB_ELEMENT_STEAM_CONVERTER: 'Dampfumformer',
          DEVICE_E_SUB_ELEMENT_DERIVATION: 'Ableitung',
          DEVICE_E_SUB_ELEMENT_HEAT_PUMP: 'Wärmepumpe',
          DEVICE_E_SUB_ELEMENT_CHP: 'BHKW',
          DEVICE_E_SUB_ELEMENT_EXHAUST_SYSTEM: 'Abgasanlage',
          DEVICE_E_SUB_ELEMENT_HEAT_ACCUMULATOR: 'Wärmespeicher',
          DEVICE_E_SUB_ELEMENT_STATIC_HEATING_SURFACE: 'Statische Heizflächen',
          DEVICE_E_SUB_ELEMENT_DISTRICT_COOLING: 'Fernkälte / Übergabestation',
          DEVICE_E_SUB_ELEMENT_COOLING_MACHINE_INDUSTRY: 'Kältemaschine Industrie',
          DEVICE_E_SUB_ELEMENT_COOLING_MACHINE_COMMERCIAL: 'Kältemaschine Gewerblich',
          DEVICE_E_SUB_ELEMENT_FREE_COOLING: 'Free Cooling',
          DEVICE_E_SUB_ELEMENT_COOLING_UNITS: 'Kühlgeräte',
          DEVICE_E_SUB_ELEMENT_REFRIGERATION_UNITS: 'Kühlmöbel',
          DEVICE_E_SUB_ELEMENT_FREEZERS: 'Tiefkühlgeräte',
          DEVICE_E_SUB_ELEMENT_CLIMATE_SPLITTING_UNIT: 'Klimasplitgerät',
          DEVICE_E_SUB_ELEMENT_RECOOLING: 'Rückkühlung',
          DEVICE_E_SUB_ELEMENT_PH_MONITOR: 'PH-Wächter',
          DEVICE_E_SUB_ELEMENT_COLD_ROOM: 'Kühlraum',
          DEVICE_E_SUB_ELEMENT_COLD_ACCUMULATOR: 'Kältespeicher',
          DEVICE_E_SUB_ELEMENT_COOLING_CEILING: 'Kühldecke',
          DEVICE_E_SUB_ELEMENT_THERMOACTIVE_COMPONENT_SYSTEM: 'TABS (Thermoactive Bauteil System)',
          DEVICE_E_SUB_ELEMENT_SUPPLY_AIR_SYSTEMS: 'Zuluftanlagen',
          DEVICE_E_SUB_ELEMENT_RECIRCULATION_SYSTEMS: 'Umluftanlagen',
          DEVICE_E_SUB_ELEMENT_DEC_PLANT: 'DEC-Anlage',
          DEVICE_E_SUB_ELEMENT_EXHAUST_AIR_SYSTEMS: 'Abluftanlagen',
          DEVICE_E_SUB_ELEMENT_AIR_DUCT: 'Luftkanal',
          DEVICE_E_SUB_ELEMENT_RECIRCULATION_UNIT: 'Umluftgerät',
          DEVICE_E_SUB_ELEMENT_HUMIDICATION: 'Befeuchtung/Entfeuchtung',
          DEVICE_E_SUB_ELEMENT_HEAT_RECOVERY: 'Wärmerückgewinnung (WRG)',
          DEVICE_E_SUB_ELEMENT_KICHEN_EXHAUST_AIR: 'Küchenabluft',
          DEVICE_E_SUB_ELEMENT_VALVE: 'Ventil',
          DEVICE_E_SUB_ELEMENT_SEPARATOR: 'Trenner',
          DEVICE_E_SUB_ELEMENT_PUMP: 'Pumpe',
          DEVICE_E_SUB_ELEMENT_FILTER: 'Filter',
          DEVICE_E_SUB_ELEMENT_MEASURING_PROBE: 'Messsonde',
          DEVICE_E_SUB_ELEMENT_EXPANSION_COMPENSATION_VESSEL: 'Expansions-/Druckausgleichsgefäss',
          DEVICE_E_SUB_ELEMENT_DEGASSING_SYSTEM: 'Entgasungsanlage',
          DEVICE_E_SUB_ELEMENT_BACKWATER_FLAP: 'Rückstauklappe / Rückstaupumpe',
          DEVICE_E_SUB_ELEMENT_WATER_TREATMENT_PLANT: 'Wasseraufbereitungsanlage',
          DEVICE_E_SUB_ELEMENT_WASTE_WATER_TREATMENT_PLANT: 'Abwasseraufbereitungsanlage',
          DEVICE_E_SUB_ELEMENT_HOT_WATER_PREPARATION: 'Warmwasseraufbereitung',
          DEVICE_E_SUB_ELEMENT_SUPPLY_LINE: 'Versorgungsleitung',
          DEVICE_E_SUB_ELEMENT_DISPOSAL_LINE: 'Entsorgungsleitung',
          DEVICE_E_SUB_ELEMENT_INSTALLATION_TECHNICAL_GASES: 'Installation technische Gase',
          DEVICE_E_SUB_ELEMENT_GAS_PRESSURE_REGULATING_STATION: 'Gasdruckregelanlage',
          DEVICE_E_SUB_ELEMENT_COMPRESSED_AIR_SYSTEM: 'Druckluftanlage, Vakuumanlage',
          DEVICE_E_SUB_ELEMENT_PASSENGER_ELEVATOR: 'Personenaufzug',
          DEVICE_E_SUB_ELEMENT_FREIGHT_ELEVATOR: 'Lastenaufzug',
          DEVICE_E_SUB_ELEMENT_ESCALATOR: 'Fahrtreppe, Fahrsteig',
          DEVICE_E_SUB_ELEMENT_LIFTING_TABLE: 'Hubtisch, Verladestation, Spezialaufzug',
          DEVICE_E_SUB_ELEMENT_OTHER_TRANSPORT_SYSTEM: 'Weitere Transportanlage',
          DEVICE_E_SUB_ELEMENT_INTEGRATED_FALL_PROTECTION: 'Integrierte Absturzsicherungen und Tritte',
          DEVICE_E_SUB_ELEMENT_WINDOW_MANUAL: 'Fenster-manuell',
          DEVICE_E_SUB_ELEMENT_WINDOW_MOTORIZED: 'Fenster-motorisiert',
          DEVICE_E_SUB_ELEMENT_ELECTRICAL_EXTERNAL_GATE: 'Elektr. Aussentor',
          DEVICE_E_SUB_ELEMENT_GATE: 'Tor',
          DEVICE_E_SUB_ELEMENT_DOOR: 'Tür',
          DEVICE_E_SUB_ELEMENT_DOOR_SAFETY_DEVICE: 'Türsicherung',
          DEVICE_E_SUB_ELEMENT_FIRE_DOOR: 'Brandschutztüre',
          DEVICE_E_SUB_ELEMENT_ESCAPE_EMERGENCY_EXIT_DOOR: 'Flucht- und Notausgangstüre',
          DEVICE_E_SUB_ELEMENT_EXTERIOR_SHADING: 'Aussenbeschattung',
          DEVICE_E_SUB_ELEMENT_LIGHTING_PROTECTION: 'Blitzschutz',
          DEVICE_E_SUB_ELEMENT_SKYLIGHT_FLAT_ROOF: 'Oberlicht',
          DEVICE_E_SUB_ELEMENT_SKYLIGHT_SLOPING_ROOF: 'Oberlicht',
          DEVICE_E_SUB_ELEMENT_MOVABLE_PARTITION_WALL: 'Bewegliche Trennwand',
          DEVICE_E_SUB_ELEMENT_INTERIOR_DOOR: 'Innentür, Innentor',
          DEVICE_E_SUB_ELEMENT_FIRE_GATES: 'Brandschutztüre/-tore',
          DEVICE_E_SUB_ELEMENT_INTERIOR_SHADING: 'Innen Beschattung',
          DEVICE_E_SUB_ELEMENT_PLANT_PROTECTION_SYSTEM: 'Betriebsschutzanlage',
          DEVICE_E_SUB_ELEMENT_SOIL_VESSEL: 'Bodengefäss',
          DEVICE_E_SUB_ELEMENT_TABLE_VESSEL: 'Tischgefäss',
          DEVICE_E_SUB_ELEMENT_SPECIAL_VESSEL: 'Spezialgefässe',
          DEVICE_E_SUB_ELEMENT_FIRE_PARTITIONING: 'Brandabschottung',
          DEVICE_E_SUB_ELEMENT_SOUND_SEPARATION: 'Schallabschottung',
          DEVICE_E_SUB_ELEMENT_AUTOCLAVE: 'Autoklav',
          DEVICE_E_SUB_ELEMENT_DISHWASHER: 'Geschirrautomat',
          DEVICE_E_SUB_ELEMENT_EYE_SHOWER: 'Augendusche',
          DEVICE_E_SUB_ELEMENT_EMERGENCY_SHOWER: 'Notdusche',
          DEVICE_E_SUB_ELEMENT_FUME_CUPBOARD: 'Laborabzug',
          DEVICE_E_SUB_ELEMENT_MEDIA_COLUMN: 'Mediensäule',
          DEVICE_E_SUB_ELEMENT_ULTRAPURE_WATER_SUPPLY: 'Reinstwasserversorgung',
          DEVICE_E_SUB_ELEMENT_EMPLOYEE_RESTAURANT: 'Mitarbeiterrestaurant / Kundenrestaurant',
          DEVICE_E_SUB_ELEMENT_VITAL_DATA_MONOTORING: 'Vitaldatenüberwachung',
          DEVICE_E_SUB_ELEMENT_XRAY_DIAGNOSTICS: 'Röntgendiagnostik',
          DEVICE_E_SUB_ELEMENT_ULTRASOUND_DIAGNOSTICS: 'Ultraschalldiagnostik',
          DEVICE_E_SUB_ELEMENT_NUCLEAR_DIAGNOSTICS: 'Nukleardiagnostik',
          DEVICE_E_SUB_ELEMENT_MAGNETIC_RESONANCE_DIAGNOSTICS: 'Magnetresonanzdiagnostik',
          DEVICE_E_SUB_ELEMENT_ELECTROMEDICINE: 'Elektromedizin',
          DEVICE_E_SUB_ELEMENT_SPECIAL_DIAGNOSTICS: 'Spezielle Diagnostik',
          DEVICE_E_SUB_ELEMENT_ENDOSCOPY: 'Endoskopie',
          DEVICE_E_SUB_ELEMENT_COMBINED_DIAGNOSTICS: 'Kombinierte, weitere Diagnostik',
          DEVICE_E_SUB_ELEMENT_DEVICE_GENERAL_EXTENDED_CARE: 'Gerät für allgemeine, erweiterte Pflege',
          DEVICE_E_SUB_ELEMENT_ANESTHESIA_DEVICE: 'Gerät für Anästhesie',
          DEVICE_E_SUB_ELEMENT_SURGICAL_DEVICE: 'Gerät für Chirurgie',
          DEVICE_E_SUB_ELEMENT_THERAPY_DEVICE: 'Gerät für Therapie',
          DEVICE_E_SUB_ELEMENT_RADIATION_THERAPY_DEVICE: 'Gerät für Strahlentherapie',
          DEVICE_E_SUB_ELEMENT_DEVICE_PEOPLE_DISABILITIES: 'Gerät für Menschen mit Behinderung, weitere Behandlung',
          DEVICE_E_SUB_ELEMENT_MEDICAL_REFRIGERATION_UNIT: 'Medizinisches Kältegerät, Wärmegerät',
          DEVICE_E_SUB_ELEMENT_HANDLING_SUBSTANCES: 'Umgang mit Stoffen',
          DEVICE_E_SUB_ELEMENT_ANALYSIS: 'Analyse',
          DEVICE_E_SUB_ELEMENT_CLEANING_DISINFECTION: 'Reinigung, Desinfektion',
          DEVICE_E_SUB_ELEMENT_STERILIZATION: 'Sterilisation',
          DEVICE_E_SUB_ELEMENT_CABINET: 'Schrank, Regal, Korpus',
          DEVICE_E_SUB_ELEMENT_TABLE: 'Tisch',
          DEVICE_E_SUB_ELEMENT_SEATING_FURNITURE: 'Sitzmobiliar',
          DEVICE_E_SUB_ELEMENT_BED_COUCH: 'Bett, Liege',
          DEVICE_E_SUB_ELEMENT_MEDICAL_SMALL_FURNITURE: 'Medizinisches Kleinmobiliar',
          DEVICE_E_SUB_ELEMENT_MEDICAL_LIGHT: 'Medizinische Leuchte',
          DEVICE_E_SUB_ELEMENT_MEDICAL_INSTRUMENTS: 'Medizinisches Instrumentarium',
          DEVICE_E_SUB_ELEMENT_MEDICAL_CART: 'Medizinischer Wagen',
          DEVICE_E_SUB_ELEMENT_BEDDING: 'Bettware',
          DEVICE_E_SUB_ELEMENT_SUPPORTING_MATERIAL: 'Stützmaterial',
          DEVICE_E_SUB_ELEMENT_CLOTHING_SUIT: 'Bekleidung, Schutzanzug',
          DEVICE_E_SUB_ELEMENT_COVER: 'Abdeckung',
          DEVICE_E_SUB_ELEMENT_PATIENT_TRANSPORT_DEVICE: 'Gerät für Patiententransport',
          DEVICE_E_SUB_ELEMENT_DEVICE_MATERIAL_TRANSPORT: 'Gerät für Materialtransport',
          DEVICE_E_SUB_ELEMENT_CONSUMABLES: 'Verbrauchsmittel',
          DEVICE_E_SUB_ELEMENT_UTILITY_EQUIPMENT: 'Gebrauchsmittel',
          DEVICE_E_SUB_ELEMENT_PRESSING_PLANT: 'Pressanlage',
          DEVICE_E_SUB_ELEMENT_SHREDDER_PLANT: 'Schredderanlage',
          DEVICE_E_SUB_ELEMENT_CONTAINER_CONVEYOR_SYSTEM: 'Akten-/Behälterförderanlage',
          DEVICE_E_SUB_ELEMENT_BANK_SAFE: 'Banktresor/ Kundentresor',
          DEVICE_E_SUB_ELEMENT_DOCUMENT_DESTRUCTION: 'Aktenvernichtung',
          DEVICE_E_SUB_ELEMENT_FLAGPOLE: 'Fahnenmast',
          DEVICE_E_SUB_ELEMENT_MAIL_DISTRIBUTION_SYSTEM: 'Postverteilanlage / Postbüro',
          DEVICE_E_SUB_ELEMENT_TREES: 'Bäume',
          DEVICE_E_SUB_ELEMENT_PATHS: 'Wege/Plätze',
          DEVICE_E_SUB_ELEMENT_FOUNTAIN: 'Brunnen',
          DEVICE_E_SUB_ELEMENT_DEFIBRILLATOR: 'Defibrillator',
          DEVICE_E_SUB_ELEMENT_WORK_EQUIPMENT: 'Arbeitsmittel',
          DEVICE_E_SUB_ELEMENT_LIFT_TRUCK: 'Hubstapler / Hubwagen'
        },
        eElementType: {
          DEVICE_E_ELEMENT_TYPE_UNDEFINED: '-',
          DEVICE_E_ELEMENT_TYPE_SEWERAGE: 'Kanalisation',
          DEVICE_E_ELEMENT_TYPE_EXTERIOR_WALLS: 'Aussenwände',
          DEVICE_E_ELEMENT_TYPE_INTERIOR_WALLS: 'Innenwände',
          DEVICE_E_ELEMENT_TYPE_CONTAINER: 'Container',
          DEVICE_E_ELEMENT_TYPE_WOOD_CONTRUCTION: 'Holz-Konstruktion',
          DEVICE_E_ELEMENT_TYPE_LIGHT_CONCRETE_CONSTRUCTION: 'Leichtbetonbauweise',
          DEVICE_E_ELEMENT_TYPE_SOLID_CONSTRUCTION: 'Massivbau',
          DEVICE_E_ELEMENT_TYPE_MASONRY_CONSTRUCTION: 'Mauerwerks-Konstruktion',
          DEVICE_E_ELEMENT_TYPE_SKELETON_CONSTRUCTION: 'Skelettbau',
          DEVICE_E_ELEMENT_TYPE_REINFORCED_CONCRETE_STRUCTURE: 'Stahlbeton-Konstruktion',
          DEVICE_E_ELEMENT_TYPE_STEEL_CONSTRUCTION: 'Stahl-Konstruktion',
          DEVICE_E_ELEMENT_TYPE_CONCRETE: 'Beton',
          DEVICE_E_ELEMENT_TYPE_FRAMEWORK: 'Fachwerk',
          DEVICE_E_ELEMENT_TYPE_GLASS_CONSTRUCTION: 'Glaskonstruktion',
          DEVICE_E_ELEMENT_TYPE_WOOD: 'Holz',
          DEVICE_E_ELEMENT_TYPE_GLUED_LAMINATED_BEAMS: 'Leimbinder',
          DEVICE_E_ELEMENT_TYPE_NAIL_BINDER: 'Nagelbinder',
          DEVICE_E_ELEMENT_TYPE_SHED_ROOF: 'Sheddach',
          DEVICE_E_ELEMENT_TYPE_STEEL: 'Stahl',
          DEVICE_E_ELEMENT_TYPE_TRANSFORMER_STATIONS: 'Trafostationen',
          DEVICE_E_ELEMENT_TYPE_MV_PLANT_TRANSFORMER: 'MS-Anlage Transformator',
          DEVICE_E_ELEMENT_TYPE_MV_PLANT_MAIN_DISTRIBUTION: 'MS-Anlage Hauptverteilung',
          DEVICE_E_ELEMENT_TYPE_MV_DISCONNECTOR_SWITCH: 'MS-Trenn-/Lastschalter',
          DEVICE_E_ELEMENT_TYPE_LV_PLANT_MAIN_DISTRIBUTION_BOARD: 'NS-Anlage Hauptverteilung',
          DEVICE_E_ELEMENT_TYPE_LV_PLANT_SUBDISTRIBUTION: 'NS-Anlage Unterverteilung',
          DEVICE_E_ELEMENT_TYPE_LV_PLANT_CONTROL_DISTRIBUTION: 'NS-Anlage Steuerverteilung/Steuerschrank',
          DEVICE_E_ELEMENT_TYPE_LV_SWITCHGEAR: 'NS Schaltanlage',
          DEVICE_E_ELEMENT_TYPE_LV_DISCONNECTOR: 'NS-Trenn-/Lastschalter',
          DEVICE_E_ELEMENT_TYPE_REACTIVE_CURRENT_COMPENSATION: 'Blindstromkompensation',
          DEVICE_E_ELEMENT_TYPE_UNINTERRUPTIBLE_POWER_SUPPLY_STATIC: 'Unterbrechungsfreiestromversorgung statisch',
          DEVICE_E_ELEMENT_TYPE_DYNAMIC_UNINTERRUPTIBLE_POWER_SUPPLY: 'Unterbrechungsfreiestromversorgung dynamisch',
          DEVICE_E_ELEMENT_TYPE_EMERGENCY_POWER_PLANT: 'Notstromanlage',
          DEVICE_E_ELEMENT_TYPE_WIND_ENERGY: 'Windenergie',
          DEVICE_E_ELEMENT_TYPE_FUEL_CELLS: 'Brennstoffzellen',
          DEVICE_E_ELEMENT_TYPE_PHOTOVOLTAICS: 'Fotovoltaik',
          DEVICE_E_ELEMENT_TYPE_ENERGY_TAX_PLANT: 'Energiesteueranlage',
          DEVICE_E_ELEMENT_TYPE_CHARGING_STATION_AC: 'Ladesäule AC',
          DEVICE_E_ELEMENT_TYPE_CHARGING_STATION_DC: 'Ladesäule DC',
          DEVICE_E_ELEMENT_TYPE_WALLBOX_AC: 'Wallbox AC',
          DEVICE_E_ELEMENT_TYPE_EMERGENCY_LIGHTING_SYSTEM_WITH_DISPLAY: 'Notlichtanlage (mit Statusanzeige Zentralversorgung)',
          DEVICE_E_ELEMENT_TYPE_EMERGENCY_LIGHTING_SYSTEM_WITHOUT_DISPLAY: 'Notlichtanlage (ohne Statusanzeige Zentralversorgung)',
          DEVICE_E_ELEMENT_TYPE_INTERIOR_LIGHTING: 'Innenbeleuchtung',
          DEVICE_E_ELEMENT_TYPE_OUTDOOR_LIGHTING: 'Aussenbeleuchtung',
          DEVICE_E_ELEMENT_TYPE_EMERGENCY_LIGHT_WITHOUT_DISPLAY: 'Notleuchte (ohne Statusanzeige Einzelversorgung)',
          DEVICE_E_ELEMENT_TYPE_EMERGENCY_LIGHT_WITH_DISPLAY: 'Notleuchte (mit Statusanzeige Einzelversorgung)',
          DEVICE_E_ELEMENT_TYPE_ESCAPE_ROUTE_WITHOUT_SUPPLY: 'Fluchtwegleuchte mit Piktogramm (ohne Einzelversorgung)',
          DEVICE_E_ELEMENT_TYPE_ESCAPE_ROUTE_WITH_SUPPLY: 'Fluchtwegleuchte mit Piktogramm (mit Einzelversorgung)',
          DEVICE_E_ELEMENT_TYPE_SIGNAL_LIGHT: 'Signalampel- oder Anzeigesystem',
          DEVICE_E_ELEMENT_TYPE_MANUAL_EMERGENCY_LIGHT: 'Handnotleuchte (mit Einzelversorgung)',
          DEVICE_E_ELEMENT_TYPE_SPECIAL_LIGHTING: 'Spezialbeleuchtung',
          DEVICE_E_ELEMENT_TYPE_ILLUMINATED_ADVERTISING_LOGO: 'Leuchtreklame / Logo',
          DEVICE_E_ELEMENT_TYPE_ELECTRONIC_MEASURING_DEVICE: 'Elektronische Messeinrichtung',
          DEVICE_E_ELEMENT_TYPE_EMERGENCY_CALL_SYSTEM: 'Notrufanlage',
          DEVICE_E_ELEMENT_TYPE_EVACUATION_SYSTEM: 'Evakuationsanlage',
          DEVICE_E_ELEMENT_TYPE_LOUDSPEAKER_SYSTEM: 'Lautsprecher oder Musikanlage',
          DEVICE_E_ELEMENT_TYPE_INTERCOM_SYSTEM: 'Gegensprechanlage',
          DEVICE_E_ELEMENT_TYPE_VIDEO_CONFERENCING_SYSTEM: 'Videokonferenzanlage',
          DEVICE_E_ELEMENT_TYPE_ALARM_SIGNALLING_SYSTEM: 'Alarmmeldeanlage',
          DEVICE_E_ELEMENT_TYPE_SAFETY_GUIDANCE_SYSTEM: 'Sicherheitsleitsystem (SLS)',
          DEVICE_E_ELEMENT_TYPE_BUILDING_MANAGEMENT_SYSTEM: 'Gebäudeleitsystem (GLT)',
          DEVICE_E_ELEMENT_TYPE_DDC_STATIONS: 'DDC Stationen (Direct-Digital-Control Stationen)',
          DEVICE_E_ELEMENT_TYPE_ACCESS_CONTROL_SYSTEM: 'Zutrittskontrollanlage (ZKA)',
          DEVICE_E_ELEMENT_TYPE_ACCESS_CONTROL_ACTUATOR: 'Zutrittskontrollstellglied (ZSG) (zb Türöffner)',
          DEVICE_E_ELEMENT_TYPE_INPUT_DEVICE: 'Eingabeeinrichtung (EE)',
          DEVICE_E_ELEMENT_TYPE_TURNSTILES: 'Drehsperren / -kreuze',
          DEVICE_E_ELEMENT_TYPE_SAFETY_GATE: 'Sicherheitsschleuse',
          DEVICE_E_ELEMENT_TYPE_FIRE_ALARM_SYSTEM: 'Brandmeldeanlage - Alarmübermitt. n. überwacht',
          DEVICE_E_ELEMENT_TYPE_FIRE_ALARM_SYSTEM_MONITORED: 'Brandmeldeanlage - Alarmübermitt. überwacht',
          DEVICE_E_ELEMENT_TYPE_SPRINKLER_WET_SYSTEM: 'Sprinkler-Nassanlage',
          DEVICE_E_ELEMENT_TYPE_SPRINKLER_DRYING_SYSTEMS: 'Sprinkler-Trockenanlagen',
          DEVICE_E_ELEMENT_TYPE_PASSIVE_EXTINGUISHING_SYSTEM: 'Passive Löschanlage',
          DEVICE_E_ELEMENT_TYPE_GAS_EXTINGUISHING_SYSTEM: 'Gaslöschanlage (mit elektrischer Füllstandskontrolle)',
          DEVICE_E_ELEMENT_TYPE_RISER: 'Steigleitung (trocken)',
          DEVICE_E_ELEMENT_TYPE_HANDHELD_FIRE_EXTINGUISHER: 'Handfeuerlöscher',
          DEVICE_E_ELEMENT_TYPE_EXTINGUISHING_POST: 'Löschposten (Typ)',
          DEVICE_E_ELEMENT_TYPE_NATURAL_SMOKE_VENTILATION: 'Natürliche Rauch- & Wärmeabzugsanlagen (Entrauchungsklappen)',
          DEVICE_E_ELEMENT_TYPE_MECHANICAL_SMOKE_VENTILATION: 'Maschinelle Rauch- & Wärmeabzugsanlagen Entrauchungsventilatoren',
          DEVICE_E_ELEMENT_TYPE_SMOKE_PRESSURE_SYSTEM: 'Rauchdruckanlage',
          DEVICE_E_ELEMENT_TYPE_BURIED_TANK: 'Erdverlegter Tank',
          DEVICE_E_ELEMENT_TYPE_FREESTANDING_TANK: 'Freistehender Tank / Sondertank',
          DEVICE_E_ELEMENT_TYPE_HEATING_BURNER_OILGAS: 'Heizbrenner Oel / Gas',
          DEVICE_E_ELEMENT_TYPE_WOOD_SOLID_FUEL_STOVE: 'Holz- / Feststoffbrenner / Ofen, Holzofen',
          DEVICE_E_ELEMENT_TYPE_STEAM_TRAP: 'Kondensatableiter',
          DEVICE_E_ELEMENT_TYPE_HEAT_PUMP: 'Wärmepumpe',
          DEVICE_E_ELEMENT_TYPE_CEILING_HEATING: 'Deckenheizung',
          DEVICE_E_ELEMENT_TYPE_RADIATOR: 'Radiator',
          DEVICE_E_ELEMENT_TYPE_FLOOR_HEATING: 'Fussbodenheizung',
          DEVICE_E_ELEMENT_TYPE_COOLING_MACHINE_INDUSTRY: 'Kältemaschine Industrie',
          DEVICE_E_ELEMENT_TYPE_COOLING_MACHINE_COMMERCIAL: 'Kältemaschine Gewerbliche Kälte',
          DEVICE_E_ELEMENT_TYPE_ICE_MACHINE: 'Eismaschine (Gewerblich)',
          DEVICE_E_ELEMENT_TYPE_BLAST_CHILLER: 'Schnellkühler (Gewerblich)',
          DEVICE_E_ELEMENT_TYPE_BLAST_FREEZER: 'Schnellfroster (Gewerblich)',
          DEVICE_E_ELEMENT_TYPE_FREEZER: 'Kühltruhe (Gewerblich)',
          DEVICE_E_ELEMENT_TYPE_FREEZER_RACKS: 'Tiefkühlregale (Gewerblich)',
          DEVICE_E_ELEMENT_TYPE_REFRIGERATOR: 'Kühlschrank',
          DEVICE_E_ELEMENT_TYPE_COMBINATION_REFRIGERATOR: 'Kombi-Kühlschrank',
          DEVICE_E_ELEMENT_TYPE_CLIMATIC_CABINET: 'Klimaschrank',
          DEVICE_E_ELEMENT_TYPE_COOLING_TABLE: 'Kühltisch (Gewerblich)',
          DEVICE_E_ELEMENT_TYPE_SALATETTE: 'Saladette (Gewerblich)',
          DEVICE_E_ELEMENT_TYPE_COOLING_ATTACHMENT: 'Kühlaufsatz (Gewerblich)',
          DEVICE_E_ELEMENT_TYPE_COOLING_THROUGH: 'Kühlwanne (Gewerblich)',
          DEVICE_E_ELEMENT_TYPE_REFRIGERATED_DISPLAY_CASE: 'Kühlvitrine (Gewerblich)',
          DEVICE_E_ELEMENT_TYPE_WASTE_COOLER: 'Abfallkühler (Gewerblich)',
          DEVICE_E_ELEMENT_TYPE_REFRIGERATED_COUNTER: 'Kühltheke (Gewerblich)',
          DEVICE_E_ELEMENT_TYPE_FREEZER_COMMERCIAL: 'Tiefkühlschrank (Gewerblich)',
          DEVICE_E_ELEMENT_TYPE_FREEZER_CLIMA: 'Tiefkühlschrank',
          DEVICE_E_ELEMENT_TYPE_MONOSPLIT_DEVICE: 'Monosplitgerät',
          DEVICE_E_ELEMENT_TYPE_MULTISPLIT_DEVICE: 'Multisplitgerät',
          DEVICE_E_ELEMENT_TYPE_DRY_RECOOLING: 'Trockenrückkühlung',
          DEVICE_E_ELEMENT_TYPE_COOLING_TOWER: 'Kühlturm',
          DEVICE_E_ELEMENT_TYPE_SUPPLY_AIR_COOLING: 'Zuluftanlagen - mit Kühlfunktion',
          DEVICE_E_ELEMENT_TYPE_SUPPLY_AIR_HEATING: 'Zuluftanlagen - mit Heizfunktion',
          DEVICE_E_ELEMENT_TYPE_SUPPLY_AIR_HUMIDIFICATION: 'Zuluftanlagen - mit Befeuchtung',
          DEVICE_E_ELEMENT_TYPE_SUPPLY_AIR_DEHUMIDIFICATION: 'Zuluftanlagen - mit Entfeuchtung',
          DEVICE_E_ELEMENT_TYPE_SUPPLY_AIR_HEATING_COOLING: 'Zuluftanlagen - Heizen/Kühlen',
          DEVICE_E_ELEMENT_TYPE_SUPPLY_AIR_PARTIAL_CONDITIONING: 'Zuluft Teilklimaanlagen',
          DEVICE_E_ELEMENT_TYPE_SUPPLY_AIR_PARTIAL_HEATING_COOLING_HUMIDFYING: 'Teilklimaanlagen - Heizen/Kühlen/Befeuchten',
          DEVICE_E_ELEMENT_TYPE_SUPPLY_AIR_PARTIAL_HEATING_COOLING_DEHUMIDFYING: 'Teilklimaanlagen - Heizen/Kühlen/Entfeuchten',
          DEVICE_E_ELEMENT_TYPE_SUPPLY_AIR_PARTIAL_HEATING_HUMIDFYING_DEHUMIDFYING: 'Teilklimaanlagen - Heizen/Befeuchten/Entfeuchten',
          DEVICE_E_ELEMENT_TYPE_SUPPLY_AIR_PARTIAL_COOLING_HUMIDFYING_DEHUMIDFYING: 'Teilklimaanlagen - Kühlen/Befeuchten/Entfeuchten',
          DEVICE_E_ELEMENT_TYPE_SUPPLY_AIR_SYSTEMS_FULL_CLIMATE: 'Zuluftanlagen - Vollklima',
          DEVICE_E_ELEMENT_TYPE_RECIRCULATION_FAN: 'Umluftventilator',
          DEVICE_E_ELEMENT_TYPE_RECIRCULATION_SYSTEM: 'Umluftanlage',
          DEVICE_E_ELEMENT_TYPE_RECIRCULATION_SYSTEM_HEATING: 'Umluftanlagen - mit Heizfunktion',
          DEVICE_E_ELEMENT_TYPE_RECIRCULATION_SYSTEM_COOLING: 'Umluftanlage - mit Kühlfunktion',
          DEVICE_E_ELEMENT_TYPE_RECIRCULATION_SYSTEM_HUMIDIFIACTION: 'Umluftanlage - mit Befeuchtung',
          DEVICE_E_ELEMENT_TYPE_RECIRCULATION_SYSTEM_DEHUMIDIFIACTION: 'Umluftanlage - mit Entfeuchtung',
          DEVICE_E_ELEMENT_TYPE_RECIRCULATION_SYSTEM_HEATING_COOLING: 'Umluftanlage - Heizen/Kühlen',
          DEVICE_E_ELEMENT_TYPE_RECIRCULATION_PARTIAL_HEATING_COOLING_HUMIDFYING: 'Umluft Teilklimaanlagen - Heizen/Kühlen/Befeuchten',
          DEVICE_E_ELEMENT_TYPE_RECIRCULATION_PARTIAL_HEATING_COOLING_DEHUMIDFYING: 'Umluft Teilklimaanlagen - Heizen/Kühlen/Entfeuchten',
          DEVICE_E_ELEMENT_TYPE_RECIRCULATION_PARTIAL_HEATING_HUMIDFYING_DEHUMIDFYING: 'Umluft Teilklimaanlagen - Heizen/Befeuchten/Entfeuchten',
          DEVICE_E_ELEMENT_TYPE_RECIRCULATION_PARTIAL_COOLING_HUMIDFYING_DEHUMIDFYING: 'Umluft Teilklimaanlagen - Kühlen/Befeuchten/Entfeuchten',
          DEVICE_E_ELEMENT_TYPE_RECIRCULATION_SYSTEMS_FULL_CONDITIONING: 'Umluftanlagen - Vollklima',
          DEVICE_E_ELEMENT_TYPE_SUPPLY_AIR_DEC_PLANT: 'Zuluft DEC-Anlagen',
          DEVICE_E_ELEMENT_TYPE_EXHAUST_AIR_FAN: 'Abluftventilator',
          DEVICE_E_ELEMENT_TYPE_EXHAUST_AIR_SYSTEMS: 'Abluftanlagen',
          DEVICE_E_ELEMENT_TYPE_FIRE_DAMPERS: 'Brandschutzklappen',
          DEVICE_E_ELEMENT_TYPE_DUCT_SYSTEM: 'Kanalsystem / Luftleitungen',
          DEVICE_E_ELEMENT_TYPE_IONIZATION_SYSTEM: 'Ionisationsanlage',
          DEVICE_E_ELEMENT_TYPE_COMPACT_RECIRCULATION_WITHOUT_HUMIDIFICATION: 'Kompakt Umluftgerät - ohne Befeuchtung',
          DEVICE_E_ELEMENT_TYPE_COMPACT_RECIRCULATION_WITH_HUMIDIFICATION: 'Kompakt Umluftgerät - mit Befeuchtung',
          DEVICE_E_ELEMENT_TYPE_RECIRCULATION_AIR_COOLING: 'Umluftkühlgerät - ULKG',
          DEVICE_E_ELEMENT_TYPE_RECIRCULATION_AIR_HEATER_WITHOUT_HUMIDIFICATION: 'Umluft Heizgerät - ULHG ohne Befeuchtung',
          DEVICE_E_ELEMENT_TYPE_RECIRCULATION_AIR_HEATER_WITH_HUMIDIFICATION: 'Umluft Heizgerät - ULHG mit Befeuchtung',
          DEVICE_E_ELEMENT_TYPE_AIR_CURTAINS: 'Luftschleier',
          DEVICE_E_ELEMENT_TYPE_HUMIDIFICATION_UNIT: 'Befeuchtungsgerät (Dezentral)',
          DEVICE_E_ELEMENT_TYPE_KVS_SYSTEM: 'KVS-System (Hochleistungs-Kreislaufverbund-System)',
          DEVICE_E_ELEMENT_TYPE_PLATE_HEAT_EXCHANGER: 'Plattenwärmetauscher (Kreuzstrom)',
          DEVICE_E_ELEMENT_TYPE_GLASS_TUBE_HEAT_EXCHANGER: 'Glasrohrwärmetauscher',
          DEVICE_E_ELEMENT_TYPE_ROTARY_HEAT_EXCHANGER: 'Rotationswärmetauscher',
          DEVICE_E_ELEMENT_TYPE_KITCHEN_EXHAUST_AIR: 'Küchenabluft',
          DEVICE_E_ELEMENT_TYPE_SAFETY_VALVE_TESTING: 'Sicherheitsventil (prüfpflichtig)',
          DEVICE_E_ELEMENT_TYPE_SAFETY_VALVE_NO_TESTING: 'Sicherheitsventil (nicht prüfpflichtig)',
          DEVICE_E_ELEMENT_TYPE_SAFETY_VALVE_DRINKING_WATER: 'Sicherheitsventil (Trinkwasser)',
          DEVICE_E_ELEMENT_TYPE_PRESSURE_REDUCING_VALVE: 'Druckreduzierventil',
          DEVICE_E_ELEMENT_TYPE_CONTROL_VALVE: 'Regelventil',
          DEVICE_E_ELEMENT_TYPE_SYSTEM_SEPARATOR: 'Systemtrenner',
          DEVICE_E_ELEMENT_TYPE_CIRCULATION_PUMP_HEAT: 'Umwälzpumpe (Wärme)',
          DEVICE_E_ELEMENT_TYPE_CIRCULATION_PUMP_COOLING: 'Umwälzpumpe (Kälte)',
          DEVICE_E_ELEMENT_TYPE_PUMPS: 'Pumpen (Meteo-,Grundwasser)',
          DEVICE_E_ELEMENT_TYPE_WASTE_WATER: 'Abwasser-/ Fäkalienpumpe',
          DEVICE_E_ELEMENT_TYPE_PRESSURE_BOOSTING_SYSTEMS: 'Druckerhöhungsanlagen',
          DEVICE_E_ELEMENT_TYPE_WATER_FILTER_BACKWASHABLE: 'Wasserfilter (rückspülbar)',
          DEVICE_E_ELEMENT_TYPE_WATER_FILTER_NOT_BACKWASHABLE: 'Wasserfilter (nicht rückspülbar)',
          DEVICE_E_ELEMENT_TYPE_ELYSATOR: 'Elysator',
          DEVICE_E_ELEMENT_TYPE_MAGNEIC_FLUX_FILTER: 'Magnetflussfilter',
          DEVICE_E_ELEMENT_TYPE_STRAINER: 'Schmutzfänger',
          DEVICE_E_ELEMENT_TYPE_WATER_DETECTOR: 'Wassermelder',
          DEVICE_E_ELEMENT_TYPE_PRESSURE_COMPENSATION_VESSEL: 'Druckausgleichsgefäss',
          DEVICE_E_ELEMENT_TYPE_EXPANSION_SYSTEM: 'Expansionsanlage',
          DEVICE_E_ELEMENT_TYPE_SOFTENING_PLANT: 'Enthärtungsanlage',
          DEVICE_E_ELEMENT_TYPE_DESALINATION_OSMOSIS_PLANT: 'Entsalzungs-Osmoseanlage',
          DEVICE_E_ELEMENT_TYPE_POST_INOCULATION_SYSTEM: 'Nachimpfung, Dosieranlage',
          DEVICE_E_ELEMENT_TYPE_UV_SYSTEM: 'UV-Anlage',
          DEVICE_E_ELEMENT_TYPE_WASTEWATER_AFTERTREATMENT: 'Abwassernachbehandlung',
          DEVICE_E_ELEMENT_TYPE_SEWAGE_LIFTING_UNIT: 'Abwasserhebeanlage',
          DEVICE_E_ELEMENT_TYPE_OIL_SEPARATOR: 'Oel-Fettabscheider (Gastro)',
          DEVICE_E_ELEMENT_TYPE_PETROL_SEPARATOR: 'Oel-Benzinabscheider (Fahrzeugverkehr)',
          DEVICE_E_ELEMENT_TYPE_SEPTIC_TANK: 'Klärgrube',
          DEVICE_E_ELEMENT_TYPE_RETENTION_BASIN: 'Rückhaltebecken',
          DEVICE_E_ELEMENT_TYPE_HOT_WATER_PREPARATION_BOILER: 'Warmwasser-Aufbereitung Boiler',
          DEVICE_E_ELEMENT_TYPE_INSTANTANEOUS_WATER_HEATER: 'Durchlauferhitzer',
          DEVICE_E_ELEMENT_TYPE_PIPING: 'Rohrleitungen (Trinkwasserprobe)',
          DEVICE_E_ELEMENT_TYPE_SLUDGE_COLLECTOR: 'Schlammsammler',
          DEVICE_E_ELEMENT_TYPE_COMPRESSORS_AIR_SYSTEM: 'Kompressoren/Druckluftanlage',
          DEVICE_E_ELEMENT_TYPE_VACUUM_SYSTEM: 'Vakuumanlage',
          DEVICE_E_ELEMENT_TYPE_PRESSURE_VESSEL: 'Druckbehälter',
          DEVICE_E_ELEMENT_TYPE_DRYER: 'Trockner',
          DEVICE_E_ELEMENT_TYPE_PASSENGER_ELEVATOR: 'Personenaufzug',
          DEVICE_E_ELEMENT_TYPE_FREIGHT_ELEVATOR: 'Lastenaufzug/Warenaufzug',
          DEVICE_E_ELEMENT_TYPE_ESCALATORS: 'Fahrtreppen',
          DEVICE_E_ELEMENT_TYPE_MOVING_WALKS: 'Fahrsteige',
          DEVICE_E_ELEMENT_TYPE_LIFTING_PLATFORMS: 'Hebebühnen',
          DEVICE_E_ELEMENT_TYPE_ADJUSTMENT_RAMPS: 'Anpassrampen',
          DEVICE_E_ELEMENT_TYPE_SMALL_GOODS_ELEVATOR: 'Kleingüteraufzüge',
          DEVICE_E_ELEMENT_TYPE_FACADE_CLEANING_SYSTEM: 'Fassadenreinigungsanlagen',
          DEVICE_E_ELEMENT_TYPE_CRANE_SYSTEM: 'Krananlagen',
          DEVICE_E_ELEMENT_TYPE_LIFTING_GEAR: 'Hebezeuge',
          DEVICE_E_ELEMENT_TYPE_HIGH_BAY_RACKING: 'Hochregallager / Umlaufregale',
          DEVICE_E_ELEMENT_TYPE_INVALID_PLATFORMS: 'Invalidenbühnen/ Treppenlifte / Invalidenaufzüge',
          DEVICE_E_ELEMENT_TYPE_FIREFIGHTERS_ELEVATOR: 'Feuerwehraufzüge',
          DEVICE_E_ELEMENT_TYPE_CONVEYOR_BELT: 'Transportband',
          DEVICE_E_ELEMENT_TYPE_ELEMENT_FACADE: 'Elementfassade',
          DEVICE_E_ELEMENT_TYPE_TIMBERED_FACADE: 'Fachwerkfassade',
          DEVICE_E_ELEMENT_TYPE_FIBER_CEMENT: 'Faserzement',
          DEVICE_E_ELEMENT_TYPE_TILES_FACADE: 'Fliesenfassade',
          DEVICE_E_ELEMENT_TYPE_GLASS_FACADE: 'Glasfassade',
          DEVICE_E_ELEMENT_TYPE_WOODEN_FACADE: 'Holzfassade',
          DEVICE_E_ELEMENT_TYPE_CLINKER: 'Klinker',
          DEVICE_E_ELEMENT_TYPE_METAL_FACADE: 'Metall',
          DEVICE_E_ELEMENT_TYPE_NATURAL_STONE_FACADE: 'Naturstein',
          DEVICE_E_ELEMENT_TYPE_POST_BEAM_FACADE: 'Pfosten-Riegel-Fassade',
          DEVICE_E_ELEMENT_TYPE_PLASTER: 'Putz',
          DEVICE_E_ELEMENT_TYPE_EXPOSED_CONCRETE: 'Sichtbeton',
          DEVICE_E_ELEMENT_TYPE_EXPOSED_BRICKWORK: 'Sichtmauerwerk',
          DEVICE_E_ELEMENT_TYPE_CURTAIN_WALL: 'Vorhangfassade',
          DEVICE_E_ELEMENT_TYPE_WASHED_CONCRETE: 'Waschbeton',
          DEVICE_E_ELEMENT_TYPE_ETICS: 'WDVS',
          DEVICE_E_ELEMENT_TYPE_SECURANTS: 'Sekuranten',
          DEVICE_E_ELEMENT_TYPE_ROPE_SYSTEM: 'Seilsystem',
          DEVICE_E_ELEMENT_TYPE_MANUAL_ALUMINIUM_SINGLE_WINDOW: 'Alufenster einfach verglast',
          DEVICE_E_ELEMENT_TYPE_MANUAL_ALUMINIUM_DOUBLE_WINDOW: 'Alufenster doppelt verglast',
          DEVICE_E_ELEMENT_TYPE_MANUAL_ALUMINIUM_TRIPLE_WINDOW: 'Alufenster dreifach verglast',
          DEVICE_E_ELEMENT_TYPE_MANUAL_WOODEN_SINGLE_WINDOW: 'Holzfenster einfach verglast',
          DEVICE_E_ELEMENT_TYPE_MANUAL_WOODEN_DOUBLE_WINDOW: 'Holzfenster doppelt verglast',
          DEVICE_E_ELEMENT_TYPE_MANUAL_WOODEN_TRIPLE_WINDOW: 'Holzfenster dreifach verglast',
          DEVICE_E_ELEMENT_TYPE_MANUAL_ALUMINIUM_WOODEN_SINGLE_WINDOW: 'Holz- Alufenster einfach verglast',
          DEVICE_E_ELEMENT_TYPE_MANUAL_ALUMINIUM_WOODEN_DOUBLE_WINDOW: 'Holz- Alufenster doppelt verglast',
          DEVICE_E_ELEMENT_TYPE_MANUAL_ALUMINIUM_WOODEN_TRIPLE_WINDOW: 'Holz- Alufenster dreifach verglast',
          DEVICE_E_ELEMENT_TYPE_MANUAL_PLASTIC_SINGLE_WINDOW: 'Kunststofffenster einfach verglast',
          DEVICE_E_ELEMENT_TYPE_MANUAL_PLASTIC_DOUBLE_WINDOW: 'Kunststofffenster doppelt verglast',
          DEVICE_E_ELEMENT_TYPE_MANUAL_PLASTIC_TRIPLE_WINDOW: 'Kunststofffenster dreifach verglast',
          DEVICE_E_ELEMENT_TYPE_MANUAL_CARBON_SINGLE_WINDOW: 'Carbonfenster einfach verglast',
          DEVICE_E_ELEMENT_TYPE_MANUAL_CARBON_DOUBLE_WINDOW: 'Carbonfenster doppelt verglast',
          DEVICE_E_ELEMENT_TYPE_MANUAL_CARBON_TRIPLE_WINDOW: 'Carbonfenster dreifach verglast',
          DEVICE_E_ELEMENT_TYPE_MANUAL_GLASS_BLOCK: 'Glasbausteine',
          DEVICE_E_ELEMENT_TYPE_MANUAL_CONCRETE_MULLION_WINDOW: 'Betonsprossenfenster',
          DEVICE_E_ELEMENT_TYPE_MOTORIZED_ALUMINIUM_SINGLE_WINDOW: 'Alufenster einfach verglast',
          DEVICE_E_ELEMENT_TYPE_MOTORIZED_ALUMINIUM_DOUBLE_WINDOW: 'Alufenster doppelt verglast',
          DEVICE_E_ELEMENT_TYPE_MOTORIZED_ALUMINIUM_TRIPLE_WINDOW: 'Alufenster dreifach verglast',
          DEVICE_E_ELEMENT_TYPE_MOTORIZED_WOODEN_SINGLE_WINDOW: 'Holzfenster einfach verglast',
          DEVICE_E_ELEMENT_TYPE_MOTORIZED_WOODEN_DOUBLE_WINDOW: 'Holzfenster doppelt verglast',
          DEVICE_E_ELEMENT_TYPE_MOTORIZED_WOODEN_TRIPLE_WINDOW: 'Holzfenster dreifach verglast',
          DEVICE_E_ELEMENT_TYPE_MOTORIZED_ALUMINIUM_WOODEN_SINGLE_WINDOW: 'Holz- Alufenster einfach verglast',
          DEVICE_E_ELEMENT_TYPE_MOTORIZED_ALUMINIUM_WOODEN_DOUBLE_WINDOW: 'Holz- Alufenster doppelt verglast',
          DEVICE_E_ELEMENT_TYPE_MOTORIZED_ALUMINIUM_WOODEN_TRIPLE_WINDOW: 'Holz- Alufenster dreifach verglast',
          DEVICE_E_ELEMENT_TYPE_MOTORIZED_PLASTIC_SINGLE_WINDOW: 'Kunststofffenster einfach verglast',
          DEVICE_E_ELEMENT_TYPE_MOTORIZED_PLASTIC_DOUBLE_WINDOW: 'Kunststofffenster doppelt verglast',
          DEVICE_E_ELEMENT_TYPE_MOTORIZED_PLASTIC_TRIPLE_WINDOW: 'Kunststofffenster dreifach verglast',
          DEVICE_E_ELEMENT_TYPE_MOTORIZED_CARBON_SINGLE_WINDOW: 'Carbonfenster einfach verglast',
          DEVICE_E_ELEMENT_TYPE_MOTORIZED_CARBON_DOUBLE_WINDOW: 'Carbonfenster doppelt verglast',
          DEVICE_E_ELEMENT_TYPE_MOTORIZED_CARBON_TRIPLE_WINDOW: 'Carbonfenster dreifach verglast',
          DEVICE_E_ELEMENT_TYPE_EXTERNAL_ROLLING_GATE: 'Rolltor',
          DEVICE_E_ELEMENT_TYPE_EXTERNAL_DROP_GATE: 'Falltor',
          DEVICE_E_ELEMENT_TYPE_EXTERNAL_SECTIONAL_GATE: 'Sektionaltor',
          DEVICE_E_ELEMENT_TYPE_EXTERNAL_SLIDING_GATE: 'Schiebetor',
          DEVICE_E_ELEMENT_TYPE_EXTERNAL_SWING_GATE: 'Drehflügeltor',
          DEVICE_E_ELEMENT_TYPE_ROLLING_GATE: 'Rolltor',
          DEVICE_E_ELEMENT_TYPE_DROP_GATE: 'Falltor',
          DEVICE_E_ELEMENT_TYPE_SECTIONAL_GATE: 'Sektionaltor',
          DEVICE_E_ELEMENT_TYPE_SLIDING_GATE: 'Schiebetor',
          DEVICE_E_ELEMENT_TYPE_SWING_GATE: 'Drehflügeltor',
          DEVICE_E_ELEMENT_TYPE_AUTOMATIC_SLIDING_DOOR_OUTSIDE: 'Automatische Schiebetüre Aussen',
          DEVICE_E_ELEMENT_TYPE_ELECTRICAL_REVOLVING_DOOR: 'Elektr. Drehtüre',
          DEVICE_E_ELEMENT_TYPE_NOTE_ELEMENT_EMERGENCY_EXIT_DOOR: 'Notelement zur Notausgangstüre (Exit controller)',
          DEVICE_E_ELEMENT_TYPE_LIGHTNING_FIRE_DOOR_BMA: 'Branschutztüre mit BMA',
          DEVICE_E_ELEMENT_TYPE_LIGHTNING_FIRE_DOOR_MANUAL: 'Branschutztüre (manuell)',
          DEVICE_E_ELEMENT_TYPE_ESCAPE_ROUTE_DOORS: 'Fluchtwegtüre, Notausgangtüren',
          DEVICE_E_ELEMENT_TYPE_MARKER_TILE: 'Markiese',
          DEVICE_E_ELEMENT_TYPE_SLAT_BLINDS: 'Lammellenstore',
          DEVICE_E_ELEMENT_TYPE_SUN_PROTECTION_FOLDING_BLINDS: 'Faltstoren',
          DEVICE_E_ELEMENT_TYPE_SUN_PROTECTION_ROLLER_BLINDS: 'Rollos',
          DEVICE_E_ELEMENT_TYPE_TIN_ROOF: 'Blechdach',
          DEVICE_E_ELEMENT_TYPE_FOIL_ROOF: 'Foliendach',
          DEVICE_E_ELEMENT_TYPE_PLASTIC_ELEMENT_ROOF: 'Kunststoffelementdach',
          DEVICE_E_ELEMENT_TYPE_SLATE_ROOF: 'Schieferdach',
          DEVICE_E_ELEMENT_TYPE_BLACK_ROOF: 'Schwarzdach',
          DEVICE_E_ELEMENT_TYPE_CORRUGATED_ASBESTOS_ETERNIT: 'Wellasbest - Eternit',
          DEVICE_E_ELEMENT_TYPE_TILE_ROOF: 'Ziegeldach',
          DEVICE_E_ELEMENT_TYPE_LIGHTNING_PROTECTION_EXTERNAL: 'Blitzschutz (Ext.)',
          DEVICE_E_ELEMENT_TYPE_LIGHTNING_PROTECTION: 'Blitzschutz',
          DEVICE_E_ELEMENT_TYPE_ROOF_HATCH: 'Dachluke',
          DEVICE_E_ELEMENT_TYPE_ROOF_GLAZING: 'Dachverglasung',
          DEVICE_E_ELEMENT_TYPE_TOP_HUNG: 'Klapp-/ Schwingfenster',
          DEVICE_E_ELEMENT_TYPE_LIGHT_DOME_GLASS: 'Lichtkuppel (Glas)',
          DEVICE_E_ELEMENT_TYPE_LIGHT_DOME_PLASTIC: 'Lichtkuppel (Kunststoff)',
          DEVICE_E_ELEMENT_TYPE_SHED_GLASS: 'Shed (Glas)',
          DEVICE_E_ELEMENT_TYPE_SHED_PLASTIC: 'Shed (Kunststoff)',
          DEVICE_E_ELEMENT_TYPE_MANUAL_SKYLIGHTS_FLAT_ROOF: 'manuellle Oberlichter',
          DEVICE_E_ELEMENT_TYPE_MOTORIZED_SKYLIGHTS_FLAT_ROOF: 'motorisierte Oberlichter',
          DEVICE_E_ELEMENT_TYPE_MANUAL_SKYLIGHTS_SLOPING_ROOF: 'manuellle Oberlichter',
          DEVICE_E_ELEMENT_TYPE_MOTORIZED_SKYLIGHTS_SLOPING_ROOF: 'motorisierte Oberlichter',
          DEVICE_E_ELEMENT_TYPE_MOVABLE_PARTITION_WALL_MANUAL: 'Bewegliche Trennwand (manuell)',
          DEVICE_E_ELEMENT_TYPE_MOVABLE_PARTITION_WALL_ELECTRIC: 'Bewegliche Trennwand (elektrisch)',
          DEVICE_E_ELEMENT_TYPE_GLASS_DOOR: 'Glasttüren',
          DEVICE_E_ELEMENT_TYPE_WOODEN_GLASS_DOOR: 'Holz-Glas-Türen',
          DEVICE_E_ELEMENT_TYPE_WOODEN_DOOR: 'Holztüren',
          DEVICE_E_ELEMENT_TYPE_PLASTIC_DOOR: 'Kunststofftüren',
          DEVICE_E_ELEMENT_TYPE_METAL_GLAS_DOOR: 'Metall-Glas-Türen',
          DEVICE_E_ELEMENT_TYPE_METAL_DOOR: 'Metalltüren',
          DEVICE_E_ELEMENT_TYPE_INTERIOR_DOORS: 'Innentüren',
          DEVICE_E_ELEMENT_TYPE_ELECTRICAL_INNER_GATE: 'Elektr. Innentor',
          DEVICE_E_ELEMENT_TYPE_ROLLER_SHUTTER_INTERIOR_DOOR: 'Rolltor Innentor',
          DEVICE_E_ELEMENT_TYPE_AUTOMATIC_SLIDING_DOOR_INSIDE: 'Automatische Schiebetüre Innen',
          DEVICE_E_ELEMENT_TYPE_REVOLVING_DOOR_INSIDE: 'Drehtüre Innen',
          DEVICE_E_ELEMENT_TYPE_FIRE_PROTECTION_DOOR_BMA: 'Brandschutztüre mit BMA',
          DEVICE_E_ELEMENT_TYPE_FIRE_PROTECTION_DOOR_MANUAL: 'Brandschutztüre (manuell)',
          DEVICE_E_ELEMENT_TYPE_LAMELLAR_BLINDS: 'Lammellenstore',
          DEVICE_E_ELEMENT_TYPE_FOLDING_BLINDS: 'Faltstoren',
          DEVICE_E_ELEMENT_TYPE_ROLLER_BLINDS: 'Rollos',
          DEVICE_E_ELEMENT_TYPE_RAISED_FLOOR: 'Doppelboden',
          DEVICE_E_ELEMENT_TYPE_HOLLOW_FLOOR: 'Hohlraumboden',
          DEVICE_E_ELEMENT_TYPE_FLOATING_SCREED: 'Schwimmender Estrich',
          DEVICE_E_ELEMENT_TYPE_OSCILLATING_FLOOR: 'Schwingboden',
          DEVICE_E_ELEMENT_TYPE_COMPOUND_SCREED: 'Verbundestrich',
          DEVICE_E_ELEMENT_TYPE_HARD_COVER: 'Hartbelag',
          DEVICE_E_ELEMENT_TYPE_TEXTILE: 'Textil',
          DEVICE_E_ELEMENT_TYPE_COATING: 'Beschichtung',
          DEVICE_E_ELEMENT_TYPE_CONCRETE_PARTITION_WALLS: 'Betontrennwände',
          DEVICE_E_ELEMENT_TYPE_PLASTERBOARD_PARTITION_WALLS: 'Gipskartontrennwände',
          DEVICE_E_ELEMENT_TYPE_GLASS_BLOCKS_PARTITION_WALLS: 'Glastrennwände',
          DEVICE_E_ELEMENT_TYPE_WOODEN_PARTITION_WALLS: 'Holztrennwände',
          DEVICE_E_ELEMENT_TYPE_BRICK_PARTITION_WALLS: 'Mauerwerkswände',
          DEVICE_E_ELEMENT_TYPE_SYSTEM_PARTITION_WALLS: 'Systemtrennwände',
          DEVICE_E_ELEMENT_TYPE_TILE_CLADDING: 'Fliesenbekleidung',
          DEVICE_E_ELEMENT_TYPE_PLASTERBOARD: 'Gipskarton',
          DEVICE_E_ELEMENT_TYPE_WOODEN_CLADDING: 'Holzbekleidung',
          DEVICE_E_ELEMENT_TYPE_CLINKER_PARTITION_WALL: 'Klinkertrennwände',
          DEVICE_E_ELEMENT_TYPE_BRICKWORK: 'Mauerwerk',
          DEVICE_E_ELEMENT_TYPE_PLASTER_CLADDING: 'Putzbekleidung',
          DEVICE_E_ELEMENT_TYPE_WALL_COVERING_EXPOSED_CONCRETE: 'Sichtbeton',
          DEVICE_E_ELEMENT_TYPE_WALLPAPER: 'Tapete',
          DEVICE_E_ELEMENT_TYPE_PLASTERBOARD_PERFORATED: 'Gipskarton gelocht',
          DEVICE_E_ELEMENT_TYPE_PLASTERBOARD_CLOSED: 'Gipskarton geschlossen',
          DEVICE_E_ELEMENT_TYPE_WOODEN_CEILINGS: 'Holzdecken',
          DEVICE_E_ELEMENT_TYPE_METAL_SLATS: 'Metalllamellen',
          DEVICE_E_ELEMENT_TYPE_MINERAL_FIBER: 'Mineralfaser (OWA)',
          DEVICE_E_ELEMENT_TYPE_PLASTER_PAINTING: 'Putz und Anstrich',
          DEVICE_E_ELEMENT_TYPE_SOIL_VESSELS_NATURAL_HYDRO: 'Bodengefässe natürlich, Hydro',
          DEVICE_E_ELEMENT_TYPE_SOIL_VESSELS_ARTIFICIAL_HYDRO: 'Bodengefässe künstlich, Hydro',
          DEVICE_E_ELEMENT_TYPE_SOIL_VESSELS_NATURAL_SUBSTRATE: 'Bodengefässe natürlich, Substrat',
          DEVICE_E_ELEMENT_TYPE_SOIL_VESSELS_ARTIFICIAL_SUBSTRATE: 'Bodengefässe künstlich, Substrat',
          DEVICE_E_ELEMENT_TYPE_TABLE_VESSELS_NATURAL_HYDRO: 'Tischgefässe natürlich, Hydro',
          DEVICE_E_ELEMENT_TYPE_TABLE_VESSELS_ARTIFICIAL_HYDRO: 'Tischgefässe künstlich, Hydro',
          DEVICE_E_ELEMENT_TYPE_TABLE_VESSELS_NATURAL_SUBSTRATE: 'Tischgefässe natürlich, Substrat',
          DEVICE_E_ELEMENT_TYPE_TABLE_VESSELS_ARTIFICIAL_SUBSTRATE: 'Tischgefässe künstlich, Substrat',
          DEVICE_E_ELEMENT_TYPE_SPECIAL_VESSELS_CONTAINERS_NATURAL: 'Spezial-Pflanzengefässe, natürlich',
          DEVICE_E_ELEMENT_TYPE_SPECIAL_VESSELS_CONTAINERS_ARTIFICIAL: 'Spezial-Pflanzengefässe, künstlich',
          DEVICE_E_ELEMENT_TYPE_ART_OBJECT: 'Kunstobjekt',
          DEVICE_E_ELEMENT_TYPE_RAMP: 'Rampe',
          DEVICE_E_ELEMENT_TYPE_RETAINING_WALL: 'Stützmauer',
          DEVICE_E_ELEMENT_TYPE_STAIRS: 'Treppe',
          DEVICE_E_ELEMENT_TYPE_ORNAMENTAL_FOUNTAIN: 'Zierbrunnen',
          DEVICE_E_ELEMENT_TYPE_EXTERIOR_ROOFING_CONCRETE: 'Beton',
          DEVICE_E_ELEMENT_TYPE_EXTERIOR_ROOFING_GLASS: 'Glas',
          DEVICE_E_ELEMENT_TYPE_EXTERIOR_ROOFING_WOODEN: 'Holz',
          DEVICE_E_ELEMENT_TYPE_EXTERIOR_ROOFING_BRICKWORK: 'Mauerwerk',
          DEVICE_E_ELEMENT_TYPE_EXTERIOR_ROOFING_CORRUGATED_IRON: 'Wellblech',
          DEVICE_E_ELEMENT_TYPE_EXTERIOR_ROOFING_METAL: 'Metall',
          DEVICE_E_ELEMENT_TYPE_PATH_ASPHALT: 'Asphalt',
          DEVICE_E_ELEMENT_TYPE_PATH_CONCRETE: 'Beton',
          DEVICE_E_ELEMENT_TYPE_PATH_WATERBOUND_COVER: 'Wassergebundene Decke',
          DEVICE_E_ELEMENT_TYPE_PATH_PLASTER: 'Pflaster',
          DEVICE_E_ELEMENT_TYPE_PATH_PLATES: 'Platten',
          DEVICE_E_ELEMENT_TYPE_PATH_INTERLOCKING_BRICKS: 'Verbundsteine',
          DEVICE_E_ELEMENT_TYPE_PATH_EXPOSED_AGGREGATE_CONCRETE: 'Waschbeton',
          DEVICE_E_ELEMENT_TYPE_PATH_GRAVEL_CRUSHED_STONES: 'Kies/Schotter',
          DEVICE_E_ELEMENT_TYPE_WATER_SYSTEM_GROUNDWATER_FOUNTAIN: 'Grundwasserbrunnen',
          DEVICE_E_ELEMENT_TYPE_WATER_SYSTEM_DRINKING_WATER_FOUNTAIN: 'Trinkwasserbrunnen',
          DEVICE_E_ELEMENT_TYPE_WATER_SYSTEM_ORNAMENTAL_FOUNTAIN: 'Zierbrunnen',
          DEVICE_E_ELEMENT_TYPE_EQUIPMENT_TRACK: 'Laufbahn',
          DEVICE_E_ELEMENT_TYPE_EQUIPMENT_PLAYGROUND: 'Spielgeräte',
          DEVICE_E_ELEMENT_TYPE_SPORTS_FIELD: 'Sportplatz',
          DEVICE_E_ELEMENT_TYPE_JUMP_PIT: 'Sprunggrube',
          DEVICE_E_ELEMENT_TYPE_DEVICE_SPORTS_EQUIPMENT: 'Sportgeräte',
          DEVICE_E_ELEMENT_TYPE_DEVICE_PLAYGROUND_EQUIPMENT: 'Spielplatzgeräte'
        },
        filter: {
          installed: 'Installiert',
          uninstalled: 'Deinstalliert',
          category: 'Zuordnung',
          deviceStatus: 'Gerätestatus'
        },
        undefined: 'Undefiniert',
        unit: 'Einheit',
        unitOptions: {
          DEVICE_UNIT_UNDEFINED: '-',
          DEVICE_UNIT_L: 'l',
          DEVICE_UNIT_KG: 'kg',
          DEVICE_UNIT_M2: 'm2',
          DEVICE_UNIT_M3: 'm3',
          DEVICE_UNIT_PCS: 'Stk',
          DEVICE_UNIT_M: 'm',
          DEVICE_UNIT_FLAT_RATE: 'Pauschal'
        },
        amount: 'Menge',
        acquisitionCostSum: 'Kaufpreis Summe',
        lifeSpan: 'Lebensdauer',
        calculatedReplacement: 'Kalkulatorischer Ersatz',
        condition: 'Zustand',
        conditionOptions: {
          DEVICE_CONDITION_UNDEFINED: '-',
          DEVICE_CONDITION_NORMAL_WEAR: 'Normale Abnutzung',
          DEVICE_CONDITION_REPAIR_NEEDED: 'Reparatur nötig',
          DEVICE_CONDITION_REPLACEMENT_NEEDED: 'Ersatz nötig',
          DEVICE_CONDITION_PERFECT: 'Gut',
          DEVICE_CONDITION_DEFICIENCY: 'Mangel'
        },
        contractnumber: 'Vertragsnummer',
        lockingKey: {
          description: 'Bezeichnung',
          lockingPlanNumber: 'Schliessplannummer',
          combinedKeys: 'Kombinierte Schlüssel',
          combinedKeysNote: 'Für welche Schlösser'
        }
      },
      energySource: {
        title: 'Energieträger',
        kind: {
          ENERGY_SOURCE_KIND_HEATER: 'Heizung',
          ENERGY_SOURCE_KIND_HOT_WATER: 'Warmwasser',
          ENERGY_SOURCE_KIND_HEATER_AND_HOT_WATER: 'Heiz- und Warmwasser'
        },
        heatDistribution: {
          title: 'Wärmeverteilung',
          HEAT_DISTRIBUTION_RADIATORS: 'Radiatoren',
          HEAT_DISTRIBUTION_FLOOR_HEATING: 'Bodenheizung',
          HEAT_DISTRIBUTION_CEILING_HEATING: 'Deckenheizung'
        },
        costDistributionHeater: 'Kostenverteilung Heizung',
        costDistributionHotWater: 'Kostenverteilung Warmwasser',
        costDistribution: {
          title: '',
          COST_DISTRIBUTION_NONE: 'Keine',
          COST_DISTRIBUTION_CONSUMPTION: 'Nach Verbrauch',
          COST_DISTRIBUTION_FIXED_KEY: 'Nach fixem Schlüssel'
        },
        energyReferenceArea: 'Energiebezugsfläche (EBF)',
        photovoltaic: 'Photovoltaik',
        selfConsumption: 'Zusammenschluss zum Eigenverbrauch (ZEV)',
        consumption: 'Verbrauch',
        co2PerYear: 'CO2 in kg/Jahr',
        consumptionKwhPerYear: 'Verbrauch kWh/Jahr'
      },
      settlementObject: {
        newSettlement: 'Verrechnungsobjekt',
        ownerIsDebtor: 'Kosten zu Lasten Eigentümer (Debitor)',
        addSettlementObject: 'Verrechnungsobjekt hinzufügen',
        billingContactId: 'Kostenträger (Debitor)',
        description: 'Bezeichnung',
        billingStart: 'Verrechnungsstart',
        billingEnd: 'Abrechnungsende',
        numericContract: 'Vertragsnummer',
        status: 'Status',
        debitUntil: 'Sollgestellt Datum bis'
      },
      createObjectView: {
        advertising: 'Vermarktung',
        generalObjectDocuments: 'Allgemeine Objektdokumente',
        level: 'Etage',
        position: 'Lage',
        currentTenant: 'aktiver Mieter',
        possibleDeposits: 'Mögliche Kautionen',
        createObjectTooltip: 'Es können nur Objekte angelegt werden, wenn die Zuständigkeit für alle Objekte im Gebäude gegeben ist. Andernfalls muss der Eigentümer die neu angelegten Objekte entsprechend zuweisen.'
      },
      createContactTab: {
        roleInBuilding: 'Rolle im Gebäude',
        craftsmen: 'Handwerker',
        janitors: 'Hauswarte',
        serviceProvider: 'Dienstleister',
        delegate: 'Delegierter / Ausschuss',
        revisor: 'Revisor',
        tenantChange: 'Mieterwechsel',
        confirmation: {
          title: 'Von Gebäude entfernen',
          text: 'Bist du sicher, dass du diesen Kontakt von dem Gebäude entfernen willst?'
        }
      },
      mortgage: {
        newMortgage: 'Neue Hypothek',
        title: 'Hypothek',
        bankName: 'Finanzinstitut',
        bankNumber: 'Clearing-Nr.',
        mortgageDesignation: {
          title: 'Bezeichnung',
          MORTGAGE_DESIGNATION_UNDEFINED: '-',
          MORTGAGE_DESIGNATION_FIXED_1_YEAR: 'Festhypothek, 1 Jahr',
          MORTGAGE_DESIGNATION_FIXED_2_YEAR: 'Festhypothek, 2 Jahre',
          MORTGAGE_DESIGNATION_FIXED_3_YEAR: 'Festhypothek, 3 Jahre',
          MORTGAGE_DESIGNATION_FIXED_4_YEAR: 'Festhypothek, 4 Jahre',
          MORTGAGE_DESIGNATION_FIXED_5_YEAR: 'Festhypothek, 5 Jahre',
          MORTGAGE_DESIGNATION_FIXED_6_YEAR: 'Festhypothek, 6 Jahre',
          MORTGAGE_DESIGNATION_FIXED_7_YEAR: 'Festhypothek, 7 Jahre',
          MORTGAGE_DESIGNATION_FIXED_8_YEAR: 'Festhypothek, 8 Jahre',
          MORTGAGE_DESIGNATION_FIXED_9_YEAR: 'Festhypothek, 9 Jahre',
          MORTGAGE_DESIGNATION_FIXED_10_YEAR: 'Festhypothek, 10 Jahre',
          MORTGAGE_DESIGNATION_FIXED_11_YEAR: 'Festhypothek, 11 Jahre',
          MORTGAGE_DESIGNATION_FIXED_12_YEAR: 'Festhypothek, 12 Jahre',
          MORTGAGE_DESIGNATION_FIXED_13_YEAR: 'Festhypothek, 13 Jahre',
          MORTGAGE_DESIGNATION_FIXED_14_YEAR: 'Festhypothek, 14 Jahre',
          MORTGAGE_DESIGNATION_FIXED_15_YEAR: 'Festhypothek, 15 Jahre',
          MORTGAGE_DESIGNATION_FIXED_16_YEAR: 'Festhypothek, 16 Jahre',
          MORTGAGE_DESIGNATION_FIXED_17_YEAR: 'Festhypothek, 17 Jahre',
          MORTGAGE_DESIGNATION_FIXED_18_YEAR: 'Festhypothek, 18 Jahre',
          MORTGAGE_DESIGNATION_FIXED_19_YEAR: 'Festhypothek, 19 Jahre',
          MORTGAGE_DESIGNATION_FIXED_20_YEAR: 'Festhypothek, 20 Jahre',
          MORTGAGE_DESIGNATION_FIXED_21_YEAR: 'Festhypothek, 21 Jahre',
          MORTGAGE_DESIGNATION_FIXED_22_YEAR: 'Festhypothek, 22 Jahre',
          MORTGAGE_DESIGNATION_FIXED_23_YEAR: 'Festhypothek, 23 Jahre',
          MORTGAGE_DESIGNATION_FIXED_24_YEAR: 'Festhypothek, 24 Jahre',
          MORTGAGE_DESIGNATION_FIXED_25_YEAR: 'Festhypothek, 25 Jahre',
          MORTGAGE_DESIGNATION_VARIABLE: 'Variable Hypothek',
          MORTGAGE_DESIGNATION_LIBOR: 'Libor-Hypothek',
          MORTGAGE_DESIGNATION_SARON: 'Saron-Hypothek'
        },
        number: 'Hypotheken-Nr.',
        amount: 'Betrag',
        openAmount: 'Offener Betrag',
        paidAmount: 'Bezahlter Betrag',
        guaranteedAmount: 'Garantierter Betrag',
        interestRate: 'Zinssatz',
        annualAmortisation: 'Jährliche Amortisation',
        amortizationFrom: 'Amortisation ab',
        AmortisationAmountDueDate: 'Amortisations Betrag pro Fälligkeit',
        validFrom: 'Gültig ab',
        expires: 'Hat Ablaufdatum?',
        expirationDate: 'Ablaufdatum',
        dueDate: 'Fälligkeit',
        dueDateInterestRate: 'Zinsfälligkeit',
        terminableOn: {
          title: 'Kündbar auf',
          MORTGAGE_TERMINABLE_ON_UNDEFINED: '-',
          MORTGAGE_TERMINABLE_ON_1_MONTH: '1 Monat',
          MORTGAGE_TERMINABLE_ON_2_MONTHS: '2 Monate',
          MORTGAGE_TERMINABLE_ON_3_MONTHS: '3 Monate',
          MORTGAGE_TERMINABLE_ON_6_MONTHS: '6 Monate',
          MORTGAGE_TERMINABLE_ON_12_MONTHS: '12 Monate'
        },
        designation: 'Bemerkung',
        deleteMortgage: 'Hypothek löschen',
        interestExpense: 'Zinsaufwand',
        remainingMortgageAmount: 'Hypothek Restbetrag',
        amortization: 'Amortisation',
        addPayment: 'Zahlung hinzufügen',
        currentMonthlyInterestCharge: 'Aktuelle monatliche Zinsbelastung',
        debitAccount: 'Belastungskonto',
        carryingAmount: 'Buchwert'
      },
      bankDetails: {
        newBankDetails: 'Neues Liegenschaftskonto',
        iban: 'IBAN',
        inTheNameOf: 'Lautend auf',
        validFrom: 'Gültig ab',
        expirationDate: 'Ablaufdatum',
        remark: 'Bemerkung',
        deleteBankDetails: 'Liegenschaftskonto löschen',
        bankName: 'Finanzinstitut',
        bankNumber: 'Clearing-Nr.'
      },
      room: {
        title: 'Räume',
        name: 'Bezeichnung',
        area: 'Fläche',
        roomLength: 'Raumlänge',
        roomWidth: 'Raumbreite',
        roomHeight: 'Raumhöhe',
        volume: 'Volumen',
        remark: 'Notiz',
        add: 'Raum hinzufügen',
        deleteRoom: 'Raum löschen'
      },
      tenants: {
        tenanciesVacancies: 'Vermietungen + Leerstände',
        tenancies: 'Vermietungen',
        vacancies: 'Leerstände'
      },
      investmentPlanning: {
        title: 'Investitionsplan',
        addComponent: 'Bauteil hinzufügen',
        components: 'Bauteile',
        propertyValue: 'Liegenschaftswert',
        buildingValue: 'Gebäudewert',
        totalBuildingValue: 'Wert aller Gebäuden',
        futureBuildingValue: 'Zukünfitger Gebäudewert',
        futurePropertyValue: 'Future Property value',
        futureTotalValueBuilding: 'Future Total value of building',
        totalPercentage: 'Totale Prozentuale',
        optionalValueEnhancingComponent: 'Optionale wertvermehrende Bauteile',
        tooltipOptionalValue: 'Optionale wertvermehrende Bauteile werden nicht in die prozentuale oder den Gesamtwert des Investitionsplans einbezogen.',
        types: {
          COMPONENT_TYPE_SURROUNDINGS: 'Umgebung',
          COMPONENT_TYPE_PLAYGROUND: 'Spielplatz',
          COMPONENT_TYPE_PAVED_PATHS: 'Befestigte Wege',
          COMPONENT_TYPE_UNDERGROUND_GARAGE: 'Unterniveaugarage',
          COMPONENT_TYPE_SHELL_CONSTRUCTION_1: 'Rohbau 1',
          COMPONENT_TYPE_FACADE: 'Fassade',
          COMPONENT_TYPE_THERMAL_INSULATION: 'Wärmedämmung (Fassade)',
          COMPONENT_TYPE_EXTERIOR_DOORS: 'Aussentüren',
          COMPONENT_TYPE_BLINDS: 'Storen',
          COMPONENT_TYPE_SUNSHADE: 'Sonnenschutz',
          COMPONENT_TYPE_ROOF: 'Dach',
          COMPONENT_TYPE_BALCONY: 'Balkon',
          COMPONENT_TYPE_INTERPHONE: 'Sonnerie',
          COMPONENT_TYPE_INTERIOR_DOORS: 'Innentüren',
          COMPONENT_TYPE_ELEVATOR: 'Lift',
          COMPONENT_TYPE_STAIRCASE: 'Treppenhaus',
          COMPONENT_TYPE_GENERAL_ROOMS: 'Allgemeine Räume',
          COMPONENT_TYPE_GENERAL_ELECTRICAL_INSTALLATIONS: 'Allgemeine Elektroinstallationen',
          COMPONENT_TYPE_ENERGY_STORAGE: 'Energielagerung',
          COMPONENT_TYPE_HEAT_GENERATION: 'Energie-/Wärmeerzeugung',
          COMPONENT_TYPE_HEAT_DISTRIBUTION: 'Wärmeverteilung',
          COMPONENT_TYPE_WATER: 'Wasser/Abwasser Leitungen',
          COMPONENT_TYPE_OTHERS: 'Übriges',
          COMPONENT_TYPE_APARTMENT_DOOR: 'Wohnungstüre',
          COMPONENT_TYPE_WINDOW: 'Fenster/Balkontüre',
          COMPONENT_TYPE_KITCHEN: 'Küche',
          COMPONENT_TYPE_WETROOM: 'Nasszelle',
          COMPONENT_TYPE_FLOOR: 'Boden/Wand/Decke'
        },
        deleteModal: {
          title: 'Bauteile löschen',
          text: 'Bist du sicher die ausgewählten Komponenten löschen wollen?'
        },
        titlesEditModal: {
          titleInstallationDate: 'Datum der Installation eingeben',
          titleCostComponent: 'Eingabe der Kosten',
          titleDistributionPercent: 'Eingabe der Verteilung in Prozent',
          titleMeasures: 'Eingabe der Massnahmen',
          titlePlannedReplacement: 'Datum des geplanten Ersatz eingeben',
          titleFutureCostFactor: 'Eingabe des zukünftigen Kostenfaktor %',
          titlePlannedCosts: 'Eingabe der geplanten Kosten'
        },
        subTitlesEditModal: {
          enterInstallationDate: 'Eingabe des Installationsdatums für alle ausgewählten Komponenten',
          enterCostComponent: 'Eingabe der Kosten für alle ausgewählten Komponenten',
          enterDistributionPercent: 'Eingabe der Verteilung in Prozent für alle ausgewählten Komponenten',
          enterMeasures: 'Eingabe der Massnahmen für alle ausgewählten Komponenten',
          enterPlannedReplacement: 'Eingabe des Installationsdatums für alle ausgewählten Komponenten',
          enterFutureCostFactor: 'Eingabe des zukünftigen Kostenfaktor in Prozent für alle ausgewählten Komponenten',
          enterPlannedCosts: 'Eingabe der geplanten Kosten für alle ausgewählten Komponenten'
        },
        actions: {
          enterInstallationDate: 'Installationsdatum hinzufügen',
          enterCostComponent: 'Kosten hinzufügen',
          enterDistributionPercent: '% hinzufügen',
          enterMeasures: 'Massnahmen hinzufügen',
          enterPlannedReplacement: 'Datum des geplanten Ersatz hinzufügen',
          enterFutureCostFactor: 'Zukünftigen Kostenfaktor % hinzufügen',
          enterPlannedCosts: 'Geplanten Kosten hinzufügen'
        },
        accountInvestPlan: {
          title: 'Gebäude für Investmentplan freischalten'
        }
      }
    },
    manageInterestedParties: {
      fileUploadTitle: 'Datei senden',
      requestModalTitle: 'Anmeldeformular anfordern',
      noFiles: 'Keine Dateien',
      noAppointments: 'Keine Termine',
      sendingFile: 'Sende Datei...',
      eMailSearchFormInputTitle: 'Suche (E-Mail-Adresse)',
      addInterestedPartiesActionButton: 'Interessenten hinzufügen',
      interestedPartiesSelectionHeader: 'Interessenten',
      interestedPartiesSelectionSummaryAll: 'Alle',
      requestApplicationFormPlaceholder: 'Bewerben Sie sich jetzt mit unserem digitalen Anmeldeformular! Falls Sie bereits ein Profil auf propbase.ch erstellt haben, dann können Sie uns dort das Anmeldeformular für dieses Objekt mittels Button „bewerben“ zustellen. Falls Sie noch nicht registriert sind, dann klicken Sie auf den Button „Jetzt bewerben“ und starten Sie Ihre digitale Bewerbung.\n\nFreundliche Grüsse',
      filter: {
        all: 'Alle',
        allEntries: 'Alle Einträge',
        new: 'Neue Anfrage',
        unanswered: 'Unbeantwortet',
        viewings: 'Besichtigung',
        openViewings: 'Offene Termine',
        applications: 'Anmeldung'
      },
      sightseeingConfirmation: 'Die Besichtigung wurde durchgeführt am',
      writeMessageOrAttachFile: 'Nachricht verfassen oder Datei anhängen',
      internalNote: 'Interne Notiz verfassen',
      noRequests: 'Es sind bisher keine Anfragen zu diesem Inserat eingegangen.',
      send: 'Senden',
      create: 'Erstellen',
      score: 'Score',
      requestApplicationForm: 'Anmeldeformular anfordern',
      appointmentDetails: 'Termindetails',
      eventCreation: {
        modalTitle: 'Termin senden',
        title: 'Titel',
        description: 'Beschreibung',
        descriptionText: 'Vielen Dank für Ihr Interesse an unserem Objekt.\n\nEine Besichtigung können wir Ihnen zum hinterlegten Termin anbieten.\nSollte Ihnen dieser Termin passen, bitten wir um eine kurze Bestätigung.\nFalls nicht, senden Sie uns bitte einen neuen Terminvorschlag.\n\nBesten Dank und freundliche Grüsse',
        location: 'Adresse',
        start: 'Beginn',
        end: 'Ende',
        appointment: 'Besichtigung'
      },
      requesterAlreadyExists: 'Es existiert bereits eine Anfrage mit dieser E-Mail auf dieses Objekt.',
      reserved: 'Reserviert',
      status: {
        all: 'Alle',
        new: 'Neu',
        responses_short: 'Antw',
        responses: 'Rückmeldungen',
        new_responses: 'Neu & Rückmeldungen'
      }
    },
    export: {
      title: 'Inserat veröffentlichen',
      IMMOSCOUT_PLATFORM: 'ImmoScout',
      HOMEGATE_PLATFORM: 'Homegate',
      NEWHOME_PLATFORM: 'NewHome',
      CASAONE_PLATFORM: 'Casasoft',
      FLATFOX_PLATFORM: 'Flatfox',
      URBANHOME_PLATFORM: 'Urbanhome',
      PROPERSTAR_PLATFORM: 'Properstar',
      COMPARIS_PLATFORM: 'Comparis',
      information: {
        newhome: 'Aktualisiert ihre Plattform in Echtzeit.',
        immoscout: 'Aktualisiert ihre Plattform zu jeder vollen Stunde.',
        homegate: 'Aktualisiert ihre Plattform in Echtzeit.',
        casaone: 'Aktualisiert ihre Plattform in Echtzeit.',
        flatfox: 'Aktualisiert ihre Plattform in Echtzeit.',
        urbanhome: 'Aktualisiert ihre Plattform in Echtzeit.',
        properstar: 'Aktualisiert ihre Plattform in Echtzeit.',
        comparis: 'Aktualisiert ihre Plattform in Echtzeit.'
      },
      newhomeInfo: '<span style="text-align: left">Aufgrund der Übertragung via IDX-Schnittstelle können die nachfolgenden Unterschiede auftretten:<br /><ul style="padding-left: 20px;"><li>Die maximale Anzahl an Bildern bei der Übertragung beträgt 13</li><li>Die maximale Anzahl an Dokumenten beträgt 1</li><li>Auf newhome.ch definierte Abstellplätze „gedeckt“ oder „ungedeckt“ werden ohne Unterscheidung als Parkplatz übermittelt</li><li>Bei der Übertragung ist die erste, auf newhome.ch definierte Unterobjektart für die Publikation auf homegate.ch relevant. Weitere Unterobjektarten werden nicht berücksichtigt.</li></ul></span>',
      info: 'Um den Export Ihres Inserates zu stoppen, ändern Sie dies in den Einstellungen des jeweiligen Inserates. Anpassungen an Ihren Inseraten sind nur in Ihrem Account auf MARKETbase möglich. Die Änderungen werden mit dem nächsten Datenabgleich auf die betroffenen Portale übermittelt.\n\nFalls nötig können Sie jederzeit Ihren Export auch manuell starten.',
      noOneConfigured: 'Du hast noch keinen Export konfiguriert. Lege unter "Einstellungen > MarketBase" einen Export an.',
      started: 'Der Export wurde erfolgreich gestartet. Je nach Anzahl der Inserate und gewähltem Portal kann es eine Weile dauern, bis sie auf der Zielplattform erscheinen.',
      startingFailed: 'Der Export konnte nicht gestartet werden.',
      pending: 'Läuft',
      successful: 'Erfolgreich',
      failed: 'Fehlgeschlagen',
      advertPlatformInfo: 'Auf welchen Portalen willst du das Inserat veröffentlichen?<br>Standardmässig werden die Marktplätze, welche unter «Einstellungen – MarketBase - Export» eingestellt sind, zur Auswahl angezeigt.<br><br><b>Hinweis:</b><br>Wir exportieren Inserate zu den Marktplätzen zu folgenden Zeiten: 09:30 Uhr, 12:30 Uhr und 17:30 Uhr.<br>Die Informationen für die Online Stellung der Inserate auf den Marktplätzen finden Sie unter «Informationen».',
      pendingDescription: 'Der Export läuft gerade.',
      successfulDescription: 'Der Export war erfolgreich.',
      failedDescription: 'Der Export konnte nicht erfolgreich ausgeführt werden. Versuche ihn erneut zu starten oder kontaktiere den Support.',
      creditTrust: {
        title: 'CreditTrust',
        description: 'CreditTrust ist die digitale Alternative zum Betreibungsauszug. Ein CreditTrust-Zertifikat ist schnell und bequem online bestellbar, mehrfach wieder verwendbar und fälschungssicher dank modernster Blockchain-Technologie.',
        acceptCertificate: 'Akzeptierst du auch CreditTrust-Zertifikate?'
      }
    },
    requestForwarding: {
      title: 'Anfragenweiterleitung',
      type: {
        title: 'Typ',
        no_forwarding: 'Keine Weiterleitung',
        central: 'Zentrale REMCat-Adresse',
        assignee: 'An Benutzer-Adresse'
      },
      centralForwardingAddress: 'Zentrale REMCat-Adresse',
      fallbackAddress: 'Fallback E-Mail (wenn z.B. kein Ansprechpartner im Objekt hinterlegt ist)'
    },
    messageForwarding: {
      title: 'Nachrichtenweiterteiltung',
      normalMessage: 'Normale Nachrichten',
      applicationFormMessage: 'Nachrichten mit Anmeldeformular'
    },
    advertisementBasics: {
      title: 'Das ist der Basis-Schritt'
    },
    advertisementCosts: {
      title: 'Das ist der Kosten-Schritt'
    },
    advertisementCriteria: {
      title: 'Das ist der Kriterien-Schritt',
      stepper_title: 'Weitere Kriterien'
    },
    advertisementPicturesAndDocuments: {
      title: 'Das ist der Bilder- und Dokumente-Schritt'
    },
    advertisementProperties: {
      title: 'Das ist der Eigenschaften-Schritt'
    },
    advertisementPublish: {
      title: 'Das ist der Veröffentlichungsschritt'
    },
    calendar: {
      startTime: 'Beginn',
      endTime: 'Ende',
      createEvent: 'Termin erstellen',
      otherCalendars: 'Andere Kalender',
      calDAV: 'CalDAV-Konto (Synchronisierung)',
      noEvent: 'Keine Termine',
      noFutureEvent: 'Es liegen derzeit keine bevorstehenden Termine vor.',
      event: {
        objectReference: 'Objektreferenz',
        create: 'Termin erstellen',
        edit: 'Termin',
        from: 'Kalender',
        category: 'Kategorie',
        template: 'Textvorlage',
        title: 'Titel',
        signature: 'Signatur',
        date: 'Datum',
        start: 'Beginn',
        end: 'Ende',
        time: 'Uhrzeit',
        description: 'Beschreibung / Nachricht',
        allDay: 'Ganztags',
        privateEvent: 'Privater Termin',
        details: 'Details',
        participants: 'Teilnehmer',
        location: 'Adresse',
        notification: 'Erinnerung',
        addNotification: 'Benachrichtigung hinzufügen',
        attachement: 'Anhänge',
        searchParticipants: 'Teilnehmer hinzufügen',
        invitationMailbox: 'Einladung versenden von',
        sendNoInvitation: 'keine Einladung versenden',
        invited: 'Teilnehmer',
        action: 'Aktion',
        deleteConfirmation: {
          title: 'Termin löschen',
          text: 'Termin unwiderruflich löschen?'
        },
        recurringEvent: {
          checkbox: 'Serientermin erstellen',
          recurrencePattern: {
            title: 'Wiederholungsmuster',
            EVENT_FREQUENCY_DAILY: 'täglich',
            EVENT_FREQUENCY_WEEKLY: 'wöchentlich',
            EVENT_FREQUENCY_MONTHLY: 'monatlich',
            EVENT_FREQUENCY_YEARLY: 'jährlich'
          },
          rangeOfRecurrence: {
            title: 'Range of Recurrence',
            start: 'Beginn',
            endBy: 'endet am',
            endAfter: 'endet nach',
            occurences: 'Terminen'
          },
          modal: {
            title: 'Wiederkehrendes Ereignis bearbeiten',
            bodyText: ' Dies ist ein Termin einer Serie. Was möchtest du bearbeiten?',
            editSingleEvent: 'Nur diesen Termin',
            editAllEvent: 'Die gesamte Serie',
            deleteSingleEvent: 'Einzelnes Ereignis löschen',
            deleteAllEvent: 'Alle Ereignisse dieser Reihe löschen'
          }
        },
        status: {
          ATTENDEE_STATUS_NEEDS_ACTION: 'Warte auf Antwort',
          ATTENDEE_STATUS_ACCEPTED: 'Akzeptiert',
          ATTENDEE_STATUS_DECLINED: 'Abgelehnt',
          ATTENDEE_STATUS_TENTATIVE: 'Vielleicht'
        }
      },
      export: {
        title: 'Kalender-Export',
        subTitle: 'Es kann nach Outlook, Thunderbird oder Google exportiert werden',
        url: 'Kalender-URL',
        general: 'Allgemein',
        apple: 'macOS/iOS',
        appleDescription: 'Beim Hinzufügen des neuen Kontos "Erweitert" als Accounttyp auswählen und die unten genannten Informationen eintragen. Bei iPhone muss die Serveradresse und der Serverpfand in das Feld \'Server\' hinzugefügt werden. Die Checkbox "SSL verwenden" muss aktiviert und "Kerberos v5 zur Authentifizierung verwenden" deaktiviert sein.',
        appleUrl: 'Serveradresse',
        applePath: 'Serverpfad',
        port: 'Port',
        other: 'Windows'
      },
      reminder: {
        create: 'Reminder erstellen',
        title: 'Reminder',
        date: 'Datum',
        priority: {
          title: 'Priorität',
          NORMAL_REMINDER_PRIORITY: 'Normal',
          LOW_REMINDER_PRIORITY: 'Gering',
          HIGH_REMINDER_PRIORITY: 'Hoch'
        },
        employee: 'Benutzer',
        contact: 'Kontakt',
        reference: 'Referenz',
        subject: 'Betreff',
        activity: {
          title: 'Aktivität',
          TODO_REMINDER_ACTIVITY: 'To do',
          CALL_REMINDER_ACTIVITY: 'Anrufen',
          MAIL_REMINDER_ACTIVITY: 'E-Mail',
          POST_REMINDER_ACTIVITY: 'Post'
        },
        referenceKey: {
          prop: 'Liegenschaft',
          mail: 'E-Mail',
          obj: 'Objekt',
          tenancy: 'Vermietung',
          building: 'Gebäude',
          contact: 'Kontakt',
          request: 'Anfrage',
          condominium: 'Stockwerkeigentümer'
        },
        confirmation: {
          title: 'Als erledigt markieren',
          text: 'Ausgewählte(n) Reminder als erledigt markieren? Erledigte Reminder verschwinden nach diesem Tag.'
        },
        markAsDone: 'Als un-/erledigt markieren',
        done: 'Erledigt',
        changeValue: 'Reminder ändern',
        changeDate: 'Datum ändern',
        changePriority: 'Priorität ändern',
        changeEmployee: 'Benutzer ändern',
        subTitle: {
          object: 'Reminder wird pro selektiertem Objekt erstellt',
          property: 'Reminder wird pro selektierter Liegenschaft erstellt',
          building: 'Reminder wird pro selektiertem Gebäude erstellt',
          tenancies: 'Reminder wird pro selektierter Vermietung erstellt',
          tenants: 'Reminder wird pro selektierter Vermietung erstellt',
          condominium: 'Reminder is created for each selected condominium',
          addressbook: 'Reminder wird pro selektiertem Kontakt erstellt'
        },
        noSubject: 'Kein Betreff'
      }
    },
    employeesSettings: {
      administrators: 'Rolle',
      employees: 'Benutzer',
      deleteUser: 'Benutzer löschen',
      deleteUserConfirmation: 'Löschen bestätigen',
      deactivateContactConfirmation: 'Kontakt deaktivieren',
      activateContactConfirmation: 'Kontakt aktivieren',
      deleteUserText: 'Diese(n) Kontakt(e) löschen?',
      deactivateContactText: 'Diese(n) Kontakt(e) deaktivieren?',
      activeUserText: 'Diese(n) Kontakt(e) aktivieren?',
      grantAdminRights: 'Admin-Rechte erteilen',
      revokeAdminRights: 'Admin-Rechte entziehen',
      addEmployee: 'Benutzer hinzufügen',
      editEmployee: 'Benutzer bearbeiten',
      administrator: 'Berechtigungen',
      roles: {
        admin: 'Admin',
        user: 'User',
        company_admin: 'Administrator',
        accounting: 'FinanceBase',
        manage_documents: 'Dokumente löschen',
        manage_templates: 'Vorlagen verwalten',
        manage_mails: 'Nachrichten löschen',
        publish_update_message: 'Update-Nachricht veröffentlichen',
        generate_data_sets: 'Demo-Daten generieren',
        management: 'ADMINbase',
        marketing: 'MARKETbase',
        asset: 'ASSETbase',
        editor: 'Schreibrechte',
        ticket_editor: 'Ticket-Schreibrechte',
        ticket_delete: 'Tickets löschen',
        janitor: 'Hauswart',
        janitor_editor: 'Hauswart - Schreibrechte',
        ticket_reader: 'Alle Tickets lesen',
        ticket_creator: 'Tickets erstellen',
        digital_signature: 'Digitale Unterschrift',
        documents_portal: 'Dokumente für das Portal',
        digital_deposit: 'Digitale Kaution'
      },
      signature: {
        title: 'Unterschriftenregelung',
        individual: 'Einzelunterschrift',
        collective: 'Kollektiv zu zweien'
      }
    },
    accountSettings: {
      updatedPassword: 'Passwort wurde erfolgreich geändert.',
      updatedInformation: 'Daten wurden erfolgreich geändert.'
    },
    companyProfileOverview: {
      editProfile: 'Profil bearbeiten',
      uploadCompanyLogo: 'Firmen-Logo hochladen',
      branch: {
        title: 'Branche',
        architect: 'Architekt',
        bank: 'Bank',
        civil: 'Bauingenieur',
        hardwareStore: 'Baumarkt',
        buildingContractors: 'Bauunternehmen',
        telecommunications: 'IT & Telekommunikation',
        facilityManagement: 'Facility Management',
        horticultureLandscaping: 'Gartenbau & Landschaftsbau',
        craftEnterprises: 'Handwerksunternehmen',
        realEstateAgents: 'Immobilienmakler',
        realtyManagement: 'Immobilienverwaltung',
        interiorArchitect: 'Innenarchitekt',
        kitchenManufacturer: 'Küchenhersteller',
        furnitureInteriors: 'Möbel & Interior',
        furnitureShop: 'Möbelhaus',
        pensionFund: 'Pensionskasse',
        security: 'Sicherheitsdienst',
        movingTransport: 'Umzug / Transport',
        insurance: 'Versicherung',
        housingAssociation: 'Wohnungsgenossenschaft',
        other: 'Sonstige'
      },
      companySize: {
        title: 'Unternehmensgrösse',
        smallBusiness: 'Start-up',
        mediumBusiness: 'KMU',
        largeBusiness: 'Enterprise'
      },
      aboutLanguage: {
        title: 'Stell dich vor!',
        whatLanguage: 'Welche Sprache sprichst du?',
        aboutUs: 'Über uns',
        showAccountDetailsTitle: 'Diese Zusatzinformationen werden auf Wunsch auf jedem deiner Inserate mit angezeigt',
        showPreview: 'Beispiel anzeigen',
        showAccountDetails: 'Zusatzinformationen anzeigen'
      },
      deleteCompanyPart: {
        title: 'Firma löschen',
        info: 'Es werden alle Daten der Firma von unserem System gelöscht. Bevor eine Firma gelöscht werden kann müssen alle Benutzer entfernt werden. Diese Aktionen kann lediglich ein Firmen-Administrator durchführen. Alle derzeit erstellten Inserate werden nicht mehr auf unserer Plattform zur Verfügung stehen und etwaige vermietete Objekte und deren Mieter werden entfernt. Diese Aktion kann nicht rückgängig gemacht werden!'
      }
    },
    clientSettings: {
      title: 'Mandanten',
      subTitle: 'Hier kannst du deine Mandanten verwalten. Diese kannst du einzelnen Inseraten zuweisen, um den Überblick zu behalten.',
      createClient: 'Mandanten erstellen',
      clientName: 'Name des Mandanten',
      listOfClients: 'Liste der Mandanten',
      deleteClientConfirmation: 'Möchtest du wirklich diesen Mandanten löschen?',
      deleteClient: 'Mandanten löschen'
    },
    staticPages: {
      imprint: {
        title1: 'Impressum',
        text1: 'Unter der Domain <a href=\'/de\' target=\'_blank\'>www.propbase.ch</a> bietet die PropBase AG mit Sitz in Neuhausen am Rheinfall (Schweiz) eine Immobilienplattform an, welche das Ziel verfolgt die Optimierung und Vernetzung der Prozesse Vermarktung, Verwaltung und Kommunikation rund um die Immobilie zu digitalisieren.',
        title2: 'Kontaktadresse',
        text2: 'PropBase AG <br> Im RhyTech 15<br>8212 Neuhausen am Rheinfall<br>Schweiz/Switzerland/Svizzera<br>E-Mail: <a href=\'mailto:info@propbase.ch\'>info@propbase.ch</a><br>Tel: +41 44 512 76 76'
      },
      termAndPrivacy: {
        title: 'Datenschutzerklärung',
        titleone: '1. Anwendungsbereich',
        onetext: 'Die PropBase AG, Im RhyTech 15, 8212 Neuhausen am Rheinfall (<b>\'PropBase\'</b>) betreibt eine Onlineplattform, auf der Mieter, Vermieter und Immobilienverwaltungen sowie weitere interessierte Personen (<b>\'Teilnehmer\'</b>) diverse Dienstleistungen rund um Immobilien und Wohnen nutzen können. Diese Datenschutzerklärung gilt für alle Geschäftsbereiche von PropBase, welche Verantwortliche für die gemäss dieser Datenschutzerklärung erhobenen Daten ist. Sie gilt insbesondere bezüglich der Personendaten, die über unsere Onlineplattform <a href=\'/de\' target=\'_blank\'>www.propbase.ch</a> (<b>\'Plattform\'</b>) erhoben werden.<br><br>Datenschutz ist Vertrauenssache, und Dein Vertrauen ist uns wichtig. Wir respektieren Deine Privatsphäre und stellen sicher, dass Deine Personendaten geschützt sind und gesetzeskonform bearbeitet werden. In dieser Datenschutzerklärung erfährst Du, welche Daten von uns erhoben werden, welche Zwecke wir damit verfolgen, und wie Du Deine Daten aktualisieren, verwalten, exportieren und löschen kannst.<br><br>Für personenbezogene Daten, die in den Anwendungsbereich der EU-Datenschutzgrundverordnung (DSGVO) fallen, stützen wir uns bei der Datenverarbeitung neben Deiner Einwilligung (Art. 6 Abs. 1 (a) DSGVO), die Du jederzeit zurückziehen kannst, auf die Erforderlichkeit im Zusammenhang mit der Erfüllung eines Vertrages (Art. 6 Abs. 1 (b) DSGVO) oder auf unsere berechtigten Interessen (Art. 6 Abs. 1 (f) DSGVO).<br><br>Wenn in dieser Datenschutzerklärung von der Bearbeitung Deiner Personendaten gesprochen wird, so ist damit jeder Umgang mit Deinen Personendaten gemeint. Dazu gehören zum Beispiel:<br><br><ul><li> die Sammlung</li><li> Speicherung</li><li>Verwaltung</li><li> Nutzung</li><li> Übermittlung</li><li> Bekanntgabe oder</li><li> Löschung Deiner Personendaten.</li></ul><br>Durch die Nutzung der Plattform erklärst Du Dich mit den hier aufgeführten Datenschutzbestimmungen einverstanden. Unter <b>\'Nutzung\' \'nutzen\'</b> verstehen wir sämtliche Interaktion auf unserer Plattform, z.B. Eingabe von Daten, Surfen, Anklicken von Schaltflächen etc.',
        titletwo: '2. Erhebung und Speicherung von Daten',
        titletwobody: {
          atitle: 'a) Allgemeines',
          atext: 'Wir erheben im Rahmen Deiner Nutzung der Plattform sowohl personenbezogene als auch nicht personenbezogene Daten (gemeinsam <b>"Daten"</b>). Personenbezogene Daten (<b>"Personendaten"</b>) sind Daten mit Bezug auf eine bestimmte oder bestimmbare natürliche Person und lassen somit Rückschlüsse auf Deine Identität zu. Soweit Daten über juristische Personen durch uns bearbeitet werden, ist deren Handhabung derjenigen von natürlichen Personendaten gleichgestellt.',
          btitle: 'b) Aufruf unserer Webseite',
          btext: 'Beim Besuch unserer Plattform speichern unsere Server temporär jeden Zugriff in einer Protokolldatei. Folgende technischen Daten werden dabei - wie grundsätzlich bei jeder Verbindung mit einem Webserver - ohne Dein Zutun erfasst und bis zur automatisierten Löschung nach spätestens 12 Monaten von uns gespeichert:<br><br><ul><li> die IP-Adresse des anfragenden Rechners</li><li> der Name des Inhabers des IP-Adressbereichs (i.d.R. Dein Internet-Access-Provider)</li><li> das Datum und die Uhrzeit des Zugriffs</li><li> die Webseite, von der aus der Zugriff erfolgte</li><li> der Name und die URL der abgerufenen Datei</li><li> den Status-Code (z.B. Fehlermeldung)</li><li> das Betriebssystem Deines Rechners</li><li> der von Dir verwendete Browser (Typ, Version und Sprache)</li><li> das verwendete Übertragungsprotokoll (z.B. HTTP/1.1).</li></ul><br>Die Erhebung und Verarbeitung dieser Daten erfolgt auf der Grundlage unserer berechtigten Interessen zum Zweck, die Nutzung unserer Plattform zu ermöglichen (Verbindungsaufbau), die Systemsicherheit und -stabilität dauerhaft zu gewährleisten und die Optimierung unseres Internetangebots zu ermöglichen sowie zu internen statistischen Zwecken.',
          ctitle: 'c) Registrierung | Benutzerkonto | Profil',
          ctext: 'Zur Nutzung verschiedener unserer Dienste muss ein persönliches Benutzerkonto erstellt werden. Im Rahmen der Registrierung auf der Plattform werden für das Erfassen eines Benutzerkontos verschiedene Daten erhoben und gespeichert, die nachträglich bearbeitet werden können. Dafür erheben wir zunächst folgende Personendaten:<br><br><ul><li> Beabsichtigte Nutzung (privat oder gewerblich)</li><li> Vorname, Nachname</li><li> E-Mail-Adresse</li><li> Passwort</li></ul><br>Die Erhebung dieser Daten erfolgt zum Zweck, Dir einen passwortgeschützten direkten Zugang zu Deinen bei uns gespeicherten Basisdaten zur Verfügung zu stellen. Du kannst zudem im Benutzerkonto ein Bewerbungsdossier oder ein Inserat erstellen, Deine Bewerbungen und Inserate einsehen sowie Deine persönlichen Daten verwalten bzw. ändern. Neben den Angaben zu Deiner Person kannst Du auch ein Foto hochladen. Das Foto gemeinsam mit Deinem Namen bildet Dein <b>Profil</b> auf der Plattform und ist für die anderen Teilnehmer öffentlich einsehbar.<br>Von gewerblichen Teilnehmern erheben wir zudem folgende Daten:<br><br><ul><li> Firmenname</li><li> E-Mail-Adresse der Kontaktperson</li><li> Sitz der Gesellschaft</li><li> Adresse</li><li> Telefonnummer</li></ul><br>Optional können Angaben zur Branche, zur Unternehmensgrösse, zur Webseite oder eine Beschreibung der Gesellschaft bei der Registrierung angegeben werden. Zudem besteht die Möglichkeit, ein Logo des Unternehmens hochzuladen.',
          dtitle: 'd) Immobilieninserate',
          dtext: 'Teilnehmer der Plattform haben die Möglichkeit Immobilieninserate aufzugeben. Bei den Daten, die dafür erhoben werden, handelt es sich grundsätzlich nicht um Personendaten, sondern um Angaben zu den angebotenen Immobilien, wie Adresse des Objektes, Anzahl Zimmer, Mietkonditionen etc. Sofern Du ein Immobilieninserat aufgibst und noch nicht auf der Plattform registriert bist, werden zusätzlich diejenigen Personendaten erhoben, die auch für die Registrierung auf der Plattform notwendig sind.',
          etitle: 'e) Ausfüllen des Anmeldeformulars',
          etext: 'Teilnehmer der Plattform haben zudem die Möglichkeit mittels Ausfüllen eines Anmeldeformulars ein Bewerbungsdossier zu erstellen und sich für konkrete Immobilieninserate zu bewerben. Zu diesem Zweck werden zusätzliche Daten erhoben, die für die Abwicklung des Bewerbungsprozesses benötigt werden. Dafür erheben wir folgende zwingende Personendaten:<br><br><ul><li> Vorname, Nachname</li><li> Geburtsdatum</li><li> Wohnadresse</li><li> Nationalität</li><li> Kinder</li><li> Angaben zum aktuellen Vermieter</li><li> Grund des Wohnungswechsels</li><li> Art des Arbeitsverhältnisses</li><li> Angaben zum Arbeitgeber</li><li> Einkommenshöhe (drei Kategorien)</li></ul><br>Neben diesen Angaben kannst Du zur Vervollständigung Deines Anmeldeformulars weitere optionale Angaben zu Deiner Person machen, wie Telefonnummer, Heimatort, Zivilstand, Haustiere, Instrumente, Raucher, Beruf und Beschäftigungsdauer. Des weiteren kannst Du Angaben machen zur Kündigung, Betreibungsangaben oder ob ein Verlustschein ausgestellt wurde. Schliesslich besteht die Möglichkeit Bemerkungen zum Anmeldeformular anzufügen.<br>Darüber hinaus hast Du die Möglichkeit Dein Anmeldeformular durch das Hochladen von persönlichen Dokumenten zu ergänzen. Dazu gehören insbesondere Betreibungsauskünfte, Ausweispapiere, Lohnauszüge und weitere Dokumente wie Lebensläufe oder Referenzen. Diese Dokumente sind auf der Plattform nicht öffentlich einsehbar. Im Rahmen der Bewerbung für ein Immobilieninserat kannst Du den Zugriff auf diese Dokumente für den Empfänger Deiner Bewerbung freischalten. Diese Dokumente sind für den Empfänger Deiner Bewerbung dann frei einsehbar.<br>Von gewerblichen Teilnehmern werden für das Ausfüllen des Anmeldeformulars die Angabe eines Ansprechpartners sowie Angaben zum Firmennamen, zur Sitzadresse, zum Geschäftszweck, und Angaben zu Betreibungen der letzten zwei Jahre oder ob ein Verlustschein ausgestellt wurde, verlangt. Optional können Angaben zur Branche, zur Unternehmensgrösse, zum Gründungsdatum, zur Haftpflichtversicherung sowie über die Anzahl Benutzer angegeben werden. Schliesslich besteht die Möglichkeit Bemerkungen zum Anmeldeformular anzufügen.',
          ftitle: 'f) Erstellen eines Suchabos',
          ftext: 'Du hast die Möglichkeit in Deinem Benutzerkonto ein Suchabo für bestimmte Immobilienangebote einzurichten. Das Suchabo soll Dir helfen, die passende Immobilie für Dich oder Deine Gesellschaft zu finden. Im Zusammenhang mit der Einrichtung eines Suchabos erheben wird folgende Daten:<br><br><ul><li> Ort der gesuchten Immobilie</li><li> Distanz zum gesuchten Ort</li><li> Art der gesuchten Immobilie</li><li> Mietpreis (Preisspanne) der gesuchten Immobilie</li></ul><br>Zur Verfeinerung der Suche können weitere Kriterien wie gesuchte Wohnfläche, Verfügbarkeit, Eigenschaften der Immobilie, Innenausstattung, gewünschter Aussenbereich sowie zur gewünschten Technik der gesuchten Immobilie angegeben werden.<br>Alle diese Daten erheben wir, um für Dich Immobilieninserate zu suchen, welche die von Dir gewünschten Kriterien erfüllen und Dir diese anzeigen zu können.',
          gtitle: 'g) Favoritenliste',
          gtext: 'Du hast die Möglichkeit aus den auf der Plattform angezeigten Immobilieninseraten, die von Dir favorisierten Immobilieninserate einer Favoritenliste hinzuzufügen. Diese werden Dir in Deinem Benutzerkonto angezeigt. Die Angaben zu Deinen favorisierten Immobilieninseraten erheben wir zum Zweck, Dir jederzeit eine Übersicht hinsichtlich der von Dir favorisierten Immobilieninseraten anzeigen zu können und Dir so beim Finden Deiner Wunschimmobilie behilflich zu sein.',
          htitle: 'h) Chat-Funktion',
          htext: 'Die Plattform verfügt über eine Chat-Funktion, über welche Du mit anderen Teilnehmern (beispielsweise mit einem Inserenten oder einem Bewerber) in Kontakt treten und Nachrichten austauschen kannst. Diese Nachrichten werden von uns gespeichert, sind auf der Plattform aber nicht öffentlich, sondern nur für die betroffenen Teilnehmer einsehbar.<br><br>Da die Nachrichten aufgrund Deines Profils auf der Plattform Dir zuordenbar sind, handelt es sich um Personendaten. Wir erheben diese Daten zum Zweck, um Dir die einfache und rasche Kommunikation mit anderen Teilnehmern auf der Plattform zu ermöglichen.',
          ititle: 'i) Nutzung kostenpflichtiger Dienste',
          itext: 'Für die Nutzung kostenpflichtiger Dienste erheben wir Daten zu Deiner Rechnungsadresse. Du kannst zwischen den Zahlungsoptionen Kreditkarte, PayPal, Sofortüberweisung, PostFinance oder per Rechnung aussuchen. Die Bezahlung erfolgt jeweils direkt über den Anbieter des Zahlungssystems. Dabei werden vom jeweiligen Anbieter Angaben zum verwendeten Zahlungsmittel (z.B. Angaben zu Deiner Kreditkarte) erhoben. Es gelten daher zusätzlich die Datenschutzbestimmungen des jeweiligen Anbieters. Wir nehmen keine Verarbeitung bezüglich der Daten des von Dir verwendeten Zahlungsmittels vor.',
          jtitle: 'j) Newsletter',
          jtext: 'Du hast die Möglichkeit, über unsere Plattform einen kostenlosen Newsletter zu abonnieren. Hierfür benötigen wir Deine E-Mail-Adresse sowie zur Personifizierung Deinen Namen. Darüber hinaus benötigen wir Deine Einwilligung, dass Du mit dem Bezug des Newsletters einverstanden bist.<br><br>Die Anmeldungen zum Newsletter werden protokolliert, um den Anmeldeprozess entsprechend den rechtlichen Anforderungen nachweisen zu können. Hierzu gehören die Speicherung des Anmelde- und des Bestätigungszeitpunktes als auch der IP-Adresse. Ebenso werden Änderungen Deiner gespeicherten Daten protokolliert.<br><br>Für diese Datenverarbeitung stützen wir uns auf Deine Einwilligung (Art. 6 Abs. 1 S. 1 lit. a DSGVO). <b>Die Einwilligung zum Erhalt des Newsletters kannst Du jederzeit widerrufen.</b> Sende Deinen Widerruf bitte an unsere E-Mail-Adresse: <a href=\'mailto:support@propbase.ch\'>support@propbase.ch</a>. Du kannst Dich auch jederzeit vom Newsletter abmelden, indem Du den Abmelde-Link am Ende jedes Newsletters betätigst.'
        },
        titlethree: '3. Verwendung der Daten',
        textthree: 'Neben den vorhergehend erwähnten Zwecken erfolgt die Erhebung der Daten generell zum Zweck des Betriebs der Plattform sowie der Abwicklung und Administration in Bezug auf die angebotenen Dienstleistungen. Die Daten werden insbesondere auch erhoben im Hinblick auf die Begründung, inhaltliche Ausgestaltung, Abwicklung und Änderung, der mit den einzelnen Teilnehmern geschlossenen Vertragsverhältnissen sowie zur ordnungsgemässen Rechnungsstellung im Falle der Beanspruchung kostenpflichtiger Dienste. Die erhobenen Daten dienen zudem der Verbesserung unserer Dienstleistungen sowie zur Analyse des Nutzungsverhaltens von Teilnehmern.<br><br>Darüber hinaus verwenden wir die erhobenen Daten auch zu eigenen Marketingzwecken. In diesem Zusammenhang erklärst Du Dich damit einverstanden, dass wir an Deine E-Mail-Adresse Informationen zur Plattform und unseren Dienstleistungen senden können. <b>Du hast jederzeit die Möglichkeit, die Verwendung Deiner Personendaten zu Marketingzwecken schriftlich abzulehnen an PropBase AG, Im RhyTech 15, 8212 Neuhausen am Rheinfall, Schweiz oder per E-Mail an <a href="mailto:support@propbase.ch">support@propbase.ch</a> bzw. Deine Einwilligung zu widerrufen.</b><br><br><b>Durch die Eingabe Deiner Personendaten sowie anderer Daten auf der Plattform erklärst Du Dich mit der Bearbeitung aller über Dich erhobenen Daten in der in dieser Datenschutzerklärung beschriebenen Art und Weise und zu dem hierin benannten Zweck einverstanden.</b>',
        titlefour: '4. Weitergabe von Daten an Dritte',
        textfour: 'Wir geben Deine Personendaten nur weiter, wenn Du ausdrücklich eingewilligt hast, hierfür eine gesetzliche Verpflichtung besteht oder dies zur Durchsetzung unserer Rechte, insbesondere zur Durchsetzung von Ansprüchen aus dem Vertragsverhältnis, erforderlich ist. Darüber hinaus geben wir Deine Daten an Dritte weiter, soweit dies im Rahmen der Nutzung der Plattform und der Vertragsabwicklung (auch ausserhalb der Plattform) erforderlich ist.<br><br>Die Weitergabe der Daten erfolgt zum Zweck der Bereitstellung und Aufrechterhaltung der Funktionalitäten unserer Plattform auf der Grundlage unserer berechtigten Interessen sowie zur Vertragsabwicklung.<br><br>Wir behalten uns vor, die erhobenen Daten an beauftragte Dritte <b>im In- und Ausland</b> zu den in dieser Datenschutzerklärung genannten Zwecken bearbeiten zu lassen oder weiterzugeben. Die jeweiligen Datenempfänger, welche Zugriff auf die von uns erhobenen Daten haben, werden verpflichtet, die Daten ausschliesslich für die Auftragsabwicklung und nicht für weitere Zwecke zu nutzen und den Datenschutz zu beachten.<br><br><b>Gesetzliche Offenlegungspflichten</b>: Eine Offenlegung von Daten gegenüber Aufsichtsbehörden, Gerichtsbehörden oder anderen zuständigen Personen ist ausserdem dann ausdrücklich zulässig, wenn das anwendbare Recht dies vorschreibt.<br><br><b>Geschäftliche Übertragungen</b>: Wir behalten uns vor, Informationen einschliesslich Deiner Personendaten in Zusammenhang mit einer Reorganisation, Umstrukturierung, Fusion, einem Verkauf oder einer anderen Art von Übertragung von Vermögenswerten an Dritte zu übermitteln, unter der Bedingung, dass der Empfänger zustimmt, die übermittelten Personendaten auf eine Art und Weise zu behandeln, welche mit dieser Datenschutzerklärung in Einklang steht.',
        titlefive: '5. Übermittlung von Daten ins Ausland',
        textfive: 'Die Plattform wird auf Servern in der Schweiz gehostet. Wir sind berechtigt, Deine persönlichen Daten zum Zweck der in dieser Datenschutzerklärung beschriebenen Datenbearbeitungen auch an dritte Unternehmen (beauftragte Dienstleister) im Ausland zu übertragen. Diese sind im gleichen Umfang wie wir selbst zum Datenschutz verpflichtet. Wenn das Datenschutzniveau in einem Land nicht dem schweizerischen bzw. dem europäischen entspricht, verpflichten wir beauftragte Dritte vertraglich, zur Einhaltung eines Datenschutzniveaus, das demjenigen in der Schweiz bzw. in der EU entspricht.',
        titlesix: '6. Datensicherheit',
        textsix: 'Wir treffen geeignete und angemessene Massnahmen, um zu verhindern, dass Personendaten durch unbefugte Dritte eingesehen, zerstört, missbraucht oder manipuliert werden können. Sämtliche Personendaten werden verschlüsselt auf Servern innerhalb der Schweiz gespeichert.<br><br>Die Kommunikation über die Plattform erfolgt mit einer TLS-Verschlüsselung (Transport Layer Security). Es kann trotzdem vorkommen, dass Daten, die an uns über das Internet oder einen E-Mail-Dienst übermittelt werden, von Dritten unerlaubt eingesehen werden können. Weiter besteht die Möglichkeit, dass die Daten bedingt durch die Natur des Internets unter Umständen grenzüberschreitend über Server von Drittstaaten, d. h. auch Länder, die nicht dasselbe Datenschutzniveau bieten, zirkulieren. Sehr vertrauliche Informationen sollten deswegen nicht über das Internet (z.B. E-Mail) weitergegeben werden.<br><br>Obwohl wir die technischen Vorkehrungen vornehmen, um eine sichere Übermittlung und Aufbewahrung der Daten zu gewährleisten, kann nicht vollständig ausgeschlossen werden, dass unbefugte Dritte, z.B. mittels sogenanntem Hacken unserer Server, in den Besitz von Daten gelangen. Wir schliessen daher die Haftung in diesem Zusammenhang, soweit gesetzlich zulässig, aus.<br>',
        titleseven: '7. Deine Rechte',
        textseven: 'Du hast das Recht, über die Personendaten, die von uns über Dich gespeichert werden, auf Antrag Auskunft zu erhalten. Zusätzlich hast Du das Recht auf <b>Berichtigung</b> unrichtiger Daten, ein Recht auf <b>Übertragbarkeit</b> sowie das Recht auf <b>Einschränkung</b> und Widerspruch gegen die Bearbeitung sowie das Recht auf <b>Löschung</b> Deiner Personendaten, soweit dem keine gesetzliche Aufbewahrungspflicht oder ein Erlaubnistatbestand, der uns die Verarbeitung der Personendaten gestattet, entgegensteht. Sofern in dieser Datenschutzerklärung nicht ersichtlich, teilen wir Dir auf Anfrage auch gerne mit, wie lange wir einzelne Personendaten von Dir speichern.<br><br>Du kannst uns für die vorgenannten Zwecke erreichen entweder mittels Briefpost an <b>PropBase AG, Im RhyTech 15, 8212 Neuhausen am Rheinfall, Schweiz oder per E-Mail an <a href=\'mailto:support@propbase.ch\'>support@propbase.ch</a>.</b> Für die Bearbeitung Deines Gesuchs verlangen wir in der Regel einen Identitätsnachweis.<br><br>Es ist unser Bestreben, Datenschutzbeschwerden möglichst schnell und effektiv zu bearbeiten. Du hast auch das Recht, eine <b>Beschwerde</b> bei der zuständigen Aufsichtsbehörde des Landes, in dem Du wohnst, einzureichen.',
        titleeight: '8. Einwilligung und Recht auf Widerruf',
        texteight: 'Sofern für die Verarbeitung Deiner Personendaten eine Einwilligung notwendig ist, verarbeiten wir diese erst nach Deiner ausdrücklichen Einwilligung.<br><br><b>Wir weisen Dich darauf hin, dass Du die erteilte Einwilligung zur künftigen Verarbeitung Deiner Personendaten jederzeit widerrufen kannst.</b> Teile uns Deinen Widerruf entweder schriftlich mit an PropBase AG, Im RhyTech 15, 8212 Neuhausen am Rheinfall, Schweiz oder per E-Mail an <a href="mailto:support@propbase.ch">support@propbase.ch</a>.</b>',
        titlenine: '9. Webanalyse-Tools',
        textnine: 'Zur kontinuierlichen Optimierung unseres Angebots sowie der Verbesserung von Werbemassnahmen erheben wir auf der Grundlage unserer berechtigten Interessen sogenannte Trackingdaten, die Auskunft über die Nutzung unserer Plattform geben und das Zusammenstellen von Berichten über die Webseitenaktivitäten erlauben. Dafür verwenden wir zurzeit:<br><br><ul><li> Google Analytics, <a href=\'https://analytics.google.com/\' target=\'_blank\'>https://analytics.google.com/</a>; <a href=\'https://www.google.com/intl/en/policies/privacy/\' target=\'_blank\'>https://www.google.com/intl/en/policies/privacy/</a></li><li> Google Webmaster Tools, <a href=\'https://www.google.com/webmasters/\' target=\'_blank\'>https://www.google.com/webmasters/</a></li><li> Google Adwords, <a href=\'https://adwords.google.com/\' target=\'_blank\'>https://adwords.google.com/</a></li><li> Google Tag Manager, <a href=\'https://www.google.com/analytics/tag-manager/\' target=\'_blank\'>https://www.google.com/analytics/tag-manager/</a></li><li> Optinmonster, <a href=\'https://optinmonster.com/\' target=\'_blank\'>https://optinmonster.com/</a></li><li> Instapage, <a href=\'https://instapage.com/\' target=\'_blank\'>https://instapage.com/</a></li><li> Cleaverreach, <a href=\'https://www.cleverreach.com/en/\' target=\'_blank\'>https://www.cleverreach.com/en/</a></li><li> Facebook Business Analytics (Pixel Einbindung), <a href=\'https://analytics.facebook.com/\' target=\'_blank\'>https://analytics.facebook.com/</a></li></ul><br>',
        textnineatitle: 'a) Google Analytics',
        textnineatext: 'Im Rahmen des Einsatzes von Google Analytics, werden Daten inklusive gekürzter IP Adressen (verhindert die Identifikation einzelner Geräte) an Google übertragen. Google beachtet die Datenschutzbestimmungen des \'Swiss-U.S. Privacy Shield\' und des \'EU- US Privacy Shield\'-Abkommens und hat sich beim US-Handelsministerium für diese Abkommen registrieren lassen (Informationen zu den Abkommen findest Du hier: Swiss-U.S. Privacy Shield und EU-US Privacy Shield). Die an Google übermittelte (gekürzte) IP-Adresse wird nicht mit anderen Daten von Google zusammengeführt.<br><br>Google Analytics verwendet Cookies. Die durch Cookies erzeugten Informationen, beispielsweise Browser Typ, Zeit, Ort und Häufigkeit Deines Plattform-Besuchs einschliesslich Deiner (gekürzten) IP-Adresse, werden an Google in die USA übertragen und dort gespeichert. Cookies, mit welchen Tracking-Daten erhoben werden, enthalten keine personenbezogenen Daten, d. h. die IP-Adresse wird unmittelbar auf Deinem Zugriffsgerät gekürzt und somit anonymisiert. Dadurch wird eine anonymisierte Übermittlung und Speicherung der Daten gewährleistet.<br><br>Google bietet für die gängigsten Browser ein Deaktivierungs-Addon an, das mehr Kontrolle darüber gibt, welche Daten von Google zu der von Dir aufgerufenen Webseite erfasst werden. Das Addon teilt dem JavaScript (ga.js) von Google Analytics mit, dass keine Informationen zum Plattform-Besuch an Google Analytics übermittelt werden sollen. Das Deaktivierungs-Addon für Browser von Google Analytics verhindert aber nicht, dass Informationen an uns oder an andere von uns gegebenenfalls eingesetzte Webanalyse-Tools übermittelt werden. Weitere Informationen zur Installation des Browser Addon erhältst Du über nachfolgenden Link: https://tools.google.com/dlpage/gao- ptout?hl=de oder https://support.google.com/analytics/answer/6004245?hl=de.<br><br>Wir haben mit Google eine Vereinbarung zur Auftragsdatenverarbeitung geschlossen.',
        titleteen: 'Cookies',
        textteen: 'Für die Optimierung unserer Plattform und zur Ermittlung der Seitenabrufe werden auf der Grundlage unserer berechtigten Interessen sowie zur Vertragsabwicklung sogenannte Cookies eingesetzt. Bei den von uns verwendeten Cookies handelt es sich grundsätzlich um sog. \'Session-Cookies\'. Sie werden nach Ende Deines Besuchs automatisch gelöscht. Einzelne Cookies bleiben auf Deinem Endgerät gespeichert, sog. \'Permanent Cookies\', bis Du diese löschst. Diese Cookies ermöglichen es uns, Deinen Browser beim nächsten Besuch wiederzuerkennen. Auch Google Analytics verwendet Permanent Cookies (siehe Ziff. 9a oben).<br><br>Cookies sind kleine Dateien, die es ermöglichen, auf dem Zugriffsgerät der Nutzer/in (PC, Smartphone o.ä.) spezifische, auf das Gerät bezogene Informationen zu speichern. Sie dienen zum einen der Benutzerfreundlichkeit der Plattform (z.B. Speicherung von Login-Daten). Zum anderen dienen sie dazu, um die statistischen Daten der Plattformnutzung zu erfassen und sie zwecks Verbesserung des Angebotes analysieren zu können.<br><br>Mit Aufruf unserer Plattform und der mit ihr verbundenen Seiten wird eingewilligt, dass Cookies eingesetzt werden und damit Nutzungsdaten erhoben, gespeichert und genutzt werden. Ausserdem erfolgt damit eine Einwilligung, dass diese Daten in Cookies über das Ende einer Browsersitzung gespeichert und bei einem erneuten Seitenbesuch wieder aufgerufen werden können.<br><br>Die meisten Browser akzeptieren Cookies automatisch. Du kannst auf den Einsatz der Cookies Einfluss nehmen. Die meisten Browser verfügen über eine Option, mit der das Speichern von Cookies eingeschränkt oder komplett verhindert werden kann. Allerdings wird darauf hingewiesen, dass die Nutzung und insbesondere der Nutzungskomfort ohne Cookies eingeschränkt wird. Nachfolgend findest Du eine Auflistung der gängigsten Browser, die wir mit der jeweiligen Anleitung zur Beeinflussung der Browsereinstellungen verlinkt haben:<ul><li> Mozilla Firefox</li><li> Google Chrome</li><li> Google Chrome (Mobile)</li><li> Microsofts Windows Internet Explorer</li><li> Microsofts Windows Internet Explorer (Mobile)</li><li> Apple Safari</li><li> Apple Safari (Mobile)</li></ul><br>Sollte sich Dein Browser nicht darunter befinden, helfen wir gerne weiter. Schicke uns zu diesem Zweck eine E-Mail an <a href=\'mailto:support@propbase.ch\'>support@propbase.ch</a> (bitte Browser angeben!).',
        titleeleven: '11. Interaktion mit sozialen Netzwerken',
        texteleven: 'Auf unserer Plattform verwenden wir zurzeit keine Social Plugins.',
        titletwelve: '12. Änderungen der Datenschutzerklärung',
        texttwelve: 'Durch die Weiterentwicklung unserer Plattform und der angebotenen Dienstleistungen, die Implementierung neuer Technologien oder der Änderung rechtlicher Rahmenbedingungen kann es notwendig werden, diese Datenschutzerklärung zu ändern. Jede wesentliche Änderung dieser Datenschutzerklärung wird registrierten Teilnehmern per E-Mail an die im Rahmen der Registrierung angegebene E-Mail-Adresse oder durch einen entsprechenden Hinweis im persönlichen Benutzerkonto mitgeteilt. Mitteilungen an die im Rahmen der Registrierung angegebene E-Mail-Adresse oder im persönlichen Benutzerkonto gelten als rechtsgültig zugestellt.<br><br>Die jeweils aktuelle Fassung der Datenschutzerklärung kann jederzeit auf unserer Plattform abgerufen und ausgedruckt werden.<br><br>Vielen Dank für Deine Aufmerksamkeit.',
        date: 'Stand: 11. Juli 2018'
      },
      tos: {
        title: 'Allgemeine Geschäftsbedingungen',
        subtitle: 'der PropBase AG, Im RhyTech 15, 8212 Neuhausen am Rheinfall',
        titleone: '1. Anwendungsbereich',
        onetext: 'Diese Allgemeinen Geschäftsbedingungen (AGB) gilt für alle Geschäftsbereiche der PropBase AG (nachfolgend <b>\'wir\'</b> oder <b>\'uns\'</b>). Sie gilt insbesondere bezüglich sämtlicher Dienstleistungen, Leistungen und Produkte (gemeinsam <b>\'Leistungen\'</b>), die über unsere Onlineplattform <a href=\'/de\'>www.propbase.ch</a> (<b>\'Plattform\'</b>) erworben oder gebucht werden und legt die Richtlinien für die Nutzung unserer Plattform fest.<br><br>Wir sprechen Dich in diesen ABG jeweils direkt mit <b>\'Du\'</b>, <b>\'Dich\'</b>, <b>\'Dir\'</b> etc. an. Angesprochen sind damit sämtliche Personen, die unsere Plattform in irgendeiner Weise nutzen und/oder unsere Leistungen beziehen oder auf andere Weise mit uns in ein vertragliches Verhältnis treten.<br><br>Durch die Nutzung unserer Plattform, insbesondere zum Erwerb unserer Leistungen erklärst Du Dich mit diesen AGB einverstanden. Bevor Du unsere Leistungen nutzt oder eine Bestellung aufgibst, solltest Du die Geschäftsbedingungen gelesen und verstanden haben. Du kannst bei Beanspruchung einzelner unserer Leistungen aufgefordert werden, Deine Zustimmung zu den AGB mittels Anklicken eines entsprechenden Bestätigungsfeldes zu wiederholen.<br><br>Die Verarbeitung von personenbezogenen Daten ist in unserer <a href=\'/de/privacy_policy\' target=\'_blank\'>Datenschutzerklärung</a> geregelt. Die Datenschutzerklärung ist integraler und bindender Bestandteil dieser AGB',
        titletwo: '2. Registrierung',
        texttwo: 'Der Bezug unserer Leistungen setzt eine Registrierung voraus. Die Registrierung erfolgt durch Eröffnung eines persönlichen Benutzerkontos und ist kostenlos. Falls Du noch kein Benutzerkonto hast, wirst Du bei der ersten Buchung dazu aufgefordert, Dich mit den erforderlichen Angaben zu registrieren.<br><br>Die Registrierung steht neben juristischen Personen nur unbeschränkt handlungsfähigen natürlichen Personen offen, welche volljährig sind (d.h. Personen, welche mind. 18 Jahre alt sind). Du bist verpflichtet, die für die Registrierung notwendigen Angaben vollständig und wahrheitsgetreu anzugeben. Änderungen sind umgehend nachzuführen, so dass die Angaben im Benutzerkonto jederzeit vollständig und richtig sind. Nicht vollständig durchgeführte Registrationen werden wir nach einer angemessenen Zeitdauer ohne Mitteilung löschen.<br><br>Die im Rahmen der Registrierung erhobenen Zugangsdaten, wie Benutzernamen, E-Mail-Adresse und Passwort sind für Deine <b>persönliche Verwendung bestimmt und vertraulich zu behandeln</b>. Sämtliche über Dein Benutzerkonto getätigten Buchungen werden Dir zugerechnet und sind für Dich verbindlich.<br><br>Wie behalten uns das Recht vor, nach eigenem Ermessen jederzeit personenbezogene Daten zu löschen oder Dein Benutzerkonto zu sperren.',
        titlethree: '3. Leistungen und Preise',
        titlethreebody: {
          atitle: 'a) Allgemeines',
          atext: 'Unsere Plattform verbindet Mieter und Vermieter auf innovative und benutzerfreundliche Weise.<br><br>Als Mieter kannst Du mit wenigen Klicks Dein Wunschobjekt anfragen, ein digitales Anmeldeformular erstellen oder direkt mit Deinem zukünftigen Vermieter über die Plattform kommunizieren. Des Weiteren erlaubt Dir unsere Plattform unter anderem die für das Mietverhältnis erforderlichen Daten auszutauschen, Termine zu organisieren sowie Deine Anfragen zu verwalten.<br><br>Als Vermieter kannst Du mit wenigen Klicks ein Inserat für Deine Immobilie erstellen oder über eine Schnittstelle importieren. Des Weiteren kannst Du die Kriterien Deines zukünftigen Mieters und die Art der Anfragen bestimmen. Dadurch zeigen wir Dir Deine Bewerber mit prozentualer Trefferquote. Zudem erlaubt Dir unsere Plattform Nachrichten, Inserate, Besichtigungstermine, digitale Unterschriften etc. an einem Ort einfach zu verwalten.',
          btitle: 'b) Immobilieninserate (kostenloser Probezeitraum!)',
          btext: 'Auf unserer Plattform können Inserenten Immobilieninserate platzieren und interessierte Personen nach den Angeboten suchen. Für die Platzierung von Immobilieninseraten gelten die auf unserer Plattform publizierten Preise und Bedingungen. Angeboten werden vier unterschiedliche Inserat-Pakete, die sich bezüglich der maximalen Anzahl Inserate pro Monat sowie im Preis unterscheiden. Der Leistungsumfang der einzelnen Pakete (mit Ausnahme der zulässigen Anzahl Inserate pro Monat) ist jeweils identisch, wobei der Leistungsbeschrieb ebenfalls auf unserer Plattform publiziert wird. Massgebend sind jeweils diejenigen Preise und derjenige Leistungsbeschrieb, der im Zeitpunkt des Abschlusses einer Inserat-Buchung auf der Plattform publiziert ist. ',
          ctitle: 'c) Inhalt der Immobilieninserate',
          ctext: 'Für den Inhalt der Inserate ist der Inserent sowohl gegenüber uns, als auch gegenüber Dritten verantwortlich. Als Inserent verpflichtest Du Dich, insbesondere dafür zu sorgen, dass die erfassten und veröffentlichten Inserate, Angebote und Angaben zutreffen, vollständig und nicht täuschend sind und zudem keine rechtlichen Vorschriften oder Rechte Dritter verletzen. Als <b>unzulässig und/oder missbräuchlich</b> gelten insbesondere folgende Beispiele:<br><br><ul><li>Inserate über Immobilien, die nicht oder nicht ernsthaft zur Miete auf dem Markt sind. Inserate für nicht mehr verfügbare (vermietete oder reservierte) Immobilien sind zu deaktivieren; </li><li>Inserate über Immobilien, bei denen der Inserent keine tatsächliche und rechtliche Verfügungsmacht über die inserierte Immobilie hat, sei es als Eigentümer oder mit eigenem Vermarktungsauftrag;</li><li>Die Verwendung von Fotos und Videos, welche nicht die inserierte Immobilie zeigen;</li><li>Inserate über Immobilien, in welcher die Vermarktung der angebotenen Immobilie nicht im Mittelpunkt steht, sondern in unangemessener Weise zu eigenen oder fremden Werbezwecken des Inserenten dient;</li><li> Jede entgeltliche oder unentgeltliche Weitergabe von mit dem eigenen Benutzerkonto zusammenhängenden Rechten zur Nutzung oder Mitbenutzung durch Dritte; </li><li>Die Verwendung entgeltlicher Internet- oder Telefondienste sowie das Erfordernis kostenpflichtiger Registrierung für die Kontaktnahme durch interessierte Personen.</li></ul><br>Wir behalten uns ausdrücklich vor, bei unzulässigen oder missbräuchlichen Inseraten, vom Inserenten und/oder Personen mit Zugriff zum betroffenen Benutzerkonto, jederzeit Änderungen von Inseraten zu verlangen oder Inserate ohne Grundangabe und vorgängige Benachrichtigung abzulehnen oder zu löschen. Die Beurteilung, ob ein unzulässiges oder missbräuchliches Inserat vorliegt, nehmen wir nach freiem Ermessen vor. Als solche gelten auch Inserate, die rechtswidrig oder unsittlich sind oder Rechte Dritter verletzen. <b>Bei Löschungen aus den vorgenannten Gründen besteht kein Anspruch des Inserenten auf Rückforderung von Vergütungen.</b><br><br><b>Durch die Veröffentlichung eines Inserates willigst Du ein, dass wir Dein Inserat und dessen Inhalt auf der Plattform für eigene Marketing- und andere Zwecke nutzen, auswerten oder veröffentlichen (z. B. auf Social Media Plattformen).</b> Personenbezogene Daten sind von dieser Regelung nicht betroffen. Diese verarbeiten wir ausschliesslich gemäss unserer Datenschutzerklärung.',
          dtitle: 'd) Weitere Leistungen für Vermieter',
          dtext: 'Neben der Möglichkeit, auf unserer Plattform Inserate zu veröffentlichen, profitierst Du von diversen weiteren Leistungen, die Du auf der Plattform nutzen kannst. So etwa die Möglichkeit Deine Inserate sowie Dokumente des Bewerbungsprozesses und Mietverhältnisses über Dein Benutzerkonto zu verwalten, mit den potentiellen Mietern zu kommunizieren, Besichtigungstermine zu organisieren etc. <b>Die Nutzung dieser Leistungen ist kostenlos.</b> Wir behalten uns allerdings vor, mit einer vorgängigen Ankündigungszeit von mindestens einem Monat einzelne oder alle unserer kostenlosen Leistungen sowie zusätzliche Leistungen nur noch kostenpflichtig anzubieten.',
          etitle: 'e) Leistungen für Mieter',
          etext: 'Als Mieter profitierst Du neben der Möglichkeit, die auf unserer Plattform veröffentlichten Inserate einzusehen oder nach bestimmten Kriterien zu suchen, von diversen weiteren Leistungen, die Du auf unserer Plattform nutzen kannst. So etwa die Möglichkeit, ein digitales Anmeldeformular für Deine Bewerbungen zu erstellen oder Dich mit Deinem zukünftigen Vermieter über die Plattform auszutauschen, Termine zu organisieren sowie Deine Anfragen an Vermieter zu verwalten.<br><br><b>Die Nutzung dieser Leistungen ist kostenlos.</b> Wir behalten uns allerdings vor, mit einer vorgängigen Ankündigungszeit von mindestens einem Monat einzelne oder alle unserer kostenlosen Leistungen sowie zusätzliche Leistungen nur noch kostenpflichtig anzubieten..'
        },
        titlefour: '4. Vertragsschluss',
        textfour: 'Die über unsere Plattform oder andere Verkaufskanäle gewährte Übersicht über unsere Inserate-Pakete und Preise gilt lediglich als Einladung zur Offertstellung durch Dich. Du triffst Deine Auswahl über den von Dir gewählten Verkaufskanal. Die getroffene Auswahl wird Dir am Ende des Buchungsvorganges auf der Plattform, telefonisch oder per E-Mail mitgeteilt. Mit der Veröffentlichung des <b>ersten Inserates</b> mittels Anklicken des entsprechenden Bestätigungsfelds (\'Veröffentlichen\') auf der Plattform oder mittels mündlicher Bestätigung per Telefon oder schriftlich per E-Mail, unterbreitest Du ein verbindliches Angebot zum Erwerb der ausgewählten Leistung. Der Vertrag hinsichtlich der von uns angebotenen Leistungen mit Dir kommt zustande, sobald wir Dir über unsere Plattform, telefonisch oder per E-Mail Deine Buchung bestätigt haben. Bestätigungen an allfällige von Dir falsch angegebene E-Mail-Adressen gelten als rechtsgültig zugestellt. Sofern wir eine Bestellung nicht umgehend bestätigen, bleibst Du für zwei Tage an Dein Angebot gebunden.<br><br>Als Dein Vertragspartner tritt die PropBase AG, Im RhyTech 15, 8212 Neuhausen am Rheinfall auf.<br><br>Bei einer telefonischen Buchung kannst Du diese AGB vorab unter <a href=\'/de/terms_conditions\'>www.propbase.ch/de/terms_conditions</a> einsehen. Telefonische Buchungen oder Buchungen per E-Mail kommen nur unter Zugrundelegung dieser AGB zustande, welche mit der Buchung als angenommen gelten.',
        titlefive: '5. Bezahlung',
        textfive: 'Bei Buchungen über unsere Plattform erfolgt die Bezahlung entweder mittels Belastung auf der während des Buchungsvorganges angegebenen oder im Benutzerkonto hinterlegten Kreditkarte (Eurocard/MasterCard, Visa), PostFinance, PayPal oder auf Rechnung. Bei Bezahlung auf Rechnung hat die Bezahlung innerhalb von 5 Werktagen ab Buchungsdatum zu erfolgen. Massgebend für die Fristwahrung ist das Datum des Zahlungsauftrags, wobei der volle Buchungspreis spätestens innerhalb 7 Werktagen ab Buchungsdatum unserem Konto gutgeschrieben sein muss. Es liegt in unserem Ermessen, zu entscheiden, welche Zahlungsarten zugelassen sind. <br><br>Sämtliche im Rahmen der Zahlung anfallenden Bankgebühren sind von Dir zu bezahlen. <b>Du hast sicherzustellen, dass bei Banküberweisungen unserem Konto der volle Buchungspreis gutgeschrieben wird. Sofern nicht der volle Buchungspreis auf unserem Konto eingeht, gilt die ausgewählte Leistung als nicht bezahlt.</b><br><br> <b>Ein Anspruch auf Bezug der erworbenen oder gebuchten Leistung entsteht erst mit vollständiger Bezahlung des Buchungspreises (Eingang des entsprechenden Betrages auf unserem Konto oder Zahlungsbestätigung des Anbieters des jeweiligen Zahlungssystems). Wir behalten uns vor, Leistungen bis zur vollständigen Bezahlung zurückzuhalten.</b> Bei Bezahlung auf Rechnung kann die Leistung im Voraus bezogen bzw. teilweise bezogen werden. Sofern der volle Buchungspreis nicht spätestens innerhalb 7 Werktagen ab Buchungsdatum unserem Konto gutgeschrieben ist, sistieren wir unsere Leistung umgehend und entschädigungslos bis zur entsprechenden Gutschrift. Die Verpflichtung zur Bezahlung des vollen Buchungspreises bleibt davon unberührt.',
        titlesix: '6. Änderung, Unterbrechung und Einstellung unserer Plattform',
        textsix: 'Wir behalten uns vor, unsere Plattform einschliesslich aller Funktionalitäten und Inhalte nach eigenem Ermessen jederzeit anzupassen und zu ändern. Solche Änderungen können durch uns jederzeit in Kraft gesetzt werden. <br><br>Wir behalten uns vor, unsere Plattform einschliesslich aller Funktionalitäten und Inhalte nach eigenem Ermessen jederzeit anzupassen und zu ändern. Solche Änderungen können durch uns jederzeit in Kraft gesetzt werden. <br><br><b>Bei Verdacht auf eine nicht vertragsgemässe, widerrechtliche oder unsittliche Verwendung der Plattform durch Inserenten können wir ohne Mitteilung und ohne Angabe von Gründen die betreffenden Inhalte und betroffenen Benutzerkontos löschen.</b>Bei Verdacht auf eine nicht vertragsgemässe, widerrechtliche oder unsittliche Verwendung der Plattform durch Inserenten können wir ohne Mitteilung und ohne Angabe von Gründen die betreffenden Inhalte und betroffenen Benutzerkontos löschen.',
        titleseven: '7. Haftung und Gewährleistung',
        textseven: 'Für die Sicherheit und den Schutz der über das Internet übermittelten Daten sowie für die Vollständigkeit und Richtigkeit der Inhalte auf unserer Plattform übernehmen wir keine Haftung. Insbesondere übernehmen wir keine Haftung für direkte oder indirekte Schäden oder Folgeschäden, die den Nutzern/Besuchern unserer Plattform entstehen.<br><br>Für die Sicherheit und den Schutz der über das Internet übermittelten Daten sowie für die Vollständigkeit und Richtigkeit der Inhalte auf unserer Plattform übernehmen wir keine Haftung. Insbesondere übernehmen wir keine Haftung für direkte oder indirekte Schäden oder Folgeschäden, die den Nutzern/Besuchern unserer Plattform entstehen.<br><br>Auch die Gewährleistung für die Funktionalität und Verfügbarkeit, Servicequalität, Richtigkeit und Vollständigkeit unserer Plattform wird, soweit gesetzlich zulässig, wegbedungen.<br><br>Links, Hyperlinks oder Web-Adressen, die von unserer Plattform zu einer oder mehreren anderen Webseiten führen, dienen ausschliesslich zur Information. Die entsprechenden Webseiten sind von uns unabhängig. Wir geben keine Zusicherungen im Zusammenhang mit anderen Webseiten ab und lehnen jegliche Haftung im Zusammenhang mit anderen Webseiten ab. ',
        titleeight: '8. Stornierung',
        texteight: 'Buchungen sind mit Anklicken des Bestätigungsfelds (\'Veröffentlichen\') im Rahmen der Veröffentlichung des ersten Inserates auf unserer Plattform verbindlich (vgl. Ziff. 4 oben) und können nicht mehr annulliert werden. Die Bearbeitung während der Buchungsfrist ist hingegen jederzeit möglich. In Ausnahmefällen kann eine Buchung mit unserer schriftlichen Zustimmung annulliert werden, wobei es in unserem freien Ermessen steht, Annullierungen zu akzeptieren. Durch die Annullation entstandene Kosten und/oder Bearbeitungsgebühren werden weiterverrechnet. ',
        titlenine: '9. Urheberrecht',
        textnine: 'Die Plattform sowie die gesamten über die Plattform zugänglichen Inhalte sind urheberrechtlich geschützt und gehören, soweit nicht anders bestimmt, ausschliesslich und umfassend der PropBase AG. <br><br>Das (vollständige oder teilweise) Reproduzieren, Verbreiten, Übermitteln (elektronisch oder mit anderen Mitteln), Modifizieren, Verknüpfen oder Benutzen der Inhalte für öffentliche oder kommerzielle Zwecke ist ohne vorherige schriftliche Zustimmung von uns untersagt. <br><br>Das (vollständige oder teilweise) Reproduzieren, Verbreiten, Übermitteln (elektronisch oder mit anderen Mitteln), Modifizieren, Verknüpfen oder Benutzen der Inhalte für öffentliche oder kommerzielle Zwecke ist ohne vorherige schriftliche Zustimmung von uns untersagt. <br><br> Sofern wir Urheberrechtsverletzungen von registrierten Nutzern unserer Plattform feststellen, behalten wir uns vor, diese per sofort von der Nutzung unserer Plattform auszuschliessen und das Benutzerkonto zu sperren bzw. zu löschen.',
        titleteen: '10. Leistungen von Drittanbietern',
        textteen: 'Bestimmte Leistungen auf unserer Plattform werden durch Dritte und nicht durch uns bereitgestellt, was wir jeweils entsprechend kennzeichnen. Für die Beanspruchung dieser Leistungen gelten – soweit nicht ausdrücklich anders vereinbart – die Geschäftsbedingungen der jeweiligen Drittanbieter. Wir übernehmen keinerlei Haftung oder Gewährleistung für derartig beanspruchte Leistungen. Für den Fall der Beanspruchung dieser Leistungen, hast Du Dich vorgängig über die geltenden Geschäftsbedingungen des Drittanbieters zu informieren.',
        titleeleven: '11. Erfüllungsort, Gerichtsstand und anwendbares Recht',
        texteleven: 'Als Erfüllungsort sämtlicher unserer Leistungen wird der Sitz der PropBase AG vereinbart.<br><br>Auf diese AGB und allfällige aus oder im Zusammenhang mit dem Verhältnis zwischen der PropBase AG und Dir entstehende Streitigkeiten ist ausschliesslich Schweizer Recht anwendbar, unter Ausschluss der kollisionsrechtlichen Bestimmungen und der Bestimmungen des UN-Kaufrechts (CISG).<br><br>Ausschliesslicher Gerichtsstand für alle Streitigkeiten zwischen der PropBase AG und Dir ist der Sitz der PropBase AG. Wir sind zudem berechtigt, Dich auch an Deinem Domizil rechtlich zu belangen.',
        titletwelve: '12. Schlussbestimmungen',
        texttwelve: 'Sollten einzelne oder mehrere Bestimmungen dieser AGB ganz oder teilweise unwirksam oder nicht durchsetzbar sein oder werden, wird die Wirksamkeit oder Durchsetzbarkeit der übrigen Bestimmungen dieser AGB oder der Bezug unserer Leistungen davon nicht berührt. Die Parteien werden in diesem Fall die unwirksame oder nicht durchsetzbare Bestimmung durch eine wirksame und durchsetzbare Bestimmung ersetzen, die dem wirtschaftlichen Zweck der zu ersetzenden Bestimmung am nächsten kommt. Dasselbe gilt sinngemäss für den Fall, dass diese AGB eine Regelungslücke enthalten sollte.<br><br>Sollten einzelne oder mehrere Bestimmungen dieser AGB ganz oder teilweise unwirksam oder nicht durchsetzbar sein oder werden, wird die Wirksamkeit oder Durchsetzbarkeit der übrigen Bestimmungen dieser AGB oder der Bezug unserer Leistungen davon nicht berührt. Die Parteien werden in diesem Fall die unwirksame oder nicht durchsetzbare Bestimmung durch eine wirksame und durchsetzbare Bestimmung ersetzen, die dem wirtschaftlichen Zweck der zu ersetzenden Bestimmung am nächsten kommt. Dasselbe gilt sinngemäss für den Fall, dass diese AGB eine Regelungslücke enthalten sollte.<br><br>Du verzichtest darauf, allfällige Forderungen gegenüber uns zur Verrechnung zu bringen.<br><br>Wir behalten uns das Recht vor, diese AGB jederzeit zu ändern. Änderungen werden auf unserer Plattform zugänglich gemacht und treten mit ihrer Aufschaltung in Kraft.',
        date: 'Stand 13. Juli 2018',
        signature: '© PropBase AG'
      },
      aboutUs: {
        title: 'Über uns',
        partone: {
          text1: 'Wir bringen Mieter und Vermieter auf einer Plattform zusammen.',
          text2: 'Die PropBase AG ist ein in Neuhausen am Rheinfall ansässiges PropTech-Unternehmen, das 2016 gegründet wurde und heute über 20 Mitarbeiter beschäftigt. Bei der PropBase AG steht der Mensch als Kunde, Mitarbeiter und Partner stets im Zentrum.'
        },
        parttwo: {
          number1: '2016',
          number2: '> 10',
          number3: '> 178.400',
          subtitle1: 'Gründung',
          subtitle2: 'Mitarbeiter',
          subtitle3: 'Getrunkene Kaffees',
          text1: '',
          text2: '',
          text3: ''
        },
        partthree: {
          title: 'Einfach, smart und digital',
          subtitle: 'Alles rund um deine Immobilie',
          text1: 'Mit dem selbstentwickelten Immobilienportal bietet die PropBase AG eine umfassende Lösung aus einer Hand.<br><br>PropBase optimiert und vernetzt die Prozesse Vermarktung, Verwaltung, Kommunikation und weitere Dienstleistungen rund um deine Immobilie.'
        },
        partfour: {
          title: 'Unsere Werte',
          text: 'Mit Liebe verbinden und inspirieren wir Menschen, damit du an jedem Ort das Gefühl der Freiheit und Verbundenheit erlebst. Daran glauben wir.'
        },
        partfive: {
          title: 'Sei auch du einer von Uns.',
          text: 'Werde ein Teil unseres ambitionierten und engagierten Teams und unterstütze uns dabei den Immobilienmarkt zu revolutionieren.',
          button: 'Aktuell keine offenen Stellen'
        },
        partsix: {
          title: 'Den ersten Kontakt vergisst man nie.',
          text: 'Hast du Fragen, Wünsche oder Anregungen?<br>Bitte nimm Kontakt mit uns auf, wir helfen dir gerne.'
        },
        contact: 'kontaktieren'
      }
    },
    marketingSettings: {
      requests: {
        title: 'Anfragen',
        subTitle: 'Hier kannst du alle Einstellungen und Daten für das Anfragemanagement vornehmen.',
        requestAddress: 'Zentrale Anfrage-Adresse'
      },
      export: {
        title: 'Export',
        subTitle: 'Nehme hier die Konfiguration und Einrichtung für den Immobilienexport auf Portale vor.',
        hostname: 'Hostname',
        port: 'Port',
        username: 'Benutzername',
        password: 'Passwort',
        agencyId: 'AgencyId/CustomerId',
        deleteExportData: 'Exportdaten löschen',
        preset: {
          title: 'Exportierte Kontaktdaten',
          allEnabled: 'Alle Kontakt-Felder',
          noVisit: 'Keine Besichtigungsperson',
          allDisabled: 'Keine Kontakt-Felder'
        }
      },
      applicationForm: {
        title: 'Anmeldeformular',
        subTitle: 'Bestimme hier die Fusszeile für dein Anmeldeformular',
        contractCreationCost1: 'Zieht der Mietinteressent nach Ausfertigung eines vereinbarten Mietvertrages seine Bewerbung zurück, wird eine Umtriebsentschädigung von CHF ',
        contractCreationCost2: '(zzgl. MWST) verrechnet.*',
        obtainInfoAgreement: 'Hiermit ermächtige ich {name}, Auskünfte über meine Person einzuholen. Ich bestätige, alle Fragen wahrheitsgetreu beantwortet zu haben.',
        privacyPolicy: 'Bei der Verwendung des Anmeldeformulars gelten unsere ',
        privacyPolicy2: '.'
      },
      import: {
        title: 'Import',
        directPublication: 'Direkte Veröffentlichung von importierten Inseraten',
        enableEmail: 'E-Mail Benachrichtigungen über Importe'
      }
    },
    marketingObjects: {
      onlineTooltip: 'Inseriert auf folgenden Marktplätzen',
      roomsFrom: 'Zimmer (von)',
      roomsTo: 'Zimmer (bis)',
      status: {
        title: 'Status',
        new: 'Neu',
        new_reserved: 'Neu (reserviert)',
        online: 'Online',
        online_reserved: 'Online (reserviert)',
        online_rented: 'Online (vermietet)',
        offline: 'Offline',
        offline_reserved: 'Offline (reserviert)',
        offline_rented: 'Offline (vermietet)',
        rented: 'Vermietet'
      },
      publish: 'Veröffentlichen',
      unPublish: 'Deaktivieren',
      impossibleToPublish: 'Kein Marktplatz ist ausgewählt',
      objectAutomaticallyUnpublishDate: 'Das Inserat wird am {datetime} automatisch deaktiviert.',
      objectAutomaticallyUnpublishAmount: 'Das Inserat wird automatisch nach {amount} Anfragen deaktiviert.',
      confirmationUnPublish: {
        title: 'Inserat deaktivieren',
        body: 'Willst du dieses Inserat wirklich auf allen Marktplätzen deaktivieren?'
      },
      setAssignee: 'Zuständigen wählen',
      assigneeMarketing: 'Zuständiger',
      removeFromMarketing: 'Aus Vermarktung entfernen',
      marketingNote: 'Notiz für Vermarktung',
      startMarketing: 'Start Vermarktung',
      editNote: 'Notiz bearbeiten',
      chooseAction: 'Welche Aktion willst du durchführen?',
      chooseActionDescription: 'Du kannst entweder direkt einen neuen Mieter (von bspw. einer Warteliste) hinzufügen oder das Objekt in die Vermarktung übergeben um neue Interessenten zu suchen.',
      markForMarketing: 'Für Vermarktung freigeben',
      addNewTenant: 'Neuen Mieter hinzufügen',
      confirmModal: {
        confirmationTitle: 'Bestätigen',
        confirmationTextPublish: 'Diese(s) Objekt(e) veröffentlichen?',
        confirmationTextUnPublish: 'Diese(s) Objekt(e) deaktivieren?',
        removeFromMarketingText: 'Willst du wirklich die ausgewählten Objekte aus der Vermarktung entfernen? Die Objekte werden offline gestellt und der Bewirtschaftung übergeben.'
      },
      details: {
        tabs: {
          advert: 'Inserat',
          interestedParties: 'Anfragen',
          contacts: 'Kontakte',
          statistics: 'Statistiken'
        }
      },
      editAdvert: {
        tabs: {
          export: 'Export',
          communication: 'Kommunikation'
        },
        next: 'Weiter',
        cancel: 'Abbrechen',
        back: 'Zurück',
        publish: 'Veröffentlichen',
        saveDraft: 'Entwurf speichern'
      },
      contactsTab: {
        owner: 'Eigentümer',
        marketing: 'Vermarkter',
        currentTenant: 'Mieter',
        administration: 'Bewirtschafter',
        viewingAppointment: 'Besichtigung'
      }
    },
    processHandover: {
      title: 'Übergabeprotokoll',
      participants: 'Teilnehmer',
      movingInTenancy: 'Einziehende Vermietung',
      movingOutTenancy: 'Auszug Vermietung',
      rooms: {
        title: 'Räume',
        availableRooms: 'Raumvorschläge',
        availableRoomsTooltip: 'Hier werden Raumvorschläge aufgelistet, die mittels Klick auf den + Button zum Objekt hinzugefügt werden können',
        selectedRooms: 'Vorhandene Räume',
        selectedRoomsTooltip: 'Hier werden alle Räume aufgelistet, die bereits in dem Objekt vorhanden sind',
        availableDevices: 'Gerätevorschläge',
        selectedDevices: 'Meine Geräte',
        existingDevices: 'Vorhandene Geräte',
        existingDevicesTooltip: 'Hier werden alle Geräte aufgelistet, die bereits in dem Objekt vorhanden sind',
        existingDevicesWithinRoom: 'Innerhalb des Raumes',
        suggestionsDevices: 'Vorschläge',
        suggestionsDevicesTooltip: 'Hie werden Geräte vorgeschlagen, die normalerweise in dem entsprechenden Raum vorhanden sind. Mittels Klick auf den + Button werden diese dem ausgewählten Raum hinzugefügt.',
        suggestionsDevicesDescription: 'basierend auf die Raumbezeichnung',
        kitchen: 'Küche',
        wetRoom: 'Nasszelle',
        room: 'Zimmer',
        corridor_entrance: 'Korridor/Eingangsbereich',
        reduit_storage: 'Reduit/Abstellraum',
        balcony_seatingArea: 'Balkon/Sitzplatz',
        cellar: 'Keller ',
        parking: ' Parkplatz',
        secondaryRoom: 'Nebenraum',
        addRoom: 'Raum hinzufügen',
        editRoom: 'Raum bearbeiten'
      },
      devices: {
        title: ' Geräte',
        devicesWithoutRoom: 'Nicht zugeordnete Geräte',
        letterbox: 'Briefkasten',
        addDeviceModal: 'Gerät hinzufügen',
        finish: 'Fertig'
      },
      keys: {
        title: 'Schlüssel',
        existingKeys: 'Vorhandene Schlüssel',
        existingKeysTooltip: ' Hier werden alle Schlüssel aufgelistet, die bereits erfasst worden sind. Hinweis: Schlüssel der einzelnen Räume innerhalb des Objektes werden auf dem jeweiligen Raum erfasst.',
        existingKeysSubtitle: 'Schlüssel, die nicht innerhalb eines Raumes erfasst worden sind',
        listEntryTitleKey: 'Schlüssel',
        listEntryTitleWireless: 'Funksender',
        addKey: 'Schlüssel hinzufügen',
        suggestionsKeys: {
          title: 'Vorschläge',
          basement: 'Keller',
          attic: 'Estrich',
          washingCard: 'Waschkarte',
          letterbox: 'Briefkasten',
          flatKey: 'Wohnungsschlüssel',
          garage: 'Garage',
          handTransmitter: 'Handsender'
        },
        suggestionsKeysTooltip: 'Hier werden Schlüsseltypen vorgeschlagen, die häufig in entsprechenden Objekttyp vorhanden sind. Mittels Klick auf den + Button werden diese dem ausgewählten Objekt hinzugefügt. Es werden keine Zimmerschlüssel, die innerhalb der verschiedenen Räume im Objekt sind aufgelistet.',
        suggestionsKeysSubtitle: 'basierend auf dem Objekttyp'
      },
      confirmationDeletion: {
        title: 'Löschen bestätigen',
        body: 'Bist du sicher, dass du das/die ausgewählte(n) Element(e) löschen möchtest?',
        roomBody: 'Bist du sicher, dass du den/die ausgewählte(n) Raum/Räume löschen möchtest? Alle zugehörigen Bauteile & Geräte, sowie Verknüpfungen zu bestehenden Tickets werden dadurch gelöscht.'
      },
      subtitleContactPersonsSelection: 'Wähle hier alle Kontaktpersonen aus, die an der Übergabe vor Ort sein werden'
    },
    createOrder: {
      title: 'Auftrag erstellen',
      selectContact: 'Kontakt auswählen',
      selectReceiver: 'Ausführender auswählen',
      selectObject: 'Objekt auswählen',
      unselectReceiver: 'Ausführender abwählen',
      selectContactPersonDescription: 'Optional kannst du explizit eine Kontaktperson der ausgewählten Firma anschreiben.',
      selectedDevices: 'Ausgewählte Geräte',
      continueWithoutContact: 'weiter ohne Kontakt',
      noContacts: 'Keine Kontakte',
      orderCreator: 'Zuständiger',
      executeFrom: 'Auftrag auszuführen ab',
      executeUntil: 'Auftrag auszuführen bis',
      orderDetails: 'Auftragsdetails',
      orderDescription: 'Auftragsbeschrieb',
      contactPersonOnSite: 'Ansprechsperson vor Ort',
      sameAsOrderCreator: 'Wie Auftragsersteller',
      contactPersonOfCompany: 'Bitte wähle eine Kontaktperson.',
      location: 'Standort:',
      address: 'Adresse:',
      componentDevice: 'Bauteil/Gerät:',
      manufacturer: 'Hersteller:',
      brand: 'Marke:',
      model: 'Modell:',
      serialNumber: 'Seriennummer:',
      assetNumberFm: 'Anlagenummer FM:',
      descriptionOrderDetails: 'Im Namen und auf Rechnung vom Eigentümer erteilen wir Ihnen folgenden Auftrag:',
      futureTenant: '(Zukünftiger Mieter)',
      notifyOnlyStatusChanges: 'Kontaktperson vor Ort bei Annahme und Erledigung des Auftrages per Email informieren',
      includeCorrespondenceContact: 'Kontaktinformationen des Ausführenden senden',
      property: 'Liegenschaft:',
      city: 'Ort:',
      watcher: 'Beobachter',
      statusUpdate: {
        title: 'Status-Updates',
        description: 'Wähle hier die Kontakte aus, die bei Erstellung und Erledigung eines Tickets eine E-Mail mit entsprechender Information erhalten sollen. Bitte überprüfe, dass alle ausgewählten Kontakte eine E-Mail-Adresse hinterlegt haben.',
        sendStatus: 'Status-Updates versenden',
        doNotSendStatus: 'Keine Status-Updates versenden'
      },
      addConnection: 'Verknüpfung hinzufügen',
      linkedObjects: 'Verknüpfte Objekte',
      allObjects: 'Alle Objekte'
    },
    addTenancy: {
      tenants: 'Mieter auswählen',
      selectTenant: 'Mieter auswählen',
      addAnotherTenant: 'weiteren Mieter auswählen',
      noDebtor: 'Wähle mindestens einen Debitor aus um zum nächsten Schritt zu gelangen.',
      noTenants: 'Wähle mindestens einen Mieter aus um zum nächsten Schritt zu gelangen.',
      tenancy: 'Vermietung bearbeiten',
      contractTemplate: 'Vertragsvorlage',
      contractTemplateDescription: 'Hier kannst du eine oder mehrere Vertragsvorlage/n vom Eigentümer des Objekts auswählen.<br>Du kannst die Vertragsvorlagen verwalten indem du unter Einstellungen zum Reiter \'Vorlagen\' navigierst.<br>Du kannst jederzeit diesen Prozess erneut starten um den Vertrag später zu erstellen oder eine aktualisierte Version zu generieren.',
      createContractAndSave: 'Mietvertrag erstellen und speichern',
      createContract: 'Mietvertrag erstellen',
      createDocument: 'Dokument erstellen',
      createWithoutContract: 'Speichern ohne Mietvertrag',
      removeContactTitle: 'Mieter aus Vermietung entfernen',
      removeContactBody: 'Willst du diesen Kontakt als Mieter aus dieser neuen Vermietungen entfernen?',
      removeDebtorTitle: 'Debitor aus Vermietung entfernen',
      removeDebtorBody: 'Willst du diesen Kontakt als Debitor aus dieser neuen Vermietungen entfernen?',
      removeCorrespondenceTitle: 'Korrespondenzadresse aus Vermietung entfernen',
      removeCorrespondenceBody: 'Willst du diesen Kontakt als Korrespondenzadresse aus dieser neuen Vermietungen entfernen?',
      removeGuarantorTitle: 'Solidarhafter aus Vermietung entfernen',
      removeGuarantorBody: 'Willst du diesen Kontakt als Solidarhafter aus dieser neuen Vermietungen entfernen?',
      contractualPartner: 'Vertragspartner',
      guarantor: 'Solidarhafter',
      selectGuarantor: 'Solidarhafter auswählen',
      addAnotherGuarantor: 'Weiteren Solidarhafter hinzufügen',
      CorrespondenceAddress: 'Korrespondenzadresse',
      debtor: 'Debitor',
      selectCorrespondenceAddress: 'Korrespondenzadresse auswählen',
      selectDebtor: 'Debitor auswählen',
      startsBeforePrevious: 'Die Vermietung darf nicht vor dem Enddatum der vorhergehenden Vermietung oder Leerstand starten.',
      addVacancyText: 'Möchtest du für dieses Objekt einen Leerstand nach ablauf der befristeten Vermietung hinzufügen? ',
      continueWithoutVacancy: 'Ohne Leerstand fortfahren'
    },
    addVacancy: {
      startVacancyAt: 'Start Leerstand',
      endingVacancyAt: 'Ende Leerstand',
      vacancyStatus: 'Status Leerstand',
      previousNotTerminated: 'Die vorhergehende Vermietung/Leerstand hat noch kein Enddatum.',
      startsBeforePrevious: 'Der Leerstand darf nicht vor dem Enddatum der vorhergehenden Vermietung oder Leerstand starten.'
    },
    enterTermination: {
      noAllTerminationReceived: {
        title: 'Kündigung überprüfen',
        text: 'Achtung: Die Kündigung wurde nicht von allen Vertragspartner unterschrieben. Wie möchtest du vorgehen?',
        createDocument: 'Dokument erstellen',
        continue: 'Fortfahren'
      },
      otherTenancies: 'Weitere Mietverhältnisse',
      reviewTermination: 'Kündigung überprüfen',
      terminationDetails: 'Kündigungsdetails',
      createDocument: 'Dokument erstellen',
      createDocumentFor: 'Dokument erstellen für',
      addVacancy: 'Leerstand hinzufügen',
      tenant: 'Mieter',
      guarantor: 'Solidarhafter',
      terminationType: 'Kündigungsart',
      reasonOfTermination: 'Kündigungsgrund',
      terminationJustification: 'Begründung',
      terminationCreatedOn: 'Eingang der Kündigung',
      terminationSentByTenantAt: 'Kündigung des Mieters gesendet am',
      terminatedOn: 'Gewünschtes Auszugsdatum',
      moveOutDate: 'Auszugsdatum',
      unjustifiedUse: {
        title: 'Ungerechtfertigte Nutzung',
        from: 'Ab',
        to: 'Bis',
        statusWithoutEnd: 'Ungerechtfertigte Nutzung von {startDate}',
        statusWithEnd: 'Ungerechtfertigte Nutzung von {startDate} bis {endDate}'
      },
      possibleMoveInDateNextTenant: 'Mögl. Bezug Nachmieter',
      familyFlatAttention: 'Achtung: Bitte überprüfen Sie, ob die Unterschrift von beiden Ehepartnern vorhanden ist.',
      choosePartnersQuestion: 'Haben alle Vertragspartner die Kündigung unterzeichnet?',
      reasonOfTerminationTooltipTenant: 'Ordentlich (Kündigung gemäss Vertrag)<br>Ausserterminlich  (Vorzeitige Rückgabe)<br>Ausserordentlich (Aus wichtigen Gründen, Tod des Mieters)',
      reasonOfTerminationTooltipLandlord: 'Terminlich (Kündigung gemäss Vertrag)<br>Ausserterminlich  (Vorzeitige Rückgabe)<br>Ausserordentlich (Aus wichtigen Gründen, Konkurs des Mieters, Verletzung der Sorgfaltspflicht, Zahlungsrückstand des Mieters)',
      types: {
        term: 'Ordentlich',
        offTerm: 'Ausserterminlich',
        exceptional: 'Ausserordentlich'
      },
      reasons: {
        TERMINATION_REASON_IMPORTANT_REASONS: 'Wichtige Gründe (OR Art. 266g)',
        TERMINATION_REASON_DEATH: 'Tod des Mieters (OR Art. 266i)',
        TERMINATION_REASON_VIOLATION_OF_DUE_DILIGENCE: 'Verletzung der Sorgfaltspflicht (OR Art. 257f)',
        TERMINATION_REASON_BANKRUPTCY_OF_TENANT: 'Konkurs des Mieters (OR Art. 266h)',
        TERMINATION_REASON_ARREARS: 'Zahlungsrückstand (OR Art. 257d)',
        TERMINATION_REASON_TOO_SMALL: 'Wohnung zu klein',
        TERMINATION_REASON_TOO_BIG: 'Wohnung zu gross',
        TERMINATION_REASON_TOO_EXPENSIVE: 'Wohnung zu teuer',
        TERMINATION_REASON_IMMISSIONS_TOO_HIGH: 'Immissionen zu gross',
        TERMINATION_REASON_FAMILY: 'Familiäre Gründe ',
        TERMINATION_REASON_JOB: 'Jobwechsel',
        TERMINATION_REASON_TEMPORARY_CONTRACT: 'Befristeter Vertrag ',
        TERMINATION_REASON_UNDEFINED: 'Keine Angaben ',
        TERMINATION_REASON_OWN_NEED: 'Eigenbedarf',
        TERMINATION_REASON_RENOVATION: 'Renovationskündigung',
        TERMINATION_REASON_ECONOMIC_REASONS: 'Wirtschaftliche Gründe',
        TERMINATION_REASON_AREA_TOO_SMALL: 'Fläche zu klein',
        TERMINATION_REASON_AREA_TOO_LARGE: 'Fläche zu gross',
        TERMINATION_REASON_HOME_PURCHASE: 'Kauf Eigenheim',
        TERMINATION_REASON_SALE: 'Verkauf',
        TERMINATION_REASON_UNAUTHORISED_SUBLETTING: 'Unerlaubte Untervermietung',
        TERMINATION_REASON_PAYMENT_DEFAULT: 'Zahlungsverzug',
        TERMINATION_REASON_POSTSCRIPT: 'Nachtrag'
      },
      noVacancy: 'Keinen Leerstand hinzufügen',
      moveInBeforeMoveOut: 'Mögl. Bezug Nachmieter darf nicht vor dem Auszugsdatum sein.',
      saveAndNext: 'Speichern und Weiter',
      takeData: 'Daten für die weiteren Verträge übernehmen'
    },
    marketingMessages: {
      createTask: 'Aufgabe erstellen',
      messages: 'Nachrichten',
      draft: 'Entwurf',
      draftWrintingEmail: {
        title: 'Entwurf: Email schreiben',
        text: 'Anscheinend bist du gerade dabei, eine Email zu schreiben. Durch die Erstellung einer neuen Email wird der Entwurf gelöscht und Änderungen gehen verloren.',
        discard: 'Entwurf verwerfen',
        continueEditing: 'Mit Bearbeitung fortfahren'
      },
      selectMessage: 'Wähle eine Email aus',
      unreadMessages: 'Ungelesene Nachrichten',
      markAsRead: 'Als gelesen markieren',
      markAsUnRead: 'Als ungelesen markieren',
      markAsSpam: 'Als Spam melden',
      markAsNoSpam: 'Keine Spam',
      print: 'Drucken',
      forwardAsAttachement: 'Als Anhang weiterleiten',
      folderFilter: {
        all: 'Alle',
        outbound: 'Ausgehend',
        inbound: 'Eingehend',
        spam: 'Spam',
        archive: 'Archiv',
        trash: 'Papierkorb'
      },
      sendMail: 'E-Mail senden',
      secondTitle: 'Alle Empfänger erhalten eine separate E-Mail, ohne die anderen Empfänger zu sehen',
      secondOneMailTitle: 'Es wird eine E-Mail gesendet, alle Empfänger sehen die E-Mails der anderen.',
      requestFrom: 'Anfrage von ',
      requestFromGeneric: 'Anfrage von externer Plattform',
      sendMailType: {
        title: 'Wie möchtest du die E-Mails versenden?',
        single: 'Eine E-Mail, alle Empfänger sehen die E-Mails der anderen',
        multiple: 'Alle Empfänger erhalten eine separate E-Mail'
      },
      detailEmail: 'Nachricht',
      reply: 'Antworten',
      replyAll: 'Allen antworten',
      forward: 'Weiterleiten',
      history: 'Verlauf:',
      toContact: 'Zum Kontakt',
      linkToContact: 'Kontakt zuordnen',
      titleLinkContact: 'Kontakt zu {contactName} zuordnen',
      linkToRequest: 'Anfrage zuordnen',
      linkToTicket: 'Ticket zuordnen',
      applicationForm: 'Anmeldeformular',
      linkToApplicationForm: 'Link zum Anmeldeformular: ',
      markAsConfidential: 'Vertraulich',
      markAsNotConfidential: 'Nicht vertraulich',
      linkMailToContact: {
        title: 'Mail einem Kontakt zuordnen',
        modalTitle: 'Mail zu Kontakt zuordnen',
        modalText: 'Willst du die Mail wirklich diesem Kontakt zuordnen?'
      },
      linkMailToTicket: {
        title: 'Bestätigung',
        text: 'Willst du diese E-Mail mit dem Ticket verknüpfen?'
      },
      mail: {
        mailbox: 'Postfach',
        title: 'Message',
        subject: 'Betreff',
        message: 'Massage',
        email: 'Email',
        from: 'Von',
        to: 'An',
        date: 'Datum',
        sent: 'Gesendet',
        body: 'Nachricht',
        insertBCC: 'BCC einblenden',
        removeBCC: 'BCC ausblenden',
        placeholderMessage: 'Die Platzhalter werden im Hintergrund automatisch für jede e-Mail separat ersetzt. Bitte achte darauf, dass die Platzhalter inhaltlich korrekt sind.',
        dedicatedErrorMessage: 'Aufgrund der Richtlinien von T-Online können keine E-Mails über unser System an versendet werden. </br> Bitte nehmen Sie Kontakt mit unserem Support auf. (Tel. +41 44 512 76 76 oder <a href="mailto:support@propbase.ch">support@propbase.ch</a>)',
        downloadAll: 'Alle herunterladen'
      },
      confirmModal: {
        confirmationTitle: 'Bestätigen',
        confirmationTextMarkRead: 'Diese Nachricht(en) als gelesen markieren?',
        confirmationTextMarkUnRead: 'Diese Nachricht(en) als ungelesen markieren?',
        confirmationTextDelete: 'Willst du wirklich alle ausgewählten Mails in den Papierkorb verschieben?',
        confirmationTextDeleteOneMail: 'Willst du wirklich diese Mail in den Papierkorb verschieben?',
        confirmationTextArchive: 'Diese Nachricht(en) archivieren?',
        confirmationTextRestore: 'Willst du wirklich alle ausgewählten Mails aus dem Papierkorb wiederherstellen?',
        confirmationTextRestoreFromArchive: 'Willst du wirklich alle ausgewählten Mails aus dem Archiv wiederherstellen?',
        confirmationTextEmptyTrash: 'Willst du wirklich alle ausgewählten Mails unwiderruflich löschen?',
        confirmationDiscardChanges: 'Diese Aktion durchführen? Email geht verloren.'
      },
      reminderDone: 'Erledigt am {date}'
    },
    interestedParty: {
      reference: {
        contactName: 'Kontakt',
        landlord: {
          title: 'Referenz Vermieter',
          landlord: 'Vermieter',
          contactPerson: 'Kontaktperson',
          duration: 'Wie lange wohnt er/sie schon dort?',
          punctualPayment: 'Wurde die Miete pünktlich bezahlt?',
          complaints: 'Gab es Beschwerden?',
          costs: 'Wie teuer war die Wohnung?',
          notes: 'Bemerkungen',
          email: 'Email Vermieter',
          phone: 'Telefon Vermieter'
        },
        employer: {
          title: 'Referenz Arbeitgeber',
          employer: 'Arbeitgeber',
          contactPerson: 'Kontaktperson',
          duration: 'Wie lange arbeitet er/sie schon dort?',
          probation: 'Ist er/sie noch in einer Probezeit?',
          temporalEmployment: 'Ist er/sie befristet angestellt?',
          salary: 'Stimmt der Lohn überein?',
          notes: 'Bemerkungen',
          email: 'Email Vorgesetzter',
          phone: 'Telefon Vorgesetzter'
        },
        finishReference: 'Referenz abschliessen',
        obtainedOn: 'Referenz eingeholt am'
      },
      action: {
        editTenancy: 'Vermietung bearbeiten',
        addAsTenant: 'Vermietung hinzufügen',
        addFavorite: 'Favorit',
        deleteTenancy: 'Vermietung löschen',
        activateTenancy: 'Vermietung aktivieren',
        activateVacancy: 'Leerstand aktivieren'
      },
      confirmModal: {
        tenancyConfirmationTextDelete: 'Willst du wirklich die Vermietung löschen?',
        tenancyWithSignConfirmationTextDelete: 'Willst du wirklich die Vermietung löschen und den Unterschrift-Prozess annullieren?',
        deleteTenancyOnly: 'Nur Vermietung löschen'
      },
      documents: {
        title: 'Mietvertrag'
      },
      interestedPartySelection: 'Interessentenauswahl',
      and: 'und',
      singleNoDocumentStored: 'hat keine Dokumente hinterlegt. Bitte laden Sie entsprechende Dokumente hoch',
      pluralNoDocumentStored: 'haben keine Dokumente hinterlegt. Bitte laden Sie entsprechende Dokumente hoch'
    },
    header: {
      logout: 'Logout',
      business: 'Business',
      search: 'Suchen',
      register: 'Registrieren',
      login: 'Anmelden',
      haveAccountMessage: 'Bereits registriert?'
    },
    footer: {
      contact: 'Kontakt',
      blog: 'Blog',
      howitworks: 'Business',
      prices: 'Mieten / Kaufen',
      help: 'Hilfe',
      login: 'Anmelden',
      aboutus: 'Über uns',
      cookies: 'Cookies',
      socialmedia: 'Soziale Medien',
      sitemap: 'Sitemap',
      privacypolicy: 'Datenschutz',
      terms_conditions: 'AGBs',
      imprint: 'Impressum',
      overview: 'Überblick',
      copyright: 'Alle Rechte vorbehalten',
      socialMedias: 'Soziale Medien',
      rentIn: 'Mieten in',
      buyIn: 'Kaufen in',
      cities: {
        zurich: 'Zürich',
        genf: 'Genf',
        basel: 'Basel',
        bern: 'Bern',
        lausanne: 'Lausanne'
      }
    },
    search: {
      saveFilter: 'Filter speichern',
      deleteFilter: 'Filter löschen',
      deleteFilterConfirmation: 'Diesen Filter löschen?',
      pleaseSelectFilter: 'Filter auswählen',
      placeholder: 'Suchbegriff',
      sort: 'Sortieren',
      filter: 'Filtern',
      filterAll: 'Alle',
      resetFilter: 'Filter zurücksetzen',
      noFilter: 'Kein Filter',
      enterFilterName: 'Filter-Name eingeben'
    },
    advertisement: {
      city: 'Stadt',
      street: 'Strasse',
      contactPersonViewing: 'Kontaktperson für Besichtigung',
      contactPersonViewingPlaceholderTenant: 'Bitte Mieter wählen',
      contactPersonViewingPlaceholderJanitor: 'Bitte Hauswart wählen',
      contactPersonViewingPlaceholderServiceprovider: 'Bitte Dienstleister wählen',
      sameAsAssignee: 'Wie Zuständiger',
      publishContactData: 'Kontakt veröffentlichen',
      contact: '\nKontakt:\n',
      contactTitle: 'Kontakt:',
      includeContactDataInDefaultAnswer: 'Kontaktdaten in Standardantwort einfügen',
      includeApplicationformLinkInDefaultAnswer: 'Link zum Anmeldeformular in Standardantwort einfügen',
      applicationformLink: 'Link zum Anmeldeformular',
      viewingAppointmentText: 'Besichtigungsinformationen',
      viewingAppointmentTextPlaceholder: 'Dieser Text wird auf folgenden Plattformen veröffentlicht: Homegate, newhome und Immoscout24',
      defaultAnswer: 'Automatische Antwort auf Anfragen',
      labelLanguage: 'Sprache des Inserates',
      publishObjectOn: 'Objekt publizieren am',
      time: 'Zeit',
      onlineUntil: 'Online bis',
      amountOfRequests: 'Anzahl Anfragen',
      status: {
        name: 'Status',
        published: 'Publiziert',
        archived: 'Offline',
        draft: 'Entwurf',
        sold: 'Verkauft',
        imported: 'Importiert',
        rented: 'Vermietet'
      },
      type: {
        name: 'Typ',
        rent: 'Vermietung',
        sale: 'Verkauf'
      },
      costs: {
        onRequest: 'Auf Anfrage',
        coldRent: 'Nettomiete',
        price: 'Preis',
        priceM2: 'Preis/m²',
        additional: 'Nebenkosten',
        heating: 'Heizkosten',
        total: 'Bruttomiete'
      },
      objectCategory: {
        name: 'Kategorie',
        // Below violation of using snake_case instead of kebab-case is done
        // because of easier translation of backend values
        house: 'Haus',
        apartment: 'Wohnung',
        industrial_real_estate: 'Gewerbe/Industrie',
        gastronomy: 'Gastronomie',
        garden: 'Garten',
        parking: 'Parkplatz',
        secondary: 'Wohnnebenräume',
        estate: 'Grundstück',
        agriculture: 'Landwirtschaft'
      },
      objectType: {
        name: 'Objekt-Typ',
        null: '-',
        // Below violation of using snake_case instead of kebab-case is done
        // because of easier translation of backend values
        attic_apartment: 'Attikawohnung',
        duplex_apartment: 'Maisonette / Duplex',
        terraced_apartment: 'Terrassenwohnung',
        granny_flat: 'Einliegerwohnung',
        detached_house: 'Einfamilienhaus',
        row_house: 'Reiheneinfamilienhaus',
        single_house: 'Einzelhaus',
        terraced_house: 'Terrassenhaus',
        storage: 'Lager',
        shop: 'Laden',
        factory: 'Fabrik',
        gastronomy: 'Gastronomie',
        hotel: 'Hotel',
        other: 'Andere Objekte',
        temporary_living: 'Wohnen auf Zeit',
        studio: 'Studio',
        single_room: 'Einzelzimmer',
        furnished: 'Möbliertes Wohnen',
        attic: 'Mansarde',
        alottment_garden: 'Schrebergarten',
        cafe: 'Café',
        bar: 'Bar',
        club: 'Club / Disco',
        casino: 'Casino',
        cinema: 'Kino / Theater',
        squash_badminton: 'Squash / Badminton',
        indoor_tennis_court: 'Tennishalle',
        outdoor_tennis_court: 'Tennisplatz',
        sports_hall: 'Sportanlage',
        camping_ground: 'Camping- / Zeltplatz',
        outdoor_swimmingpool: 'Freibad',
        indoor_swimmingpool: 'Hallenbad',
        golf_course: 'Golfplatz',
        motel: 'Motel',
        pub: 'Pub',
        bifamiliar_house: 'Doppeleinfamilienhaus',
        multiple_dwelling: 'Mehrfamilienhaus',
        cave_earth: 'Höhlen- / Erdhaus',
        castle: 'Schloss',
        chalet: 'Chalet',
        rustic: 'Rustico',
        agricultural_installation: 'Landwirtschaftsbetrieb',
        mountain_farm: 'Alpwirtschaft',
        farm: 'Bauernhaus',
        advertising_area: 'Werbefläche',
        commercial: 'Gewerbe',
        practice: 'Praxis',
        kiosk: 'Kiosk',
        gardening: 'Gärtnerei',
        fuel_station: 'Tankstelle',
        garage: 'Autogarage',
        cheese_factory: 'Käserei',
        butcher: 'Metzgerei',
        bakery: 'Bäckerei',
        hairdresser: 'Coiffeursalon',
        shopping_center: 'Shoppingcenter',
        industrial_object: 'Industrieobjekt',
        arcade: 'Arkade',
        atelier: 'Atelier',
        living_commercial: 'Wohn- / Geschäftshaus',
        library: 'Bücherei',
        hospital: 'Krankenhaus',
        laboratory: 'Labor',
        mini_golf: 'Minigolfplatz',
        nursing_home: 'Pflegeheim',
        riding_hall: 'Reithalle',
        sanatorium: 'Sanatorium',
        workshop: 'Werkstatt',
        part_room: 'Partyraum',
        sauna: 'Sauna',
        solarium: 'Solarium',
        carpentry_shop: 'Schreinerei',
        retirement_home: 'Altersheim',
        department_store: 'Geschäftshaus',
        home: 'Heim',
        display_window: 'Schaufenster',
        parking_garage: 'Parkhaus',
        parking_surface: 'Parkfläche',
        open_slot: 'Aussenstellplatz',
        covered_slot: 'Gedeckter Parkplatz',
        single_garage: 'Einzelgarage',
        double_garage: 'Doppelgarage',
        underground_slot: 'Auto-Einstellplatz',
        boat_dry_dock: 'Boot Hallenplatz',
        boat_landing_stage: 'Boot Stegplatz',
        covered_bike_slot: 'Moto Hallenplatz',
        outdoor_bike_slot: 'Moto Aussenplatz',
        horse_box: 'Stallboxe',
        boat_mooring: 'Boot Bojenplatz',
        customer_parking: 'Kundenparkplatz',
        building_land: 'Bauland',
        agricultural_land: 'Agrarland',
        commercial_land: 'Gewerbeland',
        industrial_land: 'Industriebauland',
        hobby_room: 'Hobbyraum',
        cellar_compartment: 'Kellerabteil',
        attic_compartment: 'Estrichabteil',
        house_granny_flat: 'Stöckli',
        attic_flat: 'Attikawohnung',
        office: 'Büro',
        apartment: 'Wohnung',
        villa: 'Villa'
      },
      properties: 'Eigenschaften',
      rooms: 'Zimmer',
      title: 'Titel',
      description: 'Beschreibung',
      plotArea: 'Grundstücksfläche',
      livingSpace: 'Wohnfläche',
      stats: {
        views: 'Ansichten',
        clicks: 'Klicks',
        wishlist: 'Favoriten',
        requests: 'Anfragen',
        unansweredRequests: 'Unbeantwortete Anfrage',
        appointments: 'Besichtigungen',
        appointmentsInFuture: 'Zukünftige Besichtigungen',
        applications: 'Bewerbungen'
      },
      action: {
        openExpose: 'Exposé öffnen',
        saveAndOpenExpose: 'Speichern & Exposé öffnen',
        titleModal: 'Bitte wähle die Sprache für das Dokuments'
      }
    },
    userRequests: {
      title: 'Meine Anfragen'
    },
    userRequestDetails: {
      title: 'Meine Anfrage'
    },
    applicationForm: {
      title: 'Anmeldeformular',
      titleSuccess: 'Ihre Bewerbung wurde erfolgreich versendet!',
      subTitle: 'Vielen Dank für Ihr Interesse an unserem Objekt.<br>Hier haben Sie die Möglichkeit Ihr Anmeldeformular digital auszufüllen.',
      subTitleSuccess: 'Der Inserent hat Ihr Bewerbungsdossier erhalten und wird sich mit Ihnen in Verbindung setzen.',
      mainTenant: 'Hauptmieter',
      additionalTenant: 'Weiterer Mieter',
      infoAboutTenant: 'Angaben zum Mieter',
      civilStatus: {
        title: 'Zivilstand',
        single: 'Ledig',
        married: 'Verheiratet',
        divorced: 'Geschieden',
        widowed: 'Verwitwet',
        separated: 'Getrennt',
        registeredPartnership: 'Eingetragene Partnerschaft',
        dissolvedPartnership: 'Aufgelöste Partnerschaft'
      },
      licensePlateNumber: 'Kennzeichen',
      pets: 'Haustiere',
      petsDescription: 'Welche?',
      instruments: 'Instrumente',
      instrumentsDescription: 'Welche?',
      smokers: 'Raucher',
      employment: 'Arbeitsverhältnis',
      employed: 'Angestellt',
      selfEmployed: 'Selbstständig',
      apprentice: 'Lernender/Student',
      unemployed: 'Nicht erwerbstätig',
      retired: 'Rente',
      less3Month: 'Weniger als 3 Monate',
      more3Month: 'Mehr als 3 Monate',
      sinceYears: 'Beschäftigung',
      since1Year: 'Seit 1 Jahr',
      since2Years: 'Seit 2 Jahren',
      since3Years: 'Seit 3 Jahren',
      since4Years: 'Seit 4 Jahren',
      since5Years: 'Seit 5 Jahren',
      moreThan5Years: 'Mehr als 5 Jahre',
      income: 'Einkommen',
      noIncome: 'Kein Einkommen',
      upTo45000: 'bis 45\'000',
      '45000to55000': '45\'000 bis 55\'000',
      '55000to70000': '55\'000 bis 70\'000',
      '70000to85000': '70\'000 bis 85\'000',
      '85000to100000': '85\'000 bis 100\'000',
      moreThan100000: 'Über 100\'000',
      type: 'Art',
      indefinite: 'Unbefristet',
      limited: 'Befristet',
      temporary: 'Temporär',
      companyPosition: 'Beruf',
      supervisor: 'Vorgesetzter',
      supervisorPhone: 'Telefon (Vorgesetzter)',
      supervisorEmail: 'Email (Vorgesetzter)',
      currentLandlord: 'Heutiger Vermieter',
      noCurrentLandlord: 'Kein bisheriger Vermieter',
      sameAsMainIndividual: 'Wohnen Sie an der selben Adresse wie der Hautpmieter?',
      relationToMainIndividual: 'Beziehung zum Hauptmieter',
      landlordName: 'Bisheriger Vermieter (Firma)',
      rentedSince: 'Zur Miete seit',
      cancelledByTenant: 'Durch Mieter gekündigt',
      relocationReason: 'Grund des Wechsels',
      miscInfo: 'Individuelle Angaben',
      foreclosure: 'Wurden Sie in den letzten 2 Jahren betrieben? ',
      foreclosureCompany: 'Wurde die Firma in den letzten 2 Jahren betrieben?',
      debtCertificate: 'Wurde in den letzten 5 Jahren ein Verlustschein auf Sie ausgestellt?',
      debtCertificateCompany: 'Wurde in den letzten 5 Jahren ein Verlustschein auf Ihre Firma ausgestellt?',
      liabilityInsurance: 'Haben Sie eine Privathaftpflichtversicherung?',
      liabilityInsuranceCompany: 'Besteht eine Firmenhaftpflichtversicherung?',
      adultCount: 'Anzahl Erwachsene (+18) im Mietobjekt',
      childrenCount: 'Anzahl Kinder im Mietobjekt',
      parkingSpacesRequested: 'Anzahl gewünschter Parkplätze',
      licensePlate: 'Autokennzeichen',
      legalNotice: 'Rechtliches',
      preferredDeposit: 'Bevorzugte Kaution',
      depositYouPrefer: 'Welche Kaution bevorzugen Sie?',
      premiumForThisYear: 'Prämie für dieses Jahr',
      premiumPerYear: 'Prämie pro Jahr',
      anyQuestion: 'Haben Sie Fragen? Zögern Sie nicht uns unter {phoneNumberMarketerAccount} oder {emailMarketerAccount} zu kontaktieren.',
      contractCreationCost: 'Zieht der Mietinteressent nach Ausfertigung eines vereinbarten Mietvertrages seine Bewerbung zurück, wird eine Umtriebsentschädigung von {cost} (zuzüglich MWST) dem Mietinteressenten verrechnet.',
      documents: 'Dokumente',
      debtEnforcementRegister: 'Betreibungsauszug',
      idCard: 'ID/Ausweis',
      wageStatement: 'Lohnausweis',
      tradeRegisterExcerptMedia: 'Handelsregisterauszug',
      media: 'weitere Dokumente',
      addTenant: '+ weiteren Mieter hinzufügen',
      businessPurpose: 'Geschäftszweck',
      tradeRegister: 'Ist die Firma im Handelsregister eingetragen?',
      vatLiable: 'MwSt-pflichtig',
      founded: 'Gegründet',
      spaceUtilisation: 'Nutzung der Fläche',
      remark: 'Bemerkung',
      previousGrossRent: 'Bisheriger Bruttomietzins',
      hasViewingDone: 'Wurde eine Besichtigung durchgeführt?',
      desiredStartOfContract: 'Gewünschter Vertragsbeginn',
      desiredParkingOptions: 'Bitte wählen Sie die gewünschten Parkmöglichkeiten aus',
      creditTrust: {
        title: 'CreditTrust Zertifikat/Betreibungsauszug',
        description: 'CreditTrust ist die digitale Alternative zum Betreibungsauszug. In 3 Minuten verfügbar. Mehrfach verwendbar.',
        doYouHaveCertificate: 'Haben Sie bereits ein CreditTrust Zertifikat?',
        noIHaveDebtRegister: 'Nein, ich habe einen Betreibungsauszug',
        debtEnforcementRegister: 'Betreibungsauszug',
        creditTrustCertificate: 'CreditTrust Zertifikat',
        certificateValid: 'Zertifikat ist gültig',
        certificateNotValid: 'Zertifikat ist nicht gültig',
        wannaOrderCertificate: 'Wollen Sie ein neues CreditTrust Zertifikat bestellen?',
        haveYouMovedLastThreeYears: 'Sind Sie in den letzten 3 Jahren umgezogen?',
        orderCertificate: 'CreditTrust Zertifikat für CHF 27.90 bestellen',
        acceptTerms: 'Ich akzeptiere die CreditTrust <a href=\'https://credittrust.ch/de/terms\' target=\'_blank\'>AGBs</a> und bestätige die CreditTrust <a href=\'https://credittrust.ch/de/privacy\' target=\'_blank\'>Datenschutzerklärung</a> gelesen zuhaben.',
        confirmOrderAndPayment: 'Ich akzeptiere, dass mir nach der Bestellung die Rechnung für das Zertifikat per Mail zugestellt wird.',
        certificateIssuedAndValid: 'Zertifikat erfolgreich ausgestellt. Die Rechnung wird Ihnen per E-Mail gesendet.',
        certificateIssuedAndNotValid: 'Leider konnte kein Zertifikat ausgestellt. Es entstanden für Sie keine Kosten. Bitte reichen Sie einen Betreibungsauszug ein.',
        certificateOrderError: 'Da ist was schief gelaufen. Bitte erneut versuchen.',
        certificateGetError: 'Es ist ein Fehler beim Hochladen des Dokuments aufgetreten. Bitte überprüfen Sie Ihre E-Mail auf eine Kopie des Dokuments und fügen Sie es manuell hinzu.',
        pleaseSubmitDebtEnforcementRegister: 'Bitte reichen Sie einen Betreibungsauszug ein.',
        orderIsBeingProcessed: 'Die Bestellung wird bearbeitet',
        creditTrustOnlyForSwiss: 'Leider können wir kein Zertifikat ausstellen, wenn Sie derzeit ausserhalb der Schweiz leben.',
        certificateNoIssuable: 'Leider konnte kein Zertifikat ausgestellt. Es entstanden für Sie keine Kosten. Bitte reichen Sie einen Betreibungsauszug ein.'
      },
      tvProvider: {
        title: 'TV Anbieter',
        types: {
          TV_PROVIDER_UNDEFINED: '-',
          TV_PROVIDER_UPC: 'UPC',
          TV_PROVIDER_THIRD_PARTY: 'Fremdanbieter'
        },
        tooltip: 'Damit im Voraus bereits Vorkehrungen getroffen werden können, wähle hier deinen, für den Standort gewünschten TV-Anbieter aus.'
      }
    },
    loadingErrors: {
      generic: 'Daten konnte nicht geladen werden. Bitte versuche es erneut.',
      property: 'Liegenschaft nicht geladen. Bitte versuche es erneut.',
      building: 'Gebäude nicht geladen. Bitte versuche es erneut.',
      object: 'Objekt(e) nicht geladen. Bitte versuche es erneut.',
      tenancy: 'Vermietung(en) nicht geladen. Bitte versuche es erneut.',
      device: 'Gerät(e) nicht geladen. Bitte versuche es erneut.',
      filter: 'Filter nicht geladen. Bitte versuche es erneut.',
      client: 'Mandant(en) nicht geladen. Bitte versuche es erneut.',
      advertisement: 'Objekt(e) nicht geladen. Bitte versuche es erneut.',
      reference: 'Notiz(en) nicht geladen. Bitte versuche es erneut.',
      calendar: 'Kalender nicht geladen. Bitte versuche es erneut.',
      calendarSyncToken: 'Kalender-URL nicht geladen werden. Bitte versuche es erneut.',
      contactSyncToken: 'Kontakt-URL nicht geladen. Bitte versuche es erneut.',
      request: 'Anfrage(n) nicht geladen. Bitte versuche es erneut.',
      message: 'Nachricht(en) nicht geladen. Bitte versuche es erneut.',
      employees: 'Benutzer nicht geladen. Bitte versuche es erneut.',
      janitors: 'Hauswarte nicht nicht geladen. Bitte versuche es erneut.',
      delegates: 'Delegierte nicht geladen. Bitte versuche es erneut.',
      image: 'Bild(er) nicht geladen. Bitte versuche es erneut.',
      exportPlatforms: 'Export-Plattform(en) nicht geladen. Bitte versuche es erneut.',
      event: 'Termin(e) nicht geladen. Bitte versuche es erneut.',
      exports: 'Export-Konfiguration(en) nicht geladen. Bitte versuche es erneut',
      user: 'Benutzer nicht geladen. Bitte versuche es erneut.',
      requestForwarding: 'Weiterleitung(en) fehlgeschlagen. Bitte versuche es erneut.',
      messageForwarding: 'Nachrichtenweiterleitung(en) nicht geladen. Bitte versuche es erneut.',
      import: 'Import nicht geladen. Bitte versuche es erneut.',
      accountSettings: 'Daten nicht geladen. Bitte versuche es erneut.',
      contacts: 'Kontakt(e) nicht geladen. Bitte versuche es erneut.',
      notAllowedContacts: 'Du hast keine Berechtigung für diesen Kontakt',
      contactsCSV: 'Kontaktliste nicht geladen. Bitte versuche es erneut.',
      networkPartners: 'Netzwerkparter nicht geladen. Bitte versuche es erneut.',
      owners: 'Eigentümer nicht geladen. Bitte versuche es erneut.',
      rentReports: 'Aggregierten Miete(n) nicht geladen. Bitte versuche es erneut.',
      ticket: 'Ticket(s) nicht geladen. Bitte versuche es erneut.',
      notes: 'Notiz(en) nicht geladen. Bitte versuche es erneut.',
      activity: 'Aktivität(en) nicht geladen. Bitte versuche es erneut.',
      documents: 'Dokument(e) nicht geladen. Bitte versuche es erneut.',
      reminders: 'Reminder nicht geladen. Bitte versuche es erneut.',
      signature: 'Signatur nicht geladen. Bitte versuche es erneut.',
      template: 'Textvorlage(n) nicht geladen. Bitte versuche es erneut.',
      renderTemplate: 'Textvorlage konnte nicht geladen werden. Bitte versuche es erneut.',
      media: 'Datei(en) nicht geladen. Bitte versuche es erneut.',
      domain: 'Domain(s) nicht geladen. Bitte versuche es erneut.',
      mailbox: 'Postfach nicht geladen. Bitte versuche es erneut.',
      rejectRequestsOnce: 'Anfragen können nur einmal abgesagt werden.',
      rejectReservedRequests: 'Du kannst einer reservierten Anfrage nicht absagen. Lösche zuerst die Vermietung auf den Anfragedetails wenn du dieser Anfrage eine Absage erteilen willst.',
      rejectReservedRequestsActiveTenant: 'Aktivierte Vermietungen können nicht abgesagt werden.',
      applicationLink: 'Der Anmeldeformular-Link konnte nicht geladen werden. Bitte versuche es erneut.',
      registrationToken: 'Der Token ist abgelaufen oder wurde bereits verwendet.',
      contactHasNoEmail: 'Dieser Kontakt hat keine E-Mail hinterlegt',
      reportingUrls: 'Das Reporting konnte nicht geladen werden',
      noaddressToFill: 'Keine Adresse zum Ausfüllen',
      ticketDeleted: 'Das Ticket wurde gelöscht.',
      ticketClosed: 'Auftrag {ordernumber} wurde geschlossen.'
    },
    savingErrors: {
      onboarding: 'Die Daten konnten nicht (vollständig) gespeichert werden.',
      data: 'Die Daten konnten nicht gespeichert werden. Bitte versuche es erneut',
      building: 'Gebäude nicht gespeichert. Bitte versuche es erneut.',
      buildingCreation: 'Die eingegebene Adresse existiert nicht.',
      object: 'Objekt(e) nicht gespeichert. Bitte versuche es erneut.',
      objectInactive: 'Inaktiv Datum darf nicht vor dem Enddatum des letzten Mietverhältnis/Leerstand sein',
      importContact: 'Kontaktimport nicht durchgeführt. Bitte versuchen Sie es erneut.',
      addContact: 'Kontakt(e) nicht hinzugefügt. Bitte versuche es erneut.',
      editContact: 'Kontkt(e) nicht bearbeitet. Bitte versuche es erneut.',
      removeContact: 'Kontakt(e) nicht entfernt. Bitte versuche es erneut.',
      notSamePersonLinked: 'Du kannst keine Person mit sich selbst verknüpfen',
      registration: 'Registrierung nicht erfolgreich abgeschlossen. Bitte versuche es erneut.',
      addEmployee: 'Benutzer nicht hinzugefügt. Bitte versuche es erneut.',
      employeeRegistered: 'Es existiert bereits ein Nutzer mit dieser E-Mail-Adresse. Der Nutzer darf noch keinen Account auf PropBase besitzen.',
      cantEditEmployee: 'Benutzer können nicht bearbeitet werden',
      filter: 'Filter nicht gespeichert. Bitte versuche es erneut.',
      reference: 'Notiz nicht gespeichert. Bitte versuche es erneut.',
      request: 'Anfrage(n) nicht gespeichert. Bitte versuche es erneut.',
      client: 'Mandant(en) nicht gespeichert. Bitte versuche es erneut',
      message: 'Nachricht(en) nicht gespeichert. Bitte versuche es erneut.',
      employee: 'Benutzer nicht gespeichert. Bitte versuche es erneut.',
      employeeOnlyAdmin: 'Du bist der letzte Administrator. Benenne zuerst einen weiteren aktiven Administrator',
      image: 'Bild(er) nicht gespeichert. Bitte versuche es erneut.',
      password: 'Neues Passwort nicht gespeichert. Bitte versuche es erneut.',
      accountSettings: 'Daten nicht gespeichert. Bitte versuche es erneut.',
      advertisements: 'Inserat(e) nicht gespeichert. Bitte versuche es erneut.',
      event: 'Termin(e) nicht gespeichert. Bitte versuche es erneut.',
      file: 'Datei(en) nicht gespeichert. Bitte versuche es erneut.',
      exportPlatforms: 'Export-Plattform(en) nicht gespeichert. Bitte versuche es erneut',
      export: 'Export-Konfiguration nicht gespeichert. Bitte versuche es erneut',
      mergeAdvertisement: 'Inserat konnte nicht zusammengeführt werden. Bitte versuche es erneut.',
      newObject: 'Objekt(e) nicht erstellt. Bitte versuche es erneut.',
      requestForwarding: 'Weiterleitung nicht gespeichert werden. Bitte versuche es erneut.',
      messageForwarding: 'Nachrichtenweiterleitung nicht gespeichert werden. Bitte versuche es erneut.',
      import: 'Import nicht gespeichert. Bitte versuche es erneut.',
      notReadyToPublish: 'Inserat(e) noch nicht bereit zur Veröffentlichung. Bitte bearbeite es zuerst.',
      setNetworkPartner: 'Netzwerkpartner nicht gesetzt. Bitte versuche es erneut.',
      unsetNetworkPartner: 'Netzwerkpartner nicht zurückgesetzt. Bitte versuche es erneut.',
      setNetworkPartnerPropertyWithoutObject: 'Die Liegenschaft {propertyIds} hat keine Objekte und kann deswegen nicht geteilt werden.',
      ticket: 'Ticket nicht gespeichert. Bitte versuche es erneut.',
      note: 'Notiz(en) nicht erstellt. Bitte versuche es erneut.',
      updateReminder: 'Reminder nicht aktualisiert. Bitte versuche es erneut.',
      property: 'Liegenschaft nicht gespeichert. Bitte versuche es erneut.',
      propertyWithOptedTenancies: 'Die Liegenschaft hat noch aktive optierte Vermietungen und kann deshalb nicht auf \'nicht optiert\' umgestellt werden.',
      rentComponentStillInUse: 'Der/Die Mietzinsbestandteil/e {component} können nicht entfernt werden, da diese in laufenden Mietverhältnissen verwendet werden.',
      signature: 'Signatur nicht gespeichert. Bitte versuche es erneut.',
      tenantHaveAddress: 'Alle Mieter müssen eine Adresse gesetzt haben.',
      tenancyStartingAtAfterEndingAt: 'Startdatum der Vermietung muss vor dem Enddatum liegen.',
      subTenancyStartingAtAfterEndingAt: 'Der Vertragsstart des Untermieters kann nicht vor der aktuellen Vermietung starten.',
      tenancyStartingOverLap: 'Vertragsstart darf nicht vor dem Vertragsende des letzten Mieters sein.',
      endDateCantchangeAfterwards: 'Vertragsende darf nicht geändert werden, wenn bereits ein zukünftiges Mietverhältnis oder zukünftiger Leerstand besteht.',
      endDateBeforeDebit: 'Vertragsende darf nicht vor dem Sollgestellt Datum bis {debitUntil} sein',
      startDateBeforeDebit: 'Vertragsstart darf nicht vor dem Sollgestellt Datum bis {debitUntil} sein',
      endDateAfterEndDateSubTenant: 'End of contract must be more than ending date of subtenant: {subTenant}',
      liabilityNotBeforeEndContract: 'Haftungsende darf nicht vor Vertragsende sein',
      nextPossibleMoveInBeforeMoveOutAt: '<b>Mögl. Bezug Nachmieter </b><span class="ml-1 mr-1"> kann nicht vor </span><b>Auszugsdatum</b> <span class="ml-1">sein.</span>',
      firstRentPossibleAtAfterEndingAt: 'Mietzinsanpassung erstmals möglich per darf nicht vor Vertragsstart sein',
      renovationStartingAtAfterEndingAt: 'Startdatum der Renovierung muss vor dem Enddatum liegen.',
      costBeforeStartingAt: 'Mietzinsanpassungsdatum muss nach Vermietungsstart liegen.',
      earliestTerminationDateAfterStartingDate: 'Frühstes Kündigungs-Datum muss nach dem Vertragsstart liegen.',
      template: 'Textvorlage nicht gespeichert. Bitte versuche es erneut.',
      domain: 'Domain nicht gespeichert. Bitte versuche es erneut.',
      mailbox: 'Postfach nicht gespeichert. Bitte versuche es erneut.',
      mailboxUnvalid: 'Du kannst kein Postfach hinzufügen, dessen Domain nicht verifiziert ist',
      mailRead: 'E-Mail(s) nicht als gelesen markiert. Bitte versuche es erneut.',
      mailUnread: 'E-Mail(s) nicht als ungelesen markiert. Bitte versuche es erneut.',
      document: 'Dokument(e) nicht gespeichert. Bitte versuche es erneut.',
      mailSend: 'E-Mail(s) nicht gesendet. Bitte versuche es erneut.',
      mailSavedDraft: 'E-Mail(s) nicht gespeichert. Bitte versuche es erneut.',
      activity: 'Aktivität(en) nicht gespeichert. Bitte versuche es erneut.',
      setMarketingObjectAssignee: 'Zuordnung(en) nicht gespeichert. Bitte versuche es erneut',
      publishObject: 'Inserat(e) nicht veröffentlicht. Bitte versuche es erneut.',
      unPublishObject: 'Inserat(e) nicht deaktiviert. Bitte versuche es erneut.',
      setLandlordReference: 'Referenz Vermieter nicht gespeichert. Bitte versuche es erneut.',
      setEmployerReference: 'Referenz Arbeitgeber nicht gespeichert. Bitte versuche es erneut.',
      messageLinked: 'Nachricht nicht verknüpft. Bitte versuche es erneut.',
      lastOfficialInspection: 'Die letzte offizielle Inspektion kann nicht in der Zukunft liegen.',
      nextOfficialInspection: 'Die nächste offizielle Inspektion kann nicht in der Vergangenheit liegen.',
      nextOfficialInspectionBeforeLast: 'Die nächste offizielle Inspektion kann nicht vor der letzten offiziellen Inspektion liegen.',
      nextOfficialInspectionEqual: 'Die letzte offizielle Inspektion und die nächste offizielle Inspektion dürfen nicht das gleiche Datum haben.',
      nextMaintenanceDevice: 'Die nächste Wartung kann nicht in der Vergangenheit liegen',
      lastMaintenanceDevice: 'Die letzte Wartung kann nicht in der Zukunft liegen',
      subscription: 'Der Vertragsstart muss vor dem Vertragsende liegen',
      installation: 'Das Installationsdatum kann nicht in der Zukunft liegen.',
      uninstallation: 'Das Deinstallationdatum kann nicht vor dem Installationdatum liegen.',
      insuranceStartDate: 'Das Startdatum der Versicherung muss vor dem Enddatum liegen.',
      insuranceEarliestTerminationDate: 'Die Kündigungsfrist muss innerhalb der Vertragslaufzeit liegen.',
      favorite: 'Der Favoriten-Status konnte nicht geändert werden.',
      contactAlreadyApplied: 'Dieser Kontakt ist bereits Interessent zu diesem Inserat',
      savingApplicationForm: 'Uuups... Da ist was schief gelaufen. Bitte versuche es erneut.',
      sendingApplicationForm: 'Uuups... Da ist was schief gelaufen. Bitte versuche es erneut.',
      requiredApplicationForm: 'Nicht alle Pflichtfelder sind ausgefüllt',
      calendar: 'Termin(e) konnte(n) nicht gespeichert werden. Bitte versuche es erneut.',
      weakPassword: 'Passwort ist zu schwach',
      activateTenancy: 'Die Vermietung konnte nicht aktiviert werden. Bitte versuche es erneut.',
      contactLinked: 'Der Kontakt konnte nicht verlinkt werden. Bitte versuche es erneut.',
      endTimeAfterStart: 'Das Enddatum darf nicht vor dem Startdatum liegen.',
      invalidDate: 'Ungültiges Datum',
      costAdjustmentAfterContractStart: 'Das Mietzinsanpassungsdatum darf nicht vor dem Vertragsstart sein',
      costAdjustmentAfterEndingAt: 'Das Mietzinsanpassungsdatum muss vor dem Enddatum sein.',
      debitDateAndAdjustment: 'Mietzinsanpassung darf nicht vor dem Sollgestellt Datum {debitUntil} bis sein',
      notEqualToOtherAdjBydate: 'Zwei Mietzinsanpassungen mit dem selben Datum sind nicht erlaubt.',
      eventAccepted: 'Der Einladungs-Status "Zusage" konnte nicht gesetzt werden.',
      eventDeclined: 'Der Einladungs-Status "Absage" konnte nicht gesetzt werden.',
      vacancy: 'Der Leerstand konnte nicht gespeichert werden.',
      validationError: 'In der Kachel ',
      validationError2: ' sind nicht alle Felder vollständig ausgefüllt.',
      validationError3: 'Nicht alle Pflichtfelder sind ausgefüllt.',
      mandatoryMissing: 'Nicht alle Pflichtfelder sind ausgefüllt',
      hasNoDebtor: 'Wähle mindestens einen existierenden Kontakt oder erstelle einen neuen als Debitor um zum nächsten Schritt zu gelangen.',
      contractTenantBeforeOwnership: 'Der Vertragsstart des Mieters kann nicht vor dem Eigentumsstart sein',
      condominiumStartingAtAfterEndingAt: 'Eigentumsstart darf nicht vor dem Eigentumsende des vorherigen Eigentümerverhältnis liegen.',
      condominiumEndAtCanNotBeDeleted: 'Eigentumsende darf nicht gelöscht werden, wenn bereits ein zukünftiges Eigentümerverhältnis besteht.',
      condominiumGap: 'Es darf keine Lücke zwischen zwei Eigentümerverhältnissen sein',
      vacancyEndAtCanNotBeDeleted: 'Ende Leerstand darf nicht gelöscht werden, wenn bereits ein zukünftiges Mietverhältnis besteht.',
      tenancyEndAtCanNotBeDeleted: 'Vertragsende darf nicht gelöscht werden, wenn bereits ein zukünftiges Mietverhältnis oder zukünftiger Leerstand besteht.',
      subTenantStartingDate: 'Subtenancy must end after the start date.',
      subTenantLessThenEnding: 'Das Vertragsende des Untermieters kann nicht später als das Vertragsende des Mietverhältnis sein.',
      reasonVacancyOnTwoVacancies: 'Grund für Leerstand darf bei zwei aufeinander folgenden Leerständen nicht derselbe sein.',
      renewalValidMoreThanContractDate: 'Erneuerungsoptionen: Option bis und Auszuüben bis darf nicht vor dem Vertragsstart sein.',
      renewalValidRenewalOptionExerciceUntil: 'Erneuerungsoptionen: Option bis muss vor Auszuüben bis sein.',
      earlyRightValidMoreThanContractDate: 'Vorzeitiges Kündigungsrecht: Option bis und Auszuüben bis darf nicht vor dem Vertragsstart sein.',
      earlyRightValidRenewalOptionExerciceUntil: 'Vorzeitiges Kündigungsrecht: Option bis muss vor Auszuüben bis sein.',
      sameDateTenanciesError: 'Beginn des Mietverhältnisses muss mind. 1 Tag nach dem Beginn eines aktivierten Leerstandes sein',
      sameDateOfTenanciesError: 'There is already a tenancy that starts at the same date!',
      renderingContractError: 'Das Dokument konnte nicht erstellt werden. Betreff und Nachricht dürfen nicht leer sein',
      lackOfBriefTag: 'Um nur 1 Dokument zu erstellen, muss die Vorlage die Platzhalter {#brief} und {/brief} enthalten. Bitte setze  {#brief} an den Anfang und {/brief} ans Ende deiner Vorlage.',
      lackOfDataLoop: 'Um einzelne Dokumente zu erstellen, müssen die Platzhalter {#brief} und {/brief} aus der Vorlage entfernt werden. Möchtest du nur 1 Dokument generieren, kannst du die Checkbox “Nur 1 Dokument erstellen” anhaken.',
      hasNoDevice: 'Mind. ein Bauteil/Gerät auswählen',
      hasNoObject: 'Select at least one object',
      createOrder: 'Auftrag konnte nicht erstellt werden. Bitte versuche es erneut.',
      operatorHasNoEmail: 'Ausführender hat keine E-Mail hinterlegt.',
      plot: 'Parzelle konnte nicht gespeichert werden. Bitte versuche es erneut.',
      executeUntilBeforeExecuteFrom: 'Auftrag auszuführen bis, kann nicht vor Auftrag auszuführen ab beginnen.',
      invalidMoreThanFrom: 'Die Option kann nicht nach dem Ende starten',
      contactInactivated: 'Kontakt(e) nicht deaktiviert. Bitte versuche es erneut.',
      contactActivated: 'Kontakt(e) nicht aktiviert. Bitte versuche es erneut.',
      ticketToItSelf: 'A ticket cannot be linked to itself',
      fileNotSupported: 'Dateityp nicht unterstüzt.',
      closeTenancy: 'tenancy(ies) not closed. Please try again.',
      byDateAfterEndContract: 'Per Datum darf nicht nach Vertragsende sein.',
      contractFailed: 'Fehler bei der Vorlage {templateName}. Bitte überprüfe {error}.',
      signersHasSameEmails: 'Die Unterzeichner können nicht dieselbe E-Mail-Adresse haben.',
      contactAlreadySelected: 'Der Kontakt wurde bereits ausgewählt.',
      CountryIndexDatePossibleBeforeCountryIndexDate: 'Landesindex Datum möglich darf nicht vor dem Landesindex Datum sein',
      CostIncreaseDatePossibleBeforeCostIncreaseDate: 'Kostensteigerung Datum möglich darf nicht vor dem Kostensteigerung Datum sein',
      someContactNoEmail: 'Mindestens ein ausgewählter Kontakt im Abschnitt "Status Updates" hat keine E-Mail-Adresse hinterlegt.',
      publishAtCantBePast: 'Objekt publizieren am kann nicht in der Vergangenheit sein.',
      alreadyReachedAmountRequest: 'Du hast diese Anzahl von Anfragen bereits erreicht.',
      unPublishAtCantBePast: '<span style="font-weight: bold">Online bis &nbsp;</span> kann nicht in der Vergangenheit sein.',
      digitalDepositValidContacts: 'Es sind nicht alle Mieterangaben vollständig ausgefüllt',
      handoverProtocolMovingTenancy: 'Es muss mindestens eine Vermietung oder ein Leerstand ausgewählt werden, um eine Übergabe vorzubereiten.',
      secondHandoverSameDateTime: 'you can\'t create second protocol for the same object with the same date and time',
      birthDate: 'Geburtstag darf nicht vor 1900 oder in Zukunft liegen.'
    },
    uploadingErrors: {
      maxFileSize: 'Die hochgeladene Datei ist größer als die maximal zulässige Grösse',
      maxTotalFilesSize25MB: 'Die Gesamtgrösse aller Anhänge darf 25 MB nicht überschreiten. Bitte entferne einige Dateien und versuche es erneut.',
      zipFileNotAccepted: 'Du kannst keine Dateien aus einem ZIP-Ordner hochladen. Entpacke zuerst den ZIP-Ordner!'
    },
    deleteErrors: {
      client: 'Mandant(en) nicht gelöscht. Bitte versuche es erneut.',
      filter: 'Filter nicht gelöscht. Bitte versuche es erneut.',
      contact: 'Kontakt(e) nicht gelöscht. Bitte versuche es erneut.',
      contactAttachedToTenancy: 'Mindestens ein Kontakt ist mit einem Mietverhältnis verbunden',
      contactLinkedOrAttached: 'Kontakt(e) konnte nicht gelöscht werden, da mindestens ein Kontakt in einer Vermietung oder einer Anfrage eingetragen ist oder mit einem anderen Kontakt verknüpft ist.',
      contactisActiveTenancy: 'Kontakt/e die in einer aktiven Vermietung oder mit einem Gebäude verbunden sind, können nicht deaktiviert werden.',
      tenancies: 'Vermietung(en) nicht gelöscht. Bitte versuche es erneut.',
      company: 'Firma nicht gelöscht. Bitte versuche es erneut.',
      advert: 'Objekt(e) nicht gelöscht. Bitte versuche es erneut.',
      group: 'Portfolio nicht gelöscht. Bitte versuche es erneut.',
      template: 'Textvorlage(n) nicht gelöscht. Bitte versuche es erneut.',
      domain: 'Domain nicht gelöscht. Bitte versuche es erneut.',
      mailbox: 'Postfach nicht gelöscht. Bitte versuche es erneut.',
      employee: 'Benutzer nicht gelöscht. Bitte versuche es erneut.',
      property: 'Liegenschaft(en) nicht gelöscht. Bitte versuche es erneut.',
      building: 'Gebäude nicht gelöscht. Bitte versuche es erneut.',
      object: 'Objekt(e) nicht gelöscht. Bitte versuche es erneut.',
      mail: 'E-Mail(s) nicht gelöscht. Bitte versuche es erneut.',
      archive: 'E-Mail(s) nicht archiviert. Bitte versuche es erneut.',
      request: 'Anfrage(n) nicht gelöscht. Bitte versuche es erneut.',
      reservedRequest: 'Reservierte Anfragen können nicht gelöscht werden. Lösche zuerst die Vermietung und dann die Anfrage.',
      deleteActiveTenancyTooltip: 'Du kannst Objekte nur löschen, wenn noch nie ein Mietverhältnis erstellt worden ist.',
      deleteActiveTenancyTooltipMsg: 'Du kannst Vermietungen nur löschen, wenn diese noch nie aktiviert worden sind.',
      inactivatecontactisActiveTenancyTooltip: 'Du kannst nur Kontakte deaktivieren, die nicht mit einer Vermietung oder Gebäude verbunden sind.',
      deleteBuildingSynchronizedWithAccountingOrHasActiveTenancyTooltip: 'Gebäude die mit der Buchhaltung synchronisiert sind und/oder aktvierte Mietverhältnisse haben, können nicht gelöscht werden.',
      activateTenancyTooltip: 'Es können nur Mietverhältnisse aktiviert werden, die den Status „Nicht aktiviert“ haben',
      closeTenancyTooltip: 'Nur aktivierte Vermietungen mit dem Vertragsende in der Vergangenheit können abgeschlossen werden.',
      activateCondominiumTooltip: 'Du kannst Eigentümerverhältnisse nur aktivieren, wenn diese den Status "nicht aktiviert" haben.',
      ticket: 'Das Ticket konnte nicht gelöscht werden. Bitte versuche es erneut.',
      note: 'Comment is not deleted. Please try again.',
      device: 'Gerät(e)ut nicht gelöscht. Bitte versuche es erne.',
      handoverProtocolDelete: 'Übergabeprotokoll(e) nicht gelöscht. Bitte versuche es erneut.'
    },
    successMessages: {
      onboarding: 'Daten erfolgreich gespeichert. Eventuelle Mietzinsanpassungen werden in der Liegenschafts- und Gebäude-Tabelle über Nacht aktualisiert.',
      buildingCreation: 'Gebäude erstellt',
      buildingDeletion: 'Gebäude wurde(n) gelöscht',
      objectDeletion: 'Objekt(e) wurde(n) gelöscht',
      portfolioCreation: 'Portfolio erstellt',
      deletion: 'wurde gelöscht',
      networkPartnerUpdated: 'Netzwerkpartner zugeordnet. Die Aktualisierung kann einige Sekunden in Anspruch nehmen. Evtl. muss die Seite neu geladen werden.',
      regionSetting: 'Region(en) aktualisiert',
      profileUpdated: 'Profil aktualisiert',
      saveLogo: 'Logo aktualisiert',
      addContact: 'Kontakt hinzugefügt',
      deleteCompany: 'Firma gelöscht',
      deleteEmployee: 'Benutzer entfernt',
      archiveMail: 'Nachrichten archiviert',
      deleteMail: 'Nachrichten erfolgreich in Papierkorb verschoben',
      restoreMail: 'Nachrichten erfolgreich vom Papierkorb wiederhergestellt',
      restoreMailFromArchive: 'Nachrichten erfolgreich von Archiv wiederhergestellt',
      emptyTrashMail: 'Nachrichten erfolgreich gelöscht',
      tenancies: 'Vermietung(en) gelöscht',
      revokeAdmin: 'Administrator-Rechte entzogen',
      grantAdmin: 'Administrator-Rechte freigegeben',
      addEmployee: 'Benutzer hinzugefügt',
      propertyCreation: 'Liegenschaft(en) aktualisiert',
      propertyDeletion: 'Liegenschaft(en) wurde(n) gelöscht',
      templateContractDeletion: 'Vertragsvorlage gelöscht',
      contactDeletion: 'Kontakt(e) gelöscht',
      contactInactivated: 'Kontakt(e) deaktiviert',
      contactActivated: 'Kontakt aktiviert',
      contactLinked: 'Kontakt verknüpft',
      emailLinked: 'E-Mail verlinkt',
      emailUnLinked: 'Email non linkato',
      contactUnLinked: 'Kontaktverknüpfung aufgehoben',
      domainCreation: 'Domain erstellt',
      mailboxCreation: 'Postfach erstellt',
      mailboxUpdated: 'Postfach aktualisiert',
      mailRead: 'E-Mail(s) als gelesen markiert',
      mailUnread: 'E-Mail(s) als ungelesen markiert',
      mailSend: 'E-Mail(s) gesendet',
      mailSavedDraft: 'Mail(s) als Entwurf gespeichert',
      activityCreation: 'Aktivität(en) erstellt',
      reminderCreation: 'Reminder erstellt',
      reminderUpdated: 'Reminder aktualisiert',
      activityUpdated: 'Aktivität(en) aktualisiert',
      setMarketingObjectAssignee: 'Benutzer zugeordnet. Die Aktualisierung kann einige Sekunden in Anspruch nehmen. Evtl. muss die Seite neu geladen werden.',
      publishObject: 'Inserat(e) veröffentlicht. Die Veröffentlichung kann je nach gewähltem Portal einige Zeit in Anspruch nehmen!',
      unPublishObject: 'Inserat(e) deaktiviert. Die Deaktivierung kann je nach veröffentlichtem Portal einige Zeit in Anspruch nehmen!',
      setLandlordReference: 'Referenz Vermieter gespeichert.',
      setEmployerReference: 'Referenz Arbeitgeber gespeichert.',
      messageLinked: 'Nachricht verknüpft',
      reference: 'Referenz gesetzt',
      activateTenancy: 'Das Mietverhältnis wurde erfolgreich aktiviert',
      activateCondominium: 'Das Eigentümerverhältnis wurde erfolgreich aktiviert',
      tenantAdded: 'Vermietung wurde erfolgreich erstellt',
      vacancyAdded: 'Leerstand wurde erfolgreich erstellt',
      vacancyActivated: 'Leerstand wurde erfolgreich aktiviert',
      contractAdded: 'Mietvertrag wurde erfolgreich erstellt',
      markedForMarketing: 'Objekt wurde erfolgreich an {name} zur Vermarktung übergeben.',
      removeFromMarketing: 'Objekt(e) wurde(n) erfolgreich aus der Vermarktung entfernt',
      markAsReadRequest: 'Anfrage(n) als gelesen markiert',
      markAsUnReadRequest: 'Anfrage(n) als ungelesen markiert',
      eventAccepted: 'Der Einladungs-Status "Zusage" wurde erfolgreich gesetzt.',
      eventDeclined: 'Der Einladungs-Status "Absage" wurde erfolgreich gesetzt.',
      addressChanged: 'Adresse(n) erfolgreich geändert',
      applicationFormSettings: 'Anmeldeformulareinstellungen erfolgreich gespeichert',
      requestAdded: 'Anfrage wurde erfolgreich erstellt',
      requesMoved: 'Anfrage/n wurde/n erfolgreich verschoben.',
      transferPropertiesToAccounting: 'Liegenschaft/en wurde/n erfolgreich mit Abacus synchronisiert. Die Synchronisierung kann einige Minuten in Anspruch nehmen.',
      eventCreated: 'Termin wurde erfolgreich gespeichert.',
      eventCreatedNotVisible: 'Termin wurde erfolgreich gespeichert. Er ist derzeit nicht sichtbar, da der entsprechende Kalender nicht ausgewählt ist.',
      deviceSaved: 'Bauteile & Geräte wurden erfolgreich gespeichert.',
      componentSaved: 'Component(s) was successfully saved',
      linkSaved: 'Link(s) was successfully saved',
      marketingNoteAdded: 'Notiz wurde erfolgreich hinzugefügt',
      createOrder: 'Auftrag/Aufträge wurde/n erfolgreich erstellt',
      plotSaved: 'Parzelle wurde erfolgreich gespeichert.',
      changeSaved: 'Änderungen wurden erfolgreich gespeichert',
      rentAdjustmentDeletion: 'Mietzinsanpassungen wurden erfolgreich gel�scht',
      ticket: 'Ticket wurde erfolgreich gespeichert',
      deleteTicket: 'Ticket wurde erfolgreich gelöscht',
      extendTenancy: 'Das Mietverhältnis wurde erfolgreich verlängert.',
      addLinkTicket: 'Das Ticket wurde erfolgreich verknüpft',
      removeLinkTicket: 'Die Verknüpfung wurde erfolgreich aufgehoben',
      sendRawDocument: 'Dokument wurde erfolgreich gesendet',
      closeTenancy: 'Vermietungen erfolgreich abgeschlossen.',
      serialLetterCreated: 'Die Erstellung der Dokumente kann einige Sekunden in Anspruch nehmen.',
      automaticResponse: 'Automatische Antwort gespeichert.',
      notificationUpdated: 'Benachrichtigungen aktualisiert',
      orderSent: 'Auftrag wurde erfolgreich gesendet.',
      note: 'Notiz wurde erfolgreich gespeichert.',
      handoverProtocol: 'Übergabeprotokoll wurde erfolgreich erstellt.',
      markTicketUnread: 'Ticket wurde als ungelesen markiert',
      syncStarted: 'Synchronisation hat erfolgreich gestartet.',
      handoverProtocolDelete: 'Übergabeprotokoll(e) erfolgreich gelöscht',
      digitalDepositCreation: 'Der Antrag wurde erfolgreich versendet.',
      deviceDeleted: 'Gerät/e wurde/n erfolgreich gelöscht',
      eventDeleted: 'Der Termin wurde erfolgreich gelöscht.',
      dataSaved: 'Daten wurden erfolgreich gespeichert'
    },
    nonExistent: {
      energySource: 'Keine Energieträger',
      device: 'Keine Geräte',
      insurance: 'Keine Versicherung',
      settlement: 'Keine Verrechnungsobjekt',
      renovation: 'Keine Renovierungen',
      tenancies: 'Keine Vermietungen',
      condominium: 'Keine Stockwerkeigentümer',
      mortgage: 'Keine Hypotheken',
      room: 'Keine Räume',
      bankDetails: 'Kein Liegenschaftskonto'
    },
    placeholders: {
      hash: {
        kp: {
          kontaktperson: {
            name: 'Kontaktperson Schleife - Start',
            description: ''
          }
        },
        stwe: {
          stwe: {
            name: 'STWE Schleife - Start',
            description: ''
          }
        },
        mieter: {
          mieter: {
            name: 'Mieter Schleife - Start',
            description: ''
          }
        },
        vm_loop: {
          name: 'Vermietung Schleife - Start',
          description: ''
        },
        sol: {
          haft: {
            name: 'Solidarhafter Schleife - Start',
            description: ''
          }
        },
        vm: {
          mzr: {
            name: 'Mietzinsreserve Schleife - Start',
            description: ''
          },
          eopt: {
            name: 'Erneuerungsoptionen Schleife - Start',
            description: ''
          },
          vkopt: {
            name: 'Vorzeitiges Kündigungsrecht Schleife - Start',
            description: ''
          },
          mit: {
            name: 'Mitbewohner Schleife - Start',
            description: ''
          },
          unter: {
            name: 'Untermieter Schleife - Start',
            description: ''
          },
          mz_bestand: {
            name: 'Alle Mietzinskomponenten Schleife - Start',
            description: ''
          }
        },
        g: {
          name: 'Bauteil & Gerät Schleife - Start',
          description: ''
        },
        brief: {
          name: 'Brief Schleife - Start',
          description: ''
        },
        sign: {
          name: 'Signatur Schleife - Start',
          description: ''
        }
      },
      slash: {
        kp: {
          kontaktperson: {
            name: 'Kontaktperson Schleife - Ende',
            description: ''
          }
        },
        stwe: {
          stwe: {
            name: 'STWE Schleife - Ende',
            description: ''
          }
        },
        mieter: {
          mieter: {
            name: 'Mieter Schleife - Ende',
            description: ''
          }
        },
        vm_loop: {
          name: 'Vermietung Schleife - Ende',
          description: ''
        },
        sol: {
          haft: {
            name: 'Solidarhafter Schleife - Ende',
            description: ''
          }
        },
        vm: {
          mzr: {
            name: 'Mietzinsreserve Schleife - Ende',
            description: ''
          },
          eopt: {
            name: 'Erneuerungsoptionen Schleife - Ende',
            description: ''
          },
          vkopt: {
            name: 'Vorzeitiges Kündigungsrecht Schleife - Ende',
            description: ''
          },
          mit: {
            name: 'Mitbewohner Schleife - Ende',
            description: ''
          },
          unter: {
            name: 'Untermieter Schleife - Ende',
            description: ''
          },
          mz_bestand: {
            name: 'Alle Mietzinskomponenten Schleife - Ende',
            description: ''
          },
          ks_datum_moeglich: {
            name: 'Kostensteigerung Datum möglich',
            description: '01/2024'
          }
        },
        g: {
          name: 'Bauteil & Gerät Schleife - Ende',
          description: ''
        },
        brief: {
          name: 'Brief Schleife - Ende',
          description: ''
        },
        sign: {
          name: 'Signatur Schleife - Ende',
          description: ''
        }
      },
      brief_betreff: {
        name: 'Brief - Titel',
        description: 'Titel'
      },
      brief_brieftext: {
        name: 'Brief - Beschreibung',
        description: 'Beschreibung'
      },
      benutzer: {
        name: {
          name: 'Benutzer - Name',
          description: 'Max Mustermann'
        },
        tel: {
          name: 'Benutzer - Telefon',
          description: '044 444 44 44'
        },
        mail: {
          name: 'Benutzer - E-Mail',
          description: 'max.mustermann@muster.ch'
        },
        pos: {
          name: 'Benutzer - Job',
          description: 'CEO'
        },
        ort: {
          name: 'Benutzer - Ort',
          description: 'Musterhausen'
        },
        signatur: {
          name: 'Benutzer Unterschrift',
          description: 'Signatur des aktuellen Benutzers.'
        }
      },
      auftragsnummer: {
        name: 'Auftrag - Auftragsnummer',
        description: '12345.678'
      },
      raum: {
        name: 'Bauteil & Gerät - Raum ',
        description: 'Küche'
      },
      sign: {
        vname: {
          name: 'Signatur Vorname',
          description: ''
        },
        nname: {
          name: 'Signatur Nachname',
          description: ''
        },
        position: {
          name: 'Signatur Job',
          description: ''
        },
        signatur: {
          name: 'Benutzer Unterschrift schleife',
          description: 'Signatur des aktuellen Benutzers für die Schleife.'
        }
      },
      beginn: {
        name: 'Untermieter Schleife - Vertragsstart',
        description: '01.01.2022'
      },
      ende: {
        name: 'Untermieter Schleife - Vertragsende',
        description: '31.12.2022'
      },
      geb: {
        name: 'Mitbewohner Schleife - Geburtstag',
        description: '01.01.1990'
      },
      sol: {
        name: {
          name: 'Solidarhafter Schleife - Name',
          description: 'Max Mustermann'
        },
        briefanschrift: {
          name: 'Solidarhafter - Briefanschrift',
          description: 'Herr <br> Max Mustermann <br> Musterstrasse 1 <br> CH-8000 Zürich'
        },
        briefanrede: {
          name: 'Solidarhafter - Briefanrede',
          description: 'Sehr geehrter Herr Mustermann'
        },
        alle_namen: {
          name: 'Alle Solidarhafternamen',
          description: 'Max Mustermann, Maxima Mustermann'
        }
      },
      ko: {
        brief_anrede: {
          name: 'Kontakt - Briefanrede',
          description: 'Sehr geehrte Frau Musterfrau <br> Sehr geehrter Herr Mustermann'
        },
        briefanschrift: {
          name: 'Kontakt Briefanschrift',
          description: 'Herr <br> Max Mustermann <br> Musterstrasse 1 <br> CH-8000 Zürich, ZH'
        },
        briefanschrift_1: {
          name: 'Kontakt Briefanschrift 1',
          description: 'Herr <br> Max Mustermann <br> Musterstrasse 1 <br> 8000 Zürich'
        },
        briefanschrift_2: {
          name: 'Kontakt Briefanschrift 2',
          description: 'Herr <br> Max Mustermann <br> Musterstrasse 1 <br> CH - 8000 Zürich'
        },
        firmenname: {
          name: 'Kontakt - Firmenname',
          description: 'Muster AG'
        },
        anrede: {
          name: 'Kontakt - Anrede',
          description: 'Kontakt - Anrede'
        },
        name: {
          name: 'Kontakt - Name',
          description: 'Max Mustermann'
        },
        vname: {
          name: 'Kontakt - Vorname',
          description: 'Max'
        },
        nname: {
          name: 'Kontakt - Nachname',
          description: 'Mustermann'
        },
        titel: {
          name: 'Kontakt - Titel',
          description: 'Dr.'
        },
        az: {
          name: 'Kontakt - Adresszusatz (aktuell)',
          description: 'c/o Muster AG'
        },
        str: {
          name: 'Kontakt - Strasse (aktuell)',
          description: 'Musterstrasse'
        },
        nr: {
          name: 'Kontakt - Hausnummer (aktuell)',
          description: '1'
        },
        pf: {
          name: 'Kontakt - Postfach (aktuell)',
          description: 'Postfach 5'
        },
        plz: {
          name: 'Kontakt - PLZ (aktuell)',
          description: '8000'
        },
        ort: {
          name: 'Kontakt - Ort (aktuell)',
          description: 'Zürich'
        },
        kanton: {
          name: 'Kontakt - Kanton',
          description: 'ZH'
        },
        land: {
          name: 'Kontakt - Land',
          description: 'CH'
        },
        tel: {
          name: 'Kontakt - Telefon',
          description: '+41 44 512 76 76'
        },
        mail: {
          name: 'Kontakt - Email',
          description: 'info@example.ch'
        },
        site: {
          name: 'Kontakt - Website',
          description: 'www.kontakt.ch'
        },
        mobile: {
          name: 'Kontakt Mobil',
          description: '+41 76 111 22 33'
        },
        phone_w: {
          name: 'Kontakt Telefon Geschäft',
          description: '+41 44 512 76 76'
        },
        fax: {
          name: 'Kontakt Fax',
          description: '+41 44 512 76 77'
        },
        vat: {
          name: 'Kontakt MWST',
          description: 'MWST-Nr. 123 456'
        },
        pref_lang: {
          name: 'Kontakt Sprache',
          description: 'de'
        },
        pref_com: {
          name: 'Kontakt Kommunikation',
          description: 'E-Mail'
        },
        geb_name: {
          name: 'Kontakt Geburtsname',
          description: 'Maxim'
        },
        home_2: {
          name: 'Kontakt - Home 2',
          description: 'Home 2'
        },
        zivil: {
          name: 'Kontakt Zivilstand',
          description: 'ledig'
        },
        citiezenship: {
          name: 'Kontakt Staatsangehörigkeit',
          description: 'Schweiz'
        },
        nat: {
          name: 'Kontakt Nationalität',
          description: 'Schweiz'
        },
        residence: {
          name: 'Kontakt Wohnsitz',
          description: 'Schweiz'
        },
        valid_until: {
          name: 'Kontakt Gültig bis',
          description: '01.01.2020'
        },
        geb: {
          name: 'Kontakt Geburtsdatum',
          description: '01.05.1998'
        },
        beruf: {
          name: 'Kontakt Beruf',
          description: 'Sachbearbeiter'
        },
        ahv: {
          name: 'Kontakt AHV-Nummer',
          description: '756.7875.4564.45'
        },
        business_email: {
          name: 'Kontakt Geschäfts-E-Mail',
          description: 'max@mustermann.ag'
        }
      },
      kp: {
        kontaktperson: {
          name: 'Kontaktperson Schleife - Start',
          description: 'Kontaktperson'
        },
        titel: {
          name: 'Kontaktperson - Titel',
          description: 'Dr.'
        },
        anrede: {
          name: 'Kontaktperson - Anrede',
          description: 'Frau / Herr / Divers'
        },
        vname: {
          name: 'Kontaktperson Vorname',
          description: 'Max'
        },
        nname: {
          name: 'Kontaktperson Nachname',
          description: 'Mustermann'
        },
        geb_name: {
          name: 'Kontaktperson Geburtsname',
          description: 'Maxim'
        },
        tel_g: {
          name: 'Kontaktperson Telefon Geschäft',
          description: '+41 44 512 76 76'
        },
        mobile: {
          name: 'Kontaktperson Mobil',
          description: '+41 76 111 22 33'
        },
        mail: {
          name: 'Kontaktperson - Email',
          description: ''
        },
        beruf: {
          name: 'Kontaktperson Beruf',
          description: 'Sachbearbeiter'
        }
      },
      hs: {
        briefanschrift: {
          name: 'Haupt Stockwerkeigentümer Briefanschrift',
          description: 'Herr <br> Max Mustermann <br> Musterstrasse 1 <br> CH-8000 Zürich, ZH'
        },
        briefanschrift_1: {
          name: 'Haupt Stockwerkeigentümer Briefanschrift 1',
          description: 'Herr <br> Max Mustermann <br> Musterstrasse 1 <br> 8000 Zürich'
        },
        briefanschrift_2: {
          name: 'Haupt Stockwerkeigentümer Briefanschrift 2',
          description: 'Herr <br> Max Mustermann <br> Musterstrasse 1 <br> CH - 8000 Zürich'
        },
        brief_anrede: {
          name: 'Haupt Stockwerkeigentümer Briefanrede',
          description: 'Sehr geehrter Herr Mustermann'
        },
        firmenname: {
          name: 'Haupt Stockwerkeigentümer Firmenname',
          description: 'Muster AG'
        },
        anrede: {
          name: 'Haupt Stockwerkeigentümer Anrede',
          description: 'Herr / Frau / X'
        },
        name: {
          name: 'Haupt Stockwerkeigentümer Name',
          description: 'Max Mustermann'
        },
        vname: {
          name: 'Haupt Stockwerkeigentümer Vorname',
          description: 'Max'
        },
        nname: {
          name: 'Haupt Stockwerkeigentümer Nachname',
          description: 'Mustermann'
        },
        titel: {
          name: 'Haupt Stockwerkeigentümer Titel',
          description: 'Dr.'
        },
        az: {
          name: 'Haupt Stockwerkeigentümer Adresszusatz (aktuell)',
          description: 'c/o Muster AG'
        },
        str: {
          name: 'Haupt Stockwerkeigentümer Strasse (aktuell)',
          description: 'Musterstrasse'
        },
        nr: {
          name: 'Haupt Stockwerkeigentümer Hausnummer (aktuell)',
          description: '1'
        },
        pf: {
          name: 'Haupt Stockwerkeigentümer Postfach (aktuell)',
          description: 'Postfach 5'
        },
        plz: {
          name: 'Haupt Stockwerkeigentümer PLZ (aktuell)',
          description: '8000'
        },
        ort: {
          name: 'Haupt Stockwerkeigentümer Ort (aktuell)',
          description: 'Zürich'
        },
        kanton: {
          name: 'Haupt Stockwerkeigentümer Kanton',
          description: 'ZH'
        },
        land: {
          name: 'Haupt Stockwerkeigentümer Land',
          description: 'CH'
        },
        tel: {
          name: 'Haupt Stockwerkeigentümer Telefon',
          description: '+41 44 512 76 76'
        },
        mail: {
          name: 'Haupt Stockwerkeigentümer Email',
          description: 'info@example.ch'
        },
        site: {
          name: 'Haupt Stockwerkeigentümer Website',
          description: 'www.stewe.ch'
        }
      },
      stwe: {
        alle: {
          name: 'Alle STWE',
          description: 'Max Mustermann, Musterstrasse 1, 8000 Zürich, ZH <br> Maxima Mustermann, Musterstrasse 1, 8000 Zürich, ZH <br> '
        },
        alle_namen: {
          name: 'Alle STWE Alle Namen',
          description: 'Max Mustermann, Maxima Mustermann'
        },
        alle_anreden: {
          name: 'Alle STWE Anrede',
          description: 'Frau Mustermann <br>Herr Mustermann'
        },
        alle_name: {
          name: 'Alle STWE Alle Name',
          description: 'Alle STWE Alle Namen'
        },
        brief_anrede: {
          name: 'Alle STWE Briefanrede',
          description: 'Sehr geehte Frau Musterfrau<br> Sehr geehrter Herr Mustermann'
        },
        stwe: {
          name: 'STWE Schleife - Start',
          description: ''
        },
        korrespondenz: {
          name: 'Korrespondenzadresse',
          description: 'Max Mustermann, Musterstrasse 1, 8000 Zürich, ZH'
        },
        anz: {
          pers: {
            name: 'Vermietungen Anzahl Personen',
            description: '2'
          }
        },
        es: {
          name: 'Eigentumsstart',
          description: '01.01.2022'
        },
        ee: {
          name: 'Eigentumsende',
          description: '31.12.2022'
        },
        vertrag: {
          name: 'Vertragsnummer',
          description: '4785'
        },
        zusatz: {
          name: 'Vertragszusätze',
          description: 'Haustiere'
        },
        brief_briefanschrift: {
          name: 'Alle STWE - Briefanschrift',
          description: 'Herr <br> Max Mustermann <br> Musterstrasse 1 <br> CH-8000 Zürich, ZH'
        },
        brief_briefanschrift_1: {
          name: 'Alle STWE - Briefanschrift 1',
          description: 'Herr <br> Max Mustermann <br> Musterstrasse 1 <br> 8000 Zürich'
        },
        brief_briefanschrift_2: {
          name: 'Alle STWE - Briefanschrift 2',
          description: 'Herr <br> Max Mustermann <br> Musterstrasse 1 <br> CH - 8000 Zürich'
        }
      },
      s: {
        briefanschrift: {
          name: 'STWE Schleife - Briefanschrift',
          description: 'Herr <br> Max Mustermann <br> Musterstrasse 1 <br> CH-8000 Zürich, ZH'
        },
        briefanschrift_1: {
          name: 'STWE Schleife - Briefanschrift 1',
          description: 'Herr <br> Max Mustermann <br> Musterstrasse 1 <br> 8000 Zürich'
        },
        briefanschrift_2: {
          name: 'STWE Schleife - Briefanschrift 2',
          description: 'Herr <br> Max Mustermann <br> Musterstrasse 1 <br> CH - 8000 Zürich'
        },
        firmenname: {
          name: 'STWE Schleife - Firmenname',
          description: 'Muster AG'
        },
        anrede: {
          name: 'STWE Schleife - Anrede',
          description: 'Herr / Frau / X'
        },
        name: {
          name: 'STWE Schleife - Name',
          description: 'Max Mustermann'
        },
        vname: {
          name: 'STWE Schleife - Vorname',
          description: 'Max'
        },
        nname: {
          name: 'STWE Schleife - Nachname',
          description: 'Mustermann'
        },
        titel: {
          name: 'STWE Schleife - Titel',
          description: 'Dr.'
        },
        az: {
          name: 'STWE Schleife - Adresszusatz (aktuell)',
          description: 'c/o Muster AG'
        },
        str: {
          name: 'STWE Schleife - Strasse (aktuell)',
          description: 'Musterstrasse'
        },
        nr: {
          name: 'STWE Schleife - Hausnummer (aktuell)',
          description: '1'
        },
        pf: {
          name: 'STWE Schleife - Postfach (aktuell)',
          description: 'Postfach 5'
        },
        plz: {
          name: 'STWE Schleife - PLZ (aktuell)',
          description: '8000'
        },
        ort: {
          name: 'STWE Schleife - Ort (aktuell)',
          description: 'Zürich'
        },
        kanton: {
          name: 'STWE Schleife - Kanton',
          description: 'ZH'
        },
        land: {
          name: 'STWE Schleife - Land',
          description: 'CH'
        },
        tel: {
          name: 'STWE Schleife - Telefon',
          description: '+41 44 512 76 76'
        },
        mobile: {
          name: 'STWE Schleife - Mobil',
          description: '+41 76 111 22 33'
        },
        mail: {
          name: 'STWE Schleife - Email',
          description: 'info@example.ch'
        },
        site: {
          name: 'STWE Schleife - Website',
          description: 'www.stwe.ch'
        },
        geb: {
          name: 'Mieter Schleife - Geburtsdatum',
          description: '01.01.1990'
        },
        che: {
          name: 'Mieter Schleife - MWST-Nummer',
          description: 'CHE-123.456.789 MWST'
        },
        work: {
          name: 'Mieter Schleife - Telefon Geschäft',
          description: '+41 44 512 76 76'
        },
        nat: {
          name: 'Mieter Schleife - Nationalität',
          description: 'CH'
        },
        pref_language: {
          name: 'Mieter Schleife - Bevorzugte Sprache',
          description: 'Italiano'
        },
        mobil: {
          name: 'Mieter Schleife - Mobil',
          description: '+41 76 123 45 67'
        },
        zivil: {
          name: 'Mieter Schleife - Zivilstand',
          description: 'Single'
        },
        bgo: {
          name: 'Mieter Schleife - Bürgerort',
          description: 'Schaffhausen'
        }
      },
      e: {
        name: {
          name: 'Eigentümer Firmenname',
          description: 'Eigentümer AG '
        },
        briefanschrift: {
          name: 'Eigentümer Briefanschrift',
          description: 'Muster AG <br> c/o Max Mustermann <br> Musterstrasse 1 <br> CH-8000 Zürich, ZH'
        },
        briefanschrift_1: {
          name: 'Eigentümer Briefanschrift 1',
          description: 'Muster AG <br> c/o Max Mustermann <br> Musterstrasse 1 <br> 8000 Zürich'
        },
        briefanschrift_2: {
          name: 'Eigentümer Briefanschrift 2',
          description: 'Muster AG <br> c/o Max Mustermann <br> Musterstrasse 1 <br> CH - 8000 Zürich'
        },
        firmenname: {
          name: 'Eigentümer Firmenname',
          description: 'Muster AG'
        },
        az: {
          name: 'Eigentümer Adresszusatz',
          description: 'c/o Muster AG'
        },
        str: {
          name: 'Eigentümer Strasse',
          description: 'Musterstrasse'
        },
        nr: {
          name: 'Eigentümer Hausnummer',
          description: '1'
        },
        plz: {
          name: 'Eigentümer PLZ',
          description: '8000'
        },
        ort: {
          name: 'Eigentümer Ort',
          description: 'Zürich'
        },
        kanton: {
          name: 'Eigentümer Kanton',
          description: 'ZH'
        },
        tel: {
          name: 'Eigentümer Telefon',
          description: '+41 44 512 76 76'
        },
        mail: {
          name: 'Eigentümer Email',
          description: 'info@example.ch'
        },
        site: {
          name: 'Eigentümer Website',
          description: 'www.eigentuemer.ch'
        },
        che: {
          name: 'MWST-Nummer',
          description: 'CHE-123.456.789 MWST.'
        },
        vname: {
          name: 'Eigentümer Vorname',
          description: 'Max'
        },
        nname: {
          name: 'Eigentümer Nachname',
          description: 'Mustermann'
        }
      },
      am: {
        name: {
          name: 'Asset Manager Firmenname',
          description: 'Asset Manager AG '
        },
        briefanschrift: {
          name: 'Asset Manager Briefanschrift',
          description: 'Muster AG <br> c/o Max Mustermann <br> Musterstrasse 1 <br> CH-8000 Zürich, ZH'
        },
        briefanschrift_1: {
          name: 'Asset Manager Briefanschrift 1',
          description: 'Muster AG <br> c/o Max Mustermann <br> Musterstrasse 1 <br> 8000 Zürich'
        },
        briefanschrift_2: {
          name: 'Asset Manager Briefanschrift 2',
          description: 'Muster AG <br> c/o Max Mustermann <br> Musterstrasse 1 <br> CH - 8000 Zürich'
        },
        firmenname: {
          name: 'Asset Manager Firmenname',
          description: 'Muster AG'
        },
        az: {
          name: 'Asset Manager Adresszusatz',
          description: 'c/o Muster AG'
        },
        str: {
          name: 'Asset Manager Strasse',
          description: 'Musterstrasse'
        },
        nr: {
          name: 'Asset Manager Hausnummer',
          description: '1'
        },
        plz: {
          name: 'Asset Manager PLZ',
          description: '8000'
        },
        ort: {
          name: 'Asset Manager Ort',
          description: 'Zürich'
        },
        kanton: {
          name: 'Asset Manager Kanton',
          description: 'ZH'
        },
        tel: {
          name: 'Asset Manager Telefon',
          description: '+41 44 512 76 76'
        },
        mail: {
          name: 'Asset Manager Email',
          description: 'info@example.ch'
        },
        site: {
          name: 'Asset Manager Website',
          description: 'www.assetmanager.ch'
        },
        che: {
          name: 'MWST-Nummer',
          description: 'CHE-123.456.789 MWST.'
        },
        ap: {
          name: {
            name: 'Asset Manager Ansprechpartner Name',
            description: 'Max Mustermann'
          },
          tel: {
            name: 'Asset Manager Ansprechpartner Telefon',
            description: '+44 444 44 44'
          },
          mail: {
            name: 'Asset Manager Ansprechpartner E-Mail',
            description: 'max.mustermann@muster.ch'
          },
          pos: {
            name: 'Asset Manager Ansprechpartner Position',
            description: 'Asset Manager'
          }
        }
      },
      bw: {
        briefanschrift: {
          name: 'Bewirtschaftung Briefanschrift',
          description: 'Muster AG <br> c/o Max Mustermann <br> Musterstrasse 1 <br> CH-8000 Zürich, ZH'
        },
        briefanschrift_1: {
          name: 'Bewirtschaftung Briefanschrift 1',
          description: 'Muster AG <br> c/o Max Mustermann <br> Musterstrasse 1 <br> 8000 Zürich'
        },
        briefanschrift_2: {
          name: 'Bewirtschaftung Briefanschrift 2',
          description: 'Muster AG <br> c/o Max Mustermann <br> Musterstrasse 1 <br> CH - 8000 Zürich'
        },
        firmenname: {
          name: 'Bewirtschaftung Firmenname',
          description: 'Muster AG'
        },
        az: {
          name: 'Bewirtschaftung Adresszusatz',
          description: 'c/o Muster AG'
        },
        str: {
          name: 'Bewirtschaftung Strasse',
          description: 'Musterstrasse'
        },
        nr: {
          name: 'Bewirtschaftung Hausnummer',
          description: '1'
        },
        plz: {
          name: 'Bewirtschaftung PLZ',
          description: '8000'
        },
        ort: {
          name: 'Bewirtschaftung Ort',
          description: 'Zürich'
        },
        kanton: {
          name: 'Bewirtschaftung Kanton',
          description: 'ZH'
        },
        tel: {
          name: 'Bewirtschaftung Telefon',
          description: '+41 44 512 76 76'
        },
        mail: {
          name: 'Bewirtschaftung Email',
          description: 'info@example.ch'
        },
        site: {
          name: 'Bewirtschaftung Website',
          description: 'www.bewirtschaftung.ch'
        },
        che: {
          name: 'MWST-Nummer',
          description: 'CHE-123.456.789 MWST.'
        },
        ap: {
          name: {
            name: 'Bewirtschaftung Ansprechpartner Name',
            description: 'Max Mustermann'
          },
          tel: {
            name: 'Bewirtschaftung Ansprechpartner Telefon',
            description: '+44 444 44 44'
          },
          mail: {
            name: 'Bewirtschaftung Ansprechpartner E-Mail',
            description: 'max.mustermann@muster.ch'
          },
          pos: {
            name: 'Bewirtschaftung Ansprechpartner Position',
            description: 'Asset Manager'
          }
        },
        name: {
          name: 'Bewirtschaftung Firmenname',
          description: 'Muster AG'
        }
      },
      verm: {
        name: {
          name: 'Vermarkter Firmenname',
          description: 'Vermarkter AG'
        },
        briefanschrift: {
          name: 'Vermarkter Briefanschrift',
          description: 'Muster AG <br> c/o Max Mustermann <br> Musterstrasse 1 <br> CH-8000 Zürich, ZH'
        },
        briefanschrift_1: {
          name: 'Vermarkter Briefanschrift 1',
          description: 'Muster AG <br> c/o Max Mustermann <br> Musterstrasse 1 <br> 8000 Zürich'
        },
        briefanschrift_2: {
          name: 'Vermarkter Briefanschrift 2',
          description: 'Muster AG <br> c/o Max Mustermann <br> Musterstrasse 1 <br> CH - 8000 Zürich'
        },
        firmenname: {
          name: 'Vermarkter Firmenname',
          description: 'Muster AG'
        },
        az: {
          name: 'Vermarkter Adresszusatz',
          description: 'c/o Muster AG'
        },
        str: {
          name: 'Vermarkter Strasse',
          description: 'Musterstrasse'
        },
        nr: {
          name: 'Vermarkter Hausnummer',
          description: '1'
        },
        plz: {
          name: 'Vermarkter PLZ',
          description: '8000'
        },
        ort: {
          name: 'Vermarkter Ort',
          description: 'Zürich'
        },
        kanton: {
          name: 'Vermarkter Kanton',
          description: 'ZH'
        },
        tel: {
          name: 'Vermarkter Telefon',
          description: '+41 44 512 76 76'
        },
        mail: {
          name: 'Vermarkter Email',
          description: 'info@example.ch'
        },
        site: {
          name: 'Vermarkter Website',
          description: 'www.vermarkter.ch'
        },
        che: {
          name: 'MWST-Nummer',
          description: 'CHE-123.456.789 MWST.'
        },
        ap: {
          name: {
            name: 'Vermarkter Ansprechpartner Name',
            description: 'Max Mustermann'
          },
          tel: {
            name: 'Vermarkter Ansprechpartner Telefon',
            description: '+44 444 44 44'
          },
          mail: {
            name: 'Vermarkter Ansprechpartner E-Mail',
            description: 'max.mustermann@muster.ch'
          },
          pos: {
            name: 'Vermarkter Ansprechpartner Position',
            description: 'Asset Manager'
          }
        }
      },
      hm: {
        briefanschrift: {
          name: 'Hauptmieter Briefanschrift',
          description: 'Herr <br> Max Mustermann <br> Musterstrasse 1 <br> CH-8000 Zürich, ZH'
        },
        briefanschrift_1: {
          name: 'Hauptmieter Briefanschrift 1',
          description: 'Herr <br> Max Mustermann <br> Musterstrasse 1 <br> 8000 Zürich'
        },
        briefanschrift_2: {
          name: 'Hauptmieter Briefanschrift 2',
          description: 'Herr <br> Max Mustermann <br> Musterstrasse 1 <br> CH - 8000 Zürich'
        },
        brief_anrede: {
          name: 'Hauptmieter Briefanrede',
          description: 'Sehr geehrter Herr Mustermann'
        },
        firmenname: {
          name: 'Hauptmieter Firmenname',
          description: 'Muster AG'
        },
        anrede: {
          name: 'Hauptmieter Anrede',
          description: 'Herr / Frau / X'
        },
        name: {
          name: 'Hauptmieter Name',
          description: 'Max Mustermann'
        },
        vname: {
          name: 'Hauptmieter Vorname',
          description: 'Max'
        },
        nname: {
          name: 'Hauptmieter Nachname',
          description: 'Mustermann'
        },
        titel: {
          name: 'Hauptmieter Titel',
          description: 'Dr.'
        },
        az: {
          name: 'Hauptmieter Adresszusatz (aktuell)',
          description: 'c/o Muster AG'
        },
        str: {
          name: 'Hauptmieter Strasse (aktuell)',
          description: 'Musterstrasse'
        },
        nr: {
          name: 'Hauptmieter Hausnummer (aktuell)',
          description: '1'
        },
        pf: {
          name: 'Hauptmieter Postfach (aktuell)',
          description: 'Postfach 5'
        },
        plz: {
          name: 'Hauptmieter PLZ (aktuell)',
          description: '8000'
        },
        ort: {
          name: 'Hauptmieter Ort (aktuell)',
          description: 'Zürich'
        },
        kanton: {
          name: 'Hauptmieter Kanton',
          description: 'ZH'
        },
        land: {
          name: 'Hauptmieter Land',
          description: 'CH'
        },
        tel: {
          name: 'Hauptmieter Telefon',
          description: '+41 44 512 76 76'
        },
        mail: {
          name: 'Hauptmieter Email',
          description: 'info@example.ch'
        },
        site: {
          name: 'Hauptmieter Website',
          description: 'www.hauptmieter.ch'
        },
        geb: {
          name: 'Hauptmieter Geburtstag',
          description: '01.01.1990'
        },
        nat: {
          name: 'Hauptmieter Nationalität',
          description: 'CH'
        },
        pref_language: {
          name: 'Hauptmieter Bevorzugte Sprache',
          description: 'English'
        },
        tel_g: {
          name: 'Hauptmieter Telephon Geschäft',
          description: '41 44 512 76 76'
        },
        mobil: {
          name: 'Hauptmieter Mobil',
          description: '41 76 123 45 67'
        },
        zivil: {
          name: 'Hauptmieter Zivilstand',
          description: 'Single'
        },
        bgo: {
          name: 'Hauptmieter Bürgerort',
          description: 'Schaffhausen'
        }
      },
      m: {
        briefanschrift: {
          name: 'Mieter Schleife - Briefanschrift',
          description: 'Herr <br> Max Mustermann <br> Musterstrasse 1 <br> CH-8000 Zürich, ZH'
        },
        briefanschrift_1: {
          name: 'Mieter Schleife - Briefanschrift 1',
          description: 'Herr <br> Max Mustermann <br> Musterstrasse 1 <br> 8000 Zürich'
        },
        briefanschrift_2: {
          name: 'Mieter Schleife - Briefanschrift 2',
          description: 'Herr <br> Max Mustermann <br> Musterstrasse 1 <br> CH - 8000 Zürich'
        },
        firmenname: {
          name: 'Mieter Schleife - Firmenname',
          description: 'Muster AG'
        },
        anrede: {
          name: 'Mieter Schleife - Anrede',
          description: 'Herr / Frau / X'
        },
        name: {
          name: 'Mieter Schleife - Name',
          description: 'Max Mustermann'
        },
        vname: {
          name: 'Mieter Schleife - Vorname',
          description: 'Max'
        },
        nname: {
          name: 'Mieter Schleife - Nachname',
          description: 'Mustermann'
        },
        titel: {
          name: 'Mieter Schleife - Titel',
          description: 'Dr.'
        },
        az: {
          name: 'Mieter Schleife - Adresszusatz (aktuell)',
          description: 'c/o Muster AG'
        },
        str: {
          name: 'Mieter Schleife - Strasse (aktuell)',
          description: 'Musterstrasse'
        },
        nr: {
          name: 'Mieter Schleife - Hausnummer (aktuell)',
          description: '1'
        },
        pf: {
          name: 'Mieter Schleife - Postfach (aktuell)',
          description: 'Postfach 5'
        },
        plz: {
          name: 'Mieter Schleife - PLZ (aktuell)',
          description: '8000'
        },
        ort: {
          name: 'Mieter Schleife - Ort (aktuell)',
          description: 'Zürich'
        },
        kanton: {
          name: 'Mieter Schleife - Kanton',
          description: 'ZH'
        },
        land: {
          name: 'Mieter Schleife - Land',
          description: 'CH'
        },
        tel: {
          name: 'Mieter Schleife - Telefon',
          description: '+41 44 512 76 76'
        },
        mail: {
          name: 'Mieter Schleife - Email',
          description: 'info@example.ch'
        },
        site: {
          name: 'Mieter Schleife - Website',
          description: 'www.stwe.ch'
        },
        che: {
          name: 'MWST-Nummer',
          description: 'CHE-123.456.789 MWST'
        },
        work: {
          name: 'Mieter Schleife - Telefon Geschäft',
          description: '+41 44 512 76 76'
        },
        nat: {
          name: 'Mieter Schleife - Nationalität',
          description: 'CH'
        },
        pref_language: {
          name: 'Mieter Schleife - Bevorzugte Sprache',
          description: 'Deutsch'
        },
        tel_g: {
          name: 'Mieter Schleife - Telefon Geschäft',
          description: '+41 44 512 76 76'
        },
        mobil: {
          name: 'Mieter Schleife - Mobil',
          description: '+41 76 123 45 67'
        },
        zivil: {
          name: 'Mieter Schleife - Zivilstand',
          description: 'Ledig'
        },
        bgo: {
          name: 'Mieter Schleife - Bürgerort',
          description: 'Schaffhausen'
        },
        geb: {
          name: 'Mieter Schleife - Geburtstag',
          description: '01.01.1990'
        }
      },
      mieter: {
        alle: {
          name: 'Alle Mieter',
          description: 'Max Mustermann, Musterstrasse 1, 8000 Zürich, ZH <br> Maxima Mustermann, Musterstrasse 1, 8000 Zürich, ZH <br> '
        },
        alle_1: {
          name: 'Alle Mieter 1',
          description: 'Max Mustermann, Musterstrasse 1, 8000 Zürich <br> Maxima Mustermann, Musterstrasse 1, 8000 Zürich <br> '
        },
        alle_namen: {
          name: 'Alle Mieternamen',
          description: 'Max Mustermann, Maxima Mustermann <br> '
        },
        brief_briefanschrift: {
          name: 'Alle Mieter - Briefanschrift',
          description: 'Herr <br> Max Mustermann <br> Musterstrasse 1 <br> CH-8000 Zürich, ZH'
        },
        brief_briefanschrift_1: {
          name: 'Alle Mieter - Briefanschrift 1',
          description: 'Herr <br> Max Mustermann <br> Musterstrasse 1 <br> 8000 Zürich'
        },
        brief_briefanschrift_2: {
          name: 'Alle Mieter - Briefanschrift 2',
          description: 'Herr <br> Max Mustermann <br> Musterstrasse 1 <br> CH - 8000 Zürich'
        },
        brief_briefanschrift_3: {
          name: 'Alle Mieter - Briefanschrift 3',
          description: 'Frau Maxima Mustermann <br> Herr Max Mustermann <br> Musterstrasse 1<br> 8000 Zürich'
        },
        alle_anreden: {
          name: 'Alle Mieter Anrede',
          description: 'Frau Mustermann <br>Herr Mustermann'
        },
        alle_name: {
          name: 'Alle Mieter Alle Name',
          description: 'Alle STWE Alle Namen'
        },
        brief_anrede: {
          name: 'Alle Mieter Briefanrede',
          description: 'Sehr geehte Frau Musterfrau<br> Sehr geehrter Herr Mustermann'
        },
        mieter: {
          name: 'Mieter Schleife - Start',
          description: ''
        }
      },
      vm: {
        kuend_begruendung: {
          name: 'Kündigungsgrund',
          description: 'Eigennutzen'
        },
        ks_datum_moeglich: {
          name: 'Kostensteigerung Datum möglich',
          description: '01.01.2022'
        },
        vdatum: {
          name: 'Vermietung Vertragsdatum',
          description: '17.12.2020'
        },
        vz: {
          name: 'Vermietung Verwendungszweck',
          description: 'Büroraum'
        },
        kdm: {
          name: 'Vermietung Kündigung des Mieter gesendet am',
          description: '20.10.2021'
        },
        akonto: {
          name: 'Vermietung Akonto',
          description: '100'
        },
        pauschal: {
          name: 'Vermietung Pauschal',
          description: '100'
        },
        mwst: {
          name: 'Vermietung MWST 8.1%',
          description: '8.10'
        },
        brutto_mwst: {
          name: 'Vermietung Brutto',
          description: '1200'
        },
        zweitwohnsitz: {
          name: 'Zweitwohnsitz (Ja/Nein)',
          description: 'Ja'
        },
        steuerbar: {
          name: 'Steuerbar (Ja/Nein)',
          description: 'Ja'
        },
        akt: {
          ks_datum: {
            name: 'Kostensteigerung - Datum',
            description: '01.01.2021'
          }
        },
        korrespondenz: {
          name: 'Korrespondenzadresse',
          description: 'Max Mustermann, Musterstrasse 1, 8000 Zürich, ZH'
        },
        alle_solidarhafter: {
          name: 'Alle Solidarhafter',
          description: 'Max Mustermann, Musterstrasse 1, 8000 Zürich, ZH'
        },
        fam: {
          name: 'Familienwohnung (Ja/Nein)',
          description: 'Ja'
        },
        opt: {
          name: 'Optiert (Ja/Nein)',
          description: 'Ja'
        },
        anz_pers: {
          name: 'Vermietung Anzahl Personen',
          description: '2'
        },
        mietbeginn: {
          name: 'Vermietung Mietbeginn',
          description: '01.01.2022'
        },
        ve: {
          name: 'Vermietung Vertragsende',
          description: '31.12.2022'
        },
        vt: {
          name: 'Vermietung Vertragstyp',
          description: 'unbefristet'
        },
        vta: {
          name: 'Vermietung Vertragsart',
          description: 'VMWG'
        },
        nutzung: {
          name: 'Vermietung Nutzungsart',
          description: 'Wohnen'
        },
        vertrag: {
          name: 'Vermietung Vertragsnummer',
          description: '1010'
        },
        zuzahlen_bis: {
          name: 'Vermietung Monatsmiete zahlbar bis',
          description: '1'
        },
        zusatz: {
          name: 'Vermietung Vertragszusätze',
          description: 'Haustiere'
        },
        kd: {
          name: 'Kündigungsdatum',
          description: '27.03.2022'
        },
        gek_auf: {
          name: 'Vermietung gekündigt auf',
          description: '30.06.2022'
        },
        auszug: {
          name: 'Auszugsdatum',
          description: '30.06.2022'
        },
        gew: {
          auszug: {
            name: 'Gewünschtes Auszugsdatum',
            description: '13.03.2025'
          }
        },
        haft: {
          name: 'Haftungsende',
          description: '30.06.2022'
        },
        moegl_nm: {
          name: 'Vermietung Mögl. Bezug Nachmieter',
          description: '01.07.2022'
        },
        ka: {
          name: 'Vermietung Kündigungsart',
          description: 'Ordentlich'
        },
        kg: {
          name: 'Vermietung Kündigungsgrund',
          description: 'Eigenbedarf'
        },
        kf: {
          name: 'Vermietung Kündigungsfrist Mieter',
          description: '3'
        },
        kfv: {
          name: 'Vermietung Kündigungsfrist Vermieter',
          description: '3'
        },
        erst_kb: {
          name: 'Vermietung erstmals kündbar Mieter',
          description: '31.12.2021'
        },
        erst_kbv: {
          name: 'Vermietung erstmals kündbar Vermieter',
          description: '31.12.2021'
        },
        kuend_mnt: {
          name: 'Vermietung Kündigungsmonate Mieter',
          description: 'Ende jeden Monats, ausser 31.12'
        },
        kuendv_mnt: {
          name: 'Vermietung Kündigungsmonate Vermieter',
          description: 'Ende jeden Monats, ausser 31.12'
        },
        kuend_mnt_ausser: {
          name: 'Vermietung keine Kündigungsmonate Mieter',
          description: '31.12'
        },
        kuendv_mnt_ausser: {
          name: 'Vermietung keine Kündigungsmonate Vermieter',
          description: '31.12'
        },
        netto: {
          name: 'Vermietung Netto',
          description: '1000'
        },
        bg: {
          name: 'Vermietung Berechnungsgrundlage',
          description: 'Standard'
        },
        netto_m2: {
          name: 'Vermietung Netto m2/Jahr',
          description: '1000'
        },
        nk: {
          name: 'Vermietung Nebenkosten',
          description: '100'
        },
        hk: {
          name: 'Vermietung Heizkosten',
          description: '100'
        },
        hk_nk: {
          name: 'Vermietung Heiz- und Nebenkosten',
          description: '200'
        },
        brutto: {
          name: 'Vermietung Brutto',
          description: '1200'
        },
        faelligkeiten: {
          name: 'Vermietung Fälligkeiten',
          description: 'Jan, Feb, Mrz, Apr, Mai, Jun, Jul, Aug, Sep, Okt, Nov, Dez'
        },
        faellig_anzahl: {
          name: 'Vermietung Anzahl Fälligkeiten pro Jahr',
          description: '12'
        },
        ks_typ: {
          name: 'Kostensteigerung - Typ',
          description: 'Pauschal / Index'
        },
        ks_datum: {
          name: 'Kostensteigerung - Datum',
          description: '01.01.2021'
        },
        ks_proz: {
          name: 'Kostensteigerung - Prozent',
          description: '0.5'
        },
        mrz: {
          name: 'Mietzinsreserve Schleife - Start',
          description: ''
        },
        eopt: {
          name: 'Erneuerungsoptionen Schleife - Start',
          description: ''
        },
        vkopt: {
          name: 'Vorzeitiges Kündigungsrecht Schleife - Start',
          description: ''
        },
        mz_bestand: {
          name: 'Alle Mietzinskomponenten Schleife - Start',
          description: ''
        },
        komp: {
          alle: {
            name: 'Alle Mietzinskomponenten',
            description: 'Auflistung aller Komponenten'
          }
        },
        korrespondenz_briefanschrift: {
          name: 'Korrespondenz- Briefanschrift',
          description: 'Herr Max Mustermann Musterstrasse 1 8000 Zürich'
        },
        korrespondenz_briefanrede: {
          name: 'Korrespondenz- Briefanrede',
          description: 'Sehr geehrter Herr Mustermann'
        },
        ks_datum_vor_proz: {
          name: 'Kostensteigerung Vorbehalt in %',
          description: '0.5'
        },
        ks_datum_vor_chf: {
          name: 'Kostensteigerung Vorbehalt in CHF',
          description: '15.00'
        }
      },
      fvm: {
        name: 'Alle Mietzinskomponenten Schleife - Früheres Mietverhältnis wert',
        description: '1000'
      },
      kaution: {
        typ: {
          name: 'Kautionstyp',
          description: 'Depot'
        },
        betrag: {
          name: 'Kaution Betrag',
          description: '5000'
        },
        zuzahlen_bis: {
          name: 'Kaution zu zahlen bis',
          description: '31.12.2020'
        },
        aufbewahrer: {
          name: 'Kaution Aufbewahrer',
          description: 'UBS AG'
        },
        konto: {
          name: 'Kaution Bankkonto',
          description: 'CH11 1111 1111 1111 1111 1'
        }
      },
      mz: {
        referenzzins_datum: {
          name: 'Referenzzins Datum',
          description: '01.05.2020'
        },
        referenzzins: {
          name: 'Referenzzins Effektiv',
          description: '1.25'
        },
        referenzzins_moegl: {
          name: 'Referenzzins Möglich',
          description: '1.5'
        },
        referenzzins_proz: {
          name: 'Referenzzins Anpassung in %',
          description: '1'
        },
        referenzzins_chf: {
          name: 'Referenzzins Anpassung in CHF',
          description: '50'
        },
        referenzzins_vor_proz: {
          name: 'Referenzzins Vorbehalt in %',
          description: '0.25'
        },
        referenzzins_vor_chf: {
          name: 'Referenzzins Vorbehalt in CHF',
          description: '23.00'
        },
        akt: {
          index: {
            teuerung: {
              name: 'Aktuelle Landesindex Teuerung',
              description: '101.3'
            },
            datum: {
              name: 'Aktueller Landesindex Datum',
              description: 'Mai 2021'
            }
          },
          referenzzins_datum: {
            name: 'Aktuelles Referenzzins Datum',
            description: '1.25%'
          },
          teuerung_moeglich: {
            name: 'Landesindex Teuerung möglich',
            description: '101.3'
          },
          teuerung_m_proz: {
            name: 'Landesindex Teuerung in %',
            description: '1'
          },
          teuerung_m_chf: {
            name: 'Landesindex Teuerung in CHF',
            description: '50'
          }
        },
        index: {
          teuerung: {
            name: 'Landesindex Teuerung',
            description: '101.3'
          },
          datum: {
            name: 'Landesindex Datum',
            description: '8.2021'
          },
          jahr: {
            name: 'Landesindex Basisjahr',
            description: '2020'
          },
          teuerung_moeglich: {
            name: 'Landesindex Teuerung möglich',
            description: '101.3'
          },
          teuerung_m_proz: {
            name: 'Landesindex Teuerung in %',
            description: '1'
          },
          teuerung_m_chf: {
            name: 'Landesindex Teuerung in CHF',
            description: '50'
          },
          teuerung_datum_moeglich: {
            name: 'Landesindex Datum möglich',
            description: '8.2021'
          },
          teuerung_vor_proz: {
            name: 'Landesindex Vorbehalt in %',
            description: '0.30'
          },
          teuerung_vor_chf: {
            name: 'Landesindex Vorbehalt in CHF',
            description: '5.00'
          }
        }
      },
      typ: {
        name: 'Mietzinsreserve - Typ',
        description: 'Ungenügende Bruttorendite'
      },
      bez: {
        name: 'Mietzinsreserve - Bezeichnung',
        description: '% der Nettomiete'
      },
      eff: {
        name: 'Mietzinsreserve - Effektiv',
        description: '1'
      },
      moegl: {
        name: 'Mietzinsreserve - Möglich',
        description: '1'
      },
      bem: {
        name: 'Mietzinsreserve - Bemerkung',
        description: 'Bemerkung'
      },
      proz: {
        name: 'Mietzinsreserve - Anpassung in %',
        description: '9.00'
      },
      chf: {
        name: 'Mietzinsreserve - Anpassung in CHF',
        description: '150.00'
      },
      von: {
        name: 'Erneuerungsoptionen - Von',
        description: '31.12.2022'
      },
      bis: {
        name: 'Erneuerungsoptionen - Bis',
        description: '31.12.2022'
      },
      auszuueben: {
        name: 'Erneuerungsoptionen - Auszuüben',
        description: '31.12.2022'
      },
      verl: {
        name: 'Erneuerungsoptionen - Automatische Verlängerung',
        description: 'Ja oder nein'
      },
      verldauer: {
        name: 'Erneuerungsoptionen in Monaten / Jahren',
        description: '1 Jahr, 2 Jahre, 3 Jahre… und/oder 1 Monat, 2 Jahre und 2 Monate etc.'
      },
      kuenddauer: {
        name: 'Kündigungsoption in Monaten / Jahren',
        description: '1 Jahr, 2 Jahre, 3 Jahre… Oder 1 Jahr und 1 Monat, 2 Jahre und 2 Monate etc.'
      },
      index: {
        erst_per: {
          name: 'Indexmiete - Mietzinsanpassung erstmals möglich per',
          description: '01.01.2022'
        },
        nach_mnt: {
          name: 'Indexmiete - Mietzinsanpassung nach Monate',
          description: '12'
        },
        nach_pt: {
          name: 'Indexmiete - Mietzinsanpassung nach Punkten',
          description: '100'
        },
        unterst_proz: {
          name: 'Indexmiete - Unterstellung des Indexes in %',
          description: '100'
        },
        ref_mnt: {
          name: 'Indexmiete - Referenzmonat für Index',
          description: '12'
        },
        max_zins: {
          name: 'Indexmiete - Maximalzins',
          description: '12'
        },
        anzeigefrist: {
          name: 'Indexmiete - Anzeigefrist',
          description: '1 Monat'
        },
        mnt: {
          name: 'Indexmiete - Mietzinsanpassungsmonate',
          description: 'Jan, Jun'
        }
      },
      ltz: {
        netto: {
          name: 'Frühere Netto',
          description: '1000'
        },
        nk: {
          name: 'Frühere Nebenkosten',
          description: '100'
        },
        hk: {
          name: 'Frühere Heizkosten',
          description: '100'
        },
        brutto: {
          name: 'Frühere Brutto',
          description: '1200'
        },
        datum: {
          name: 'Früheres Datum',
          description: '01.04.2022'
        },
        mieter_alle: {
          name: 'Frühere Mieter',
          description: 'Max Mustermann, Maxima Mustermann'
        },
        mieter_alle_namen: {
          name: 'Frühere Mieter 1',
          description: 'Max Mustermann, Maxima Mustermann'
        },
        mieter_briefanschrift: {
          name: 'Frühere Vermietung - Briefanschrift',
          description: 'Herr <br> Max Mustermann <br> Musterstrasse 1 <br> CH-8000 Zürich, ZH'
        },
        mieter_briefanschrift_1: {
          name: 'Frühere Vermietung - Briefanschrift 1',
          description: 'Herr <br> Max Mustermann <br> Musterstrasse 1 <br> 8000 Zürich'
        },
        mieter_briefanschrift_2: {
          name: 'Frühere Vermietung - Briefanschrift 2',
          description: 'Herr <br> Max Mustermann <br> Musterstrasse 1 <br> CH - 8000 Zürich'
        },
        referenzzins: {
          name: 'Frühere Referenzzins',
          description: '1.25'
        },
        index: {
          teuerung: {
            name: 'Frühere Landesindex Teuerung',
            description: '101.3'
          },
          datum: {
            name: 'Früheres Landesindex Datum',
            description: '8.2021'
          },
          jahr: {
            name: 'Früheres Basisjahr',
            description: '8.2021'
          }
        },
        vm: {
          netto: {
            name: 'Frühere Vermietung Netto',
            description: '1000'
          },
          nk: {
            name: 'Frühere Vermietung Nebenkosten',
            description: '100'
          },
          hk: {
            name: 'Frühere Vermietung Heizkosten',
            description: '100'
          },
          brutto: {
            name: 'Frühere Vermietung Brutto',
            description: '1200'
          },
          datum: {
            name: 'Frühere Vermietung Datum',
            description: '01.04.2022'
          },
          mieter_alle: {
            name: 'Frühere Vermietung Mieter',
            description: 'Max Mustermann, Maxima Mustermann'
          }
        },
        mz: {
          referenzzins: {
            name: 'Frühere Vermietung Referenzzins',
            description: '1.25'
          },
          index: {
            teuerung: {
              name: 'Frühere Vermietung Landesindex Teuerung',
              description: '101.3'
            },
            datum: {
              name: 'Frühere Vermietung Landesindex Datum',
              description: '8.2021'
            },
            jahr: {
              name: 'Frühere Vermietung Landesindex Basisjahr',
              description: '8.2021'
            }
          }
        },
        sol: {
          alle_namen: {
            name: 'Frühere Solidarhafter',
            description: 'Max Mustermann'
          }
        }
      },
      ls: {
        id: {
          name: 'Liegenschaft ID',
          description: '100'
        },
        egrid: {
          name: 'EGRID',
          description: 'CH123456789'
        },
        bez: {
          name: 'Liegenschaft Bezeichnung',
          description: 'Musterstrasse 1'
        },
        ort: {
          name: 'Liegenschaft Ort',
          description: 'Zürich'
        },
        plz: {
          name: 'Liegenschaft Parzelle',
          description: '4782'
        },
        iban: {
          name: 'Liegenschaft IBAN',
          description: 'CH11 1111 1111 1111 1111 1'
        },
        bank: {
          name: 'Finanzinstitut',
          description: 'UBS AG'
        },
        acctname: {
          name: 'Lautend auf',
          description: 'Max Mustermann, Zürich'
        },
        parzelle: {
          name: 'Liegenschaft Parzelle',
          description: '4782'
        },
        lautendauf: {
          name: 'Lautend auf',
          description: 'Max Mustermann, Zürich'
        },
        stichtag: {
          hknk: {
            name: 'Stichtag HKNK',
            description: '30.06'
          }
        }
      },
      gb: {
        id: {
          name: 'Gebäude ID',
          description: '555'
        },
        egid: {
          name: 'EGID',
          description: '123456789'
        },
        bez: {
          name: 'Gebäude Bezeichnung',
          description: 'Musterstrasse 1'
        },
        str: {
          name: 'Gebäude Strasse',
          description: 'Musterstrasse'
        },
        nr: {
          name: 'Gebäude Nummer',
          description: '1'
        },
        vertragszusaetze: {
          name: 'Contract additions to the building',
          description: 'Keine Haustiere erlaubt'
        },
        bem: {
          name: 'Gebäude Bemerkungen ',
          description: 'Bemerkungen'
        }
      },
      obj: {
        id: {
          name: 'Objekt ID',
          description: '4587'
        },
        str: {
          name: 'Objekt Strasse',
          description: 'Musterstrasse'
        },
        bemerkungen: {
          name: 'Objekt Bemerkungen',
          description: ''
        },
        bez: {
          name: 'Objekt Bezeichnung',
          description: '1.0.1 Attikawohnung'
        },
        typ: {
          name: 'Objekt Typ',
          description: 'Wohnung'
        },
        art: {
          name: 'Objekt Unterobjektart',
          description: 'Attikawohnung'
        },
        zimmer: {
          name: 'Objekt Zimmer',
          description: '3.5'
        },
        strasse: {
          name: 'Objekt Strasse',
          description: 'Musterstrasse'
        },
        nr: {
          name: 'Objekt Hausnummer',
          description: '1'
        },
        plz: {
          name: 'Objekt PLZ',
          description: '8000'
        },
        ort: {
          name: 'Objekt Ort',
          description: 'Zürich'
        },
        ewid: {
          name: 'EWID',
          description: '1'
        },
        etage: {
          name: 'Objekt Etage',
          description: '1. OG'
        },
        lage: {
          name: 'Objekt Lage',
          description: 'Süd/West'
        },
        flaeche: {
          name: 'Objekt Fläche',
          description: '120'
        },
        nf: {
          name: 'Objekt Nutzfläche',
          description: '120'
        },
        nebenraeume: {
          name: 'Objekt Nebenräume',
          description: 'Keller'
        },
        zugeordnete_nebenraeume: {
          name: 'Objekt zugeordnete Nebenräume',
          description: 'Keller 101'
        },
        mitbenutzung: {
          name: 'Objekt Mitbenutzung',
          description: 'Veloraum'
        },
        sond_vereinbarung: {
          name: 'Objekt besondere Vereinbarung',
          description: 'keine Haustiere erlaubt'
        },
        besonderheiten: {
          name: 'Objekt Besonderheiten',
          description: 'wurde neu gestrichen'
        },
        e: {
          zust: {
            name: {
              name: 'Objekt Zuständiger Eigentümer',
              description: 'Max Mustermann'
            },
            tel: {
              name: 'Objekt Zuständiger Eigentümer Telefon',
              description: '+41 44 444 44 44'
            },
            mail: {
              name: 'Objekt Zuständiger Eigentümer Email',
              description: 'max.mustermann@muster.ch'
            },
            pos: {
              name: 'Objekt Zuständiger Eigentümer Position',
              description: 'CEO'
            }
          },
          ap: {
            signatur: {
              name: 'Eigentümer Unterschrift',
              description: 'Eigentümer Unterschrift'
            }
          }
        },
        bw: {
          zust: {
            name: {
              name: 'Objekt Zuständiger Bewirtschaftung',
              description: 'Max Mustermann'
            },
            tel: {
              name: 'Objekt Zuständiger Bewirtschaftung Telefon',
              description: '+41 44 444 44 44'
            },
            mail: {
              name: 'Objekt Zuständiger Bewirtschaftung Email',
              description: 'max.mustermann@muster.ch'
            },
            pos: {
              name: 'Objekt Zuständiger Bewirtschaftung Position',
              description: 'CEO'
            }
          },
          ap: {
            signatur: {
              name: 'Bewirtschafter Unterschrift',
              description: 'Bewirtschafter Unterschrift'
            }
          }
        },
        am: {
          zust: {
            name: {
              name: 'Objekt Zuständiger Asset Manager',
              description: 'Max Mustermann'
            },
            tel: {
              name: 'Objekt Zuständiger Asset Manager Telefon',
              description: '+41 44 444 44 44'
            },
            mail: {
              name: 'Objekt Zuständiger Asset Manager Email',
              description: 'max.mustermann@muster.ch'
            },
            pos: {
              name: 'Objekt Zuständiger Asset Manager Position',
              description: 'CEO'
            }
          },
          ap: {
            signatur: {
              name: 'Asset Manager Unterschrift',
              description: 'Asset Manager Unterschrift'
            }
          }
        },
        bh: {
          zust: {
            name: {
              name: 'Objekt Zuständiger Buchhaltung',
              description: 'Max Mustermann'
            },
            tel: {
              name: 'Objekt Zuständiger Buchhaltung Telefon',
              description: '+41 44 444 44 44'
            },
            mail: {
              name: 'Objekt Zuständiger Buchhaltung Email',
              description: 'max.mustermann@muster.ch'
            },
            pos: {
              name: 'Objekt Zuständiger Buchhaltung Position',
              description: 'CEO'
            }
          },
          ap: {
            signatur: {
              name: 'Buchhaltung Unterschrift',
              description: 'Buchhaltung Unterschrift'
            }
          }
        },
        verm: {
          zust: {
            name: {
              name: 'Objekt Zuständiger Vermarktung',
              description: 'Max Mustermann'
            },
            tel: {
              name: 'Objekt Zuständiger Vermarktung Telefon',
              description: '+41 44 444 44 44'
            },
            mail: {
              name: 'Objekt Zuständiger Vermarktung Email',
              description: 'max.mustermann@muster.ch'
            },
            pos: {
              name: 'Objekt Zuständiger Vermarktung Position',
              description: 'CEO'
            }
          },
          ap: {
            signatur: {
              name: 'Vermarktung Unterschrift',
              description: 'Vermarktung Unterschrift'
            }
          }
        },
        awn: {
          name: 'Objekt aWN',
          description: '12'
        },
        int_nr: {
          name: 'Interne Objekt Nummer',
          description: '12'
        },
        wquote: {
          name: 'Wertquote',
          description: '65'
        },
        gewquote: {
          name: 'Gesamtwertquote',
          description: '1000'
        },
        all: {
          etage: {
            name: 'Anzahl Geschosse',
            description: '3'
          }
        }
      },
      name: {
        name: 'Untermieter Schleife - Name',
        description: 'Max Mustermann'
      },
      fc: {
        name: 'Alle Mietzinskomponenten Schleife - Frühere Währung',
        description: 'CHF'
      },
      fv: {
        name: 'Alle Mietzinskomponenten Schleife - Früherer Wert',
        description: '100.00'
      },
      cc: {
        name: 'Alle Mietzinskomponenten Schleife - Aktuelle Währung',
        description: 'CHF'
      },
      cv: {
        name: 'Alle Mietzinskomponenten Schleife - Aktueller Wert',
        description: '120.00'
      },
      type: {
        name: 'Alle Mietzinskomponenten Schleife - Typ',
        description: 'Akonto / Pauschal'
      },
      g: {
        name: 'Bauteil & Gerät Schleife - Start',
        description: ''
      },
      geraetetyp: {
        name: 'Bauteil & Gerät',
        description: 'Kühlschrank'
      },
      bkph: {
        name: 'Bauteil & Gerät - BKP Nummer',
        description: '258'
      },
      hersteller: {
        name: 'Bauteil & Gerät - Hersteller',
        description: 'V-Zug'
      },
      marke: {
        name: 'Bauteil & Gerät - Marke',
        description: 'V-Zug'
      },
      modell: {
        name: 'Bauteil & Gerät - Modell',
        description: 'Adora'
      },
      seriennummer: {
        name: 'Bauteil & Gerät - Seriennummer',
        description: 'V-Zug'
      },
      bemerkung: {
        name: 'Bauteil & Gerät - Bemerkung',
        description: 'Bemerkung'
      },
      installation: {
        name: 'Bauteil & Gerät - Installation',
        description: '01.01.2022'
      },
      deinstallation: {
        name: 'Bauteil & Gerät - Deinstallation',
        description: '31.01.2022'
      },
      abl_garantie: {
        name: 'Bauteil & Gerät - Ablauf Garantie',
        description: '31.12.2022'
      },
      ltz_wartung: {
        name: 'Bauteil & Gerät - Letzte Wartung',
        description: '31.01.2022'
      },
      beschreibung: {
        name: 'Bauteil & Gerät - Auftragsbeschreibung',
        description: 'Beschreibung'
      },
      auftragsdetails: {
        name: 'Auftrag - Auftragsdetals',
        description: 'Auftragsdetals'
      },
      k: {
        brief_anrede: {
          name: 'Auftrag - Empfänger Briefanrede',
          description: 'Sehr geehrte Frau Musterfrau <br> Sehr geehrter Herr Mustermann'
        },
        briefanschrift: {
          name: 'Auftrag - Empfänger Briefanschrift',
          description: 'Herr <br> Max Mustermann <br> Musterstrasse 1 <br> CH-8000 Zürich, ZH'
        },
        briefanschrift_1: {
          name: 'Auftrag - Empfänger Briefanschrift 1',
          description: 'Herr <br> Max Mustermann <br> Musterstrasse 1 <br> 8000 Zürich'
        },
        briefanschrift_2: {
          name: 'Auftrag - Empfänger Briefanschrift 2',
          description: 'Herr <br> Max Mustermann <br> Musterstrasse 1 <br> CH - 8000 Zürich'
        },
        firmenname: {
          name: 'Auftrag - Empfänger Firmenname',
          description: 'Muster AG'
        },
        anrede: {
          name: 'Auftrag - Empfänger Anrede',
          description: 'Herr / Frau / X'
        },
        name: {
          name: 'Auftrag - Empfänger Name',
          description: 'Max Mustermann'
        },
        vname: {
          name: 'Auftrag - Empfänger Vorname',
          description: 'Max'
        },
        nname: {
          name: 'Auftrag - Empfänger Nachname',
          description: 'Mustermann'
        },
        titel: {
          name: 'Auftrag - Empfänger Titel',
          description: 'Dr.'
        },
        az: {
          name: 'Auftrag - Empfänger Adresszusatz (aktuell)',
          description: 'c/o Muster AG'
        },
        str: {
          name: 'Auftrag - Empfänger Strasse (aktuell)',
          description: 'Musterstrasse'
        },
        nr: {
          name: 'Auftrag - Empfänger Hausnummer (aktuell)',
          description: '1'
        },
        pf: {
          name: 'Auftrag - Empfänger Postfach (aktuell)',
          description: 'Postfach 5'
        },
        plz: {
          name: 'Auftrag - Empfänger PLZ (aktuell)',
          description: '8000'
        },
        ort: {
          name: 'Auftrag - Empfänger Ort (aktuell)',
          description: 'Zürich'
        },
        kanton: {
          name: 'Auftrag - Empfänger Kanton (aktuell)',
          description: 'Zürich'
        },
        land: {
          name: 'Auftrag - Empfänger Land (aktuell)',
          description: 'CH'
        },
        tel: {
          name: 'Auftrag - Empfänger Telefon',
          description: '+41 44 444 44 44'
        },
        mail: {
          name: 'Auftrag - Empfänger E-Mail',
          description: 'info@example.ch'
        },
        site: {
          name: 'Auftrag - Empfänger Website',
          description: 'www.muster.ch'
        }
      },
      avo: {
        briefanschrift: {
          name: 'Auftrag - Ansprechperson vor Ort Briefanschrift',
          description: 'Herr <br> Max Mustermann <br> Musterstrasse 1 <br> CH-8000 Zürich, ZH'
        },
        briefanschrift_1: {
          name: 'Auftrag - Ansprechperson vor Ort Briefanschrift 1',
          description: 'Herr <br> Max Mustermann <br> Musterstrasse 1 <br> 8000 Zürich'
        },
        briefanschrift_2: {
          name: 'Auftrag - Ansprechperson vor Ort Briefanschrift 2',
          description: 'Herr <br> Max Mustermann <br> Musterstrasse 1 <br> CH - 8000 Zürich'
        },
        firmenname: {
          name: 'Auftrag - Ansprechperson vor Ort Firmenname',
          description: 'Muster AG'
        },
        anrede: {
          name: 'Auftrag - Ansprechperson vor Ort Anrede',
          description: 'Herr / Frau / X'
        },
        name: {
          name: 'Auftrag - Ansprechperson vor Ort Name',
          description: 'Max Mustermann'
        },
        vname: {
          name: 'Auftrag - Ansprechperson vor Ort Vorname',
          description: 'Max'
        },
        nname: {
          name: 'Auftrag - Ansprechperson vor Ort Nachname',
          description: 'Mustermann'
        },
        titel: {
          name: 'Auftrag - Ansprechperson vor Ort Titel',
          description: 'Dr.'
        },
        az: {
          name: 'Auftrag - Ansprechperson vor Ort Adresszusatz (aktuell)',
          description: 'c/o Muster AG'
        },
        str: {
          name: 'Auftrag - Ansprechperson vor Ort Strasse (aktuell)',
          description: 'Musterstrasse'
        },
        nr: {
          name: 'Auftrag - Ansprechperson vor Ort Hausnummer (aktuell)',
          description: '1'
        },
        pf: {
          name: 'Auftrag - Ansprechperson vor Ort Postfach (aktuell)',
          description: 'Postfach 5'
        },
        plz: {
          name: 'Auftrag - Ansprechperson vor Ort PLZ (aktuell)',
          description: '8000'
        },
        ort: {
          name: 'Auftrag - Ansprechperson vor Ort Ort (aktuell)',
          description: 'Zürich'
        },
        kanton: {
          name: 'Auftrag - Ansprechperson vor Ort Kanton (aktuell)',
          description: 'Zürich'
        },
        land: {
          name: 'Auftrag - Ansprechperson vor Ort Land (aktuell)',
          description: 'CH'
        },
        tel: {
          name: 'Auftrag - Ansprechperson vor Ort Telefon',
          description: '+41 44 444 44 44'
        },
        mail: {
          name: 'Auftrag - Ansprechperson vor Ort E-Mail',
          description: 'info@example.ch'
        },
        site: {
          name: 'Auftrag - Ansprechperson vor Ort Website',
          description: 'www.muster.ch'
        }
      },
      ae: {
        vname: {
          name: 'Auftrag - Auftragsersteller Vorname',
          description: 'Max'
        },
        nname: {
          name: 'Auftrag - Auftragsersteller Nachname',
          description: 'Mustermann'
        },
        tel: {
          name: 'Auftrag - Auftragsersteller Telefon',
          description: '+41 44 444 44 44'
        },
        mail: {
          name: 'Auftrag - Auftragsersteller E-Mail',
          description: 'info@example.ch'
        },
        pos: {
          name: 'Auftrag - Auftragsersteller Position',
          description: 'Sachbearbeiter'
        }
      },
      termin_ab: {
        name: 'Auftrag - Termin ab',
        description: '21.10.2021'
      },
      termin_bis: {
        name: 'Auftrag - Termin bis',
        description: '21.10.2021'
      },
      datum: {
        heute: {
          name: 'Heutiges Datum',
          description: '21.10.2021'
        }
      },
      brief: {
        name: 'Brief Schleife - Start',
        description: ''
      },
      brief_titel: {
        name: 'Brief - Titel',
        description: 'Titel'
      },
      brief_beschreibung: {
        name: 'Brief - Beschreibung',
        description: 'Beschreibung'
      }
    },
    generic: {
      dearMale: 'Sehr geehrter',
      dearFemale: 'Sehr geehrte',
      edited: 'Bearbeitet',
      total: 'Total',
      totalWithoutVacancy: 'Total <span class="font-weight-normal">(ohne Leerstand)</span>',
      totalVacancy: 'Total <span class="font-weight-normal">(Leerstand)</span>',
      tags: 'Tags',
      unassigned: 'Nicht zugeordnet',
      assigneeObject: 'Objektzuständiger',
      attention: 'ACHTUNG',
      pleaseSelect: '(* bitte ankreuzen)',
      showAll: 'Mehr anzeigen',
      showLess: 'Weniger anzeigen',
      showMore: 'Mehr anzeigen',
      communication: 'Kommunikation',
      serialEmail: 'Serien E-Mail schreiben',
      oneEmail: 'E-Mail schreiben',
      contacts: 'Kontakte',
      permissions: 'Berechtigungen',
      color: 'Farbe',
      privacypolicyButton: 'Datenschutzbestimmungen',
      search: 'Suche',
      searchContact: 'Kontakt suchen',
      creationDate: 'Erstellungsdatum',
      roles: 'Rollen',
      select: 'Auswählen',
      unselect: 'Abwählen',
      inactivate: 'Deaktivieren',
      newRequest: 'Neue Anfrage',
      reject: 'Absagen',
      reactivate: 'Reaktivieren',
      moveRequest: 'Anfrage verschieben',
      interestedPartySelectionOwner: 'Interessentenauswahl Eigentümer',
      rejectWithoutMail: 'Absagen ohne Nachricht',
      rejectWithMail: 'Absagen mit Nachricht',
      closeTenancy: 'Vermietung/en abschliessen',
      thumbnail: 'Foto',
      object: 'Objekt',
      unit: 'Einheit',
      status: 'Status',
      currentStatus: 'Status aktuell',
      futureStatus: 'Status zukünftig',
      marketingStatus: 'Status Vermarktung',
      assignee: 'Zuständiger',
      events: 'Termine',
      reminders: 'Reminder',
      contactPerson: 'Kontaktperson',
      requests: 'Anfragen',
      viewingAppointments: 'Besichtigungen',
      applications: 'Anmeldungen',
      editActionButton: 'Bearbeiten',
      createNewBuildingActionButton: 'Gebäude anlegen',
      createNewObjectActionButton: 'Objekt anlegen',
      deleteObjectActionButton: 'Objekt löschen',
      createNewPropertyActionButton: 'Liegenschaft anlegen',
      writeEmail: 'Nachricht schreiben',
      editAdvertActionButton: 'Inserat bearbeiten',
      settings: 'Einstellungen',
      clearFilters: 'Filter löschen',
      clearSelection: 'Auswahl zurücksetzen',
      advertisement: 'Inserat',
      message: 'Nachricht',
      messages: 'Nachrichten',
      references: 'Interne Notizen',
      years: 'Jahre',
      minutes: 'Minuten',
      hour: 'Stunde',
      hours: 'Stunden',
      day: 'Tag',
      days: 'Tage',
      month: 'Monate',
      appointments: 'Termine',
      documents: 'Dokumente',
      document: 'Dokument',
      noDocument: 'Kein Dokument',
      rentalDocuments: 'Vermietungsdokumente',
      condominiumDocuments: 'Stockwerkeigentumsdokumente',
      floorPlan: 'Grundriss',
      virtualTour: '360° Rundgang',
      movie: 'Video',
      type: 'Typ',
      role: 'Role',
      client: 'Mandant',
      selectField: {
        yes: 'Ja',
        no: 'Nein'
      },
      months: {
        all: 'Jeden Monat',
        1: 'Jan',
        2: 'Feb',
        3: 'Mrz',
        4: 'Apr',
        5: 'Mai',
        6: 'Jun',
        7: 'Jul',
        8: 'Aug',
        9: 'Sep',
        10: 'Okt',
        11: 'Nov',
        12: 'Dez'
      },
      monthsComplete: {
        1: 'Januar',
        2: 'Februar',
        3: 'März',
        4: 'April',
        5: 'Mai',
        6: 'Juni',
        7: 'Juli',
        8: 'August',
        9: 'September',
        10: 'Oktober',
        11: 'November',
        12: 'Dezember'
      },
      daysComplete: {
        sunday: 'Sonntag',
        monday: 'Montag',
        tuesday: 'Dienstag',
        wednesday: 'Mittwoch',
        thursday: 'Donnerstag',
        friday: 'Freitag',
        saturday: 'Samstag'
      },
      countries: {
        country: 'Land',
        switzerland: 'Schweiz',
        germany: 'Deutschland',
        austria: 'Österreich',
        liechtenstein: 'Liechtenstein'
      },
      basics: 'Basis',
      building: 'Gebäude',
      costs: 'Kosten',
      attributes: 'Eigenschaften',
      pictures: 'Bilder',
      addPicture: 'Bilder hinzufügen',
      noPictures: 'Keine Bilder',
      noVideos: 'Kein Video',
      noVirtualTour: 'Kein 360° Rundgang',
      addVideo: 'Video hinzufügen',
      noParkings: 'Keine Parkplätze',
      publish: 'Veröffentlichen',
      english: 'EN',
      german: 'DE',
      french: 'FR',
      italian: 'IT',
      selectedEntries: 'markierte Einträge',
      selectHiddenEntries: 'Selektiere alle {amount} möglichen Einträge.',
      unselectHiddenEntries: 'Alle {amount} mögliche Einträge wurden selektiert.',
      entries: 'Einträge',
      done: 'erledigt',
      answerAll: 'antworten',
      advertisements: 'Inserate',
      cancel: 'Abbrechen',
      view: 'Anzeigen',
      edit: 'Bearbeiten',
      back: 'Zurück',
      readView: 'Zur Leseansicht',
      next: 'Weiter',
      createSerialPrint: 'Seriendruck erstellen',
      serialLetter: 'Serienbrief erstellen',
      oneSerialLetter: 'Brief erstellen',
      duplicate: 'Duplizieren',
      statistics: 'Statistiken',
      private: 'Privatperson',
      company: 'Firma',
      companyName: 'Firmenname',
      industries: 'Branchen',
      industry: 'Branche',
      jobTitle: 'Beruf',
      avatar: 'Foto',
      firstName: 'Vorname',
      lastName: 'Nachname',
      birthName: 'Geburtsname',
      contactTitle: 'Titel',
      name: 'Name',
      email: 'E-Mail',
      address: 'Adresse',
      enterAddress: 'Adresse eingeben',
      streetHouseNumber: 'Strasse',
      streetNumber: 'Hausnummer',
      street: 'Strasse',
      country: 'Land',
      zip: 'PLZ',
      no: 'Nr.',
      city: 'Ort',
      state: 'Bundesland',
      canton: 'Kanton',
      addressAddition: 'Adresszusatz',
      postOfficeBox: 'Postfach',
      postOfficeBoxPlaceholder: 'Beispiel: Postfach 5',
      notes: 'Notizen',
      debitPositionUntil: 'Sollgestellt Datum bis',
      salutation: 'Individuelle Anrede für Briefe und E-Mail’s',
      location: 'Ort',
      phoneNumber: 'Telefonnummer',
      phoneLabel: {
        mobile: 'P',
        work: 'G',
        home: 'P'
      },
      birthdate: 'Geburtstag',
      buildingID: {
        id: 'Gebäude-ID',
        idShort: 'Gbd.-ID'
      },
      website: 'Website',
      vatNumber: 'MWST-Nummer',
      account: 'Account',
      job: 'Job',
      changePassword: 'Mein Passwort ändern',
      newPassword: 'Neues Passwort',
      confirmPassword: 'Passwort wiederholen',
      passwordRequirment: 'Das Passwort muss mind. 8 Zeichen haben. Davon muss mindestens 1 Gross- und Kleinbuchstabe und eine Zahl enthalten sein',
      delete: 'Löschen',
      activate: 'Aktivieren',
      deactivate: 'Deaktivieren',
      active: 'Aktiv',
      inactive: 'Inaktiv',
      leaveProcess: 'Prozess verlassen',
      copy: 'Kopieren',
      create: 'Erstellen',
      link: 'Zuordnen',
      confirm: 'Bestätigen',
      add: 'Hinzufügen',
      addAnother: 'Weiteren hinzufügen',
      discardChanges: 'Änderungen verwerfen',
      deleted: 'Gelöscht',
      write: 'Nachricht schreiben',
      byDate: 'per Datum',
      since: 'seit',
      asOf: 'Ab',
      fromDate: 'ab ',
      title: {
        title: 'Anrede',
        mr: 'Herr',
        mrs: 'Frau',
        divers: 'X'
      },
      ahvNbr: 'AHV-Nummer',
      ahv: 'AHV',
      phone: {
        home: 'Telefon',
        home1: 'Telefon Privat',
        home2: 'Privat 2',
        work: 'Telefon Geschäft',
        mobile: 'Mobil',
        fax: 'Fax'
      },
      gender: {
        title: 'Anrede',
        male: 'Herr',
        female: 'Frau',
        other: 'X'
      },
      form: {
        browse: 'Durchsuchen',
        save: 'Speichern',
        saveAndMarkForMarketing: 'Speichern und für Marketing markieren',
        send: 'Senden',
        reset: 'Zurücksetzen',
        delete: 'Löschen',
        start: 'Starten',
        upload: 'Hochladen',
        attach: 'Anhängen',
        apply: 'Bewerben',
        applyAdd: 'Hinzufügen',
        toCommunication: 'zur Kommunikation',
        accept: 'Übernehmen',
        typeTextPlaceholder: 'Schreibe etwas hier...',
        selectFile: 'Datei auswählen oder hierher ziehen',
        dropFile: 'Datei loslassen',
        modify: 'Ändern',
        addToCalendar: 'Zum Kalender hinzufügen'
      },
      birthday: 'Geburtstag',
      birthplace: 'Geburtsort',
      dateOfDeath: 'Todestag',
      nationality: {
        title: 'Nationalität',
        switzerland: 'Schweiz',
        foreignCitizenship: 'ausländische Staatsangehörigkeit'
      },
      residenceStatus: 'Aufenthaltsstatus',
      residenceStatusB: 'B',
      residenceStatusC: 'C',
      residenceStatusCi: 'CI',
      residenceStatusG: 'G',
      residenceStatusL: 'L',
      residenceStatusF: 'F',
      residenceStatusN: 'N',
      residenceStatusS: 'S',
      validUntil: 'Gültig bis',
      function: 'Funktion',
      selectAll: 'Alle auswählen',
      internalNote: 'Interne Notiz',
      tenant: 'Mieter',
      user: 'Benutzer',
      attachments: 'Dateien',
      submitApplicationForm: 'Anmeldeformular',
      dataFromApplicationForm: 'Daten vom Anmeldeformular',
      download: 'Download',
      placeholder: 'Platzhalter',
      actions: 'Aktionen',
      all: 'Alle',
      until: 'Bis',
      ListIsEmpty: 'Liste ist leer',
      noResult: 'Keine Treffer gefunden',
      selected: 'Ausgewählt',
      browserSupport: {
        title: 'Browser Support',
        textBody: 'Bitte benutze Google Chrome oder Mozilla Firefox als Browser um sicherzustellen, dass die Anwendung korrekt funktioniert.'
      },
      copied: 'Kopiert!',
      note: 'Bemerkung',
      timeline: 'Zeitachse',
      fill: 'Verarbeiten',
      automaticAddressToFill: 'Textdaten zur Adressgewinnung',
      createAnother: 'Weiteren erstellen',
      takeOverAddress: 'Adresse übernehmen',
      takeOverAddressToolTip: 'Daten übernehmen: Strasse, Nummer, PLZ, Ort, Land, Kanton',
      uploadMore: 'Weiteres hochladen',
      addDocumentToContact: 'Dokument dem Kontakt hinzufügen',
      addDocumentToTenancy: 'Dokument der Vermietung hinzufügen',
      addDocumentToVacancy: 'Dokument der Vermietung hinzufügen',
      showInPortal: 'Im Portal anzeigen',
      createOnlyOneDocument: 'Nur 1 Dokument erstellen',
      createOnlyOneDocumentTooltip: 'Für jede ausgewählte Vorlage wird ein Dokument erstellt, welches alle ausgewählten Vermietungen/Objekte beinhaltet.',
      addDocumentToOwnerAgreement: 'Dokument dem Eigentümerverhältnis hinzufügen',
      includeRoommate: 'Mitbewohner einbeziehen',
      tenancy: 'Vermietung',
      assignees: 'Zuständige Kontakte',
      citizenship: 'Bürgerort',
      civilStatus: 'Zivilstand',
      archive: 'Archivieren',
      generatedAfterSave: 'Wird beim Speichern vergeben',
      restore: 'Wiederherstellen',
      emptyTrash: 'Papierkorb leeren',
      error: 'Fehler',
      updateNow: 'Jetzt updaten',
      priceModel: {
        UNDEFINED_PRICING_MODEL: '-',
        SAAS_PRICING_MODEL: 'SaaS',
        LICENSE_PRICING_MODEL: 'Lizenz',
        SAAS_AND_LICENSE_PRICING_MODEL: 'Saas & Lizenz'
      },
      showInterestedParties: 'Interessenten anzeigen',
      reload: 'Neu laden',
      more: 'Mehr',
      businessEmail: 'Geschäfts-E-Mail',
      useEmail: 'E-Mail verwenden',
      subtenant: 'Untermieter:',
      tooltipAssembleList: 'Spaltenauswahl',
      addContactPerson: 'Kontaktperson hinzufügen',
      accountId: 'ID: ',
      condo_owner: 'STWE',
      myTicketsOverview: 'Meine Ticketübersicht',
      alreadySelected: 'Bereits verknüpft',
      accept: 'Akzeptieren',
      decline: 'Ablehnen',
      onSite: 'Vor Ort',
      inOffice: 'Im Büro',
      preview: 'Vorschau',
      system: 'System',
      uploadSignature: 'Upload signature'
    },
    language: {
      title: 'Sprache',
      german: 'Deutsch',
      english: 'Englisch',
      italian: 'Italienisch',
      french: 'Französisch'
    },
    cookie: {
      message: 'Um unsere Webseite für Sie optimal zu gestalten und fortlaufend verbessern zu können, verwenden wir Cookies. Durch die weitere Nutzung der Webseite stimmen Sie der Verwendung von Cookies zu.',
      gotIt: 'Verstanden!'
    },
    createSeparateTicket: 'Erstelle für jedes Gerät ein eigenes Ticket',
    ticketPreview: 'Ticket Vorschau',
    ticketTitle: 'Sammelauftrag {name}',
    generateExcel: {
      title: 'Excel-Bericht generieren',
      titleStep1: 'Liegenschaften und Gebäude auswählen',
      titleStep2: 'Feldauswahl',
      createExcel: 'Export erstellen',
      all: 'Alle',
      rented: 'Vermietet',
      vacant: 'Leerstand',
      targetData: 'Stichtag',
      onlyMovingInOutTenancies: 'Nur Ein-/ausziehende Mieter',
      period: 'Zeitraum',
      fieldsTitle: 'Felder',
      selectAll: 'Alle auswählen',
      deselectAll: 'Alle abwählen',
      selectedFields: 'Ausgewählte Felder',
      availableFields: 'Verfügbare Felder',
      selectedFieldsTooltip: 'Felder mit dem gleichen Symbol bleiben im Excel-Bericht zusammen. Innerhalb der Gruppierung können Sie aber die Reihenfolge der einzelnen Felder anpassen.',
      property: 'Liegenschaft',
      building: 'Gebäude',
      object: 'Objekt',
      tenancy: 'Vermietung / STWE',
      tenantOwner: 'Mieter/Stockwerkeigentümer',
      contact: 'Kontakt',
      marketing: 'Vermarktung',
      linkedContacts: 'Verknüpfte Kontakte',
      sorting: {
        title: 'Gewünschte Sortierung der Objekte',
        byObjectId: 'Nach Objekt-ID',
        byObjectNumber: 'Nach Objekt-Nummer',
        standard: 'PROPbase Standard (Aktuelle Sortierung in Objekten)'
      },
      composition: {
        title: 'Export Zusammensetzung',
        separately: 'Liegenschaften separat ausführen',
        consolidate: 'Liegenschaften zusammenführen'
      },
      compositionLinesOrColumns: {
        vertical: 'Mieter und Mietzinsanpassung untereinander',
        horizontal: 'Alle ausgewählten Felder nebeneinander'
      },
      fields: {
        propertyId: 'Liegenschafts-ID',
        propertyName: 'Liegenschafts-Bezeichnung',
        owner: 'Eigentümer',
        buildingId: 'Gebäude-ID',
        buildingName: 'Gebäude-Bezeichnung',
        egid: 'EGID',
        constructionYear: 'Baujahr',
        street: 'Strasse',
        houseNumber: 'Hausnummer',
        zip: 'PLZ',
        city: 'Ort',
        objectId: 'Objekt-ID',
        numericId: 'Objekt-Nummer',
        objectName: 'Objekt-Name',
        status: 'Status',
        position: 'Lage',
        salutation: 'Anrede',
        name: 'Mieter/Stockwerkeigentümer Name',
        email: 'E-mail',
        workEmail: 'Geschäfts-E-Mail',
        mobile: 'Mobil',
        phone: 'Telefon',
        birthday: 'Geburtstag',
        nationality: 'Nationalität',
        civilStatus: 'Zivilstand',
        companyName: 'Firmenname',
        occupation: 'Beruf',
        correspondenceAddress: 'Korrespondenzadresse',
        debtor: 'Debitor',
        tenantAddress: 'Adresse',
        guarantor: 'Solidarhafter',
        subtenants: 'Untermieter/Mieter bei STWEG',
        subtenancyStart: 'Untermieter Start',
        subtenancyEnd: 'Untermieter Ende',
        category: 'Kategorie',
        subcategory: 'Unterkategorie',
        valueQuota: 'Wertquote',
        volume: 'Volumen',
        objectTag: 'Tags',
        area: 'Fläche',
        rooms: 'Zimmer',
        floor: 'Etage',
        typeOfUse: 'Nutzungsart',
        contractType: 'Vertragstyp',
        startOfContract: 'Mietverhältnis Vertragsstart',
        endOfContract: 'Mietverhältnis Vertragsende',
        contractNumber: 'Vertragsnummer',
        rentByDate: 'Mietzins per Datum',
        netRentMonthly: 'Nettomiete monatlich',
        netRentPeriod: 'Nettomiete periodisch',
        heatingAndAdditionalCosts: 'Heiz- und Nebenkosten monatlich',
        heatingAndAdditionalCostsPeriod: 'Heiz- und Nebenkosten periodisch',
        netRentYearly: 'Nettomiete jährlich',
        netRentM2Yearly: 'Nettomiete m2 jährlich',
        advancePayment: 'Akonto monatlich',
        advancePaymentPeriod: 'Akonto periodisch',
        flatRate: 'Pauschale monatlich',
        flatRatePeriod: 'Pauschale periodisch',
        additionalRentComponents: 'Weitere Mietzinsbestandteile monatlich',
        additionalRentComponentsPeriod: 'Weitere Mietzinsbestandteile periodisch',
        rentComponents: 'Mietzinsbestandteile monatlich',
        grossRentMonthly: 'Bruttomiete monatlich',
        grossRentPeriod: 'Bruttomiete periodisch',
        grossRentYearly: 'Bruttomiete jährlich',
        tax: 'MWST',
        taxNetRent: 'Nettomiete MWST',
        taxHeating: 'Heiz- und Nebenkosten MWST',
        grossRentInclTax: 'Bruttomiete inkl. MWST',
        targetNetRent: 'Ziel Nettomiete',
        marketNetRent: 'Markt Nettomiete',
        dueDates: 'Fälligkeiten',
        assignee: 'Zuständiger',
        opted: 'Optiert',
        contractAmendments: 'Vertragszusätze',
        ewid: 'EWID',
        awn: 'aWN',
        referenceInterestRateDate: 'Referenzzins Datum',
        referenceInterestRateEffective: 'Referenzzins Effektiv',
        referenceRatePossible: 'Referenzzins Möglich',
        costIncreaseDatePossible: 'Kostensteigerung Datum möglich',
        countryIndexBaseYear: 'Landesindex Basisjahr',
        countryIndexDate: 'Landesindex Datum',
        countryIndexInflation: 'Landesindex Teuerung',
        costIncreaseType: 'Kostensteigerung Typ',
        costIncreaseDate: 'Kostensteigerung Datum',
        costIncreaseValue: 'Kostensteigerung Prozent',
        rentMonthlyDueBy: 'Monatsmiete zahlbar bis',
        rentType: 'Vertragsart',
        depositType: 'Kautionstyp',
        depositInstitute: 'Kautionsinstitut',
        depositNumber: 'Kautionsnummer',
        depositAmount: 'Kautionshöhe',
        depositDue: 'Kaution zu zahlen bis',
        depositPaidAt: 'Kaution bezahlt am',
        depositPaidOut: 'Kaution ausbezahlt',
        depositPaidAmount: 'Kaution bezahlter Betrag',
        depositRefundedOn: 'Rückerstattet am',
        depositRefundAmount: 'Kaution Rückerstattungshöhe',
        depositNote: 'Kaution Bemerkung',
        retentionOfRentEffective: 'Mietzinsreserve effektiv',
        retentionOfRentPossible: 'Mietzinsreserve möglich',
        taxable: 'Steuerbar',
        netRentMarketing: 'Nettomiete (Vermarktung)',
        heatingAndAdditionalMarketing: 'Heiz- und Nebenkosten (Vermarktung)',
        grossRentMarketing: 'Bruttomiete (Vermarktung)',
        statusMarketing: 'Vermarktung Offline/Online',
        linkedContactRoleOnBuilding: 'Verknüpfte Kontakte - Rolle im Gebäude',
        linkedContactIndustry: 'Verknüpfte Kontakte - Branche',
        linkedContactName: 'Verknüpfte Kontakte - Name',
        linkedContactAddress: 'Verknüpfte Kontakte - Adresse',
        linkedContactPhone: 'Verknüpfte Kontakte - Telefon',
        linkedContactMobile: 'Verknüpfte Kontakte - Mobil',
        linkedContactEmail: 'Verknüpfte Kontakte - E-Mail',
        linkedContactWebsite: 'Verknüpfte Kontakte - Website',
        linkedContactNotes: 'Verknüpfte Kontakte - Notizen',
        referenceInterestRateReservationValue: 'Referenzzinssatz-Reservierungswert',
        countryIndexInflationReservationPercentage: 'Landesindex-Inflationsreservierung in %',
        countryIndexInflationReservationValue: 'Landesindex-Inflationsreservierungswert',
        countryIndexDatePossible: 'Landesindex-Datum möglich',
        countryIndexInflationPossible: 'Landesindex-Inflation möglich',
        costIncreasePossibleDate: 'Kostensteigerungsdatum möglich',
        referenceInterestRateReservationPercentage: 'Referenzzinssatz-Reservierung in %',
        tenantNoticePeriod: 'Kündigungsfrist Mieter (Monat)',
        tenantNoticeToQuit: 'Kündigungsdatum Mieter (Ende Monat)',
        tenantEarliestQuit: 'Frühestes Kündigungsdatum Mieter',
        landlordNoticePeriod: 'Kündigungsfrist Vermieter (Monat)',
        landlordNoticeToQuit: 'Kündigungsdatum Vermieter (Ende Monat)',
        landlordEarliestQuit: 'Frühestes Kündigungsdatum Vermieter',
        terminationResponsible: 'Wer hat den Vertrag gekündigt?',
        terminationType: 'Kündigungsart',
        reasonOfTermination: 'Kündigungsgrund',
        terminationJustification: 'Begründung',
        terminationCreatedOn: 'Kündigung erhalten am',
        terminationSentByTenantAt: 'Kündigung durch Mieter gesendet am',
        terminatedOn: 'Gewünschtes Auszugsdatum',
        moveOutDate: 'Auszugsdatum',
        liabilityEndsAt: 'Haftungsende',
        possibleMoveInDateNextTenant: 'Mögliches Einzugsdatum nächster Mieter',
        unjustifiedUse: 'Unberechtigte Nutzung',
        unjustifiedUseFrom: 'Von',
        firstRentAdjustmentPossibleOn: 'Erste Mietanpassung möglich am',
        rentAdjustmentByMonth: 'Mietanpassung nach Monaten',
        rentAdjustmentByPoints: 'Mietanpassung nach Punkten',
        referenceMonthForIndex: 'Referenzmonat für Index',
        contractImputedAtIndex: 'Vertrag % im Index berücksichtigt',
        maximumRate: 'Maximalsatz',
        rentAdjustmentMonths: 'Monate der Mietanpassung',
        rentAdjustmentAdditionalBenefit: 'Mietanpassung durch erhöhte Leistung möglich',
        belowInitialRentAllowed: 'Unterschreitungen der Anfangsmiete erlaubt',
        additionalCostsAdjustmentAllowed: 'Anpassung der Nebenkostenpauschale möglich',
        entAdjustmentNotification: 'Kündigungsfrist',
        optionFrom1: 'Option von 1',
        optionFrom2: 'Option von 2',
        optionFrom3: 'Option von 3',
        optionFrom4: 'Option von 4',
        optionUntil1: 'Option bis 1',
        optionUntil2: 'Option bis 2',
        optionUntil3: 'Option bis 3',
        optionUntil4: 'Option bis 4',
        optionType1: 'Optionstyp 1',
        optionType2: 'Optionstyp 2',
        optionType3: 'Optionstyp 3',
        optionType4: 'Optionstyp 4',
        automaticExtending1: 'Automatische Verlängerung 1',
        automaticExtending2: 'Automatische Verlängerung 2',
        automaticExtending3: 'Automatische Verlängerung 3',
        automaticExtending4: 'Automatische Verlängerung 4',
        rentAdjustmentNotification: 'Anzeigefrist',
        optionPer1: 'Option pro 1',
        optionPer2: 'Option pro 2',
        optionPer3: 'Option pro 3',
        optionPer4: 'Option pro 4',
        earlyTerminationExerciseUntil1: 'Ausübung bis 1',
        earlyTerminationExerciseUntil2: 'Ausübung bis 2',
        earlyTerminationExerciseUntil3: 'Ausübung bis 3',
        earlyTerminationExerciseUntil4: 'Ausübung bis 4',
        renewalExerciseUntil1: 'Ausübung bis 1',
        renewalExerciseUntil2: 'Ausübung bis 2',
        renewalExerciseUntil3: 'Ausübung bis 3',
        renewalExerciseUntil4: 'Ausübung bis 4'
      }
    },
    massRental: {
      title: 'Massenvermietung anlegen',
      selectObjects: 'Objekte auswählen',
      editTenanciesByCat: '{category} - Vermietungen bearbeiten',
      desiredStartOfContractTooltip: 'Der gewünschte Vertragsbeginns muss auf den heutigen Tag oder auf einen Tag in der Zukunft fallen'
    },
    editDocument: {
      title: 'Dokument Name und Typ bearbeiten'
    }
  },
  Switzerland: 'Schweiz',
  Albania: 'Albanien',
  Algeria: 'Algerien',
  'American Samoa': 'Amerikanisch-Samoa',
  Anguilla: 'Anguilla',
  Antarctica: 'Antarktis',
  'Antigua and Barbuda': 'Antigua und Barbuda',
  Argentinia: 'Argentinien',
  Australia: 'Australien',
  Austria: 'Österreich',
  Azerbaijan: 'Aserbaidschan',
  Belarus: 'Weissrussland',
  Belgium: 'Belgien',
  Bolivia: 'Bolivien',
  'Bonaire, Sint Eustatius and Saba': 'Bonaire',
  'Bosnia and Herzegovina': 'Bosnien und Herzegowina',
  'Bouvet Island': 'Bouvetinsel',
  Brazil: 'Brasilien',
  'British Indian Ocean Territory': 'Britisches Territorium im Indischen Ozean',
  Bulgaria: 'Bulgarien',
  Cambodia: 'Kambodscha',
  Cameroon: 'Kamerun',
  Canada: 'Kanada',
  'Cayman Islands': 'Kaimaninseln',
  'Central African Republic': 'Zentralafrika',
  Chad: 'Tschad',
  'Chistmas Island': 'Weihnachtsinsel',
  'Cocos (Keeling) Islands': 'Kokosinsel (Keeling)',
  Colombia: 'Kolumbien',
  Comoros: 'Komoren',
  'Congo, Republic of the (Brazzaville)': 'Kongo (Brazzaville)',
  'Congo, the Democratic Republic of the (Kinshasa)': 'Kongo (Kinshasa)',
  'Cook Islands': 'Cookinseln',
  Croatia: 'Kroatien',
  Cuba: 'Kuba',
  Cyprus: 'Zypern',
  'Czech Republic': 'Tschechische Republik',
  'Côte d\'Ivoire, Republic of': 'Elfenbeinküste',
  Denmark: 'Dänemark',
  'Dominican Republic': 'Dominikanische Republic',
  Ecuador: 'Equador',
  Egypt: 'Ägypten',
  'Equatorial Guinea': 'Äquatorialguinea',
  Estonia: 'Estland',
  Ethiopia: 'Äthiopien',
  'Falkland Islands (Islas Malvinas)': 'Falklandinseln (Malvinen)',
  'Faroe Islands': 'Färöer',
  Finland: 'Finnland',
  France: 'Frankreich',
  'French Guiana': 'Französisch-Guyana',
  'French Polynesia': 'Französisch-Polynesien',
  'French Southern and Antarctic Lands': 'Französische Süd- und Antarktisgebiete',
  Gabon: 'Gabun',
  'Gambia, The': 'Gambia',
  Georgia: 'Georgien',
  Germany: 'Deutschland',
  Greece: 'Griechenland',
  'Heard Island and McDonald Island': 'Heard und McDonaldinseln',
  'Holy See (Vatican City)': 'Vatikanstadt',
  Hungary: 'Ungarn',
  Iceland: 'Island',
  India: 'Indien',
  Indonesia: 'Indonesien',
  'Iran, Islamic Republic of': 'Iran',
  Iraq: 'Irak',
  Ireland: 'Irland',
  Italy: 'Italien',
  Jamaica: 'Jamaika',
  Kazakhstan: 'Kasachstan',
  Kenya: 'Kenia',
  'Korea, Democratic People\'s Republic of': 'Nordkorea',
  'Korea, Republic of': 'Südkorea',
  Kyrgyzstan: 'Kirgisistan',
  Latvia: 'Lettland',
  Lebanon: 'Libanon',
  Liberia: 'Liberia',
  Libya: 'Libyen',
  Lithuania: 'Litauen',
  Luxembourg: 'Luxemburg',
  'Macedonia, Republic of': 'Mazedonien',
  Madagascar: 'Madagaskar',
  Maldives: 'Malediven',
  'Marshall Islands': 'Marshallinseln',
  Mexico: 'Mexiko',
  'Micronesia, Federated States of': 'Mikronesien',
  Moldova: 'Moldavien',
  Mongolia: 'Mongolei',
  Morocco: 'Marokko',
  Mozambique: 'Mosambik',
  Netherlands: 'Niederlande',
  'New Caledonia': 'Neukaledonien',
  'New Zealand': 'Neu Seeland',
  'Norfork Island': 'Norfolkinsel',
  'Northern Mariana Islands': 'Nördliche Marianen',
  Norway: 'Norwegen',
  'Palestine, State of': 'Palästina',
  'Papua New Guinea': 'Papua-Neuguinea',
  Philippines: 'Philippinen',
  Pitcairn: 'Pitcairninseln',
  Poland: 'Polen',
  Qatar: 'Katar',
  Romania: 'Rumänien',
  'Russian Federation': 'Russland',
  Rwanda: 'Ruanda',
  'Saint Helena': 'Sankt Helena',
  'Sao Tome and Principe': 'São Tomé und Príncipe',
  'Saudi Arabia': 'Saudi-Arabien',
  Serbia: 'Serbien',
  Seychelles: 'Seychellen',
  Singapore: 'Singapur',
  Slovakia: 'Slowakei',
  Slovenia: 'Slowenien',
  'Solomon Islands': 'Salomonen',
  'South Africa': 'Südafrika',
  'South Georgia and South Sandwich Islands': 'Südgeorgien und die Südlichen Sandwichinseln',
  'South Sudan': 'Südsudan',
  Spain: 'Spanien',
  Swaziland: 'Swasiland',
  Sweden: 'Schweden',
  'Syrian Arab Republic': 'Syrien',
  Tajikistan: 'Tadschikistan',
  'Tanzania, United Republic of': 'Tansania',
  'Timor-Leste': 'Osttimor',
  'Trinidad and Tobago': 'Trinidad und Tobago',
  Tunisia: 'Tunesien',
  Turkey: 'Türkei',
  'Turks and Caicos Islands': 'Turks- und Caicosinseln',
  'United Arab Emirates': 'Vereinigte arabische Emirate',
  'United Kingdom': 'Vereinigtes Königreich',
  'United States': 'USA',
  'United States Minor Outlying Islands': 'Kleinere Inselbesitzungen der Vereinigten Staaten',
  Uzbekistan: 'Usbekistan',
  'Venezuela, Bolivarian Republic of': 'Venezuela',
  'Wallis and Futuna': 'Wallis und Futuna',
  'Western Sahara': 'Westsahara',
  Yemen: 'Jemen',
  Zambia: 'Sambia',
  'Åland Islands': 'Äland-Inseln'
}
